webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = "<main id=\"center-panel\" class=\"shop-centerPanel\" tabindex=\"-1\">\r\n    <oly-dynamic-content oly-dc-global-schedule class=\"dynamic-content2-panelTopGlobal\"></oly-dynamic-content>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule class=\"dynamic-content2-panelTop\"></oly-dynamic-content>\r\n\r\n    <div ui-view=\"center-panel\"></div>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule=\"bottom\" class=\"dynamic-content2-panelBottom\"></oly-dynamic-content>\r\n</main>\r\n"

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = "<aside id=\"right-panel\" class=\"shop-rightPanel\" tabindex=\"-1\" ng-if=\"$breakpoints.isInGreaterThanMediumFormatLandscape\">\r\n    <wow-cart-offscreen></wow-cart-offscreen>\r\n</aside>\r\n"

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var RrPageGroupFeaturePrefix = 'rrShowPlacementsIn';
var RrPageGroupFeatureSuffix = 'Pages';

var RichRelevanceBaseInstrumentationController = function () {
    function RichRelevanceBaseInstrumentationController($scope, $window, featureService, richRelevanceService, config) {
        _classCallCheck(this, RichRelevanceBaseInstrumentationController);

        this.$scope = $scope;
        this.$window = $window;
        this.featureService = featureService;
        this.richRelevanceService = richRelevanceService;

        // attributes from the component.
        // each controller must declare these
        // so we can use them to decide whether to
        // add placement types.
        this.pageGroup = null;
        this.placementIds = null;

        this.initialize(_.extend(this.getDefaultConfig(), config));
    }

    _createClass(RichRelevanceBaseInstrumentationController, [{
        key: 'getDefaultConfig',
        value: function getDefaultConfig() {
            return {
                // when enabled, calls the subclass implementation of
                // sendInstrumentation() when $stateChangeSuccess (ui-router)
                // occurs. Disable this if the state change isn't required or
                // the subclass implements this on its own.
                // eg: category-instrumentaion-component
                instrumentOnStateChange: true
            };
        }
    }, {
        key: 'initialize',
        value: function initialize(config) {
            var _this = this;

            if (config.instrumentOnStateChange) {
                this.$scope.$on('$stateChangeSuccess', function () {
                    // sub class must implement sendInstrumentaton
                    // and perform the RR instrumentation call.
                    _this.sendInstrumentation();
                });
            }
        }
    }, {
        key: 'addPlacementTypesIfEnabled',
        value: function addPlacementTypesIfEnabled() {
            var _this2 = this;

            this.placementTypes().forEach(function (placementId) {
                _this2.$window.R3_COMMON.addPlacementType(placementId);
                _this2.richRelevanceService.recordPlacementsRequested(placementId);
            });
        }
    }, {
        key: 'placementTypes',
        value: function placementTypes() {
            var _this3 = this;

            if (!this.pageGroup || !this.placementIds) {
                return [];
            }

            var featureEnabled = this.pageFeatureEnabled();
            if (!featureEnabled) {
                return [];
            }

            return this.placementIds.split(',').map(function (placementId) {
                return _this3.richRelevanceService.getEffectivePlacementId(placementId.trim());
            });
        }
    }, {
        key: 'pageFeatureEnabled',
        value: function pageFeatureEnabled() {
            // corresponding feature is [prefix][pageGroup][suffix]
            // eg: rrShowPlacementsInHomepagePages
            return this.featureService.isEnabled(this.featureService.features['' + RrPageGroupFeaturePrefix + this.pageGroup + RrPageGroupFeatureSuffix]);
        }
    }]);

    return RichRelevanceBaseInstrumentationController;
}();

module.exports = RichRelevanceBaseInstrumentationController;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1),
    map = _require.map;

function createRecipeTile(recipe) {
    return {
        id: recipe.ID,
        type: 'recipe',
        data: { recipe: recipe }
    };
}

function createRecipeTiles(recipes) {
    return map(recipes, createRecipeTile);
}

module.exports = {
    createRecipeTile: createRecipeTile,
    createRecipeTiles: createRecipeTiles
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1),
    forEach = _require.forEach,
    _require2 = __webpack_require__(23),
    createInspirationTiles = _require2.createInspirationTiles;

function mergeInspirationTiles(cards, inspirationTiles, _ref) {
    var pageNumber = _ref.pageNumber,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === undefined ? Number.MAX_VALUE : _ref$pageSize,
        type = _ref.type;

    var pageOffset = pageNumber != null ? pageSize * (pageNumber - 1) : 0;

    // Merge inspiration cards with actual cards
    forEach(inspirationTiles, function (inspTiles, position) {
        position = parseInt(position, 10) - pageOffset;

        if (position < 0 || position >= pageSize) return;

        Array.prototype.splice.apply(cards, [position, 0].concat(createInspirationTiles(inspTiles, type)));
    });

    return cards;
}

module.exports = { mergeInspirationTiles: mergeInspirationTiles };

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1),
    map = _require.map;

function createInspirationTile(inspirationTile) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'inspiration';

    return {
        id: inspirationTile.ID,
        type: type,
        data: { inspirationTile: inspirationTile }
    };
}

function createInspirationTiles(inspirationTiles, type) {
    return map(inspirationTiles, function (inspirationTile) {
        return createInspirationTile(inspirationTile, type);
    });
}

module.exports = {
    createInspirationTile: createInspirationTile,
    createInspirationTiles: createInspirationTiles
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1),
    reduce = _require.reduce;

var categoryLevels = Object.freeze(['department', 'category', 'subcategory']);
var categoryLevelIndexes = Object.freeze(reduce(categoryLevels, function (result, key, val) {
    result[key] = val;
    return result;
}, {}));

module.exports = {
    categoryLevels: categoryLevels,
    categoryLevelIndexes: categoryLevelIndexes
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (product) {
    return {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: product.Source
                },
                products: [{
                    name: product.Name,
                    id: product.Stockcode,
                    price: product.Price,
                    variant: product.PackageSize
                }]
            }
        }
    };
};

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trolleyQuantityValidation = {
    INVALID_QUANTITY: 'InvalidQuantity',
    SUPPLY_LIMIT_EXCEEDED: 'QtyIsGreater',
    DELIVERY_PASS_LIMIT_EXCEEDED: 'DeliveryPassLimit'
};

module.exports = { trolleyQuantityValidation: trolleyQuantityValidation };

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    clone = _require.clone,
    nth = _require.nth,
    last = _require.last,
    some = _require.some;

var CategoriesConstants = __webpack_require__(24);

var CategorySelectionList = function () {
    function CategorySelectionList() {
        var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, CategorySelectionList);

        this.value = clone(categories);
    }

    _createClass(CategorySelectionList, [{
        key: 'popCategory',
        value: function popCategory() {
            this.value = clone(this.value);
            this.value.pop();
        }
    }, {
        key: 'pushCategory',
        value: function pushCategory(category) {
            this.value = clone(this.value);
            this.value.push(category);
        }
    }, {
        key: 'isActive',
        value: function isActive(categoryNodeId) {
            return some(this.value, function (category) {
                return category.NodeId === categoryNodeId;
            });
        }
    }, {
        key: 'clone',
        value: function clone() {
            return new CategorySelectionList(this.value);
        }
    }, {
        key: 'hasSelectedCategories',
        get: function get() {
            return this.value.length > 0;
        }
    }, {
        key: 'department',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.department);
        }
    }, {
        key: 'category',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.category);
        }
    }, {
        key: 'subcategory',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.subcategory);
        }
    }, {
        key: 'current',
        get: function get() {
            return last(this.value);
        }
    }]);

    return CategorySelectionList;
}();

module.exports = CategorySelectionList;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var uiRouter = __webpack_require__(6);
var ocLazyLoad = __webpack_require__(312);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars

// General Modules
var olyCommonModule = __webpack_require__(4);
var wowCommonModule = __webpack_require__(5);
var shopModule = __webpack_require__(313);

// modules that is used acorss the whole site.
var inspirationModule = __webpack_require__(504); // required by shop.
var searchModule = __webpack_require__(516);
var authModule = __webpack_require__(30);
var orderModule = __webpack_require__(533);
var fulfilmentModule = __webpack_require__(570);

// Aplication declaration.
angular.module('wowApp', [olyCommonModule, wowCommonModule, shopModule, inspirationModule, searchModule, authModule, fulfilmentModule, orderModule, uiRouter, ocLazyLoad, 'restangular']);

// Application configuration.
__webpack_require__(607);

/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.9
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
(function (angular, window) {
    'use strict';

    var regModules = ['ng', 'oc.lazyLoad'],
        regInvokes = {},
        regConfigs = [],
        modulesToLoad = [],
        // modules to load from angular.module or other sources
    realModules = [],
        // real modules called from angular.module
    recordDeclarations = [],
        broadcast = angular.noop,
        runBlocks = {},
        justLoaded = [];

    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);

    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
        var modules = {},
            providers = {
            $controllerProvider: $controllerProvider,
            $compileProvider: $compileProvider,
            $filterProvider: $filterProvider,
            $provide: $provide, // other things (constant, decorator, provider, factory, service)
            $injector: $injector,
            $animateProvider: $animateProvider
        },
            debug = false,
            events = false,
            moduleCache = [],
            modulePromises = {};

        moduleCache.push = function (value) {
            if (this.indexOf(value) === -1) {
                Array.prototype.push.apply(this, arguments);
            }
        };

        this.config = function (config) {
            // If we want to define modules configs
            if (angular.isDefined(config.modules)) {
                if (angular.isArray(config.modules)) {
                    angular.forEach(config.modules, function (moduleConfig) {
                        modules[moduleConfig.name] = moduleConfig;
                    });
                } else {
                    modules[config.modules.name] = config.modules;
                }
            }

            if (angular.isDefined(config.debug)) {
                debug = config.debug;
            }

            if (angular.isDefined(config.events)) {
                events = config.events;
            }
        };

        /**
         * Get the list of existing registered modules
         * @param element
         */
        this._init = function _init(element) {
            // this is probably useless now because we override angular.bootstrap
            if (modulesToLoad.length === 0) {
                var elements = [element],
                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
                    append = function append(elm) {
                    return elm && elements.push(elm);
                };

                angular.forEach(names, function (name) {
                    names[name] = true;
                    append(document.getElementById(name));
                    name = name.replace(':', '\\:');
                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
                        angular.forEach(element[0].querySelectorAll('.' + name), append);
                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
                    }
                });

                angular.forEach(elements, function (elm) {
                    if (modulesToLoad.length === 0) {
                        var className = ' ' + element.className + ' ';
                        var match = NG_APP_CLASS_REGEXP.exec(className);
                        if (match) {
                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
                        } else {
                            angular.forEach(elm.attributes, function (attr) {
                                if (modulesToLoad.length === 0 && names[attr.name]) {
                                    modulesToLoad.push(attr.value);
                                }
                            });
                        }
                    }
                });
            }

            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
            }

            var addReg = function addReg(moduleName) {
                if (regModules.indexOf(moduleName) === -1) {
                    // register existing modules
                    regModules.push(moduleName);
                    var mainModule = angular.module(moduleName);

                    // register existing components (directives, services, ...)
                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+

                    angular.forEach(mainModule.requires, addReg);
                }
            };

            angular.forEach(modulesToLoad, function (moduleName) {
                addReg(moduleName);
            });

            modulesToLoad = []; // reset for next bootstrap
            recordDeclarations.pop(); // wait for the next lazy load
        };

        /**
         * Like JSON.stringify but that doesn't throw on circular references
         * @param obj
         */
        var stringify = function stringify(obj) {
            try {
                return JSON.stringify(obj);
            } catch (e) {
                var cache = [];
                return JSON.stringify(obj, function (key, value) {
                    if (angular.isObject(value) && value !== null) {
                        if (cache.indexOf(value) !== -1) {
                            // Circular reference found, discard key
                            return;
                        }
                        // Store value in our collection
                        cache.push(value);
                    }
                    return value;
                });
            }
        };

        var hashCode = function hashCode(str) {
            var hash = 0,
                i,
                chr,
                len;
            if (str.length == 0) {
                return hash;
            }
            for (i = 0, len = str.length; i < len; i++) {
                chr = str.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        function _register(providers, registerModules, params) {
            if (registerModules) {
                var k,
                    moduleName,
                    moduleFn,
                    tempRunBlocks = [];
                for (k = registerModules.length - 1; k >= 0; k--) {
                    moduleName = registerModules[k];
                    if (!angular.isString(moduleName)) {
                        moduleName = getModuleName(moduleName);
                    }
                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
                        continue;
                    }
                    // new if not registered
                    var newModule = regModules.indexOf(moduleName) === -1;
                    moduleFn = ngModuleFct(moduleName);
                    if (newModule) {
                        regModules.push(moduleName);
                        _register(providers, moduleFn.requires, params);
                    }
                    if (moduleFn._runBlocks.length > 0) {
                        // new run blocks detected! Replace the old ones (if existing)
                        runBlocks[moduleName] = [];
                        while (moduleFn._runBlocks.length > 0) {
                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
                        }
                    }
                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
                    }
                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
                    registerModules.pop();
                    justLoaded.push(moduleName);
                }
                // execute the run blocks at the end
                var instanceInjector = providers.getInstanceInjector();
                angular.forEach(tempRunBlocks, function (fn) {
                    instanceInjector.invoke(fn);
                });
            }
        }

        function _registerInvokeList(args, moduleName) {
            var invokeList = args[2][0],
                type = args[1],
                newInvoke = false;
            if (angular.isUndefined(regInvokes[moduleName])) {
                regInvokes[moduleName] = {};
            }
            if (angular.isUndefined(regInvokes[moduleName][type])) {
                regInvokes[moduleName][type] = {};
            }
            var onInvoke = function onInvoke(invokeName, invoke) {
                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
                    regInvokes[moduleName][type][invokeName] = [];
                }
                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
                    newInvoke = true;
                    regInvokes[moduleName][type][invokeName].push(invoke);
                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
                }
            };

            function checkHashes(potentialNew, invokes) {
                var isNew = true,
                    newHash;
                if (invokes.length) {
                    newHash = signature(potentialNew);
                    angular.forEach(invokes, function (invoke) {
                        isNew = isNew && signature(invoke) !== newHash;
                    });
                }
                return isNew;
            }

            function signature(data) {
                if (angular.isArray(data)) {
                    // arrays are objects, we need to test for it first
                    return hashCode(data.toString());
                } else if (angular.isObject(data)) {
                    // constants & values for example
                    return hashCode(stringify(data));
                } else {
                    if (angular.isDefined(data) && data !== null) {
                        return hashCode(data.toString());
                    } else {
                        // null & undefined constants
                        return data;
                    }
                }
            }

            if (angular.isString(invokeList)) {
                onInvoke(invokeList, args[2][1]);
            } else if (angular.isObject(invokeList)) {
                angular.forEach(invokeList, function (invoke, key) {
                    if (angular.isString(invoke)) {
                        // decorators for example
                        onInvoke(invoke, invokeList[1]);
                    } else {
                        // components registered as object lists {"componentName": function() {}}
                        onInvoke(key, invoke);
                    }
                });
            } else {
                return false;
            }
            return newInvoke;
        }

        function _invokeQueue(providers, queue, moduleName, reconfig) {
            if (!queue) {
                return;
            }

            var i, len, args, provider;
            for (i = 0, len = queue.length; i < len; i++) {
                args = queue[i];
                if (angular.isArray(args)) {
                    if (providers !== null) {
                        if (providers.hasOwnProperty(args[0])) {
                            provider = providers[args[0]];
                        } else {
                            throw new Error('unsupported provider ' + args[0]);
                        }
                    }
                    var isNew = _registerInvokeList(args, moduleName);
                    if (args[1] !== 'invoke') {
                        if (isNew && angular.isDefined(provider)) {
                            provider[args[1]].apply(provider, args[2]);
                        }
                    } else {
                        // config block
                        var callInvoke = function callInvoke(fct) {
                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
                            if (invoked === -1 || reconfig) {
                                if (invoked === -1) {
                                    regConfigs.push(moduleName + '-' + fct);
                                }
                                if (angular.isDefined(provider)) {
                                    provider[args[1]].apply(provider, args[2]);
                                }
                            }
                        };
                        if (angular.isFunction(args[2][0])) {
                            callInvoke(args[2][0]);
                        } else if (angular.isArray(args[2][0])) {
                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
                                if (angular.isFunction(args[2][0][j])) {
                                    callInvoke(args[2][0][j]);
                                }
                            }
                        }
                    }
                }
            }
        }

        function getModuleName(module) {
            var moduleName = null;
            if (angular.isString(module)) {
                moduleName = module;
            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
                moduleName = module.name;
            }
            return moduleName;
        }

        function moduleExists(moduleName) {
            if (!angular.isString(moduleName)) {
                return false;
            }
            try {
                return ngModuleFct(moduleName);
            } catch (e) {
                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                    return false;
                }
            }
        }

        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
            var instanceInjector,
                filesCache = $cacheFactory('ocLazyLoad');

            if (!debug) {
                $log = {};
                $log['error'] = angular.noop;
                $log['warn'] = angular.noop;
                $log['info'] = angular.noop;
            }

            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
            providers.getInstanceInjector = function () {
                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
            };

            broadcast = function broadcast(eventName, params) {
                if (events) {
                    $rootScope.$broadcast(eventName, params);
                }
                if (debug) {
                    $log.info(eventName, params);
                }
            };

            function reject(e) {
                var deferred = $q.defer();
                $log.error(e.message);
                deferred.reject(e);
                return deferred.promise;
            }

            return {
                _broadcast: broadcast,

                _$log: $log,

                /**
                 * Returns the files cache used by the loaders to store the files currently loading
                 * @returns {*}
                 */
                _getFilesCache: function getFilesCache() {
                    return filesCache;
                },

                /**
                 * Let the service know that it should monitor angular.module because files are loading
                 * @param watch boolean
                 */
                toggleWatch: function toggleWatch(watch) {
                    if (watch) {
                        recordDeclarations.push(true);
                    } else {
                        recordDeclarations.pop();
                    }
                },

                /**
                 * Let you get a module config object
                 * @param moduleName String the name of the module
                 * @returns {*}
                 */
                getModuleConfig: function getModuleConfig(moduleName) {
                    if (!angular.isString(moduleName)) {
                        throw new Error('You need to give the name of the module to get');
                    }
                    if (!modules[moduleName]) {
                        return null;
                    }
                    return angular.copy(modules[moduleName]);
                },

                /**
                 * Let you define a module config object
                 * @param moduleConfig Object the module config object
                 * @returns {*}
                 */
                setModuleConfig: function setModuleConfig(moduleConfig) {
                    if (!angular.isObject(moduleConfig)) {
                        throw new Error('You need to give the module config object to set');
                    }
                    modules[moduleConfig.name] = moduleConfig;
                    return moduleConfig;
                },

                /**
                 * Returns the list of loaded modules
                 * @returns {string[]}
                 */
                getModules: function getModules() {
                    return regModules;
                },

                /**
                 * Let you check if a module has been loaded into Angular or not
                 * @param modulesNames String/Object a module name, or a list of module names
                 * @returns {boolean}
                 */
                isLoaded: function isLoaded(modulesNames) {
                    var moduleLoaded = function moduleLoaded(module) {
                        var isLoaded = regModules.indexOf(module) > -1;
                        if (!isLoaded) {
                            isLoaded = !!moduleExists(module);
                        }
                        return isLoaded;
                    };
                    if (angular.isString(modulesNames)) {
                        modulesNames = [modulesNames];
                    }
                    if (angular.isArray(modulesNames)) {
                        var i, len;
                        for (i = 0, len = modulesNames.length; i < len; i++) {
                            if (!moduleLoaded(modulesNames[i])) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        throw new Error('You need to define the module(s) name(s)');
                    }
                },

                /**
                 * Given a module, return its name
                 * @param module
                 * @returns {String}
                 */
                _getModuleName: getModuleName,

                /**
                 * Returns a module if it exists
                 * @param moduleName
                 * @returns {module}
                 */
                _getModule: function getModule(moduleName) {
                    try {
                        return ngModuleFct(moduleName);
                    } catch (e) {
                        // this error message really suxx
                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
                        }
                        throw e;
                    }
                },

                /**
                 * Check if a module exists and returns it if it does
                 * @param moduleName
                 * @returns {boolean}
                 */
                moduleExists: moduleExists,

                /**
                 * Load the dependencies, and might try to load new files depending on the config
                 * @param moduleName (String or Array of Strings)
                 * @param localParams
                 * @returns {*}
                 * @private
                 */
                _loadDependencies: function _loadDependencies(moduleName, localParams) {
                    var loadedModule,
                        requires,
                        diff,
                        promisesList = [],
                        self = this;

                    moduleName = self._getModuleName(moduleName);

                    if (moduleName === null) {
                        return $q.when();
                    } else {
                        try {
                            loadedModule = self._getModule(moduleName);
                        } catch (e) {
                            return reject(e);
                        }
                        // get unloaded requires
                        requires = self.getRequires(loadedModule);
                    }

                    angular.forEach(requires, function (requireEntry) {
                        // If no configuration is provided, try and find one from a previous load.
                        // If there isn't one, bail and let the normal flow run
                        if (angular.isString(requireEntry)) {
                            var config = self.getModuleConfig(requireEntry);
                            if (config === null) {
                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                                return;
                            }
                            requireEntry = config;
                            // ignore the name because it's probably not a real module name
                            config.name = undefined;
                        }

                        // Check if this dependency has been loaded previously
                        if (self.moduleExists(requireEntry.name)) {
                            // compare against the already loaded module to see if the new definition adds any new files
                            diff = requireEntry.files.filter(function (n) {
                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                            });

                            // If the module was redefined, advise via the console
                            if (diff.length !== 0) {
                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                            }

                            // Push everything to the file loader, it will weed out the duplicates.
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                            return;
                        } else if (angular.isArray(requireEntry)) {
                            var files = [];
                            angular.forEach(requireEntry, function (entry) {
                                // let's check if the entry is a file name or a config name
                                var config = self.getModuleConfig(entry);
                                if (config === null) {
                                    files.push(entry);
                                } else if (config.files) {
                                    files = files.concat(config.files);
                                }
                            });
                            if (files.length > 0) {
                                requireEntry = {
                                    files: files
                                };
                            }
                        } else if (angular.isObject(requireEntry)) {
                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                                self.setModuleConfig(requireEntry);
                                moduleCache.push(requireEntry['name']);
                            }
                        }

                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                        }
                    });

                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
                    return $q.all(promisesList);
                },

                /**
                 * Inject new modules into Angular
                 * @param moduleName
                 * @param localParams
                 * @param real
                 */
                inject: function inject(moduleName) {
                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

                    var self = this,
                        deferred = $q.defer();
                    if (angular.isDefined(moduleName) && moduleName !== null) {
                        if (angular.isArray(moduleName)) {
                            var promisesList = [];
                            angular.forEach(moduleName, function (module) {
                                promisesList.push(self.inject(module, localParams, real));
                            });
                            return $q.all(promisesList);
                        } else {
                            self._addToLoadList(self._getModuleName(moduleName), true, real);
                        }
                    }
                    if (modulesToLoad.length > 0) {
                        var res = modulesToLoad.slice(); // clean copy
                        var loadNext = function loadNext(moduleName) {
                            moduleCache.push(moduleName);
                            modulePromises[moduleName] = deferred.promise;
                            self._loadDependencies(moduleName, localParams).then(function success() {
                                try {
                                    justLoaded = [];
                                    _register(providers, moduleCache, localParams);
                                } catch (e) {
                                    self._$log.error(e.message);
                                    deferred.reject(e);
                                    return;
                                }

                                if (modulesToLoad.length > 0) {
                                    loadNext(modulesToLoad.shift()); // load the next in list
                                } else {
                                        deferred.resolve(res); // everything has been loaded, resolve
                                    }
                            }, function error(err) {
                                deferred.reject(err);
                            });
                        };

                        // load the first in list
                        loadNext(modulesToLoad.shift());
                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
                        return modulePromises[localParams.name];
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                },

                /**
                 * Get the list of required modules/services/... for this module
                 * @param module
                 * @returns {Array}
                 */
                getRequires: function getRequires(module) {
                    var requires = [];
                    angular.forEach(module.requires, function (requireModule) {
                        if (regModules.indexOf(requireModule) === -1) {
                            requires.push(requireModule);
                        }
                    });
                    return requires;
                },

                /**
                 * Invoke the new modules & component by their providers
                 * @param providers
                 * @param queue
                 * @param moduleName
                 * @param reconfig
                 * @private
                 */
                _invokeQueue: _invokeQueue,

                /**
                 * Check if a module has been invoked and registers it if not
                 * @param args
                 * @param moduleName
                 * @returns {boolean} is new
                 */
                _registerInvokeList: _registerInvokeList,

                /**
                 * Register a new module and loads it, executing the run/config blocks if needed
                 * @param providers
                 * @param registerModules
                 * @param params
                 * @private
                 */
                _register: _register,

                /**
                 * Add a module name to the list of modules that will be loaded in the next inject
                 * @param name
                 * @param force
                 * @private
                 */
                _addToLoadList: _addToLoadList,

                /**
                 * Unregister modules (you shouldn't have to use this)
                 * @param modules
                 */
                _unregister: function _unregister(modules) {
                    if (angular.isDefined(modules)) {
                        if (angular.isArray(modules)) {
                            angular.forEach(modules, function (module) {
                                regInvokes[module] = undefined;
                            });
                        }
                    }
                }
            };
        }];

        // Let's get the list of loaded modules & components
        this._init(angular.element(window.document));
    }]);

    var bootstrapFct = angular.bootstrap;
    angular.bootstrap = function (element, modules, config) {
        // we use slice to make a clean copy
        angular.forEach(modules.slice(), function (module) {
            _addToLoadList(module, true, true);
        });
        return bootstrapFct(element, modules, config);
    };

    var _addToLoadList = function _addToLoadList(name, force, real) {
        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
            modulesToLoad.push(name);
            if (real) {
                realModules.push(name);
            }
        }
    };

    var ngModuleFct = angular.module;
    angular.module = function (name, requires, configFn) {
        _addToLoadList(name, false, true);
        return ngModuleFct(name, requires, configFn);
    };

    // CommonJS package manager support:
    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
        module.exports = 'oc.lazyLoad';
    }
})(angular, window);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 1000,
            compile: function compile(element, attrs) {
                // we store the content and remove it before compilation
                var content = element[0].innerHTML;
                element.html('');

                return function ($scope, $element, $attr) {
                    var model = $parse($attr.ocLazyLoad);
                    $scope.$watch(function () {
                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
                    }, function (moduleName) {
                        if (angular.isDefined(moduleName)) {
                            $ocLazyLoad.load(moduleName).then(function () {
                                // Attach element contents to DOM and then compile them.
                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                                // of the compiled contents when attaching to the parent DOM.
                                $animate.enter(content, $element);
                                // get the new content & compile it
                                $compile($element.contents())($scope);
                            });
                        }
                    }, true);
                };
            }
        };
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
            var uaCssChecked = false,
                useCssLoadPatch = false,
                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];

            /**
             * Load a js/css file
             * @param type
             * @param path
             * @param params
             * @returns promise
             */
            $delegate.buildElement = function buildElement(type, path, params) {
                var deferred = $q.defer(),
                    el,
                    loaded,
                    filesCache = $delegate._getFilesCache(),
                    cacheBuster = function cacheBuster(url) {
                    var dc = new Date().getTime();
                    if (url.indexOf('?') >= 0) {
                        if (url.substring(0, url.length - 1) === '&') {
                            return url + '_dc=' + dc;
                        }
                        return url + '&_dc=' + dc;
                    } else {
                        return url + '?_dc=' + dc;
                    }
                };

                // Store the promise early so the file load can be detected by other parallel lazy loads
                // (ie: multiple routes on one page) a 'true' value isn't sufficient
                // as it causes false positive load results.
                if (angular.isUndefined(filesCache.get(path))) {
                    filesCache.put(path, deferred.promise);
                }

                // Switch in case more content types are added later
                switch (type) {
                    case 'css':
                        el = $window.document.createElement('link');
                        el.type = 'text/css';
                        el.rel = 'stylesheet';
                        el.href = params.cache === false ? cacheBuster(path) : path;
                        break;
                    case 'js':
                        el = $window.document.createElement('script');
                        el.src = params.cache === false ? cacheBuster(path) : path;
                        break;
                    default:
                        filesCache.remove(path);
                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
                        break;
                }
                el.onload = el['onreadystatechange'] = function (e) {
                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
                    el.onload = el['onreadystatechange'] = null;
                    loaded = 1;
                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
                    deferred.resolve();
                };
                el.onerror = function () {
                    filesCache.remove(path);
                    deferred.reject(new Error('Unable to load ' + path));
                };
                el.async = params.serie ? 0 : 1;

                var insertBeforeElem = anchor.lastChild;
                if (params.insertBefore) {
                    var element = angular.element(angular.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
                    if (element && element.length > 0) {
                        insertBeforeElem = element[0];
                    }
                }
                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);

                /*
                 The event load or readystatechange doesn't fire in:
                 - iOS < 6       (default mobile browser)
                 - Android < 4.4 (default mobile browser)
                 - Safari < 6    (desktop browser)
                 */
                if (type == 'css') {
                    if (!uaCssChecked) {
                        var ua = $window.navigator.userAgent.toLowerCase();

                        // iOS < 6
                        if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
                            useCssLoadPatch = iOSVersion < 6;
                        } else if (ua.indexOf("android") > -1) {
                            // Android < 4.4
                            var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
                            useCssLoadPatch = androidVersion < 4.4;
                        } else if (ua.indexOf('safari') > -1) {
                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
                        }
                    }

                    if (useCssLoadPatch) {
                        var tries = 1000; // * 20 = 20000 miliseconds
                        var interval = $interval(function () {
                            try {
                                el.sheet.cssRules;
                                $interval.cancel(interval);
                                el.onload();
                            } catch (e) {
                                if (--tries <= 0) {
                                    el.onerror();
                                }
                            }
                        }, 20);
                    }
                }

                return deferred.promise;
            };

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * The function that loads new files
             * @param config
             * @param params
             * @returns {*}
             */
            $delegate.filesLoader = function filesLoader(config) {
                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var cssFiles = [],
                    templatesFiles = [],
                    jsFiles = [],
                    promises = [],
                    cachePromise = null,
                    filesCache = $delegate._getFilesCache();

                $delegate.toggleWatch(true); // start watching angular.module calls

                angular.extend(params, config);

                var pushFile = function pushFile(path) {
                    var file_type = null,
                        m;
                    if (angular.isObject(path)) {
                        file_type = path.type;
                        path = path.path;
                    }
                    cachePromise = filesCache.get(path);
                    if (angular.isUndefined(cachePromise) || params.cache === false) {

                        // always check for requirejs syntax just in case
                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
                            // Detect file type using preceding type declaration (ala requireJS)
                            file_type = m[1];
                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
                        }

                        if (!file_type) {
                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
                                // Detect file type via file extension
                                file_type = m[1];
                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
                                // requirejs
                                file_type = 'js';
                            } else {
                                $delegate._$log.error('File type could not be determined. ' + path);
                                return;
                            }
                        }

                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
                            cssFiles.push(path);
                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
                            templatesFiles.push(path);
                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
                            jsFiles.push(path);
                        } else {
                            $delegate._$log.error('File type is not valid. ' + path);
                        }
                    } else if (cachePromise) {
                        promises.push(cachePromise);
                    }
                };

                if (params.serie) {
                    pushFile(params.files.shift());
                } else {
                    angular.forEach(params.files, function (path) {
                        pushFile(path);
                    });
                }

                if (cssFiles.length > 0) {
                    var cssDeferred = $q.defer();
                    $delegate.cssLoader(cssFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            cssDeferred.reject(err);
                        } else {
                            cssDeferred.resolve();
                        }
                    }, params);
                    promises.push(cssDeferred.promise);
                }

                if (templatesFiles.length > 0) {
                    var templatesDeferred = $q.defer();
                    $delegate.templatesLoader(templatesFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            templatesDeferred.reject(err);
                        } else {
                            templatesDeferred.resolve();
                        }
                    }, params);
                    promises.push(templatesDeferred.promise);
                }

                if (jsFiles.length > 0) {
                    var jsDeferred = $q.defer();
                    $delegate.jsLoader(jsFiles, function (err) {
                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
                            $delegate._$log.error(err);
                            jsDeferred.reject(err);
                        } else {
                            jsDeferred.resolve();
                        }
                    }, params);
                    promises.push(jsDeferred.promise);
                }

                if (promises.length === 0) {
                    var deferred = $q.defer(),
                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
                    $delegate._$log.error(err);
                    deferred.reject(err);
                    return deferred.promise;
                } else if (params.serie && params.files.length > 0) {
                    return $q.all(promises).then(function () {
                        return $delegate.filesLoader(config, params);
                    });
                } else {
                    return $q.all(promises)['finally'](function (res) {
                        $delegate.toggleWatch(false); // stop watching angular.module calls
                        return res;
                    });
                }
            };

            /**
             * Load a module or a list of modules into Angular
             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
             * @param params Object optional parameters
             * @returns promise
             */
            $delegate.load = function (originalModule) {
                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var self = this,
                    config = null,
                    deferredList = [],
                    deferred = $q.defer(),
                    errText;

                // clean copy
                var module = angular.copy(originalModule);
                var params = angular.copy(originalParams);

                // If module is an array, break it down
                if (angular.isArray(module)) {
                    // Resubmit each entry as a single module
                    angular.forEach(module, function (m) {
                        deferredList.push(self.load(m, params));
                    });

                    // Resolve the promise once everything has loaded
                    $q.all(deferredList).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });

                    return deferred.promise;
                }

                // Get or Set a configuration depending on what was passed in
                if (angular.isString(module)) {
                    config = self.getModuleConfig(module);
                    if (!config) {
                        config = {
                            files: [module]
                        };
                    }
                } else if (angular.isObject(module)) {
                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
                        config = {
                            files: [module]
                        };
                    } else {
                        config = self.setModuleConfig(module);
                    }
                }

                if (config === null) {
                    var moduleName = self._getModuleName(module);
                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
                    $delegate._$log.error(errText);
                    deferred.reject(new Error(errText));
                    return deferred.promise;
                } else {
                    // deprecated
                    if (angular.isDefined(config.template)) {
                        if (angular.isUndefined(config.files)) {
                            config.files = [];
                        }
                        if (angular.isString(config.template)) {
                            config.files.push(config.template);
                        } else if (angular.isArray(config.template)) {
                            config.files.concat(config.template);
                        }
                    }
                }

                var localParams = angular.extend({}, params, config);

                // if someone used an external loader and called the load function with just the module name
                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
                    return $delegate.inject(config.name, localParams, true);
                }

                $delegate.filesLoader(config, localParams).then(function () {
                    $delegate.inject(null, localParams).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            // return the patched service
            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * cssLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite cssLoader and it will probably not use promises :(
             */
            $delegate.cssLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('css', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.cssLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * jsLoader function
             * @type Function
             * @param paths array list of js files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite jsLoader and it will probably not use promises :(
             */
            $delegate.jsLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('js', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.jsLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
            /**
             * templatesLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters for $http
             * because the user can overwrite templatesLoader and it will probably not use promises :(
             */
            $delegate.templatesLoader = function (paths, callback, params) {
                var promises = [],
                    filesCache = $delegate._getFilesCache();

                angular.forEach(paths, function (url) {
                    var deferred = $q.defer();
                    promises.push(deferred.promise);
                    $http.get(url, params).success(function (data) {
                        if (angular.isString(data) && data.length > 0) {
                            angular.forEach(angular.element(data), function (node) {
                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
                                    $templateCache.put(node.id, node.innerHTML);
                                }
                            });
                        }
                        if (angular.isUndefined(filesCache.get(url))) {
                            filesCache.put(url, true);
                        }
                        deferred.resolve();
                    }).error(function (err) {
                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + err));
                    });
                });
                return $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.templatesLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
// Array.indexOf polyfill for IE8
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var k;

        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var ngAnimate = __webpack_require__(27);
var ngMessages = __webpack_require__(9);
var ngSanitize = __webpack_require__(17);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars
var olyDialog = __webpack_require__(13);

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(4);
var recipeModule = __webpack_require__(314);

var shopModuleName = 'wowApp.shop';

angular.module(shopModuleName, [olyCommonModule, wowCommonModule, recipeModule, ngAnimate, ngMessages, ngSanitize, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(342);
__webpack_require__(345);
__webpack_require__(349);
__webpack_require__(353);
__webpack_require__(385);
__webpack_require__(390);
__webpack_require__(395);
__webpack_require__(416);
__webpack_require__(421);
__webpack_require__(428);
__webpack_require__(430);
__webpack_require__(434);
__webpack_require__(449);
__webpack_require__(452);
__webpack_require__(455);
__webpack_require__(463);
__webpack_require__(472);
__webpack_require__(476);
__webpack_require__(479);
__webpack_require__(496);
__webpack_require__(499);

module.exports = shopModuleName;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var ngMessages = __webpack_require__(9);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars
var olyDialog = __webpack_require__(13);

var olyCommonModule = __webpack_require__(4);
var wowCommonModule = __webpack_require__(5);

var _require = __webpack_require__(315),
    recipeTileListComponentDefinition = _require.recipeTileListComponentDefinition;

var _require2 = __webpack_require__(316),
    recipeListTileListComponentDefinition = _require2.recipeListTileListComponentDefinition;

var recipeModuleName = 'wowApp.recipe';

angular.module(recipeModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular', olyDialog]).service('RecipeCategoriesService', ['Restangular', '$q', 'BootstrapService', __webpack_require__(317)]).service('RecipeService', ['Restangular', '$templateCache', 'BreakpointsService', __webpack_require__(318)]).service('RecipeListsService', ['Restangular', __webpack_require__(322)]).component('wowRecipeTileList', recipeTileListComponentDefinition).component('wowRecipeListTileList', recipeListTileListComponentDefinition).directive('wowRecipeSavedListNavigation', ['$state', 'RecipeListsService', 'ShopperService', __webpack_require__(323)]).component('wowRecipePrint', __webpack_require__(325).recipePrintComponentDefinition).component('wowRecipeTile', __webpack_require__(327).recipeTileControllerComponentDefinition).component('wowRecipeSaveToList', __webpack_require__(329).recipeSaveToListComponentDefinition).component('wowRecipeNavigation', __webpack_require__(331).recipeNavigationComponentDefinition).component('wowRecipeDetail', __webpack_require__(333).recipeDetailComponentDefinition).component('wowRecipeDetailVideo', __webpack_require__(336).recipeDetailVideoComponentDefinition).component('wowRecipeExportOptions', __webpack_require__(338).recipeDetailExportOptionsComponentDefinition).component('wowRecipeEmailForm', __webpack_require__(340).recipeDetailFormComponentDefinition);

module.exports = recipeModuleName;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(21),
    createRecipeTiles = _require.createRecipeTiles;

var RecipeTileListController = function () {
    function RecipeTileListController(settings, recipeService, sortByKeys) {
        _classCallCheck(this, RecipeTileListController);

        this.settings = settings;
        this.recipeService = recipeService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(RecipeTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.recipeService.getRecipes(this.currentCategory.aisle.ID, pageSize, pageNumber, sortType).then(function (tiles) {
                return _this.createTiles(tiles);
            });
        }
    }]);

    return RecipeTileListController;
}();

RecipeTileListController.$inject = ['Settings', 'RecipeService', 'SortByKeys'];

var recipeTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: RecipeTileListController,
    template: '\n        <wow-tile-list\n            list-title="::$ctrl.currentCategory.aisle.Name"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    RecipeTileListController: RecipeTileListController,
    recipeTileListComponentDefinition: recipeTileListComponentDefinition
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(21),
    createRecipeTiles = _require.createRecipeTiles;

var RecipeListTileListController = function () {
    function RecipeListTileListController(settings, recipeListsService, sortByKeys) {
        _classCallCheck(this, RecipeListTileListController);

        this.settings = settings;
        this.recipeListsService = recipeListsService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(RecipeListTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.recipeListsService.getSavedRecipes(pageSize, pageNumber, sortType).then(function (tiles) {
                return _this.createTiles(tiles);
            });
        }
    }]);

    return RecipeListTileListController;
}();

RecipeListTileListController.$inject = ['Settings', 'RecipeListsService', 'SortByKeys'];

var recipeListTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: RecipeListTileListController,
    template: '\n        <wow-tile-list\n            list-title="::\'My Favourite Recipes\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    RecipeListTileListController: RecipeListTileListController,
    recipeListTileListComponentDefinition: recipeListTileListComponentDefinition
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var RecipeCategoriesService = function () {
    function RecipeCategoriesService(restangular, $q, bootstrap) {
        _classCallCheck(this, RecipeCategoriesService);

        this.$q = $q;

        this._api = restangular.all('recipeCategories');

        this.categories = [];
        this.currentCategory = {};

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.RecipeCategories)) {
            this.setAll(bootstrap.getBootstrappedData(bootstrap.bootstrapped.RecipeCategories));
        }
    }

    _createClass(RecipeCategoriesService, [{
        key: 'getAll',
        value: function getAll() {
            if (this.categories.length > 0) {
                return this.$q.when(this.categories);
            }

            return this._api.getList().then(this.setAll.bind(this));
        }
    }, {
        key: 'setAll',
        value: function setAll(categories) {
            this.categories = categories;
            this.resetCurrentCategory();

            return categories;
        }
    }, {
        key: 'resetCurrentCategory',
        value: function resetCurrentCategory() {
            this.currentCategory = {};
        }
    }, {
        key: 'setCategoryByName',
        value: function setCategoryByName(aisleName, categoryName) {
            this.currentCategory = this.getCategoryByName(aisleName, categoryName);
        }
    }, {
        key: 'getCategoryByName',
        value: function getCategoryByName(aisleName, categoryName) {
            var department = _.find(this.categories, function (category) {
                return category.UrlFriendlyName === aisleName;
            });
            var aisle = department ? _.find(department.ChildCategories, function (childCategory) {
                return childCategory.UrlFriendlyName === categoryName;
            }) : {};

            return {
                department: department || {},
                aisle: aisle
            };
        }
    }, {
        key: 'hasCurrentCategory',
        value: function hasCurrentCategory() {
            return !!(this.currentCategory && this.currentCategory.aisle && this.currentCategory.department);
        }
    }]);

    return RecipeCategoriesService;
}();

module.exports = RecipeCategoriesService;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1),
    templates = __webpack_require__(319);

var RecipeService = function () {
    function RecipeService(restangular, $templateCache, _breakpointsService) {
        _classCallCheck(this, RecipeService);

        this.breakpointsService = _breakpointsService;

        this._api = restangular.one('recipes');
        _.forEach(templates, function (template) {
            $templateCache.put(template.id, template.content);
        });

        this.recipeDetailsCache = {};
    }

    _createClass(RecipeService, [{
        key: 'getRecipes',
        value: function getRecipes(recipeCategoryId, pageSize, pageNumber, sortType) {
            return this._api.get({
                recipeCategoryId: recipeCategoryId,
                pageSize: pageSize,
                pageNumber: pageNumber,
                sortType: sortType
            }).then(function (response) {
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount
                };
            });
        }
    }, {
        key: 'getRecipe',
        value: function getRecipe(recipeId) {
            if (!(recipeId in this.recipeDetailsCache)) {
                this.recipeDetailsCache[recipeId] = this._api.one('', recipeId).get();
            }

            return this.recipeDetailsCache[recipeId];
        }
    }, {
        key: 'emailRecipe',
        value: function emailRecipe(recipeUrl, recipientAddress, userEmail, message, sendCopy) {
            return this._api.post('email', {
                recipeUrl: recipeUrl,
                toAddress: recipientAddress,
                from: userEmail,
                message: message,
                sendCopy: sendCopy
            });
        }
    }]);

    return RecipeService;
}();

module.exports = RecipeService;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
    id: 'Default',
    content: __webpack_require__(320).trim()
}, {
    id: 'Jamie_Oliver',
    content: __webpack_require__(321).trim()
}];

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeDetail-image\"\r\n    ng-style=\"{'background-image': 'url(' + ($ctrl.breakpointsService.isInSmallFormat ? $ctrl.recipe.MediumImageFilename : $ctrl.recipe.LargeImageFilename) + ')'}\">\r\n    <meta itemprop=\"image\" content=\"https://{{::($ctrl.$location.host() + $ctrl.recipe.ImageFilename)}}\"></meta>\r\n    <meta itemprop=\"description\" content=\"{{::$ctrl.recipe.Description}}\"></meta>\r\n</div>\r\n"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "<!--Jamie's recipe header-->\r\n<div class=\"recipeDetail-jamieSubHeader\">\r\n    <img class=\"recipeDetail-jamieSubHeaderImage\" alt=\"\"\r\n        ng-src=\"{{ $ctrl.breakpointsService.isInSmallFormat ? $ctrl.recipe.MediumImageFilename : $ctrl.recipe.LargeImageFilename }}\"\r\n        itemprop=\"image\"\r\n        oly-error-src/>\r\n\r\n    <div class=\"recipeDetail-jamieSubHeaderContent\">\r\n        <h2 class=\"recipeDetail-jamieSubHeaderTitle hidden-xs\">\r\n            <span class=\"sr-only\"> Jamie's recipe </span>\r\n        </h2>\r\n\r\n        <div class=\"recipeDetail-jamieSubHeaderSubtitle\" ng-if=\"$ctrl.recipe.TextTip && $ctrl.recipe.TextTip.length > 0\">\r\n            <span class=\"sr-only\"> Jamie's tip </span>\r\n        </div>\r\n\r\n        <p class=\"recipeDetail-jamieSubHeaderDescription\" itemprop=\"description\">\r\n            {{ $ctrl.recipe.TextTip }}\r\n        </p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Private variables
var _api = void 0;

function RecipeListsService(restangular) {
    _api = restangular.all('recipes/lists');

    this.loadingCount = true;
}

RecipeListsService.prototype.getSavedRecipes = function (pageSize, pageNumber, sortType) {
    var _this = this;

    return _api.doGET('', {
        pageSize: pageSize,
        pageNumber: pageNumber,
        sortType: sortType
    }).then(function (response) {
        _this.loadingCount = false;
        _this.keptRecipesCount = response.TotalRecordCount;
        return {
            items: response.Items,
            totalRecordCount: response.TotalRecordCount
        };
    });
};

RecipeListsService.prototype.initialiseCountForGuestUser = function () {
    this.keptRecipesCount = 0;
    this.loadingCount = false;
};

RecipeListsService.prototype.removeSavedRecipe = function (recipeId) {
    var _this2 = this;

    // ideally this will be a delete verb but IIS6...
    return _api.doPOST({ Id: recipeId }).then(function () {
        _this2.keptRecipesCount--;
    });
};

RecipeListsService.prototype.saveRecipeToList = function (recipeId) {
    var _this3 = this;

    return _api.get(recipeId).then(function () {
        _this3.keptRecipesCount++;
    });
};

module.exports = RecipeListsService;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, recipeListsService, shopper) {
    return {
        restrict: 'E',
        scope: {},
        link: function link(scope) {
            scope.count = 0;

            function initialiseKeptRecipeCount() {
                return shopper.IsGuest ? recipeListsService.initialiseCountForGuestUser() : recipeListsService.getSavedRecipes(1, 1, 'Name');
            }

            // Populate the kept recipes count
            initialiseKeptRecipeCount();

            scope.$watch(function () {
                return recipeListsService.keptRecipesCount;
            }, function () {
                scope.count = recipeListsService.keptRecipesCount;

                scope.url = recipeListsService.keptRecipesCount > 0 ? $state.href('shop.recipes.savedList', null, { inherit: false }) : $state.href('shop.recipes.noSavedRecipes', null, { inherit: false });

                if (scope.count <= 0 && $state.includes('shop.recipes.savedList')) {
                    $state.go('shop.recipes.noSavedRecipes', null, { location: 'replace', inherit: false });
                }

                if (scope.count > 0 && $state.includes('shop.recipes.noSavedRecipes')) {
                    $state.go('shop.recipes.savedList', null, { location: 'replace', inherit: false });
                }
            });
        },

        template: __webpack_require__(324).trim()
    };
};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<a class=\"navigation-link\" ng-href=\"{{url}}\" ui-sref-active=\"is-active\">\r\n    <span>\r\n        My Favourite Recipes\r\n        <span ng-if=\"!recipeListsService.loadingCount\">({{count}})</span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"recipeListsService.loadingCount\"></wow-loading-spinner>\r\n    </span>\r\n</a>\r\n"

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipePrintController = function RecipePrintController($timeout) {
    _classCallCheck(this, RecipePrintController);

    $timeout(function () {
        return window.print();
    }, 0);
};

var recipePrintComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['$timeout', RecipePrintController],
    template: __webpack_require__(326).trim()
};

module.exports = {
    RecipePrintController: RecipePrintController,
    recipePrintComponentDefinition: recipePrintComponentDefinition
};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeprint recipeprint-wrapper\">\r\n\t<div class=\"recipeprint-container\">\r\n\t\t<img src=\"/images/globalheader/icon-wapple-full.png\" class=\"recipeprint-logo\" alt=\"\" />\r\n\r\n\t\t<div class=\"recipeprint-ingredients\">\r\n\t\t\t<h1 class=\"recipeprint-heading\">{{::$ctrl.recipe.Title}}</h1>\r\n\t\t\t<h3 class=\"recipeprint-subheading\">Ingredients</h3>\r\n\t\t\t<ul>\r\n\t\t\t\t<li ng-repeat=\"ingredient in $ctrl.recipe.Ingredients track by $index\" class=\"recipeprint-ingredient\">\r\n\t\t\t\t\t{{::ingredient.Description}}\r\n\t\t\t\t</li>\r\n\t\t\t</ul>\r\n\r\n\t\t</div>\r\n\t\t<div class=\"recipeprint-panel\">\r\n\t\t\t<figure class=\"recipeprint-panelMiddle\">\r\n\t\t\t\t<img ng-src=\"{{::$ctrl.recipe.SmallImageFilename}}\" alt=\"\" class=\"recipeprint-image\" />\r\n\t\t\t\t<figcaption>\r\n\t\t\t\t\t<span>{{::$ctrl.recipe.Description}}</span><span class=\"recipeprint-serving\">Servings: {{::$ctrl.recipe.Servings}}</span>\r\n\t\t\t\t</figcaption>\r\n\t\t\t</figure>\r\n\t\t</div>\r\n\t\t<div class=\"recipeprint-directions\">\r\n\t\t\t<h3 class=\"recipeprint-subheading\">Directions:</h3>\r\n\t\t\t<p ng-repeat=\"paragraph in ($ctrl.recipe.Instructions | paragraphize) track by $index\" class=\"u-capitalize-first-letter\">{{ (paragraph | sentenceCase).trim() }}</p>\r\n\t\t\t<div class=\"recipe-sent\" ng-if=\"$ctrl.recipe.ContributorName\">\r\n\t\t\t\tThis recipe was sent in by\r\n\t\t\t\t<a ng-href=\"{{::$ctrl.recipe.WebpageLink}}\" target=\"_blank\" ng-if=\"::$ctrl.recipe.WebpageLink\">{{::$ctrl.recipe.ContributorName}}</a>\r\n\t\t\t\t<strong class=\"author\" ng-if=\"::!$ctrl.recipe.WebpageLink\">{{::$ctrl.recipe.ContributorName}}</strong>\r\n\t\t\t\t<span ng-if=\"::$ctrl.recipe.ContributorTown\">of {{::$ctrl.recipe.ContributorTown}}</span>.\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>"

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeTileController = function () {
    function RecipeTileController() {
        _classCallCheck(this, RecipeTileController);
    }

    _createClass(RecipeTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isJamieRecipe = this.recipe.TemplateName.toLowerCase() !== 'default';
        }
    }]);

    return RecipeTileController;
}();

var recipeTileControllerComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: RecipeTileController,
    template: __webpack_require__(328).trim()
};

module.exports = {
    RecipeTileController: RecipeTileController,
    recipeTileControllerComponentDefinition: recipeTileControllerComponentDefinition
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeTile tile\" ng-class=\"::{ 'recipeTile--jamie': $ctrl.isJamieRecipe }\">\r\n    <div class=\"recipeTile-brandImageContainer\" ng-if=\"::$ctrl.isJamieRecipe\">\r\n        <img class=\"recipeTile-brandImage\" src=\"/images/recipedetails/jamiesRecipe.png\" alt=\"jamie oliver recipe\">\r\n    </div>\r\n\r\n    <a class=\"recipeTile-imageContainer\" ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\">\r\n        <img ng-src=\"{{ ::$ctrl.recipe.MediumImageFilename }}\" alt=\"\" class=\"recipeTile-image\" oly-error-src/>\r\n    </a>\r\n\r\n    <a class=\"recipeTile-header\" ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\">\r\n        {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}}\r\n    </a>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <div class=\"recipeTile-body\">\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.Servings\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.Servings}}</span> <span class=\"recipeTile-infoLabel\">Serves</span>\r\n        </div>\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.PreparationDuration && !$ctrl.isJamieRecipe\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.PreparationDuration}}</span><span class=\"recipeTile-infoLabel\">Mins prep</span>\r\n        </div>\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.CookingDuration && !$ctrl.isJamieRecipe\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.CookingDuration}}</span> <span class=\"recipeTile-infoLabel\">Mins cook</span>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"recipeTile-footer\">\r\n        <wow-recipe-save-to-list recipe=\"::$ctrl.recipe\" recipe-id=\"::$ctrl.recipe.ID\"></wow-recipe-save-to-list>\r\n        <a ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\" class=\"button recipeTile-button\">View recipe <i class=\"iconww-ArrowRight\"></i></a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeSaveToListController = function () {
    function RecipeSaveToListController(recipeListsService, moveFocus, $state, shopperService, loginService, sessionStorage) {
        _classCallCheck(this, RecipeSaveToListController);

        this.recipeListsService = recipeListsService;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
    }

    _createClass(RecipeSaveToListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.pendingSaveRecipeStorageKey = 'RecipeSaveToListController:savedRecipeBeforeLogin:' + this.recipe.ID;

            var savedRecipeBeforeLogin = this.sessionStorage.getJsonAndRemove(this.pendingSaveRecipeStorageKey);

            if (!this.shopperService.IsGuest && savedRecipeBeforeLogin === this.recipe.ID) {
                this.saveRecipe(savedRecipeBeforeLogin);
            }
        }
    }, {
        key: 'saveRecipe',
        value: function saveRecipe() {
            var _this = this;

            var recipeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.recipe.ID;

            this.recipeListsService.saveRecipeToList(recipeId).then(function () {
                _this.recipe.IsFavouriteRecipe = true;
                _this.srMessage = _this.recipe.Title + ' saved to my favourite recipes';
                _this.moveFocus('#recipe-recipeSaveToList-' + recipeId);
            });
        }
    }, {
        key: 'keepRecipe',
        value: function keepRecipe() {
            var _this2 = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, function () {
                    _this2.sessionStorage.setJson(_this2.pendingSaveRecipeStorageKey, _this2.recipe.ID);
                });
            } else {
                this.saveRecipe(this.recipe.ID);
            }
        }
    }, {
        key: 'removeSavedRecipe',
        value: function removeSavedRecipe() {
            var _this3 = this;

            this.recipeListsService.removeSavedRecipe(this.recipe.ID).then(function () {
                _this3.srMessage = _this3.recipe.Title + ' is removed from my favourite recipes';
                _this3.recipe.IsFavouriteRecipe = false;
                _this3.moveFocus('#recipe-recipeSaveToList-' + _this3.recipe.ID);
            });
        }
    }]);

    return RecipeSaveToListController;
}();

var recipeSaveToListComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['RecipeListsService', 'MoveFocus', '$state', 'ShopperService', 'LoginService', 'SessionStorageWrapper', RecipeSaveToListController],
    template: __webpack_require__(330).trim()
};

module.exports = {
    RecipeSaveToListController: RecipeSaveToListController,
    recipeSaveToListComponentDefinition: recipeSaveToListComponentDefinition
};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<div id=\"recipe-recipeSaveToList-{{::$ctrl.recipe.ID}}\" class=\"recipeSaveToList\" ng-switch=\"$ctrl.recipe.IsFavouriteRecipe\" tabindex=\"-1\">\r\n    <button class=\"button recipeSaveToList-button\" ng-click=\"::$ctrl.keepRecipe()\" ng-switch-when=\"false\">\r\n        <span class=\"sr-only\">Add {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}} to my favourite recipes</span><i class=\"iconww-SaveRecipe\"></i>\r\n    </button>\r\n    <button class=\"button recipeSaveToList-button is-saved\" ng-switch-when=\"true\" ng-click=\"::$ctrl.removeSavedRecipe()\">\r\n        <span class=\"sr-only\">Remove {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}} from my favourite recipes</span><i class=\"iconww-SaveRecipe\"></i>\r\n    </button>\r\n    <oly-sr-notification message=\"{{$ctrl.srMessage}}\"></oly-sr-notification>\r\n</div>"

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeNavigationController = function () {
    function RecipeNavigationController(recipeCategoriesService) {
        _classCallCheck(this, RecipeNavigationController);

        this.recipeCategoriesService = recipeCategoriesService;
    }

    _createClass(RecipeNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.recipeCategoriesService.getAll();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            if (this.currentCategory) {
                this.openCategory = this.currentCategory.department;
            }
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen(category) {
            this.openCategory = this.openCategory === category ? null : category;
        }
    }]);

    return RecipeNavigationController;
}();

var recipeNavigationComponentDefinition = {
    bindings: {
        currentCategory: '<'
    },
    controller: ['RecipeCategoriesService', RecipeNavigationController],
    template: __webpack_require__(332).trim()
};

module.exports = {
    RecipeNavigationController: RecipeNavigationController,
    recipeNavigationComponentDefinition: recipeNavigationComponentDefinition
};

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation treeNavigation\" aria-label=\"Recipes\">\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <wow-recipe-saved-list-navigation></wow-recipe-saved-list-navigation>\r\n        </li>\r\n        <li ng-repeat=\"category in ::$ctrl.recipeCategoriesService.categories track by category.UrlFriendlyName\">\r\n            <button\r\n                id=\"{{ ::category.UrlFriendlyName }}\"\r\n                class=\"linkButton navigation-header navigation-link treeNavigation-parent\"\r\n                aria-expanded=\"{{ $ctrl.openCategory === category }}\"\r\n                aria-controls=\"{{ ::category.UrlFriendlyName }}-children\"\r\n                ng-class=\"{'is-open': $ctrl.openCategory === category}\"\r\n                ng-click=\"$ctrl.toggleOpen(category)\">\r\n                <span>\r\n                    {{ ::category.Name }}&nbsp;<i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i>\r\n                </span>\r\n            </button>\r\n\r\n            <ul\r\n                id=\"{{ ::category.UrlFriendlyName }}-children\"\r\n                class=\"navigation-items treeNavigation-children\"\r\n                aria-labelledby=\"{{ ::category.UrlFriendlyName }}\">\r\n\r\n                <li ng-repeat=\"child in ::category.ChildCategories track by child.UrlFriendlyName\">\r\n                    <a\r\n                        class=\"navigation-link\"\r\n                        ui-sref=\"shop.recipes.category.subCategory({ category: category.UrlFriendlyName, subCategory: child.UrlFriendlyName })\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                        <span>{{ ::child.Name }}&nbsp;<i class=\"iconww-ArrowRight\"></i></span>\r\n                    </a>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    map = _require.map,
    property = _require.property,
    recipeDtmMapper = __webpack_require__(334);

var RecipeDetailController = function () {
    function RecipeDetailController($location, $state, $window, featureService, analyticsService, breakpointsService, trolleyService) {
        _classCallCheck(this, RecipeDetailController);

        this.$location = $location;
        this.$state = $state;
        this.$window = $window;
        this.featureService = featureService;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
    }

    _createClass(RecipeDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.socialMediaEnabled = this.featureService.isEnabled(this.featureService.features.recipeSocialMedia);
            this.emailExportEnabled = this.featureService.isEnabled(this.featureService.features.recipeEmailExport);
            this.printExportEnabled = this.featureService.isEnabled(this.featureService.features.recipePrintExport);
            this.showSubheaderControls = this.socialMediaEnabled || this.emailExportEnabled || this.printExportEnabled;

            this.analyticsService.push({ data: { recipe: this.recipe }, dtmMapperFn: recipeDtmMapper });
        }

        // Ideally author information should be coming from the data layer.

    }, {
        key: 'getRecipeAuthor',
        value: function getRecipeAuthor() {
            return this.recipe && this.recipe.ParentCategoryName === 'jamie-oliver' ? 'Jamie Oliver' : 'Woolworths';
        }
    }, {
        key: 'back',
        value: function back(event) {
            event.preventDefault();
            this.$window.history.back();
        }
    }, {
        key: 'addAllProductsToTrolley',
        value: function addAllProductsToTrolley() {
            var products = map(this.recipe.Ingredients, property('Product'));
            this.trolleyService.addItemsToTrolley(products);
            this.analyticsService.pushEvent(this.analyticsService.eventsDtm.ADD_ALL);
        }
    }]);

    return RecipeDetailController;
}();

var recipeDetailComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['$location', '$state', '$window', 'FeatureService', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', RecipeDetailController],
    template: __webpack_require__(335).trim()
};

module.exports = {
    RecipeDetailController: RecipeDetailController,
    recipeDetailComponentDefinition: recipeDetailComponentDefinition
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data) {
    return {
        recipe: {
            recipeInfo: {
                recipeID: data.recipe.RecipeId,
                recipeName: data.recipe.Title
            },
            category: data.recipe.CategoryName
        }
    };
};

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeDetail {{ ::$ctrl.recipe.TemplateName.toLowerCase() }}\" itemscope itemtype=\"http://schema.org/Recipe\">\r\n    <meta itemprop=\"author\" content=\"{{ ::$ctrl.getRecipeAuthor() }}\">\r\n    <meta itemprop=\"datePublished\" content=\"{{ ::$ctrl.recipe.ValidFrom }}\">\r\n\r\n    <a class=\"recipeDetail-back u-flexCenter linkButton\" href=\"javascript://\" ng-click=\"$ctrl.back($event)\">\r\n        <div class=\"recipeDetail-widthAdjust\">\r\n            <i class=\"iconww-ArrowLeft\"></i> Back\r\n        </div>\r\n    </a>\r\n\r\n    <div class=\"recipeDetail-content\">\r\n        <!--Recipe header-->\r\n        <div class=\"recipeDetail-headerSection u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <header class=\"recipeDetail-header heading\">\r\n                    <h1 class=\"recipeDetail-title\" itemprop=\"name\">{{$ctrl.recipe.Title}}</h1>\r\n                    <div class=\"heading3\">{{$ctrl.recipe.SubTitle}}</div>\r\n                </header>\r\n\r\n                <div class=\"recipeDetail-subheaderControls\" ng-if=\"$ctrl.showSubheaderControls\">\r\n                    <wow-social-buttons ng-if=\"::$ctrl.socialMediaEnabled\" url=\"::$ctrl.url\" media=\"::$ctrl.recipe.LargeImageFilename\" description=\"::$ctrl.recipe.Title\"></wow-social-buttons>\r\n\r\n                    <span class=\"u-flexSpacer\"></span>\r\n\r\n                    <wow-recipe-export-options recipe-id=\"{{::$ctrl.recipe.RecipeId}}\" enable-email=\"::$ctrl.emailExportEnabled\" enable-print=\"::$ctrl.printExportEnabled\"></wow-recipe-export-options>\r\n                </div>\r\n\r\n                <!-- Header template -->\r\n                <div class=\"recipeDetail-headerTemplate\" ng-include=\"$ctrl.recipe.TemplateName\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"recipeDetail-info u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <div class=\"recipeDetail-infos\">\r\n                    <h2 class=\"sr-only\">Infos</h2>\r\n                    <div class=\"recipeDetail-infoItems\">\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.Servings\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"recipeYield\">{{$ctrl.recipe.Servings}}</span> Serves\r\n                        </div>\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.PreparationDuration && $ctrl.recipe.TemplateName !== 'Jamie_Oliver'\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"prepTime\" content=\"PT{{$ctrl.recipe.PreparationDuration}}M\">\r\n                                {{$ctrl.recipe.PreparationDuration}}\r\n                            </span> Mins Prep\r\n                        </div>\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.CookingDuration  && $ctrl.recipe.TemplateName !== 'Jamie_Oliver'\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"cookTime\" content=\"PT{{$ctrl.recipe.CookingDuration}}M\">\r\n                                {{$ctrl.recipe.CookingDuration}}\r\n                            </span> Mins Cook\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Recipe content LF and MF for more than 1 column-->\r\n        <div class=\"u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust recipeDetail-methodIngredients\">\r\n                <div class=\"recipeDetail-ingredients\" ng-if=\"::$ctrl.recipe.Ingredients.length > 0\">\r\n                    <h2 class=\"heading3\">Ingredients</h2>\r\n\r\n                    <ul>\r\n                        <li\r\n                            class=\"recipeDetail-ingredient u-capitalize-first-letter\"\r\n                            itemprop=\"recipeIngredient\"\r\n                            ng-repeat=\"ingredient in $ctrl.recipe.Ingredients\">\r\n                            {{ ingredient.Description }}\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n\r\n                <div class=\"recipeDetail-method\">\r\n                    <h2 class=\"heading3\">Method</h2>\r\n                    <p\r\n                        class=\"recipeDetail-instructions\"\r\n                        itemprop=\"recipeInstructions\"\r\n                        ng-repeat=\"paragraph in ($ctrl.recipe.Instructions | paragraphize) track by $index\">\r\n                        {{ (paragraph | sentenceCase).trim() }}\r\n                    </p>\r\n\r\n                    <wow-recipe-detail-video ng-repeat=\"video in $ctrl.recipe.Videos track by $index\" url=\"video.Url\"></wow-recipe-detail-video>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"u-flexCenter\" ng-if=\"::$ctrl.recipe.Ingredients.length > 0\">\r\n            <hr class=\"recipeDetail-widthAdjust recipeDetail-separator\" />\r\n        </div>\r\n\r\n        <div class=\"u-flexCenter\" ng-if=\"::$ctrl.recipe.Ingredients.length > 0\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <div>\r\n                    <div class=\"recipeDetail-productsHeader\">\r\n                        <h2 class=\"recipeDetail-productsTitle heading3\">Shop the recipe</h2>\r\n                        <button class=\"button button--primary\" ng-click=\"$ctrl.addAllProductsToTrolley()\">Add all ({{ $ctrl.recipe.Ingredients.length }})</button>\r\n                    </div>\r\n                    <div class=\"recipeDetail-products\">\r\n                        <wow-shelf-product-tile product=\"ingredient.Product\" ng-repeat=\"ingredient in $ctrl.recipe.Ingredients\" class=\"shelfProduct--recipe\"></wow-shelf-product-tile>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeDetailVideoController = function () {
    function RecipeDetailVideoController($sce) {
        _classCallCheck(this, RecipeDetailVideoController);

        this.$sce = $sce;
    }

    _createClass(RecipeDetailVideoController, [{
        key: '$onInit',
        value: function $onInit() {
            this.trustedUrl = this.$sce.trustAsResourceUrl('' + this.url + (this.url.indexOf('?') === -1 ? '?' : '&') + 'showinfo=0&enablejsapi=1');
        }
    }]);

    return RecipeDetailVideoController;
}();

var recipeDetailVideoComponentDefinition = {
    bindings: {
        url: '='
    },
    controller: ['$sce', RecipeDetailVideoController],
    template: __webpack_require__(337).trim()
};

module.exports = {
    RecipeDetailVideoController: RecipeDetailVideoController,
    recipeDetailVideoComponentDefinition: recipeDetailVideoComponentDefinition
};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "<h3 class=\"recipeDetail-videoTitle\">Video</h3>\r\n\r\n<div class=\"recipeDetail-videoContainer\">\r\n    <iframe class=\"recipeDetail-video\" ng-src=\"{{$ctrl.trustedUrl}}\" frameborder=\"0\"></iframe>\r\n</div>\r\n"

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeDetailExportOptionsController = function () {
    function RecipeDetailExportOptionsController(dialogRegistry, moveFocus, analyticsService) {
        _classCallCheck(this, RecipeDetailExportOptionsController);

        this.dialogRegistry = dialogRegistry;
        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;

        this.showPrintOption = this.enablePrint === undefined || this.enablePrint;
        this.showEmailOption = this.enableEmail === undefined || this.enableEmail;
    }

    _createClass(RecipeDetailExportOptionsController, [{
        key: 'emailRecipe',
        value: function emailRecipe() {
            var emailDialog = this.dialogRegistry.getDialog('email recipe');
            if (emailDialog) {
                emailDialog.show();
                this.moveFocus('#emailForm-recipientEmail');
            }
            this.analyticsService.pushEvent(this.analyticsService.eventsDtm.EMAIL_SHARE);
        }
    }, {
        key: 'logPrintRecipeClick',
        value: function logPrintRecipeClick() {
            this.analyticsService.pushEvent(this.analyticsService.eventsDtm.PRINT_RECIPE);
        }
    }]);

    return RecipeDetailExportOptionsController;
}();

var recipeDetailExportOptionsComponentDefinition = {
    bindings: {
        recipeId: '@',
        enablePrint: '=?',
        enableEmail: '=?'
    },
    controller: ['DialogRegistry', 'MoveFocus', 'AnalyticsService', RecipeDetailExportOptionsController],
    template: __webpack_require__(339).trim()
};

module.exports = {
    RecipeDetailExportOptionsController: RecipeDetailExportOptionsController,
    recipeDetailExportOptionsComponentDefinition: recipeDetailExportOptionsComponentDefinition
};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeExportOptions-exportOptions\">\r\n    <a class=\"recipeExportOptions-exportOptionLink recipeExportOptions-email\" href=\"javascript:;\" ng-show=\"::$ctrl.showEmailOption\" ng-click=\"::$ctrl.emailRecipe()\">\r\n        <i class=\"icon-email recipeExportOptions-exportOptionIcon\"></i>\r\n        <div class=\"recipeExportOptions-iconLabel\">\r\n            Email <span class=\"sr-only\"> recipe</span>\r\n        </div>\r\n    </a>\r\n\r\n    <a class=\"recipeExportOptions-exportOptionLink\" ng-href=\"/Shop/PrintRecipe/{{::$ctrl.recipeId}}\" target=\"_blank\" ng-show=\"::$ctrl.showPrintOption\" ng-click=\"::$ctrl.logPrintRecipeClick()\">\r\n        <i class=\"icon-printer recipeExportOptions-exportOptionIcon\"></i>\r\n        <div class=\"recipeExportOptions-iconLabel\">\r\n            Print <span class=\"sr-only\"> recipe</span>\r\n        </div>\r\n    </a>\r\n</div>\r\n\r\n<dialog name=\"email recipe\" class=\"olyDialog olyDialog--confirmation recipeExportOptions-dialog\" id=\"recipeEmailDialog\">\r\n    <div class=\"recipeExportOptions-dialogContent\" wow-hide-scroll wow-scrollbar>\r\n        <wow-recipe-email-form></wow-recipe-email-form>\r\n    </div>\r\n</dialog>"

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeDetailEmailFormController = function () {
    function RecipeDetailEmailFormController(recipeService, moveFocus, shopperService, $location, $timeout, $element) {
        _classCallCheck(this, RecipeDetailEmailFormController);

        this.recipeService = recipeService;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$element = $element;

        this.formSubmitted = false;

        this.resetForm(true, true);
    }

    _createClass(RecipeDetailEmailFormController, [{
        key: 'resetForm',
        value: function resetForm(resetMessage, initialLoad) {
            if (!initialLoad) {
                this.emailForm.$submitted = false;
            }

            if (resetMessage) {
                this.formSubmitted = false;
                this.emailSentMessage = undefined;
            }

            this.email = {
                recipientEmail: null,
                yourEmail: this.shopperService.IsGuest ? null : this.shopperService.Email,
                message: null,
                sendCopy: false
            };
        }
    }, {
        key: 'showSentMessage',
        value: function showSentMessage() {
            return this.emailSentMessage && this.formSubmitted;
        }
    }, {
        key: 'focussedOnInput',
        value: function focussedOnInput() {
            if (this.formSubmitted) {
                this.emailSentMessage = undefined;
                this.formSubmitted = false;
            }
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            var _this = this;

            if (!this.emailForm.$valid) {
                this.$timeout(function () {
                    var dialog = _this.$element.parents('#recipeEmailDialog');
                    var topPosition = (Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - dialog.innerHeight()) / 2;
                    dialog.css('top', topPosition);
                }, 0, false);
                return;
            }

            this.formSubmitted = true;
            this.recipeService.emailRecipe(this.$location.absUrl(), this.email.recipientEmail, this.email.yourEmail, this.email.message, this.email.sendCopy).then(function (response) {
                _this.emailSentMessage = response.MailStatusMessage;
                _this.resetForm(false, false);
                _this.moveFocus('._recipeEmailForm-confirmation');
            });
        }
    }, {
        key: 'cancelDialog',
        value: function cancelDialog() {
            this.resetForm(true, false);
            this.moveFocus('.recipeExportOptions-email');
            this.$element.parents('#recipeEmailDialog').removeAttr('style');
        }
    }]);

    return RecipeDetailEmailFormController;
}();

var recipeDetailFormComponentDefinition = {
    controller: ['RecipeService', 'MoveFocus', 'ShopperService', '$location', '$timeout', '$element', RecipeDetailEmailFormController],
    template: __webpack_require__(341).trim()
};

module.exports = {
    RecipeDetailEmailFormController: RecipeDetailEmailFormController,
    recipeDetailFormComponentDefinition: recipeDetailFormComponentDefinition
};

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "<div class=\" recipeEmailForm\">\r\n    <h2 for=\"recipeEmailDialog\" class=\"recipeEmailForm-header\">Send to a friend</h2>\r\n    <a oly-dialog-close class=\"icon-close_x recipeEmailForm-buttonClose\" ng-click=\"::$ctrl.cancelDialog()\" href=\"javascript:;\">\r\n        <span class=\"sr-only\">Close recipe email form</span>\r\n    </a>\r\n\r\n    <div ng-if=\"$ctrl.showSentMessage()\" class=\"alert alert--info _recipeEmailForm-confirmation\">{{$ctrl.emailSentMessage}}</div>\r\n\r\n    <form id=\"emailForm\" name=\"$ctrl.emailForm\" class=\"recipeEmailForm-form\" ng-submit=\"$ctrl.submitForm($ctrl.emailForm)\" autocomplete=\"off\" novalidate>\r\n        <oly-form-validation-summary user-message=\"There are errors in this form.\"></oly-form-validation-summary>\r\n        <div class=\"recipeEmailForm-row\">\r\n            <span class=\"recipeEmailForm-label\">Recipient's email</span>\r\n            <wow-input-container class=\"recipeEmailForm-input\">\r\n                <label>Recipient email address *</label>\r\n                <input id=\"emailForm-recipientEmail\" type=\"email\" name=\"recipientEmail\" ng-model=\"$ctrl.email.recipientEmail\" ng-focus=\"$ctrl.focussedOnInput()\" required wow-email-validator/>\r\n                <span ng-messages=\"$ctrl.emailForm.recipientEmail.$error\" class=\"wowInput-errors\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">Recipient's email address is required</span>\r\n                    <span ng-message=\"email\" class=\"wowInput-error\">Email address is required to be in the format of example@example.com</span>\r\n                </span>\r\n            </wow-input-container>\r\n        </div>\r\n        <div class=\"recipeEmailForm-row\">\r\n            <span class=\"recipeEmailForm-label\">Your email</span>\r\n            <wow-input-container class=\"recipeEmailForm-input\">\r\n                <label>Your email address *</label>\r\n                <input id=\"emailForm-yourEmail\" type=\"email\" name=\"yourEmail\" ng-model=\"$ctrl.email.yourEmail\" ng-focus=\"$ctrl.focussedOnInput()\" required wow-email-validator/>\r\n                <span ng-messages=\"$ctrl.emailForm.yourEmail.$error\" class=\"wowInput-errors\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">Your email address is required</span>\r\n                    <span ng-message=\"email\" class=\"wowInput-error\">Email address is required to be in the format of example@example.com</span>\r\n                </span>\r\n            </wow-input-container>\r\n        </div>\r\n        <div class=\"recipeEmailForm-rowBottom\">\r\n            <span class=\"recipeEmailForm-label\">Your message</span>\r\n            <wow-input-container class=\"recipeEmailForm-input\">\r\n                <label>Type your message here</label>\r\n                <textarea id=\"emailForm-message\" type=\"text\" name=\"message\" ng-model=\"$ctrl.email.message\" ng-focus=\"$ctrl.focussedOnInput()\" class=\"recipeEmailForm-inputMessage\"></textarea>\r\n            </wow-input-container>\r\n        </div>\r\n        <div class=\"recipeEmailForm-checkbox\">\r\n            <input type=\"checkbox\" id=\"sendCopy\" class=\"wowCheckbox\" value=\"false\" ng-model=\"$ctrl.email.sendCopy\" ng-focus=\"$ctrl.focussedOnInput()\"/>\r\n            <label for=\"sendCopy\" class=\"recipeEmailForm-checkboxLabel\">Send a copy to myself</label>\r\n        </div>\r\n        <button class=\"button button--primary recipeEmailForm-buttonSend\" ng-if=\"!$ctrl.formSubmitted\">\r\n            Send\r\n            <span class=\"sr-only\">recipe email</span>\r\n        </button>\r\n        <button class=\"button recipeEmailForm-tickMark\" type=\"button\" ng-if=\"$ctrl.formSubmitted\">\r\n            <i class=\"icon-tick\"></i>\r\n            <span class=\"sr-only\">Send button disabled. Select an input field to activate</span>\r\n        </button>\r\n    </form>\r\n</div>\r\n"

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp.shop');

wowApp.directive('wowAccessibilityNavLinks', ['BreakpointsService', __webpack_require__(343)]);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (breakpointsService) {
    return {
        restrict: 'E',
        link: function link($scope) {
            $scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };
        },

        template: __webpack_require__(344).trim()
    };
};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navigation\">\r\n    <h2 class=\"sr-only\">My Account Navigation</h2>\r\n    <nav role=\"navigation\" class=\"navigation-items\">\r\n        <a id=\"accessibilityLink\" ui-sref=\"shop.support.accessibility\" ui-sref-active=\"is-active\" class=\"navigation-link\">\r\n            Accessibility\r\n        </a>\r\n    </nav>\r\n</div>\r\n"

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var bannersService = __webpack_require__(346),
    _require = __webpack_require__(347),
    bannerComponentDefinition = _require.bannerComponentDefinition;


angular.module('wowApp.shop').service('BannersService', bannersService).component('wowBanner', bannerComponentDefinition);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BannersService = function () {
    function BannersService(restangular) {
        _classCallCheck(this, BannersService);

        this._api = restangular.one('banner');
        this.banners = {};
    }

    _createClass(BannersService, [{
        key: 'getBanners',
        value: function getBanners(_ref) {
            var _this = this;

            var _ref$CategoryId = _ref.CategoryId,
                CategoryId = _ref$CategoryId === undefined ? undefined : _ref$CategoryId,
                _ref$IsSpecialRoot = _ref.IsSpecialRoot,
                IsSpecialRoot = _ref$IsSpecialRoot === undefined ? false : _ref$IsSpecialRoot,
                _ref$SpecialGroupId = _ref.SpecialGroupId,
                SpecialGroupId = _ref$SpecialGroupId === undefined ? undefined : _ref$SpecialGroupId;

            if (CategoryId && !(CategoryId in this.banners)) {
                this._api.get({ CategoryId: CategoryId, IsSpecialRoot: IsSpecialRoot, SpecialGroupId: SpecialGroupId }).then(function (resp) {
                    _this.banners[CategoryId] = resp.BannerResponses;
                });
            }

            return this.banners[CategoryId];
        }
    }]);

    return BannersService;
}();

BannersService.$inject = ['Restangular'];

module.exports = BannersService;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BannerController = function () {
    function BannerController() {
        _classCallCheck(this, BannerController);
    }

    _createClass(BannerController, [{
        key: 'getLinkTarget',
        value: function getLinkTarget() {
            return this.banner.LinkTarget === 'NewWindow' ? '_blank' : undefined;
        }
    }]);

    return BannerController;
}();

var bannerComponentDefinition = {
    bindings: {
        banner: '<'
    },
    controller: BannerController,
    template: __webpack_require__(348).trim()
};

module.exports = {
    BannerController: BannerController,
    bannerComponentDefinition: bannerComponentDefinition
};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = "<a class=\"banner banner--imageLink\"\r\n    ng-href=\"{{ ::$ctrl.banner.Link }}\"\r\n    target=\"{{ ::$ctrl.getLinkTarget() }}\"\r\n    ng-if=\"::!$ctrl.banner.InspirationCard && $ctrl.banner.Link\">\r\n\r\n    <img ng-src=\"{{ ::$ctrl.banner.Image }}\"\r\n        alt=\"{{ ::$ctrl.banner.HoverText }}\"\r\n        ng-if=\"::!$ctrl.banner.InspirationCard\"\r\n        width=\"{{ ::$ctrl.banner.Width }}\"\r\n        height=\"{{ ::$ctrl.banner.Height }}\"\r\n        oly-error-src>\r\n</a>\r\n\r\n<img class=\"banner banner--image\"\r\n    ng-src=\"{{ ::$ctrl.banner.Image }}\"\r\n    alt=\"{{ ::$ctrl.banner.HoverText }}\"\r\n    ng-if=\"::!$ctrl.banner.InspirationCard && !$ctrl.banner.Link\"\r\n    width=\"{{ ::$ctrl.banner.Width }}\"\r\n    height=\"{{ ::$ctrl.banner.Height }}\"\r\n    oly-error-src>\r\n\r\n<wow-inspiration-tile class=\"banner banner--inspirationCard\"\r\n    card=\"::$ctrl.banner.InspirationCard\"\r\n    ng-if=\"::$ctrl.banner.InspirationCard\">\r\n</wow-inspiration-tile>\r\n"

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(350),
    browseTileListComponentDefinition = _require.browseTileListComponentDefinition;

var _require2 = __webpack_require__(351),
    browseLeftPanelComponentDefinition = _require2.browseLeftPanelComponentDefinition;

angular.module('wowApp.shop').component('wowBrowseTileList', browseTileListComponentDefinition).component('wowBrowseLeftPanel', browseLeftPanelComponentDefinition);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(7),
    createBundleTiles = _require.createBundleTiles,
    _require2 = __webpack_require__(22),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var BrowseTileListController = function () {
    function BrowseTileListController($scope, $timeout, settings, shelfProductService, $location, pageMetadataService, richRelevanceService, breakpointsService, sortByKeys) {
        _classCallCheck(this, BrowseTileListController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.settings = settings;
        this.shelfProductService = shelfProductService;
        this.pageMetadataService = pageMetadataService;
        this.richRelevanceService = richRelevanceService;
        this.breakpointsService = breakpointsService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(BrowseTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = {
                sortTypes: this.settings[this.category.IsSpecial ? 'specials' : 'browse'].sortOptions,
                sortContext: this.category.IsSpecial ? this.sortByKeys.SPECIALS_KEY : this.sortByKeys.BROWSE_KEY
            };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(response, pageSize, pageNumber) {
            return {
                items: mergeInspirationTiles(createBundleTiles(response.Bundles), response.InspirationCards.Cards, { pageSize: pageSize, pageNumber: pageNumber }),
                totalRecordCount: response.TotalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.getBrowsePage(pageSize, pageNumber, sortType).then(function (response) {
                return _this.setMetadata(response);
            }).then(function (response) {
                return _this.onPlacementsReceived(response);
            }).then(function (response) {
                return _this.createTiles(response, pageSize, pageNumber);
            });
        }
    }, {
        key: 'getBrowsePage',
        value: function getBrowsePage() {
            var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
            var pageNumber = arguments[1];
            var sortType = arguments[2];

            return this.shelfProductService.getBrowsePage({
                categoryId: this.category.IsBundle ? this.category.ParentNodeId : this.category.NodeId,
                pageNumber: pageNumber,
                pageSize: pageSize,
                sortType: sortType,
                url: this.$location.url(),
                formatObject: { name: this.category.Description },
                isSpecial: this.category.IsSpecial,
                isBundle: this.category.IsBundle,
                isMobile: this.breakpointsService.isInSmallFormat
            });
        }
    }, {
        key: 'setMetadata',
        value: function setMetadata(response) {
            this.pageMetadataService.setMetadata(response.SeoMetaTags);

            return response;
        }
    }, {
        key: 'onPlacementsReceived',
        value: function onPlacementsReceived(response) {
            if (this.richRelevanceService.useServerSideResults(response.RichRelevancePlacement)) {
                this.richRelevanceService.onPlacementsReceived(response.RichRelevancePlacement);
            }

            return response;
        }
    }]);

    return BrowseTileListController;
}();

BrowseTileListController.$inject = ['$scope', '$timeout', 'Settings', 'ShelfProductService', '$location', 'PageMetadataService', 'RichRelevanceService', 'BreakpointsService', 'SortByKeys'];

var browseTileListComponentDefinition = {
    bindings: {
        category: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: BrowseTileListController,
    template: '\n        <wow-tile-list\n            list-title="::$ctrl.category.Description"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            should-get-inspiration-cards="false"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    BrowseTileListController: BrowseTileListController,
    browseTileListComponentDefinition: browseTileListComponentDefinition
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrowseLeftPanelController = function () {
    function BrowseLeftPanelController(categoriesService) {
        _classCallCheck(this, BrowseLeftPanelController);

        this.categoriesService = categoriesService;
    }

    _createClass(BrowseLeftPanelController, [{
        key: 'shouldDisplayBacklink',
        value: function shouldDisplayBacklink() {
            if (this.isSpecial) {
                this.backlinkCategory = this.getBacklinkCategory();
                this.specialCategory = this.categoriesService.getSpecialCategory(this.category);
                return this.backlinkCategory && this.backlinkCategory !== this.specialCategory;
            }

            if (this.isBundle) {
                this.bundleCategory = this.categoriesService.getBundleCategory(this.category);
                return this.departmentCategory !== this.bundleCategory;
            }

            return this.departmentCategory !== this.category;
        }
    }, {
        key: 'getBacklinkCategory',
        value: function getBacklinkCategory() {
            return this.isSpecial && this.departmentCategory.IsSpecial ? this.categoriesService.getFirstSpecialCategory(this.departmentCategory) : this.departmentCategory;
        }
    }]);

    return BrowseLeftPanelController;
}();

var browseLeftPanelComponentDefinition = {
    bindings: {
        departmentCategory: '<',
        category: '<',
        isSpecial: '<',
        isBundle: '<'
    },
    controller: ['CategoriesService', BrowseLeftPanelController],
    template: __webpack_require__(352).trim()
};

module.exports = {
    BrowseLeftPanelController: BrowseLeftPanelController,
    browseLeftPanelComponentDefinition: browseLeftPanelComponentDefinition
};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = "<wow-categories-navigation\r\n    class=\"browseLeftPanel\"\r\n    class-modifier=\"leftPanel\"\r\n    category=\"$ctrl.category\"\r\n    should-show-arrow=\"true\"\r\n    should-show-show-all=\"!$ctrl.isBundle\"\r\n    should-show-specials=\"true\"\r\n    should-show-bundles=\"true\">\r\n\r\n    <div class=\"browseLeftPanel-heading\">\r\n        <a class=\"browseLeftPanel-headingBack\"\r\n            ng-if=\"::$ctrl.shouldDisplayBacklink()\"\r\n            wow-category-sref=\"$ctrl.getBacklinkCategory()\"\r\n            ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n\r\n            <span class=\"sr-only\">Back to {{ $ctrl.departmentCategory.Description }}</span>\r\n            <i class=\"iconww-ArrowLeft browseLeftPanel-backIcon\"></i>\r\n        </a>\r\n        <h3 class=\"browseLeftPanel-headingText\" ng-if=\"$ctrl.category.Description\">\r\n            {{ $ctrl.category.Description }}\r\n        </h3>\r\n    </div>\r\n</wow-categories-navigation>\r\n"

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(354),
    cartComponentDefinition = _require.cartComponentDefinition;

var _require2 = __webpack_require__(356),
    cartOffscreenComponentDefinition = _require2.cartOffscreenComponentDefinition;

var _require3 = __webpack_require__(358),
    cartItemComponentDefinition = _require3.cartItemComponentDefinition;

var _require4 = __webpack_require__(360),
    cartItemMessageComponentDefinition = _require4.cartItemMessageComponentDefinition;

var _require5 = __webpack_require__(362),
    CartItemMessageService = _require5.CartItemMessageService;

var _require6 = __webpack_require__(367),
    cartItemGroupComponentDefinition = _require6.cartItemGroupComponentDefinition;

var _require7 = __webpack_require__(369),
    cartControlsComponentDefinition = _require7.cartControlsComponentDefinition;

var _require8 = __webpack_require__(371),
    cartMessageComponentDefinition = _require8.cartMessageComponentDefinition;

var _require9 = __webpack_require__(373),
    cartSaveListComponentDefinition = _require9.cartSaveListComponentDefinition;

var _require10 = __webpack_require__(375),
    cartFilterComponentDefinition = _require10.cartFilterComponentDefinition;

var _require11 = __webpack_require__(377),
    cartLoyaltyComponentDefinition = _require11.cartLoyaltyComponentDefinition;

var _require12 = __webpack_require__(379),
    cartDeliveryFeeComponentDefinition = _require12.cartDeliveryFeeComponentDefinition;

var _require13 = __webpack_require__(381),
    cartOrderManagementComponentDefinition = _require13.cartOrderManagementComponentDefinition;

var _require14 = __webpack_require__(383),
    tileInCartComponentDefinition = _require14.tileInCartComponentDefinition;

var wowApp = angular.module('wowApp.shop');

wowApp.component('wowCart', cartComponentDefinition);
wowApp.component('wowCartOffscreen', cartOffscreenComponentDefinition);
wowApp.component('wowCartItem', cartItemComponentDefinition);
wowApp.component('wowCartItemMessage', cartItemMessageComponentDefinition);
wowApp.service('CartItemMessageService', CartItemMessageService);
wowApp.component('wowCartItemGroup', cartItemGroupComponentDefinition);
wowApp.component('wowCartControls', cartControlsComponentDefinition);
wowApp.component('wowCartMessage', cartMessageComponentDefinition);
wowApp.component('wowCartSaveList', cartSaveListComponentDefinition);
wowApp.component('wowCartFilter', cartFilterComponentDefinition);
wowApp.component('wowCartLoyalty', cartLoyaltyComponentDefinition);
wowApp.component('wowCartDeliveryFee', cartDeliveryFeeComponentDefinition);
wowApp.component('wowCartOrderManagement', cartOrderManagementComponentDefinition);
wowApp.component('wowTileInCart', tileInCartComponentDefinition);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartController = function () {
    function CartController($scope, sessionStorage, settings, trolleyService, shopperService, fulfilmentService, deliveryPassService, addressService, shopPageStateService, breakpointsService, moveFocus) {
        _classCallCheck(this, CartController);

        this.settings = settings;
        this.trolleyService = trolleyService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.addressService = addressService;
        this.scope = $scope;
        this.sessionStorage = sessionStorage;
        this.shopPageStateService = shopPageStateService;
        this.breakpointsService = breakpointsService;
        this.moveFocus = moveFocus;
    }

    _createClass(CartController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var sessionStorageKey = 'wowCart:collectionZoneMessages';
            var savedMessages = this.sessionStorage.getJsonAndRemove(sessionStorageKey);

            if (!this.shopperService.IsGuest && savedMessages) {
                this.cartMessages = savedMessages;
            }

            this.scope.$on('login:success', function (ev, loginResult) {
                if (loginResult.HasCollectionZoneMessages) {
                    // Save collection zone messages to session storage
                    _this.sessionStorage.setJson(sessionStorageKey, loginResult.LoginCollectionZoneMessages);
                }
            });
        }
    }, {
        key: 'clearCart',
        value: function clearCart() {
            this.trolleyService.clearTrolley();
        }
    }, {
        key: 'clearOutOfStock',
        value: function clearOutOfStock() {
            this.trolleyService.clearOutOfStockTrolleyItems();
        }
    }, {
        key: 'toggleOrderManagement',
        value: function toggleOrderManagement() {
            this.shouldShowOrderManagement = !this.shouldShowOrderManagement;
            this.moveFocus('#return-to-cart');
        }
    }]);

    return CartController;
}();

var cartComponentDefinition = {
    controller: ['$scope', 'SessionStorageWrapper', 'Settings', 'TrolleyService', 'ShopperService', 'FulfilmentService', 'DeliveryPassService', 'AddressService', 'ShopPageStateService', 'BreakpointsService', 'MoveFocus', CartController],
    template: __webpack_require__(355).trim()
};

module.exports = {
    CartController: CartController,
    cartComponentDefinition: cartComponentDefinition
};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart\">\r\n\r\n    <div ng-if=\"!$ctrl.shouldShowOrderManagement\">\r\n\r\n        <wow-express-cart-item-count\r\n            ng-if=\"$ctrl.fulfilmentService.isExpress && $ctrl.trolleyService.itemCount > 0\">\r\n        </wow-express-cart-item-count>\r\n\r\n        <div class=\"cart-totalSavings\" ng-if=\"$ctrl.trolleyService.savedPrice\">\r\n            Total saved <span class=\"cart-totalSavingsAmount\">{{$ctrl.trolleyService.savedPrice | wowCurrencyCents }}</span>\r\n        </div>\r\n\r\n        <wow-cart-loyalty>\r\n        </wow-cart-loyalty>\r\n\r\n        <wow-fulfilment-method-wizard\r\n            should-show-billing=\"false\"\r\n            allow-decide-later=\"true\"\r\n            is-active=\"!$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape || $ctrl.shopPageStateService.isCartOpen\">\r\n        </wow-fulfilment-method-wizard>\r\n\r\n        <wow-cart-filter\r\n            ng-if=\"$ctrl.trolleyService.trolleyProducts.length && ($ctrl.shopPageStateService.isCartOpen || !$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape)\"\r\n            search-filter=\"$ctrl.searchFilter\"\r\n            item-count=\"visibleItems.length\">\r\n        </wow-cart-filter>\r\n\r\n        <wow-cart-delivery-fee\r\n            ng-if=\"!$ctrl.searchFilter && $ctrl.fulfilmentService.isDelivery() && !$ctrl.addressService.isNonServiced\">\r\n        </wow-cart-delivery-fee>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.restrictedProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.restrictedProducts\"\r\n            group-name=\"Restricted products\",\r\n            message=\"{{ ::$ctrl.settings.productRestrictions.restrictedProductsCollectionZoneInlineMessage }}\"\r\n            action-label=\"Change delivery window\"\r\n            on-action=\"$ctrl.fulfilmentService.changeFulfilmentTimeslot()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.unavailableProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.unavailableProducts\"\r\n            group-name=\"Unavailable or out of stock products\",\r\n            message=\"{{ ::$ctrl.settings.trolley.productsUnavailableAtLocation }}\"\r\n            action-label=\"Remove all\"\r\n            on-action=\"$ctrl.clearOutOfStock()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.restrictedByDeliveryMethodProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.restrictedByDeliveryMethodProducts\"\r\n            group-name=\"Products restricted by delivery method\",\r\n            message=\"{{ ::$ctrl.trolleyService.restrictedByDeliveryMethodMessage }}\"\r\n            action-label=\"Change delivery method\"\r\n            on-action=\"$ctrl.fulfilmentService.changeFulfilmentMethod()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-message\r\n            ng-repeat=\"message in $ctrl.cartMessages\"\r\n            message=\"message\">\r\n        </wow-cart-message>\r\n\r\n        <section aria-label=\"Products in your cart\">\r\n            <wow-cart-item\r\n                oly-move-focus-ondelete\r\n                ng-repeat=\"trolleyItem in $ctrl.trolleyService.trolleyProducts | filter:{ Name: $ctrl.searchFilter } as visibleItems track by trolleyItem.Stockcode\"\r\n                trolley-item=\"trolleyItem\">\r\n            </wow-cart-item>\r\n        </section>\r\n\r\n        <wow-cart-order-management\r\n            ng-if=\"!$ctrl.shopperService.IsGuest\"\r\n            toggle-order-management=\"::$ctrl.toggleOrderManagement()\">\r\n        </wow-cart-order-management>\r\n\r\n        <div ng-if=\"$ctrl.trolleyService.trolleyProducts.length > 0\">\r\n            <wow-cart-save-list>\r\n            </wow-cart-save-list>\r\n\r\n            <button type=\"button\" class=\"linkButton cart-clearCart\" ng-click=\"$ctrl.clearCart()\">\r\n                <span class=\"u-flexCenter\">\r\n                    <wow-setting setting-group=\"Trolley\" setting-name=\"RemoveAllProductsLinkText\"></wow-setting>\r\n                    <i class=\"iconww-Cross cart-clearCartIcon\"></i>\r\n                </span>\r\n            </button>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <wow-order-management\r\n        ng-if=\"$ctrl.shouldShowOrderManagement\"\r\n        toggle-order-management=\"::$ctrl.toggleOrderManagement()\">\r\n    </wow-order-management>\r\n\r\n    <div class=\"cart-checkout\">\r\n        <i class=\"iconww-Cart cart-checkoutIcon\"></i>\r\n        <p class=\"cart-checkoutTotal\">\r\n            Your order<br>\r\n            <span class=\"cart-checkoutTotalAmount\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n        </p>\r\n        <span class=\"u-flexSpacer\"></span>\r\n        <a ui-sref=\"hyf\" class=\"button button--primary\" ng-class=\"{'is-disabled': !$ctrl.trolleyService.hasAvailableProducts()}\">\r\n            Checkout <i class=\"iconww-ArrowRight\"></i>\r\n        </a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var CartOffscreenController = function () {
    function CartOffscreenController($scope, $element, $timeout, shopPageStateService, sessionStorageWrapper) {
        var _this = this;

        _classCallCheck(this, CartOffscreenController);

        this.$element = $element;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
        this.sessionStorageWrapper = sessionStorageWrapper;

        $scope.$on('$stateChangeStart', function () {
            return _this.toggleOpen(false);
        });

        $scope.$watch(function () {
            return _this.shopPageStateService.isCartOpen;
        }, function () {
            return _this.toggleOpen(_this.shopPageStateService.isCartOpen);
        });
    }

    _createClass(CartOffscreenController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            // height to stick to the top
            // this is the height of the corporate header + category header which is
            // 30px + 50px = 80px
            this.stickyHeight = 80;

            this.$timeout(function () {
                _this2.shopPageStateService.isCartOpen = _this2.sessionStorageWrapper.getAndRemove('isCartOpen') === 'true';
            });
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this3 = this;

            this.$cart = this.$element.find('.cartOffscreen');
            this.$mask = this.$element.find('.cartOffscreen-contentMask');

            $(window).on('beforeunload.cartpanel', function () {
                return _this3.sessionStorageWrapper.set('isCartOpen', _this3.shopPageStateService.isCartOpen);
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $(window).off('beforeunload.cartpanel');
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen() {
            var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.shopPageStateService.isCartOpen;

            // This function sometimes gets called twice. Once by the ng-click from the template
            // and once by the watcher in the constructor. This is for performance reasons - if we always
            // wait for the watcher we have to wait 2 digest cycles which is slower on mobile devices.
            this.shopPageStateService.isCartOpen = open;

            this.shopPageStateService.toggleBodyScroll(!this.shopPageStateService.isCartOpen);
            this.$cart.toggleClass('is-open', this.shopPageStateService.isCartOpen);
            this.$mask.toggleClass('is-masked', this.shopPageStateService.isCartOpen);
        }
    }]);

    return CartOffscreenController;
}();

var cartOffscreenComponentDefinition = {
    controller: ['$scope', '$element', '$timeout', 'ShopPageStateService', 'SessionStorageWrapper', CartOffscreenController],
    template: __webpack_require__(357).trim()
};

module.exports = {
    CartOffscreenController: CartOffscreenController,
    cartOffscreenComponentDefinition: cartOffscreenComponentDefinition
};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartOffscreen-contentMask\" ng-click=\"$ctrl.toggleOpen(false)\"></div>\r\n\r\n<div class=\"cartOffscreen\" oly-sticky=\"$ctrl.stickyHeight\">\r\n    <h2 class=\"sr-only\">Trolley</h2>\r\n    <button class=\"cartOffscreen-openButton\" ng-click=\"$ctrl.toggleOpen()\" aria-label=\"{{$ctrl.shopPageStateService.isCartOpen ? 'Hide' : 'Show'}} trolley - visual effect only\">\r\n        <i class=\"iconww-DoubleArrowLeft cartOffscreen-openIcon\" ng-class=\"{ 'is-open': $ctrl.shopPageStateService.isCartOpen }\"></i>\r\n    </button>\r\n\r\n    <div class=\"cartOffscreen-scrollWrapper\">\r\n        <wow-cart></wow-cart>\r\n        <div class=\"cartOffscreen-cartClosedMask\"\r\n             ng-show=\"!$ctrl.shopPageStateService.isCartOpen\"\r\n             ng-click=\"$ctrl.toggleOpen(true)\"></div>\r\n    </div>\r\n    <span class=\"sr-only\">Trolley end</span>\r\n</div>\r\n"

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartItemController = function () {
    function CartItemController($timeout, config, trolleySource, analyticsService, trolleyService, cartItemMessageService, announcerService) {
        _classCallCheck(this, CartItemController);

        this.$timeout = $timeout;
        this.config = config;
        this.trolleySource = trolleySource;
        this.analyticsService = analyticsService;
        this.trolleyService = trolleyService;
        this.cartItemMessageService = cartItemMessageService;
        this.announcerService = announcerService;
    }

    _createClass(CartItemController, [{
        key: 'onError',
        value: function onError(reason) {
            this.analyticsService.pushError(reason);

            this.error = reason;
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            this.clearError();
        }
    }, {
        key: 'clearError',
        value: function clearError() {
            this.error = null;

            this.cartItemMessageService.clearErrors(this.trolleyItem.Stockcode);
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.trolleyService.removeTrolleyItem(this.trolleyItem.Stockcode).then(function () {
                _this.cartItemMessageService.removeItemMessages(_this.trolleyItem.Stockcode);
                _this.announcerService.announce(_this.trolleyItem.Name + ' removed from trolley');
            });
        }
    }]);

    return CartItemController;
}();

var cartItemComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        classModifier: '@?'
    },
    controller: ['$timeout', 'config', 'TrolleySource', 'AnalyticsService', 'TrolleyService', 'CartItemMessageService', 'AnnouncerService', CartItemController],
    template: __webpack_require__(359).trim()
};

module.exports = {
    CartItemController: CartItemController,
    cartItemComponentDefinition: cartItemComponentDefinition
};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartItem\" ng-class=\"$ctrl.classModifier\">\r\n    <div class=\"cartItem-product\">\r\n        <div class=\"cartItem-thumb\">\r\n            <a ui-sref=\"shop.productdetails({productId: $ctrl.trolleyItem.Stockcode, productName: $ctrl.trolleyItem.UrlFriendlyName})\">\r\n                <img ng-src=\"{{ ::$ctrl.trolleyItem.SmallImageFile }}\" alt=\"\" class=\"cartItem-image\" title=\"{{ ::$ctrl.trolleyItem.Name + ' ' + $ctrl.trolleyItem.PackageSize }}\" oly-error-src=\"{{ ::$ctrl.config.DefaultProductImage }}\">\r\n            </a>\r\n\r\n            <p class=\"cartItem-quantity\">\r\n                <span class=\"cartItem-quantityAmount\">{{ $ctrl.trolleyItem.QuantityInTrolley }}</span>\r\n                <span ng-if=\"::($ctrl.trolleyItem.Unit === 'KG')\">kg</span>\r\n                <br>in cart\r\n            </p>\r\n        </div>\r\n\r\n        <div class=\"cartItem-details\" ng-switch=\"::$ctrl.trolleyItem.IsAvailable\">\r\n            <h3>\r\n                <a ui-sref=\"shop.productdetails({productId: $ctrl.trolleyItem.Stockcode, productName: $ctrl.trolleyItem.UrlFriendlyName})\" class=\"cartItem-name\">\r\n                    {{ ::$ctrl.trolleyItem.Name + ' ' + $ctrl.trolleyItem.PackageSize }}\r\n                </a>\r\n            </h3>\r\n\r\n            <button type=\"button\" class=\"cartItem-removeButton\" ng-click=\"$ctrl.remove()\">\r\n                <span class=\"sr-only\">Remove from trolley.</span>\r\n                <i class=\"iconww-Cross\"></i>\r\n            </button>\r\n\r\n            <div class=\"cartItem-cartControlsPrice\" ng-switch-when=\"true\">\r\n                <wow-cart-controls\r\n                    trolley-product=\"$ctrl.trolleyItem\"\r\n                    on-error=\"$ctrl.onError(reason)\"\r\n                    on-success=\"$ctrl.onSuccess()\"\r\n                    source=\"{{ ::$ctrl.trolleySource.collectionZone }}\"\r\n                    class-modifier=\"cartControls--compact\">\r\n                </wow-cart-controls>\r\n                <wow-price\r\n                    price=\"$ctrl.trolleyItem.SalePrice\"\r\n                    class-modifier=\"price--compact\">\r\n                </wow-price>\r\n            </div>\r\n\r\n            <div class=\"cartItem-cartControlsPrice\" ng-switch-when=\"false\">\r\n                <p class=\"button button--secondaryLight is-disabled\">\r\n                    <span class=\"sr-only\">This item is </span>Unavailable<span class=\"sr-only\"> or out of stock </span>\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-cart-item-message\r\n        trolley-item=\"$ctrl.trolleyItem\"\r\n        error=\"$ctrl.error\"\r\n        on-dismiss-error=\"$ctrl.clearError()\">\r\n    </wow-cart-item-message>\r\n</div>\r\n"

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    find = _require.find;

var CartItemMessageController = function () {
    function CartItemMessageController(cartItemMessageService) {
        _classCallCheck(this, CartItemMessageController);

        this.cartItemMessageService = cartItemMessageService;
    }

    _createClass(CartItemMessageController, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.itemMessages = this.cartItemMessageService.buildItemMessages(this.trolleyItem, this.error);

            this.inlineMessage = this.nextMessage(this.itemMessages);
        }
    }, {
        key: 'onDismiss',
        value: function onDismiss(itemMessages, inlineMessage) {
            this.dismissMessage(itemMessages, inlineMessage);

            this.inlineMessage = this.nextMessage(itemMessages);
        }
    }, {
        key: 'dismissMessage',
        value: function dismissMessage(itemMessages, inlineMessage) {
            inlineMessage.isDismissed = true;

            if (inlineMessage === itemMessages.errorMessage) {
                this.onDismissError();
            }
        }
    }, {
        key: 'nextMessage',
        value: function nextMessage(itemMessages) {
            return find([itemMessages.errorMessage, itemMessages.matchedPromotionMessage, itemMessages.missedPromotionMessage], function (message) {
                return message && !message.isDismissed;
            });
        }
    }]);

    return CartItemMessageController;
}();

var cartItemMessageComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        error: '<',
        onDismissError: '&'
    },
    controller: ['CartItemMessageService', CartItemMessageController],
    template: __webpack_require__(361).trim()
};

module.exports = {
    CartItemMessageController: CartItemMessageController,
    cartItemMessageComponentDefinition: cartItemMessageComponentDefinition
};

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"'cartItemMessage cartItemMessage--' + $ctrl.inlineMessage.class\" ng-if=\"$ctrl.inlineMessage && !$ctrl.inlineMessage.isDismissed\">\r\n    <i class=\"cartItemMessage-icon\" ng-class=\"$ctrl.inlineMessage.iconClass\"></i>\r\n    <div class=\"cartItemMessage-content\" ng-include=\"$ctrl.inlineMessage.templateId\"></div>\r\n\r\n    <!-- Dismiss button-->\r\n    <button type=\"button\" ng-click=\"$ctrl.onDismiss($ctrl.itemMessages, $ctrl.inlineMessage)\" class=\"linkButton cartItemMessage-close\">\r\n        <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Dismiss message</span>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1),
    _require = __webpack_require__(363),
    cartItemMessageTemplates = _require.cartItemMessageTemplates,
    _require2 = __webpack_require__(31),
    trolleyQuantityValidation = _require2.trolleyQuantityValidation;
var CartItemMessages = function CartItemMessages(stockcode) {
    _classCallCheck(this, CartItemMessages);

    this.stockcode = stockcode;

    this.errorMessage = null;
    this.matchedPromotionMessage = null;
    this.missedPromotionMessage = null;
};

var CartItemMessageService = function () {
    function CartItemMessageService($templateCache, $sce, settings, currencyCentsFilter) {
        _classCallCheck(this, CartItemMessageService);

        this.$sce = $sce;
        this.currencyCentsFilter = currencyCentsFilter;

        cartItemMessageTemplates.forEach(function (template) {
            $templateCache.put(template.id, template.content);
        });

        this.itemLimitReachedMessage = settings.trolley.itemLimitReached;
        this.itemNotUpdatedMessage = settings.trolley.itemNotUpdated;
        this.deliveryPassLimitMessage = settings.deliveryPass.exceededMaxActiveDeliveryPassesMessage;

        this.itemMessages = {};
    }

    _createClass(CartItemMessageService, [{
        key: 'getItemMessages',
        value: function getItemMessages(stockcode) {
            if (!(stockcode in this.itemMessages)) {
                this.itemMessages[stockcode] = new CartItemMessages(stockcode);
            }

            return this.itemMessages[stockcode];
        }
    }, {
        key: 'removeItemMessages',
        value: function removeItemMessages(stockcode) {
            delete this.itemMessages[stockcode];
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors(stockcode) {
            this.getItemMessages(stockcode).errorMessage = null;
        }
    }, {
        key: 'buildItemMessages',
        value: function buildItemMessages(trolleyItem, error) {
            var itemMessages = this.getItemMessages(trolleyItem.Stockcode);

            if ((!trolleyItem.MatchedPromotions || !trolleyItem.MatchedPromotions.length) && (!trolleyItem.MissedPromotions || !trolleyItem.MissedPromotions.length) && !error && !itemMessages.errorMessage) {
                return new CartItemMessages(trolleyItem.Stockcode);
            }

            // Error may be null even though the error has not been acknowledged.
            // This can happen when using the trolley filter as the trolley items which do not match are destroyed,
            // and their local state is lost.
            //
            // Therefore, we keep the old error message even if error is not set. Error messages are cleared
            // by the cart-item when the quantity is successfully updated or the error is manually dismissed.
            itemMessages.errorMessage = error ? this.buildErrorMessages(trolleyItem, error, itemMessages.errorMessage) : itemMessages.errorMessage;

            itemMessages.matchedPromotionMessage = trolleyItem.MatchedPromotions && trolleyItem.MatchedPromotions.length ? this.buildMatchedPromotionMessage(trolleyItem, itemMessages.matchedPromotionMessage) : null;

            itemMessages.missedPromotionMessage = trolleyItem.MissedPromotions && trolleyItem.MissedPromotions.length ? this.buildMissedPromotionMessage(trolleyItem, itemMessages.missedPromotionMessage) : null;

            return itemMessages;
        }
    }, {
        key: 'buildErrorMessages',
        value: function buildErrorMessages(trolleyItem, errorType, previousErrorMessage) {
            var message = void 0;

            switch (errorType) {
                case trolleyQuantityValidation.INVALID_QUANTITY:
                    message = this.itemNotUpdatedMessage;
                    break;
                case trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED:
                    message = this.itemLimitReachedMessage.replace('{itemLimit}', trolleyItem.SupplyLimit);
                    break;
                case trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED:
                    message = this.deliveryPassLimitMessage;
                    break;
                default:
                    break;
            }

            if (previousErrorMessage && previousErrorMessage.key === message) {
                return previousErrorMessage;
            }

            return !message ? null : {
                key: message,
                class: 'errorQuantity alert alert--error',
                templateId: 'error-quantity',
                isDismissed: false,
                iconClass: 'iconww-QtyDeliveryLimit cartItemMessage-iconQuantityLimit',
                message: { errorMessage: this.$sce.trustAsHtml(message) }
            };
        }
    }, {
        key: 'buildMatchedPromotionMessage',
        value: function buildMatchedPromotionMessage(trolleyItem, previousMatchedPromotionMessage) {
            var matchedPromotion = _.find(trolleyItem.MatchedPromotions, function (promotion) {
                return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff || promotion.IsDeferred || promotion.IsR1Promotion;
            });

            var message = matchedPromotion && (matchedPromotion.IsDeferred || matchedPromotion.IsR1Promotion) ? matchedPromotion.Description : 'You\'ve saved ' + this.currencyCentsFilter(trolleyItem.ListPrice * trolleyItem.QuantityInTrolley - trolleyItem.SalePrice);

            if (previousMatchedPromotionMessage && previousMatchedPromotionMessage.key === message) {
                return previousMatchedPromotionMessage;
            }

            return {
                key: message,
                class: 'matchedPromotion alert alert--success',
                templateId: 'matched-promotion',
                isDismissed: false,
                iconClass: this.getPromotionIconClass(matchedPromotion),
                message: {
                    promotionDescription: this.$sce.trustAsHtml(message)
                }
            };
        }
    }, {
        key: 'buildMissedPromotionMessage',
        value: function buildMissedPromotionMessage(trolleyItem, previousMissedPromotionMessage) {
            var missedPromotion = _.find(trolleyItem.MissedPromotions, function (promotion) {
                return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff;
            });

            if (previousMissedPromotionMessage && previousMissedPromotionMessage.key === missedPromotion.Description) {
                return previousMissedPromotionMessage;
            }

            return {
                key: missedPromotion.Description,
                class: 'missedPromotion alert alert--info',
                templateId: 'missed-promotion',
                isDismissed: false,
                iconClass: this.getPromotionIconClass(missedPromotion),
                message: {
                    promotionDescription: missedPromotion.Description,
                    promotionLink: missedPromotion.Link
                }
            };
        }
    }, {
        key: 'getPromotionIconClass',
        value: function getPromotionIconClass(promotion) {
            return promotion && (promotion.IsDeferred || promotion.IsR1Promotion) ? 'iconww-RewardPointsEarned cartItemMessage-iconRewardPointsEarned' : 'iconww-TrolleySaver cartItemMessage-iconTrolleySaver';
        }
    }]);

    return CartItemMessageService;
}();

CartItemMessageService.$inject = ['$templateCache', '$sce', 'Settings', 'wowCurrencyCentsFilter'];

module.exports = {
    CartItemMessageService: CartItemMessageService,
    CartItemMessages: CartItemMessages
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cartItemMessageTemplates = [{
    id: 'matched-promotion',
    content: __webpack_require__(364).trim()
}, {
    id: 'missed-promotion',
    content: __webpack_require__(365).trim()
}, {
    id: 'error-quantity',
    content: __webpack_require__(366).trim()
}];

module.exports = { cartItemMessageTemplates: cartItemMessageTemplates };

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "<span class=\"cartItemMessage--matchedPromotion-description\" ng-bind-html=\"$ctrl.inlineMessage.message.promotionDescription\"></span>\r\n"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartItemMessage--missedPromotion-heading\">\r\n    <wow-setting setting-group=\"Trolley\" setting-name=\"ProductPromoMessage\"></wow-setting>\r\n</div>\r\n<a ng-href=\"{{$ctrl.inlineMessage.message.promotionLink}}\" class=\"cartItemMessage--missedPromotion-description\">\r\n    {{$ctrl.inlineMessage.message.promotionDescription}}\r\n</a>\r\n"

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<span class=\"cartItemMessage--errorQuanity\" ng-bind-html=\"$ctrl.inlineMessage.message.errorMessage\"></span>\r\n"

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartItemGroupController = function CartItemGroupController() {
    _classCallCheck(this, CartItemGroupController);
};

var cartItemGroupComponentDefinition = {
    bindings: {
        items: '<',
        groupName: '@',
        message: '@',
        actionLabel: '@',
        onAction: '&'
    },
    controller: CartItemGroupController,
    template: __webpack_require__(368).trim()
};

module.exports = {
    CartItemGroupController: CartItemGroupController,
    cartItemGroupComponentDefinition: cartItemGroupComponentDefinition
};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = "<section aria-label=\"{{ ::$ctrl.groupName }}\" class=\"cartItemGroup\">\r\n    <div class=\"cartItemGroup-container alert alert--info\" role=\"alert\">\r\n        <i class=\"iconww-ProductNa cartItemGroup-icon\"></i>\r\n        <div class=\"cartItemGroup-message\">\r\n            <p>{{ ::$ctrl.message }}</p>\r\n\r\n            <button type=\"button\" class=\"cartItemGroup-action linkButton\" ng-click=\"$ctrl.onAction()\">\r\n                {{ ::$ctrl.actionLabel }}\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-cart-item\r\n        ng-repeat=\"trolleyItem in $ctrl.items track by trolleyItem.Stockcode\"\r\n        trolley-item=\"trolleyItem\"\r\n        class-modifier=\"{{ $last ? 'cartItemGroup-lastItem' : '' }}\">\r\n    </wow-cart-item>\r\n</section>\r\n"

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var CartControlsController = function () {
    function CartControlsController($element, $timeout, $q, $state, moveFocus, trolleyService, analyticsService) {
        _classCallCheck(this, CartControlsController);

        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.trolleyService = trolleyService;
        this.analyticsService = analyticsService;

        this.updateInTrolley = _.debounce(this.updateInTrolley, 500);
    }

    _createClass(CartControlsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.product = this.trolleyProduct ? this.trolleyProduct : this.shelfProduct;
            this.isInKilograms = this.product.Unit === 'KG';
            this.defaultQuantity = this.isInKilograms ? this.product.MinimumQuantity : 1;

            this.buttonPostfix = this.isInKilograms ? ' quantity by ' + this.product.MinimumQuantity + ' kg.' : ' quantity.';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            this.product = this.trolleyProduct ? this.trolleyProduct : this.shelfProduct;

            if (this.shelfProduct) {
                this.shelfProduct.IsInTrolley = !!this.trolleyProduct;
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.product.IsDeliveryPass) {
                this.trolleyService.deliveryPassLimitReached[this.product.Stockcode] = false;
                this.trolleyService.showDCPdeliveryPassLimitReachedMsg = false;
            }
        }

        /**
         * Performs validation of the new quantity and performs the quantity update
         * if validation succeeds. This method is the entry point and is the only
         * method which should be used to add/update/remove an item in the cart.
         *
         * @param {number} newQuantity
         * @param {boolean} [allowRemove=false] Indicates whether the product can be removed.
         *  When true, if the new quantity is zero, the product is removed from the trolley.
         * @returns {Promise<any>}
         *
         * @memberOf CartControlsController
         */

    }, {
        key: 'validateAndUpdateQuantity',
        value: function validateAndUpdateQuantity(newQuantity) {
            var _this = this;

            var allowRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (newQuantity == null) {
                // The user has backspaced, we must wait for more input.
                return this.$q.reject();
            }

            newQuantity = this.correctRoundingErrors(newQuantity);

            if (allowRemove && newQuantity === 0) {
                return this.removeFromTrolley(this.product);
            }

            return this.$q.all({
                validationResult: this.validateQuantity(newQuantity),
                updateResponse: this.updateQuantity(newQuantity)
            }).then(function (result) {
                return _this.onValidateAndUpdate(result);
            });
        }
    }, {
        key: 'onValidateAndUpdate',
        value: function onValidateAndUpdate(_ref) {
            var _this2 = this;

            var validationResult = _ref.validationResult,
                updateResponse = _ref.updateResponse;

            if (updateResponse) {
                this.checkForMessages(updateResponse.Message);
            }

            if (this.onError && !validationResult.isValid) {
                this.$timeout(function () {
                    return _this2.onError({ reason: validationResult.reason });
                });
            } else if (this.onSuccess && validationResult.isValid) {
                this.$timeout(function () {
                    return _this2.onSuccess();
                });
            }
        }
    }, {
        key: 'validateQuantity',
        value: function validateQuantity(newQuantity) {
            var _this3 = this;

            return this.validateDeliveryPassLimit(this.product, newQuantity).then(function () {
                return _this3.trolleyService.validateQuantity(_this3.product, newQuantity);
            });
        }
    }, {
        key: 'updateQuantity',
        value: function updateQuantity(newQuantity) {
            // This is a dangerous hack that prevents the trolley response
            // coming back and resetting the quantity while the user is still
            // clicking the plus button. It will make the trolley service
            // throw away responses from previous update requests.
            this.trolleyService.updateRequestCount++;

            var updatePromise = this.product.IsInTrolley ? this.updateInTrolley(this.product, newQuantity) : this.addToTrolley(this.product, newQuantity);

            // Optimistically update the quantity.
            this.product.QuantityInTrolley = newQuantity;

            return updatePromise;
        }
    }, {
        key: 'updateInTrolley',
        value: function updateInTrolley(product, quantity) {
            return this.trolleyService.updateTrolleyItem(product, quantity, this.source);
        }
    }, {
        key: 'addToTrolley',
        value: function addToTrolley(product, quantity) {
            var _this4 = this;

            this.product.IsInTrolley = true;
            this.moveFocus(function () {
                return _this4.$element.find('._inTrolleyFocus');
            });

            return this.trolleyService.addItemToTrolley(product, quantity, this.source, this.$state.params.searchTerm);
        }
    }, {
        key: 'removeFromTrolley',
        value: function removeFromTrolley(product) {
            var _this5 = this;

            if (this.onRemove) {
                this.onRemove();
            }

            // If there are any pending debounced quantity updates (e.g. from the user decrementing)
            // we want to cancel those since the product is being removed.
            this.updateInTrolley.cancel();

            this.product.IsInTrolley = false;
            this.moveFocus(function () {
                return _this5.$element.find('._outOfTrolleyFocus');
            });

            return this.trolleyService.removeTrolleyItem(product.Stockcode);
        }
    }, {
        key: 'correctRoundingErrors',
        value: function correctRoundingErrors(quantity) {
            // correct for floating point rounding errors
            return this.isInKilograms ? parseFloat(quantity.toFixed(2)) : quantity;
        }
    }, {
        key: 'validateDeliveryPassLimit',
        value: function validateDeliveryPassLimit(product, quantity) {
            var _this6 = this;

            if (!product.IsDeliveryPass) {
                return this.$q.when(true);
            }

            this.trolleyService.deliveryPassLimitReached[product.Stockcode] = false;
            this.trolleyService.showDCPdeliveryPassLimitReachedMsg = false;

            return this.trolleyService.validateDeliveryPassLimit(product, quantity).then(function (response) {
                return _this6.onDeliveryPassLimitValidation(product, quantity, response.NewQuantity);
            });
        }
    }, {
        key: 'onDeliveryPassLimitValidation',
        value: function onDeliveryPassLimitValidation(product, newQuantity, validatedQuantity) {
            if (newQuantity === validatedQuantity) {
                return;
            }

            this.trolleyService.deliveryPassLimitReached[product.Stockcode] = true;
            this.trolleyService.showDCPdeliveryPassLimitReachedMsg = !!this.shelfProduct;

            product.QuantityInTrolley = validatedQuantity;
            product.IsInTrolley = validatedQuantity > 0;
        }
    }, {
        key: 'checkForMessages',
        value: function checkForMessages(message) {
            // If the response has a message, show a dialog with the message.
            if (message && !this.$state.is('checkout')) {
                this.modalMessage = message;
                this.analyticsService.pushError(message);
            }
        }
    }, {
        key: 'resetModalMessage',
        value: function resetModalMessage() {
            this.modalMessage = null;
            this.moveFocus(this.$element.find('._inTrolleyFocus'));
        }
    }]);

    return CartControlsController;
}();

CartControlsController.$inject = ['$element', '$timeout', '$q', '$state', 'MoveFocus', 'TrolleyService', 'AnalyticsService'];

var cartControlsComponentDefinition = {
    bindings: {
        trolleyProduct: '<',
        shelfProduct: '<?',
        source: '@',
        classModifier: '@?',
        onSuccess: '&?',
        onError: '&?',
        onRemove: '&?'
    },
    controller: CartControlsController,
    template: __webpack_require__(370).trim()
};

module.exports = {
    CartControlsController: CartControlsController,
    cartControlsComponentDefinition: cartControlsComponentDefinition
};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"::$ctrl.product.IsAvailable\">\r\n    <div class=\"cartControls\" ng-class=\"::$ctrl.classModifier\" ng-switch-when=\"true\" ng-switch=\"$ctrl.product.IsInTrolley\">\r\n        <button\r\n            type=\"button\"\r\n            class=\"cartControls-addButton button button--primary _outOfTrolleyFocus\"\r\n            ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.defaultQuantity)\"\r\n            ng-switch-when=\"false\">\r\n\r\n            <span class=\"cartControls-addCart\">Add to cart\r\n                <i class=\"cartControls-cartIcon iconww-Cart\"></i>\r\n            </span>\r\n        </button>\r\n\r\n        <div ng-switch-when=\"true\" class=\"cartControls-inTrolley _inTrolleyFocus\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"button button--primary cartControls-quantityButton cartControls-decrementButton\"\r\n                ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley - $ctrl.defaultQuantity, true)\">\r\n\r\n                <span class=\"sr-only\">Decrease {{::$ctrl.buttonPostfix}}</span>\r\n                <i class=\"iconww-Minus\"></i>\r\n            </button>\r\n\r\n            <input\r\n                type=\"number\"\r\n                step=\"{{ ::$ctrl.defaultQuantity }}\"\r\n                min=\"0\"\r\n                max=\"{{ ::$ctrl.product.SupplyLimit }}\"\r\n                aria-label=\"Order quantity\"\r\n                class=\"cartControls-quantityInput\"\r\n                ng-class=\"::{ 'is-kilograms': $ctrl.isInKilograms }\"\r\n                ng-model=\"$ctrl.product.QuantityInTrolley\"\r\n                ng-model-options=\"::{ allowInvalid: true }\"\r\n                ng-change=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley, !$ctrl.isInKilograms)\" />\r\n\r\n            <span ng-if=\"::$ctrl.isInKilograms\" class=\"cartControls-kgLabel\">kg</span>\r\n\r\n            <button\r\n                type=\"button\"\r\n                class=\"button button--primary cartControls-quantityButton cartControls-incrementButton\"\r\n                ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley + $ctrl.defaultQuantity)\"\r\n                ng-disabled=\"$ctrl.product.QuantityInTrolley >= $ctrl.product.SupplyLimit || $ctrl.trolleyService.deliveryPassLimitReached[$ctrl.product.Stockcode]\">\r\n\r\n                <span class=\"sr-only\">Increase {{::$ctrl.buttonPostfix}}</span>\r\n                <i class=\"iconww-Plus\"></i>\r\n            </button>\r\n        </div>\r\n\r\n        <wow-dialog\r\n            ng-if=\"$ctrl.modalMessage\"\r\n            dialog-name=\"restricted window\"\r\n            message=\"{{ $ctrl.modalMessage }}\"\r\n            on-dismiss=\"::$ctrl.resetModalMessage()\">\r\n        </wow-dialog>\r\n    </div>\r\n\r\n    <div class=\"cartControls\" ng-switch-when=\"false\">\r\n        <button type=\"button\" class=\"cartControls-addButton cartControls-addCart button button--secondaryLight\" disabled>\r\n            Unavailable\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cartMessageController = function () {
    function cartMessageController() {
        _classCallCheck(this, cartMessageController);

        this.isDismissed = false;
    }

    _createClass(cartMessageController, [{
        key: 'dismissMessage',
        value: function dismissMessage() {
            this.isDismissed = true;
        }
    }]);

    return cartMessageController;
}();

var cartMessageComponentDefinition = {
    controller: cartMessageController,
    bindings: {
        message: '<'
    },
    template: __webpack_require__(372).trim()
};

module.exports = {
    cartMessageController: cartMessageController,
    cartMessageComponentDefinition: cartMessageComponentDefinition
};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartMessage\" ng-if=\"!$ctrl.isDismissed\" role=\"status\" aria-live=\"polite\" aria-atomic=\"true\">\r\n    <p class=\"cartMessage-heading heading4\">Cart Updated</p>\r\n    <p class=\"cartMessage-text\">\r\n        {{$ctrl.message}}\r\n    </p>\r\n    <button class=\"cartMessage-closeText linkButton\" ng-click=\"$ctrl.dismissMessage()\">Ok thanks<span class=\"sr-only\">, close message</span></button>\r\n    <button class=\"cartMessage-closeButton\" ng-click=\"$ctrl.dismissMessage()\">\r\n        <span class=\"sr-only\">Close this dialog.</span>\r\n        <i class=\"iconww-Cross\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var steps = {
    INITIAL: 'INITIAL',
    SAVING: 'SAVING',
    SAVED: 'SAVED'
};

var CartSaveListController = function () {
    function CartSaveListController($timeout, $rootScope, $sanitize, moveFocus, sessionStorage, trolleyService, shopperService, loginService, shopPageStateService, savedListsService) {
        _classCallCheck(this, CartSaveListController);

        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$sanitize = $sanitize;

        this.moveFocus = moveFocus;
        this.sessionStorage = sessionStorage;
        this.trolleyService = trolleyService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.shopPageStateService = shopPageStateService;
        this.savedListsService = savedListsService;

        this.steps = steps;
    }

    _createClass(CartSaveListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.step = this.steps.INITIAL;
            this.saving = false;

            this.pendingSaveAsListStorageKey = 'CartSaveListController:pendingSaveAsList';

            if (!this.shopperService.IsGuest) {
                this.savePendingList(this.sessionStorage.getJsonAndRemove(this.pendingSaveAsListStorageKey));
            }
        }
    }, {
        key: 'savePendingList',
        value: function savePendingList(listName) {
            var _this = this;

            if (!listName) return;

            this.newListName = listName;
            this.step = this.steps.SAVING;
            this.shopPageStateService.isCartOpen = true;

            // Waiting for cart to open and the step to change
            this.$timeout(function () {
                _this.saveForm.$setSubmitted();
                _this.save(_this.newListName);
            });
        }
    }, {
        key: 'promptForLogin',
        value: function promptForLogin(listName) {
            var _this2 = this;

            return this.loginService.promptForLogin('Please login to save your trolley as a list.', undefined, undefined, { reload: false }, function () {
                _this2.sessionStorage.setJson(_this2.pendingSaveAsListStorageKey, listName);
            });
        }
    }, {
        key: 'save',
        value: function save(listName) {
            var _this3 = this;

            listName = this.$sanitize(listName).trim();

            this.setServerErrors(null);
            this.saving = true;

            if (this.shopperService.IsGuest) {
                return this.promptForLogin(listName);
            }

            return this.trolleyService.saveTrolleyAsList(listName).then(function (response) {
                return _this3.onSaved(response.plain());
            }).finally(function () {
                return _this3.saving = false;
            });
        }
    }, {
        key: 'onSaved',
        value: function onSaved(response) {
            if (response.Success) {
                this.step = this.steps.SAVED;

                this.savedListsService.invalidate();
                this.$rootScope.$broadcast('saveTrolleyAsList:ListSuccessfull'); // TODO: refactor lists menu to update automatically without this
            } else {
                this.setServerErrors(response.Message);
            }
        }
    }, {
        key: 'setServerErrors',
        value: function setServerErrors(message) {
            if (this.saveForm) {
                this.saveForm.newListName.$setValidity('server', !message);
            }

            this.serverErrorMessage = message;
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.newListName = '';
            this.setServerErrors(null);

            if (this.saveForm) {
                this.saveForm.$setPristine();
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.clear();
            this.step = this.steps.INITIAL;

            this.moveFocus('._saveCartListInitial');
        }
    }]);

    return CartSaveListController;
}();

var cartSaveListComponentDefinition = {
    controller: ['$timeout', '$rootScope', '$sanitize', 'MoveFocus', 'SessionStorageWrapper', 'TrolleyService', 'ShopperService', 'LoginService', 'ShopPageStateService', 'SavedListsService', CartSaveListController],
    template: __webpack_require__(374).trim()
};

module.exports = {
    CartSaveListController: CartSaveListController,
    cartSaveListComponentDefinition: cartSaveListComponentDefinition
};

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartSaveList\" ng-switch=\"$ctrl.step\">\r\n    <button ng-switch-when=\"INITIAL\" class=\"linkButton cartSaveList-button _saveCartListInitial\" ng-click=\"$ctrl.step = $ctrl.steps.SAVING\" >\r\n        <wow-setting setting-group=\"Trolley\" setting-name=\"SaveTrolleyAsListLinkText\"></wow-setting>\r\n        <i class=\"iconww-List cartSaveList-buttonIcon\"></i>\r\n    </button>\r\n\r\n    <div class=\"cartSaveList-saving\" ng-switch-when=\"SAVING\">\r\n        <form name=\"$ctrl.saveForm\" class=\"cartSaveList-form\" ng-submit=\"$ctrl.saveForm.$valid && $ctrl.save($ctrl.newListName)\" novalidate autocomplete=\"off\">\r\n            <wow-input-container class=\"cartSaveList-inputContainer\">\r\n                <label for=\"cartSaveList-input\">Enter a name for this list</label>\r\n                <input\r\n                    type=\"text\"\r\n                    name=\"newListName\"\r\n                    id=\"cartSaveList-input\"\r\n                    class=\"cartSaveList-input\"\r\n                    required\r\n                    ng-model=\"$ctrl.newListName\"\r\n                    ng-change=\"$ctrl.setServerErrors(null)\"\r\n                    oly-grab-focus=\"true\">\r\n\r\n                <span ng-messages=\"$ctrl.saveForm.newListName.$error\" class=\"wowInput-errors\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">List name is required.</span>\r\n                    <span ng-message=\"server\" class=\"wowInput-error\">{{ $ctrl.serverErrorMessage }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <button type=\"button\" class=\"cartSaveList-clearInput linkButton\" ng-show=\"$ctrl.newListName.length > 0\" ng-click=\"$ctrl.clear()\" oly-move-focus=\"cartSaveList-input\">\r\n                <i class=\"iconww-Cross\"></i>\r\n                <span class=\"sr-only\">Clear list name</span>\r\n            </button>\r\n\r\n            <oly-button class=\"cartSaveList-saveLoadingButton\" loading=\"{state: $ctrl.saving, message: 'Please wait, saving your cart as a list'}\" child-spinner-class=\"cartSaveList-savingSpinner\">\r\n                <button type=\"submit\" class=\"button button--primary cartSaveList-saveButton\">\r\n                    Save <span class=\"sr-only\">your trolley as a list</span>\r\n                </button>\r\n            </oly-button>\r\n        </form>\r\n\r\n        <button type=\"button\" class=\"linkButton cartSaveList-cancelButton\" ng-click=\"$ctrl.reset()\">Cancel</button>\r\n    </div>\r\n\r\n    <div class=\"cartSaveList-saved\" ng-switch-when=\"SAVED\">\r\n        <p class=\"cartSaveList-savedMessage\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\r\n            List saved\r\n            <i class=\"iconww-Tick cartSaveList-savedTick\"></i>\r\n        </p>\r\n\r\n        <button type=\"button\" class=\"linkButton cartSaveList-closeSavedButton\" ng-click=\"$ctrl.reset()\" oly-grab-focus=\"true\">\r\n            Close <span class=\"sr-only\"> and reset save to list form.</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartFilterController = function CartFilterController() {
    _classCallCheck(this, CartFilterController);
};

var cartFilterComponentDefinition = {
    bindings: {
        searchFilter: '=',
        itemCount: '='
    },
    controller: CartFilterController,
    template: __webpack_require__(376).trim()
};

module.exports = {
    CartFilterController: CartFilterController,
    cartFilterComponentDefinition: cartFilterComponentDefinition
};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<form action=\".\" class=\"cartFilter\" novalidate autocomplete=\"off\" ng-submit=\"$event.preventDefault()\" ng-switch=\"!!$ctrl.searchFilter\">\r\n    <wow-input-container class=\"cartFilter-inputContainer has-control\">\r\n        <label for=\"cart-filter\">\r\n            <wow-setting setting-group=\"Trolley\" setting-name=\"SearchFilterMessage\"></wow-setting>\r\n            <span class=\"sr-only\">; type here to auto filter your trolley matching entered text</span>\r\n        </label>\r\n        <input id=\"cart-filter\" type=\"search\" ng-model=\"$ctrl.searchFilter\" ng-model-options=\"{ debounce: 500 }\" aria-controls=\"cartFilter-status\" />\r\n        <button class=\"wowInput-control\" ng-switch-when=\"false\" oly-move-focus=\"cart-filter\">\r\n            <i class=\"iconww-Search\"></i>\r\n        </button>\r\n        <button type=\"reset\" class=\"wowInput-control\" ng-switch-when=\"true\" ng-click=\"$ctrl.searchFilter = ''\" oly-move-focus=\"cart-filter\">\r\n            <span>\r\n                <i class=\"iconww-Cross\"></i>\r\n                <span class=\"sr-only\">Clear search text</span>\r\n            </span>\r\n        </button>\r\n    </wow-input-container>\r\n</form>\r\n\r\n<p id=\"cartFilter-status\" class=\"cartFilter-status\" ng-class=\"{'sr-only': !$ctrl.searchFilter}\" role=\"status\" ng-switch=\"!!$ctrl.searchFilter\" aria-atomic=\"true\">\r\n    <span ng-switch-when=\"true\">({{ $ctrl.itemCount }}) Results found for \"{{ $ctrl.searchFilter }}\"</span>\r\n    <span ng-switch-when=\"false\">{{ $ctrl.itemCount }} products in your trolley</span>\r\n</p>\r\n"

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var loyaltyPointsCalculator = __webpack_require__(14);

var CartLoyaltyController = function () {
    function CartLoyaltyController(featureService, settingsService, trolleyService) {
        var _this = this;

        _classCallCheck(this, CartLoyaltyController);

        this.trolleyService = trolleyService;
        this.settingsService = settingsService;
        this.featureService = featureService;
        settingsService.getSettingValue('EverydayRewards', 'CardName').then(function (setting) {
            _this.rewardsCardName = setting;
        });
    }

    _createClass(CartLoyaltyController, [{
        key: 'isOptOutSaveForLaterAndBalanceIsLessThanMinimum',
        value: function isOptOutSaveForLaterAndBalanceIsLessThanMinimum() {
            return !this.shouldShowSaveForLaterPreference() && this.isLowerThanMinimumRedemptionBalance();
        }
    }, {
        key: 'getToSpendImageProperties',
        value: function getToSpendImageProperties() {
            if (!this.shouldShowSaveForLaterPreference()) {
                return { srcName: 'icon-rewards-burn.svg', className: 'cartLoyalty-pointsToSpendIcon' };
            } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return { srcName: 'icon-rewards-qff-plane.svg', className: 'cartLoyalty-pointsQffIcon' };
            } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
                return { srcName: 'icon-rewards-xmas-sock.svg', className: 'cartLoyalty-pointsXmasIcon' };
            }
            return { srcName: 'icon-tospend.png', className: 'cartLoyalty-pointsToSpendIcon' };
        }
    }, {
        key: 'shouldShowSaveForLaterPreference',
        value: function shouldShowSaveForLaterPreference() {
            return this.getSaveForLaterPreference() === 'Christmas' || this.getSaveForLaterPreference() === 'QuarterlyQff';
        }
    }, {
        key: 'getToSpendDisplayMessage',
        value: function getToSpendDisplayMessage() {
            if (this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR QANTAS' : 'SAVED FOR QANTAS';
            }
            if (this.getSaveForLaterPreference() === 'Christmas') {
                return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR XMAS' : 'SAVED FOR XMAS';
            }
            return 'TO SPEND';
        }
    }, {
        key: 'getScreenReaderMessage',
        value: function getScreenReaderMessage() {
            if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return 'to save for Qantas';
            }
            if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
                return 'to save for Christmas';
            }
            return 'to spend';
        }
    }, {
        key: 'getLowerThanMinimumBalanceStyle',
        value: function getLowerThanMinimumBalanceStyle() {
            return this.isLowerThanMinimumRedemptionBalance() ? 'cartLoyalty-pointsTopRowLowerThanMinimumBalance' : '';
        }
    }, {
        key: 'isLowerThanMinimumRedemptionBalance',
        value: function isLowerThanMinimumRedemptionBalance() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsLessThanMinimumRedemptionBalance;
        }
    }, {
        key: 'getWowRewardsEarned',
        value: function getWowRewardsEarned() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsEarned;
        }
    }, {
        key: 'getWowRewardsToSpend',
        value: function getWowRewardsToSpend() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsToSpend;
        }
    }, {
        key: 'getRewardsPoints',
        value: function getRewardsPoints() {
            return loyaltyPointsCalculator(this.getWowRewardsEarned());
        }
    }, {
        key: 'getSaveForLaterPreference',
        value: function getSaveForLaterPreference() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.SaveForLaterPreference;
        }
    }, {
        key: 'shouldShowWowRewardsSummary',
        value: function shouldShowWowRewardsSummary() {
            var isEnabledGetEdrPointsBalanceOnLogin = this.featureService.isEnabled(this.featureService.features.enableGetEdrPointsBalanceOnLogin);
            var isErrorInGettingWowRewardsBalance = this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsErrorInGettingWowRewardsBalance;
            var isRegisteredWowRewardsCustomer = this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsWowRewardsCardRegistered;

            return isEnabledGetEdrPointsBalanceOnLogin && !isErrorInGettingWowRewardsBalance && isRegisteredWowRewardsCustomer;
        }
    }]);

    return CartLoyaltyController;
}();

var cartLoyaltyComponentDefinition = {
    controller: ['FeatureService', 'SettingsService', 'TrolleyService', CartLoyaltyController],
    template: __webpack_require__(378).trim()
};

module.exports = {
    CartLoyaltyController: CartLoyaltyController,
    cartLoyaltyComponentDefinition: cartLoyaltyComponentDefinition
};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = "<!--NG IF - HIDE IF FAIL TO GET REDEEMABLE POINTS FROM LMS-->\r\n<div class=\"cartLoyalty-pointsContainer\" ng-if=\"$ctrl.shouldShowWowRewardsSummary()\">\r\n\r\n    <div class=\"cartLoyalty-points cartLoyalty-redeemable cartLoyalty-pointsLeft\"\r\n         ng-if=\"!$ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()\">\r\n        <img class=\"cartLoyalty-edr\" src=\"/Images/Collectionzone/icon-rewards-card.png\"/>\r\n        <div class=\"cartLoyalty-pointsTopRow\"\r\n             ng-class=\"{'cartLoyalty-pointsTopRowLowerThanMinimumBalance' : $ctrl.isLowerThanMinimumRedemptionBalance() && $ctrl.shouldShowSaveForLaterPreference()}\">\r\n            <span class=\"sr-only\">{{::$ctrl.rewardsCardName}}, {{$ctrl.getScreenReaderMessage()}}</span>\r\n            <div class=\"cartLoyalty-pointsRewardsContainer\">\r\n                <img class=\"cartLoyalty-pointsIcon {{$ctrl.getToSpendImageProperties().className}}\"\r\n                     ng-src=\"/Images/Collectionzone/{{$ctrl.getToSpendImageProperties().srcName}}\"/>\r\n                <span class=\"cartLoyalty-pointsTotal\" ng-if=\"!$ctrl.isLowerThanMinimumRedemptionBalance()\">\r\n                    {{$ctrl.getWowRewardsToSpend() | wowCurrency}}\r\n                </span>\r\n            </div>\r\n            <div aria-hidden=\"true\" class=\"cartLoyalty-pointsTitle\" ng-bind-html=\"$ctrl.getToSpendDisplayMessage() | sanitize\"></div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"cartLoyalty-points cartLoyalty-accrued cartLoyalty-pointsRight\"\r\n         ng-class=\"{'cartLoyalty-pointsWithBalanceLessThanMinimum' : $ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()}\">\r\n        <span class=\"sr-only\">{{::$ctrl.rewardsCardName}}, You'll Earn</span>\r\n        <img class=\"cartLoyalty-edrLessThanMinimumBalance\"\r\n             src=\"/Images/Collectionzone/icon-rewards-card.png\"\r\n             ng-if=\"$ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()\"/>\r\n        <div class=\"cartLoyalty-pointsTopRow\">\r\n            <div class=\"cartLoyalty-pointsRewardsContainer\">\r\n                <img class=\"cartLoyalty-pointsIcon cartLoyalty-pointsWoWDollarIcon cartLoyalty-pointsIconWithEarnPoints\"\r\n                     ng-src=\"/Images/Collectionzone/icon-rewards-wow-dollar.svg\"/>\r\n                <span class=\"cartLoyalty-pointsTotal\">{{$ctrl.getWowRewardsEarned() | wowLoyaltyPoints : false}}</span>\r\n                <span class=\"cartLoyalty-pointsEarn\">points</span>\r\n            </div>\r\n            <div aria-hidden=\"true\" class=\"cartLoyalty-pointsTitle\">You'll Earn</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartDeliveryFeeController = function () {
    function CartDeliveryFeeController($sce, settings, shopperService, trolleyService, deliveryPassService, deliveryFeeService) {
        _classCallCheck(this, CartDeliveryFeeController);

        this.$sce = $sce;
        this.settings = settings;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.deliveryPassService = deliveryPassService;
        this.deliveryFeeService = deliveryFeeService;

        this.deliveryFeeStructure = null;
    }

    _createClass(CartDeliveryFeeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showDeliveryFeeStructure = false;

            this.deliveryPassService.showShopperDeliveryPassPrompt();
        }
    }, {
        key: 'toggleDeliveryFeeStructure',
        value: function toggleDeliveryFeeStructure() {
            var _this = this;

            this.showDeliveryFeeStructure = !this.showDeliveryFeeStructure;

            if (this.showDeliveryFeeStructure) {
                this.deliveryFeeService.getDeliveryFeeStructure().then(function (response) {
                    _this.deliveryFeeStructure = response;
                });
            }
        }
    }]);

    return CartDeliveryFeeController;
}();

var cartDeliveryFeeComponentDefinition = {
    controller: ['$sce', 'Settings', 'ShopperService', 'TrolleyService', 'DeliveryPassService', 'DeliveryFeeService', CartDeliveryFeeController],
    template: __webpack_require__(380).trim()
};

module.exports = {
    CartDeliveryFeeController: CartDeliveryFeeController,
    cartDeliveryFeeComponentDefinition: cartDeliveryFeeComponentDefinition
};

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartDeliveryFee\">\r\n    <i class=\"iconww-DeliveryFee cartDeliveryFee-icon\"></i>\r\n\r\n    <div class=\"cartDeliveryFee-container\">\r\n        <div class=\"cartDeliveryFee-priceContainer\" ng-class=\"{ 'is-priceOnly': !$ctrl.deliveryPassService.deliveryPassPrompt.PromptText}\">\r\n            <button\r\n                class=\"text-left linkButton\"\r\n                role=\"button heading\"\r\n                aria-expanded=\"{{ $ctrl.showDeliveryFeeStructure }}\"\r\n                aria-controls=\"cartDeliveryFee-fees\"\r\n                ng-click=\"::$ctrl.toggleDeliveryFeeStructure()\"\r\n                ng-disabled=\"$ctrl.shopperService.IsGuest\">\r\n\r\n                {{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }}\r\n\r\n                <span ng-if=\"!$ctrl.shopperService.IsGuest\">\r\n                    <span class=\"sr-only\">Show {{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }} thresholds</span>\r\n                    <i ng-class=\"$ctrl.showDeliveryFeeStructure ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n                </span>\r\n            </button>\r\n\r\n            <div class=\"cartDeliveryFee-deliveryPrice\" ng-show=\"!$ctrl.showDeliveryFeeStructure\" ng-switch=\"$ctrl.trolleyService.deliveryFee > 0\">\r\n                <wow-price\r\n                    price=\"$ctrl.trolleyService.deliveryFee\"\r\n                    class-modifier=\"price--compact\"\r\n                    ng-switch-when=\"true\">\r\n                </wow-price>\r\n                <div class=\"cartDeliveryFee-free\" ng-switch-when=\"false\">\r\n                    Free\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-switch=\"$ctrl.showDeliveryFeeStructure\">\r\n            <div ng-switch-when=\"false\">\r\n                <p\r\n                    class=\"cartDeliveryFee-content cartDeliveryFee-blurb\"\r\n                    ng-class=\"{ 'has-button': $ctrl.deliveryPassService.deliveryPassPrompt.PromptText }\"\r\n                    ng-if=\"$ctrl.deliveryPassService.deliveryPassPrompt.ContentText\"\r\n                    ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.deliveryPassService.deliveryPassPrompt.ContentText)\">\r\n                </p>\r\n\r\n                <a\r\n                    class=\"button cartDeliveryFee-promptText\"\r\n                    ng-href=\"{{ ::$ctrl.settings.deliveryPass.deliverySaverPageRedirectUrl }}\"\r\n                    ng-if=\"$ctrl.deliveryPassService.deliveryPassPrompt.PromptText\">\r\n                    {{ $ctrl.deliveryPassService.deliveryPassPrompt.PromptText }}\r\n                </a>\r\n            </div>\r\n\r\n            <div ng-switch-when=\"true\" id=\"cartDeliveryFee-fees\" role=\"region\">\r\n                <table>\r\n                    <caption class=\"sr-only\">{{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }} thresholds</caption>\r\n                    <thead class=\"sr-only\">\r\n                        <tr>\r\n                            <th>Order value</th>\r\n                            <th>Delivery Fee</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr class=\"cartDeliveryFee-feeRow\" ng-repeat=\"deliveryFeeRow in ::$ctrl.deliveryFeeStructure.DeliveryFeeStructureLevels\">\r\n                            <td class=\"cartDeliveryFee-orderTotalCell\">{{ ::deliveryFeeRow.OrderValue }}</td>\r\n                            <td class=\"cartDeliveryFee-feeCell\">{{ ::deliveryFeeRow.DeliveryFee }}</td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n\r\n                <p class=\"cartDeliveryFee-note\" ng-if=\"$ctrl.deliveryFeeStructure.ScheduleReservationDeliveryFeeNote\">\r\n                    {{ ::$ctrl.deliveryFeeStructure.ScheduleReservationDeliveryFeeNote }}\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartOrderManagementController = function () {
    function CartOrderManagementController(orderManagementService) {
        _classCallCheck(this, CartOrderManagementController);

        this.orderManagement = orderManagementService;
    }

    _createClass(CartOrderManagementController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.orderManagement.getTotalOrderCount().then(function (count) {
                _this.orderCount = count;
            });

            this.shouldShowOrderManagement = false;
        }
    }]);

    return CartOrderManagementController;
}();

var cartOrderManagementComponentDefinition = {
    bindings: {
        toggleOrderManagement: '&'
    },
    controller: ['OrderManagementService', CartOrderManagementController],
    template: __webpack_require__(382).trim()
};

module.exports = {
    CartOrderManagementController: CartOrderManagementController,
    cartOrderManagementComponentDefinition: cartOrderManagementComponentDefinition
};

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "<button type=\"button\" class=\"cartOrderManagement-button linkButton _showOrderManagement\" ng-if=\"$ctrl.orderCount > 0\" ng-click=\"::$ctrl.toggleOrderManagement()\">\r\n    <span class=\"u-flexCenter\">\r\n        You have {{::$ctrl.orderCount}} open&nbsp; \r\n        <ng-pluralize \r\n            count=\"::$ctrl.orderCount\" \r\n            when=\"{'1': 'order', 'other': 'orders'}\">\r\n        </ng-pluralize>\r\n    </span>\r\n</button>"

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TileInCartController = function TileInCartController() {
    _classCallCheck(this, TileInCartController);
};

var tileInCartComponentDefinition = {
    bindings: {
        product: '<',
        classModifier: '@?'
    },
    controller: TileInCartController,
    template: __webpack_require__(384).trim()
};

module.exports = {
    TileInCartController: TileInCartController,
    tileInCartComponentDefinition: tileInCartComponentDefinition
};

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tileInCart\" ng-class=\"[{'is-inTrolley' : $ctrl.product.IsInTrolley}, $ctrl.classModifier]\">\r\n    <p class=\"tileInCart-text\">in your cart</p>\r\n</div>\r\n"

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var CategoriesService = __webpack_require__(386);
var wowCategorySref = __webpack_require__(387);

angular.module('wowApp.shop').service('CategoriesService', CategoriesService).directive('wowCategorySref', ['$state', '$timeout', 'CategoriesService', wowCategorySref]).component('wowCategoriesNavigation', __webpack_require__(388).categoriesNavigationComponentDefinition);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    concat = _require.concat,
    minBy = _require.minBy,
    filter = _require.filter,
    head = _require.head;

var _require2 = __webpack_require__(24),
    categoryLevels = _require2.categoryLevels;

var CategorySelectionList = __webpack_require__(32);

var CategoryService = function () {
    function CategoryService($q, restangular, bootstrap) {
        _classCallCheck(this, CategoryService);

        this.bootstrap = bootstrap;
        this._api = restangular.all('PiesCategoriesWithSpecials');
        this.categoriesPromise = null;
        this.currentCategories = new CategorySelectionList();
        this.rootCategory = { Children: [] };

        if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Categories)) {
            this.categoriesPromise = $q.when(this.setupCategories(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Categories)));
        }
    }

    _createClass(CategoryService, [{
        key: 'getAll',
        value: function getAll() {
            var _this = this;

            if (!this.categoriesPromise) {
                this.categoriesPromise = this._api.one('').get().then(function (res) {
                    return _this.setupCategories(res);
                });
            }

            return this.categoriesPromise;
        }
    }, {
        key: 'setupCategories',
        value: function setupCategories(res) {
            this.rootCategory = { Children: res.Categories };
            this.categoriesLookup = this._buildCategoriesLookup(res.Categories);
            return res.Categories;
        }
    }, {
        key: 'getById',
        value: function getById(categoryNodeId) {
            return this.categoriesLookup[categoryNodeId];
        }
    }, {
        key: '_buildCategoriesLookup',
        value: function _buildCategoriesLookup(categories) {
            var categoriesLookup = {};
            var remainingCategories = [].concat(_toConsumableArray(categories));

            while (remainingCategories.length) {
                var category = remainingCategories.pop();
                if (!categoriesLookup[category.NodeId]) {
                    categoriesLookup[category.NodeId] = category;
                }
                remainingCategories = concat(remainingCategories, category.Children);
            }

            return categoriesLookup;
        }
    }, {
        key: 'getCategoryTree',
        value: function getCategoryTree(categoryId) {
            var tree = [];
            var category = this.getById(categoryId);

            while (category) {
                tree.unshift(category);
                category = this.getById(category.ParentNodeId);
            }

            return tree;
        }
    }, {
        key: 'getCategoryStateInfo',
        value: function getCategoryStateInfo(nodeId) {
            var state = 'shop.browse';
            var params = {};
            var tree = this.getCategoryTree(nodeId);

            for (var i = 0; i < tree.length; ++i) {
                state += '.' + categoryLevels[i];
                params[categoryLevels[i]] = tree[i].UrlFriendlyName;
            }

            return { state: state, params: params };
        }
    }, {
        key: 'getCategorySref',
        value: function getCategorySref(nodeId) {
            var _getCategoryStateInfo = this.getCategoryStateInfo(nodeId),
                state = _getCategoryStateInfo.state,
                params = _getCategoryStateInfo.params;

            return state + '(' + JSON.stringify(params) + ')';
        }
    }, {
        key: 'getSpecialCategory',
        value: function getSpecialCategory(category) {
            return category.IsSpecial ? category : head(filter(category.Children, function (c) {
                return c.IsSpecial;
            }));
        }
    }, {
        key: 'getBundleCategory',
        value: function getBundleCategory(category) {
            return category.IsBundle ? category : head(filter(category.Children, function (c) {
                return c.IsBundle;
            }));
        }
    }, {
        key: 'getFirstSpecialCategory',
        value: function getFirstSpecialCategory(departmentCategory) {
            if (!departmentCategory.Children) return undefined;
            // get the first category in order in the department children
            var firstCategoryInDepartment = minBy(filter(departmentCategory.Children, function (category) {
                return !category.NodeId.match('_SPECIALS');
            }), function (category) {
                return category.DisplayOrder;
            });
            // get the first special category in firstCategoryInDepartment.
            if (firstCategoryInDepartment) {
                return this.getSpecialCategory(firstCategoryInDepartment);
            }

            return undefined;
        }
    }, {
        key: 'currentCategory',
        get: function get() {
            return this.currentCategories.current;
        }
    }]);

    return CategoryService;
}();

CategoryService.$inject = ['$q', 'Restangular', 'BootstrapService'];

module.exports = CategoryService;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, $timeout, categoriesService) {
    return {
        link: function link(scope, elem, attr) {
            var activeClasses = attr.uiSrefActive || attr.uiSrefActiveEq || '';
            var activeEq = !!attr.uiSrefActiveEq;
            var options = scope.$eval(attr.uiSrefOpts);
            var category = scope.$eval(attr.wowCategorySref);

            var stateInfo = void 0;

            function updateClasses() {
                if (!category || !activeClasses) {
                    return;
                }

                var isActive = activeEq ? categoriesService.currentCategories.current && categoriesService.currentCategories.current.NodeId === category.NodeId : categoriesService.currentCategories.isActive(category.NodeId);

                elem.toggleClass(activeClasses, isActive);
            }

            elem.on('click', function (e) {
                var button = e.which || e.button;
                if (stateInfo && !(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || elem.attr('target'))) {
                    // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
                    var transition = $timeout(function () {
                        return $state.go(stateInfo.state, stateInfo.params, options);
                    });
                    e.preventDefault();
                    e.preventDefault = function () {
                        return $timeout.cancel(transition);
                    };
                }
            });

            scope.$watch(attr.wowCategorySref, function (value) {
                category = value;

                if (!category) {
                    attr.href = undefined;
                    stateInfo = null;
                    return;
                }

                stateInfo = categoriesService.getCategoryStateInfo(category.NodeId);
                elem.attr('href', category ? $state.href(stateInfo.state, stateInfo.params, options) : undefined);

                updateClasses();
            });

            scope.$on('$stateChangeSuccess', function () {
                updateClasses();
            });
        }
    };
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    isEmpty = _require.isEmpty,
    find = _require.find;

var CategoriesNavigationController = function () {
    function CategoriesNavigationController(categoriesService, $element) {
        _classCallCheck(this, CategoriesNavigationController);

        this.categoriesService = categoriesService;
        this.$element = $element;
    }

    _createClass(CategoriesNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.classModifierName = this.classModifier ? 'categoriesNavigation--' + this.classModifier : '';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            this.specialCategory = this.getSpecialChild();
            this.bundleCategory = this.getBundleChild();
        }
    }, {
        key: 'selectCategory',
        value: function selectCategory(event, category) {
            if (this.onSelect && !isEmpty(category.Children)) {
                if (event.type === 'click') {
                    event.preventDefault();
                }
                this.onSelect({ event: event, category: category });
            }
        }
    }, {
        key: 'isCurrentCategory',
        value: function isCurrentCategory(category) {
            var currentCategory = this.categoriesService.currentCategories.current;

            return category && currentCategory && currentCategory.NodeId === category.NodeId;
        }
    }, {
        key: 'isActiveCategory',
        value: function isActiveCategory(category) {
            if (!category) {
                return false;
            }
            return this.selected ? this.selected.NodeId === category.NodeId : this.categoriesService.currentCategories.isActive(category.NodeId);
        }
    }, {
        key: 'getSpecialChild',
        value: function getSpecialChild() {
            if (!(this.category && this.category.Children)) {
                return null;
            }

            if (!this.category.IsSpecial) {
                return find(this.category.Children, function (c) {
                    return c.IsSpecial;
                });
            }

            return null;
        }
    }, {
        key: 'getBundleChild',
        value: function getBundleChild() {
            if (!(this.category && this.category.Children)) {
                return null;
            }

            return find(this.category.Children, function (c) {
                return c.IsBundle;
            });
        }
    }, {
        key: 'shouldDisplay',
        value: function shouldDisplay(canShow) {
            return canShow && this.category && this.category.NodeLevel && this.category.Children.length > 0;
        }
    }]);

    return CategoriesNavigationController;
}();

/**
 * @ngdoc component
 * @name wowCategoriesNavigation
 *
 * Component which generates a list of navigation links from a given category.
 *
 * @param [classModifier] {string} Custom style class name.
 * @param [category] {Object} Category to render nav items for.
 * @param [selected] {Boolean} Is this category currently selected. Used for styling.
 * @param [shouldShowShowAll] {Boolean} Controls display of show all link.
 * @param [shouldShowSpecials] {Boolean} Controls display of specials link.
 * @param [shouldShowBundles] {Boolean} Controls display of bundles link.
 * @param [shouldShowSeparator] {Boolean} Controls display of a separator element.
 * @param [shouldShowArrow] {Boolean} Determine whether the arrow icon should show at the end of elements.
 * @param [onSelect] {Function} Custom callback function to fire when a link is clicked by the user. If not set, default is to navigate to the categories page.
 */


var categoriesNavigationComponentDefinition = {
    transclude: true,
    bindings: {
        classModifier: '@?',
        category: '<?',
        selected: '<?',
        shouldShowShowAll: '<?',
        shouldShowSpecials: '<?',
        shouldShowBundles: '<?',
        shouldShowSeparator: '<?',
        shouldShowArrow: '<?',
        onSelect: '&?'
    },
    controller: ['CategoriesService', '$element', CategoriesNavigationController],
    template: __webpack_require__(389).trim()
};

module.exports = {
    CategoriesNavigationController: CategoriesNavigationController,
    categoriesNavigationComponentDefinition: categoriesNavigationComponentDefinition
};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"categoriesNavigation categoriesNavigation-items\" ng-class=\"::$ctrl.classModifierName\">\r\n    <ng-transclude></ng-transclude>\r\n\r\n    <a class=\"categoriesNavigation-link categoriesNavigation-linkShowall\"\r\n        ng-if=\"$ctrl.shouldDisplay($ctrl.shouldShowShowAll)\"\r\n        ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.category) }\"\r\n        wow-category-sref=\"$ctrl.category\"\r\n        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n        <span class=\"categoriesNavigation-linkText\">\r\n            <span>Show All <span class=\"categoriesNavigation-linkShowAllDescription\">{{ $ctrl.category.Description }}</span></span>&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\"></i>\r\n        </span>\r\n    </a>\r\n    <a class=\"categoriesNavigation-link is-special\"\r\n        ng-if=\"$ctrl.specialCategory && $ctrl.shouldDisplay($ctrl.shouldShowSpecials)\"\r\n        ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.specialCategory) }\"\r\n        wow-category-sref=\"$ctrl.specialCategory\"\r\n        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n        <span class=\"categoriesNavigation-linkText\">\r\n            {{ $ctrl.specialCategory.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\"></i>\r\n        </span>\r\n    </a>\r\n    <a class=\"categoriesNavigation-link\"\r\n        ng-if=\"$ctrl.bundleCategory && $ctrl.shouldDisplay($ctrl.shouldShowBundles)\"\r\n        ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.bundleCategory) }\"\r\n        wow-category-sref=\"$ctrl.bundleCategory\"\r\n        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n        <span class=\"categoriesNavigation-linkText\">\r\n            {{ $ctrl.bundleCategory.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\"></i>\r\n        </span>\r\n    </a>\r\n    <hr class=\"categoriesNavigation-linkSeparator\" ng-if=\"$ctrl.shouldDisplay($ctrl.shouldShowSeparator)\"></hr>\r\n    <a class=\"categoriesNavigation-link\"\r\n        ng-repeat=\"category in $ctrl.category.Children | filter:{IsSpecial:$ctrl.category.IsSpecial} | filter:{IsBundle:$ctrl.category.IsBundle} track by category.NodeId\"\r\n        ng-class=\"{ 'is-active': $ctrl.isActiveCategory(category), 'is-special': category.IsSpecial && !$ctrl.category.IsSpecial, 'is-bundle': $ctrl.category.IsBundle && !$ctrl.category.IsBundle }\"\r\n        ng-click=\"$ctrl.selectCategory($event, category)\"\r\n        wow-category-sref=\"::category\"\r\n        ui-sref-opts=\"{ reload: true, inherit: false }\"\r\n        oly-hover-menu-action=\"$ctrl.selectCategory(event, category)\">\r\n        <span class=\"categoriesNavigation-linkText\">\r\n            {{ ::category.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\"></i>\r\n        </span>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(0).module('wowApp.shop').component('wowDynamicSuburbDialog', __webpack_require__(391)).component('wowDynamicSuburbDialogContent', __webpack_require__(393));

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DynamicSuburbDialogController = function DynamicSuburbDialogController() {
    _classCallCheck(this, DynamicSuburbDialogController);
};

module.exports = {
    template: __webpack_require__(392).trim(),
    controller: [DynamicSuburbDialogController]
};

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"dynamicSuburb-dialog\" id=\"_dynamicSuburbDialog\" class=\"olyDialog dynamicSuburbDialog\">\r\n    <div class=\"dynamicSuburbDialog-content\">\r\n        <button class=\"dynamicSuburbDialog-buttonClose\" oly-dialog-close>\r\n            <div oly-analytics-on-click=\"dynamic suburbs popup ignored - no window selected\">\r\n                <span class=\"sr-only\">close dialog</span>\r\n                <i class=\"icon-close_x\"></i>\r\n            </div>\r\n        </button>\r\n        <wow-dynamic-suburb-dialog-content></wow-dynamic-suburb-dialog-content>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    replace = _require.replace;

var DynamicSuburbDialogContentController = function () {
    function DynamicSuburbDialogContentController(fulfilmentService, settings, shopperService, moveFocus, gtm) {
        _classCallCheck(this, DynamicSuburbDialogContentController);

        this.fulfilmentService = fulfilmentService;
        this.gtm = gtm;

        this.description = replace(settings.deliveryWindows.dynamicSuburbMessageDescription, '{Name}', shopperService.IsGuest ? '' : shopperService.FirstName);
    }

    _createClass(DynamicSuburbDialogContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.dialogCtrl.show();
        }
    }, {
        key: 'onTimeSelect',
        value: function onTimeSelect() {
            this.fireGtmEventAndCloseDialog('dynamic suburbs popup acknowledged - window selected');
        }
    }, {
        key: 'onDecideLater',
        value: function onDecideLater() {
            this.fireGtmEventAndCloseDialog('dynamic suburbs popup ignored - no window selected');
        }
    }, {
        key: 'fireGtmEventAndCloseDialog',
        value: function fireGtmEventAndCloseDialog(eventFired) {
            this.gtm.push({ event: eventFired });
            this.closeDialog();
        }
    }, {
        key: 'closeDialog',
        value: function closeDialog() {
            this.dialogCtrl.close();
        }
    }]);

    return DynamicSuburbDialogContentController;
}();

module.exports = {
    template: __webpack_require__(394).trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ['FulfilmentService', 'Settings', 'ShopperService', 'MoveFocus', 'GtmService', DynamicSuburbDialogContentController]
};

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div class=\"olyDialog-scrollableArea dynamicSuburbDialog-scrollableArea\">\r\n    <div class=\"dynamicSuburbDialog-header\">\r\n        <img src=\"/images/dynamicsuburb/img_dynamicsuburb_truck.svg\" class=\"dynamicSuburbDialog-headerIcon\" />\r\n        <h2 class=\"dynamicSuburbDialog-headerText\" wow-html-setting setting-group=\"DeliveryWindows\" setting-name=\"DynamicSuburbMessageHeader\"></h2>\r\n    </div>\r\n    <div class=\"dynamicSuburbDialog-textWrapper\">\r\n        <p class=\"dynamicSuburbDialog-description\" ng-bind-html=\"$ctrl.description | sanitize\"></p>\r\n        \r\n        <wow-fulfilment-method-wizard\r\n            should-show-billing=\"false\"\r\n            allow-decide-later=\"true\"\r\n            should-get-dynamic-timetable=\"true\">\r\n        </wow-fulfilment-method-wizard>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(396),
    headerComponentDefinition = _require.headerComponentDefinition;

var _require2 = __webpack_require__(398),
    corporateHeaderComponentDefinition = _require2.corporateHeaderComponentDefinition;

var _require3 = __webpack_require__(400),
    coreHeaderComponentDefinition = _require3.coreHeaderComponentDefinition;

var _require4 = __webpack_require__(402),
    coreHeaderNavComponentDefinition = _require4.coreHeaderNavComponentDefinition;

var _require5 = __webpack_require__(404),
    headerSearchComponentDefinition = _require5.headerSearchComponentDefinition;

var _require6 = __webpack_require__(406),
    headerCheckoutComponentDefinition = _require6.headerCheckoutComponentDefinition;

var _require7 = __webpack_require__(408),
    headerSkipLinksComponentDefinition = _require7.headerSkipLinksComponentDefinition;

var _require8 = __webpack_require__(410),
    categoryHeaderComponentDefinition = _require8.categoryHeaderComponentDefinition;

var _require9 = __webpack_require__(412),
    categoryHeaderSmallFormatComponentDefinition = _require9.categoryHeaderSmallFormatComponentDefinition;

var _require10 = __webpack_require__(414),
    categoryHeaderBannersComponentDefinition = _require10.categoryHeaderBannersComponentDefinition;

angular.module('wowApp.shop').component('wowHeader', headerComponentDefinition).component('wowCorporateHeader', corporateHeaderComponentDefinition).component('wowCoreHeader', coreHeaderComponentDefinition).component('wowCoreHeaderNav', coreHeaderNavComponentDefinition).component('wowHeaderSearch', headerSearchComponentDefinition).component('wowHeaderCheckout', headerCheckoutComponentDefinition).component('wowHeaderSkipLinks', headerSkipLinksComponentDefinition).component('wowCategoryHeader', categoryHeaderComponentDefinition).component('wowCategoryHeaderSmallFormat', categoryHeaderSmallFormatComponentDefinition).component('wowCategoryHeaderBanners', categoryHeaderBannersComponentDefinition);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderController = function HeaderController($breakpoints) {
    _classCallCheck(this, HeaderController);

    this.$breakpoints = $breakpoints;
};

var headerComponentDefinition = {
    controller: ['BreakpointsService', HeaderController],
    template: __webpack_require__(397).trim()
};

module.exports = {
    HeaderController: HeaderController,
    headerComponentDefinition: headerComponentDefinition
};

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = "<wow-header-skip-links></wow-header-skip-links>\r\n<wow-corporate-header class=\"hidden-xs\" class-modifier=\"corporateHeader--horizontal\"></wow-corporate-header>\r\n<wow-core-header></wow-core-header>\r\n<wow-category-header ng-if=\"!$ctrl.$breakpoints.isInSmallFormat && !$ctrl.$breakpoints.isInMediumFormatPortrait\" class-modifier=\"categoryHeader--horizontal\"></wow-category-header>\r\n<wow-category-header-small-format ng-if=\"$ctrl.$breakpoints.isInSmallFormat || $ctrl.$breakpoints.isInMediumFormatPortrait \"></wow-category-header-small-format>\r\n<wow-small-menu ng-if=\"$ctrl.$breakpoints.isInSmallFormat\"></wow-small-menu>\r\n"

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var CorporateHeaderController = function () {
    function CorporateHeaderController($state) {
        _classCallCheck(this, CorporateHeaderController);

        this.$state = $state;
    }

    /**
     * The shopping link is active at all times EXCEPT for when we
     * are on store locator OR the rewards page in Discover.
     *
     * @returns {boolean}
     *
     * @memberOf CorporateHeaderController
     */


    _createClass(CorporateHeaderController, [{
        key: 'isShoppingActive',
        value: function isShoppingActive() {
            var _this = this;

            var exceptStates = [{ state: 'shop.locator' }, { state: 'shop.inspiration.parent', params: { parent: 'woolworths-rewards' } }];

            return !_.some(exceptStates, function (s) {
                return _this.$state.is(s.state, s.params);
            });
        }
    }]);

    return CorporateHeaderController;
}();

var corporateHeaderComponentDefinition = {
    bindings: {
        classModifier: '@?'
    },
    controller: ['$state', CorporateHeaderController],
    template: __webpack_require__(399).trim()
};

module.exports = {
    corporateHeaderComponentDefinition: corporateHeaderComponentDefinition,
    CorporateHeaderController: CorporateHeaderController
};

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"corporateHeader\" ng-class=\"$ctrl.classModifier\">\r\n    <a class=\"corporateHeader-link corporateHeader-link--shopping\" href=\"/\" ng-class=\"{'is-active': $ctrl.isShoppingActive()}\" target=\"_self\">\r\n        Shopping\r\n        <i class=\"corporateHeader-activeLinkIcon iconww-ArrowDown\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" ui-sref=\"shop.locator\" ui-sref-opts=\"{reload: true}\" ng-class=\"{'is-active': ('shop.stores' | includedByState)}\">\r\n        <i class=\"corporateHeader-icon iconww-Supermarkets\"></i>\r\n        Stores\r\n        <i class=\"corporateHeader-activeLinkIcon iconww-ArrowDown\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" href=\"https://insurance.woolworths.com.au/\" target=\"_blank\">\r\n        <i class=\"corporateHeader-icon iconww-Insurance\"></i>\r\n        Insurance\r\n        <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" href=\"https://mobile.woolworths.com.au/\" target=\"_blank\">\r\n        <i class=\"corporateHeader-icon iconww-Mobile\"></i>\r\n        Mobile\r\n        <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" href=\"https://cards.woolworths.com.au\" target=\"_blank\">\r\n        <i class=\"corporateHeader-icon iconww-Money\"></i>\r\n        Credit Cards\r\n        <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" href=\"https://www.woolworthsrewards.com.au/\" target=\"_blank\">\r\n        <i class=\"corporateHeader-icon iconww-RewardPointsEarned\"></i>\r\n        Rewards\r\n        <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\"></i>\r\n    </a>\r\n    <a class=\"corporateHeader-link\" href=\"https://cards.woolworths.com.au/woolworths-gift-cards.html\" target=\"_blank\">\r\n        <i class=\"corporateHeader-icon iconww-GiftCards\"></i>\r\n        Gift Cards\r\n        <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\"></i>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoreHeaderController = function () {
    function CoreHeaderController(shopperService, shopPageStateService, moveFocus) {
        _classCallCheck(this, CoreHeaderController);

        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
    }

    _createClass(CoreHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sfSearchActive = false;
        }
    }, {
        key: 'isMenuOpen',
        value: function isMenuOpen() {
            return this.shopPageStateService.smallFormatMenuOpen;
        }
    }, {
        key: 'toggleOffscreenMenu',
        value: function toggleOffscreenMenu() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.shopPageStateService.smallFormatMenuOpen;

            this.shopPageStateService.smallFormatMenuOpen = isOpen;

            if (this.shopPageStateService.smallFormatMenuOpen) {
                this.moveFocus('#smallMenu');
            }
        }
    }, {
        key: 'hideMenu',
        value: function hideMenu() {
            if (this.isMenuOpen()) {
                this.toggleOffscreenMenu();
            }
        }
    }]);

    return CoreHeaderController;
}();

var coreHeaderComponentDefinition = {
    controller: ['ShopperService', 'ShopPageStateService', 'MoveFocus', CoreHeaderController],
    template: __webpack_require__(401).trim()
};

module.exports = {
    CoreHeaderController: CoreHeaderController,
    coreHeaderComponentDefinition: coreHeaderComponentDefinition
};

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<header class=\"coreHeader\" oly-sticky=\"'.corporateHeader--horizontal'\">\r\n    <button\r\n        type=\"button\"\r\n        class=\"coreHeader-offscreenToggle visible-xs\"\r\n        ng-class=\"{'is-open': $ctrl.isMenuOpen()}\"\r\n        ng-click=\"$ctrl.toggleOffscreenMenu()\"\r\n        aria-haspopup=\"menu\">\r\n\r\n        <div class=\"coreHeader-offscreenToggleContent\">\r\n            <i class=\"coreHeader-offscreenToggleIcon\" ng-class=\"$ctrl.isMenuOpen() ? 'iconww-Cross' : 'iconww-Menu'\"></i>\r\n            {{ $ctrl.isMenuOpen() ? 'Close' : 'Menu' }}\r\n        </div>\r\n    </button>\r\n\r\n    <div class=\"coreHeader-verticalSeparator visible-xs\"></div>\r\n\r\n    <a href=\"/\" class=\"coreHeader-logoWrapper\">\r\n        <img class=\"coreHeader-logo\" src=\"/Images/GlobalHeader/icon-header-logo.png\" alt=\"Woolworths Online Home\">\r\n    </a>\r\n\r\n    <div class=\"coreHeader-verticalSeparator hidden-xs\"></div>\r\n\r\n    <wow-core-header-nav class=\"hidden-xs coreHeader-nav\" class-modifier=\"coreHeaderNav--horizontal\"></wow-core-header-nav>\r\n\r\n    <span class=\"u-flexSpacer visible-xs\"></span>\r\n\r\n    <wow-header-search class=\"coreHeader-searchPanel\" sf-search-active=\"$ctrl.sfSearchActive\" search-toggled-on=\"$ctrl.hideMenu()\"></wow-header-search>\r\n\r\n    <a ui-sref=\"shop.authentication.login\" ui-sref-opts=\"{reload: true}\" ng-if=\"$ctrl.shopperService.IsGuest\" class=\"coreHeader-profile hidden-xs\">\r\n        <span class=\"sr-only\">Log in or sign up.</span>\r\n        <i class=\"iconww-Profile\"></i>\r\n    </a>\r\n\r\n    <a ui-sref=\"shop.myaccount.details\" ui-sref-opts=\"{reload: true}\" ng-if=\"!$ctrl.shopperService.IsGuest\" class=\"coreHeader-profile is-loggedIn hidden-xs\">\r\n        <span class=\"sr-only\">Visit your account settings.</span>\r\n        <i class=\"iconww-Profile\"></i>\r\n    </a>\r\n\r\n    <wow-header-checkout class=\"coreHeader-checkout\"></wow-header-checkout>\r\n</header>\r\n"

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoreHeaderNavController = function CoreHeaderNavController(shopperService) {
    _classCallCheck(this, CoreHeaderNavController);

    this.shopperService = shopperService;
};

var coreHeaderNavComponentDefinition = {
    bindings: {
        classModifier: '@?',
        onInspirationSelected: '&?',
        onRecipesSelected: '&?'
    },
    controller: ['ShopperService', CoreHeaderNavController],
    template: __webpack_require__(403).trim()
};

module.exports = {
    CoreHeaderNavController: CoreHeaderNavController,
    coreHeaderNavComponentDefinition: coreHeaderNavComponentDefinition
};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"coreHeaderNav\" ng-class=\"$ctrl.classModifier\">\r\n    <a ui-sref=\"shop.guestList\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-if=\"$ctrl.shopperService.IsGuest\">\r\n        My Lists <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.list\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-if=\"!$ctrl.shopperService.IsGuest\">\r\n        My Lists <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.catalogue\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\">\r\n        Catalogue <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.recipes\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-click=\"$ctrl.onRecipesSelected({ $event: $event })\">\r\n        Recipes <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.inspiration\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-click=\"$ctrl.onInspirationSelected({ $event: $event })\">\r\n        Discover <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(0);

var HeaderSearchController = function () {
    function HeaderSearchController($state, $stateParams, $q, $element, breakpointsService, moveFocus, settings, searchService) {
        _classCallCheck(this, HeaderSearchController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$element = $element;
        this.breakpointsService = breakpointsService;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchService = searchService;
    }

    _createClass(HeaderSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchText = this.$stateParams.searchTerm || '';
            this.isActive = false;
            this.sfSearchActive = this.sfSearchActive !== undefined ? this.sfSearchActive : false;
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return this.settings.search.searchSuggestionThrottleTimeout < 0 ? this.$q.when([]) : this.searchService.getSearchSuggestion(this.searchText).then(function (response) {
                return response.SearchSuggestion;
            });
        }
    }, {
        key: 'search',
        value: function search() {
            this.$state.go('shop.search', { searchTerm: this.searchText }, { inherit: false, reload: true });
        }
    }, {
        key: 'toggleSearch',
        value: function toggleSearch() {
            if (this.breakpointsService.isSmallFormat()) {
                this.sfSearchActive = !this.sfSearchActive;
                if (this.sfSearchActive) {
                    if (angular.isFunction(this.searchToggledOn)) {
                        this.searchToggledOn();
                    }

                    // Cannot use movefocus as it uses timeouts internally
                    // iOS only allows focus moving if the control directly says to do so
                    this.$element.find('#searchBox').toggleClass('is-open', true);
                    this.$element.find('#headerSearch').focus();
                }
            }
        }
    }]);

    return HeaderSearchController;
}();

var headerSearchComponentDefinition = {
    bindings: {
        searchToggledOn: '&?',
        sfSearchActive: '=?'
    },
    controller: ['$state', '$stateParams', '$q', '$element', 'BreakpointsService', 'MoveFocus', 'Settings', 'SearchService', HeaderSearchController],
    template: __webpack_require__(405).trim()
};

module.exports = {
    HeaderSearchController: HeaderSearchController,
    headerSearchComponentDefinition: headerSearchComponentDefinition
};

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<form class=\"headerSearch\" action=\".\" ng-switch=\"$ctrl.sfSearchActive\">\r\n    <!-- Two buttons which replace each other to prevent Safari from double triggering with run-on-close -->\r\n    <button\r\n       type=\"button\"\r\n       ng-switch-when=\"false\"\r\n       class=\"headerSearch-searchButton headerSearch-toggleSearchButton button button--primary\"\r\n       ng-click=\"$ctrl.toggleSearch()\">\r\n            <i class=\"iconww-Search\"></i>\r\n            <span class=\"sr-only\">Expand search</span>\r\n    </button>\r\n    <button\r\n       type=\"button\"\r\n       ng-switch-when=\"true\"\r\n       class=\"headerSearch-searchButton headerSearch-toggleSearchButton button button--primary\">\r\n            <i class=\"iconww-Search\"></i>\r\n            <span class=\"sr-only\">Collapse search</span>\r\n    </button>\r\n\r\n    <oly-autocomplete\r\n        input-id=\"headerSearch\"\r\n        id=\"searchBox\"\r\n        class=\"headerSearch-searchWrapper\"\r\n        ng-class=\"{'is-open': !$ctrl.breakpointsService.isSmallFormat() || $ctrl.sfSearchActive}\"\r\n        text=\"$ctrl.searchText\"\r\n        placeholder=\"{{::$ctrl.settings.search.searchPromptText}}\"\r\n        items=\"$ctrl.getItems()\"\r\n        throttle=\"$ctrl.settings.search.searchSuggestionThrottleTimeout\"\r\n        is-disabled=\"$ctrl.isActive\"\r\n        is-dropdown-open=\"$ctrl.isDropdownOpen\"\r\n        search-box-class=\"headerSearch-searchBox {{ $ctrl.searchText ? 'headerSearch-searchBoxClearButtonPadding' : '' }}\"\r\n        dropdown-wrapper-class=\"headerSearch-dropdownWrapper\"\r\n        dropdown-class=\"headerSearch-dropdown\"\r\n        item-class=\"headerSearch-autocompleteItem\"\r\n        item-select-class=\"headerSearch-autocompleteItemSelected\"\r\n        action-button-class=\"headerSearch-actionButton\"\r\n        search-button-class=\"headerSearch-autocompleteSearchButton\"\r\n        clear-button-class=\"headerSearch-searchBoxClearButton\"\r\n        action-button-wrapper-class=\"headerSearch-actionButtonWrapper\"\r\n        show-clear-button=\"true\"\r\n        show-search-button=\"true\"\r\n        run-on-select=\"$ctrl.search()\"\r\n        run-on-enter=\"$ctrl.search()\"\r\n        run-on-close=\"$ctrl.toggleSearch()\"\r\n        show-not-found-message=\"false\">\r\n        <autocomplete-item>\r\n            {{ ::item }}\r\n        </autocomplete-item>\r\n        <autocomplete-suffix>\r\n            <wow-multisearch\r\n                ng-if=\"!$ctrl.breakpointsService.isSmallFormat()\"\r\n                search-input=\"$ctrl.searchText\"\r\n                class-modifier=\"headerSearch-multiSearch\"\r\n                is-active=\"$ctrl.isActive\">\r\n            </wow-multisearch>\r\n        </autocomplete-suffix>\r\n    </oly-autocomplete>\r\n</form>\r\n"

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderCheckoutController = function () {
    function HeaderCheckoutController(breakpointsService, shopPageStateService, trolleyService) {
        _classCallCheck(this, HeaderCheckoutController);

        this.breakpointsService = breakpointsService;
        this.shopPageStateService = shopPageStateService;
        this.trolleyService = trolleyService;
    }

    _createClass(HeaderCheckoutController, [{
        key: 'back',
        value: function back() {
            window.history.back();
        }
    }, {
        key: 'toggleCartOpen',
        value: function toggleCartOpen() {
            this.shopPageStateService.isCartOpen = !this.shopPageStateService.isCartOpen;
        }
    }]);

    return HeaderCheckoutController;
}();

var headerCheckoutComponentDefinition = {
    controller: ['BreakpointsService', 'ShopPageStateService', 'TrolleyService', HeaderCheckoutController],
    template: __webpack_require__(407).trim()
};

module.exports = {
    HeaderCheckoutController: HeaderCheckoutController,
    headerCheckoutComponentDefinition: headerCheckoutComponentDefinition
};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<button class=\"headerCheckout-toggleCartButton\" ng-click=\"$ctrl.toggleCartOpen()\" ng-if=\"$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape\">\r\n    <i class=\"iconww-Cart headerCheckout-cartIcon\"></i>\r\n    <span class=\"sr-only\">Toggle cart</span>\r\n</button>\r\n\r\n<a ui-sref=\"hyf\" class=\"headerCheckout-orderHeader\" ng-class=\"{'is-disabled': !$ctrl.trolleyService.hasAvailableProducts()}\">\r\n    <div class=\"headerCheckout-orderTotal\">\r\n        Your order\r\n        <br/>\r\n        <span class=\"headerCheckout-orderAmount\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </div>\r\n\r\n    <button class=\"button button--primary headerCheckout-checkout\" ng-disabled=\"!$ctrl.trolleyService.hasAvailableProducts()\">\r\n        Checkout\r\n        <i class=\"iconww-ArrowRight\"></i>\r\n    </button>\r\n</a>\r\n\r\n<div class=\"headerCheckout-orderHeaderSf\" ui-sref-active=\"is-active\" ng-switch=\"$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape\">\r\n    <a ng-switch-when=\"false\" ui-sref=\"shop.cart\" class=\"headerCheckout-cartButton headerCheckout-openCartButton\">\r\n        <i class=\"iconww-Cart headerCheckout-cartButtonIcon\"></i>\r\n        <span class=\"sr-only\">Cart</span>\r\n        <span class=\"headerCheckout-cartButtonTotal\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </a>\r\n\r\n    <a ng-switch-when=\"true\" ui-sref=\"hyf\" class=\"headerCheckout-cartButton headerCheckout-openCartButton\">\r\n        <i class=\"iconww-Cart headerCheckout-cartButtonIcon\"></i>\r\n        <span class=\"sr-only\">Cart</span>\r\n        <span class=\"headerCheckout-cartButtonTotal\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </a>\r\n\r\n    <a href=\"javascript://\" ng-click=\"$ctrl.back()\" class=\"headerCheckout-cartButton headerCheckout-closeCartButton\">\r\n        <i class=\"iconww-Cross headerCheckout-cartButtonIcon\"></i>\r\n        Close <span class=\"sr-only\">Cart</span>\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var HeaderSkipLinksController = function () {
    function HeaderSkipLinksController($timeout, moveFocus, shopperService, shopPageStateService, loginService) {
        _classCallCheck(this, HeaderSkipLinksController);

        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.loginService = loginService;

        this.a11yOptionsOpen = false;
    }

    _createClass(HeaderSkipLinksController, [{
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            // auto hide focus is outside of the panel
            $('._a11yOptions').off('focusout.a11yOptions').on('focusout.a11yOptions', function () {
                // Timeout here because no item has focus yet, the check will now happen after focusin event has fired.
                _this.$timeout(function () {
                    // toggle if focus goes outside of small menu container
                    if ($(document.activeElement).closest('._a11yOptions').length === 0) {
                        _this.a11yOptionsOpen = false;
                    }
                }, 0);
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $('._a11yOptions').off('focusout.a11yOptions');
        }
    }, {
        key: 'openA11yOptions',
        value: function openA11yOptions() {
            this.a11yOptionsOpen = true;
        }
    }, {
        key: 'updatePreference',
        value: function updatePreference() {
            this.shopperService.setPreferenceEnableAccessibility(this.shopperService.preferences.EnableAccessibleOptions);
        }
    }, {
        key: 'goToTrolley',
        value: function goToTrolley() {
            this.shopPageStateService.isCartOpen = true;
            this.moveFocus('#right-panel');
        }
    }, {
        key: 'goToNavigation',
        value: function goToNavigation() {
            this.moveFocus('#left-panel');
        }
    }]);

    return HeaderSkipLinksController;
}();

var headerSkipLinksComponentDefinition = {
    controller: ['$timeout', 'MoveFocus', 'ShopperService', 'ShopPageStateService', 'LoginService', HeaderSkipLinksController],
    template: __webpack_require__(409).trim()
};

module.exports = {
    HeaderSkipLinksController: HeaderSkipLinksController,
    headerSkipLinksComponentDefinition: headerSkipLinksComponentDefinition
};

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <p class=\"sr-only\" ng-if=\"!$ctrl.shopperService.preferences.EnableAccessibleOptions\" role=\"alert\" aria-live=\"assertive\">\r\n        If you are using a screen reader to navigate the Woolworths website please select the “Accessibility On” switch in accessibility settings.\r\n    </p>\r\n\r\n    <ul class=\"headerSkipLinks-menu\">\r\n        <li class=\"headerSkipLinks-listItem\" ng-switch=\"$ctrl.shopperService.IsGuest\">\r\n            <a ng-switch-when=\"true\" ui-sref=\"shop.authentication.login\" ui-sref-opts=\"{reload: true}\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Skip to login page\r\n            </a>\r\n            <button ng-switch-when=\"false\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink linkButton\" ng-click=\"$ctrl.loginService.logout()\">\r\n                Log out\r\n            </button>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\" ng-click=\"$ctrl.goToNavigation()\">\r\n                Skip to content navigation\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" oly-move-focus=\"center-panel\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Skip to content\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\" ng-click=\"$ctrl.goToTrolley()\">\r\n                Skip to trolley\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" ng-click=\"$ctrl.openA11yOptions()\" oly-move-focus=\"headerSkipLinks-accessibility\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Accessibility Settings\r\n            </a>\r\n        </li>\r\n    </ul>\r\n    <div class=\"headerSkipLinks-optionsPanel _a11yOptions\" id=\"headerSkipLinks-accessibility\" tabindex=\"-1\" ng-show=\"$ctrl.a11yOptionsOpen\">\r\n        <p>\r\n            If you are using a screen reader or a keyboard only to navigate the Woolworths website please select the “Accessibility On” checkbox below.\r\n        </p>\r\n        <form>\r\n            <input\r\n                type=\"checkbox\"\r\n                id=\"headerSkipLinks-accessibilityOption\"\r\n                class=\"wowCheckbox\"\r\n                name=\"enableAccessibleOptions\"\r\n                ng-model=\"$ctrl.shopperService.preferences.EnableAccessibleOptions\"\r\n                ng-change=\"$ctrl.updatePreference()\" />\r\n            <label for=\"headerSkipLinks-accessibilityOption\">Accessibility On</label>\r\n        </form>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    debounce = _require.debounce;

var CategorySelectionList = __webpack_require__(32);

var CategoryHeaderController = function () {
    function CategoryHeaderController($scope, $timeout, settings, categoriesService, shopPageStateService, moveFocus) {
        _classCallCheck(this, CategoryHeaderController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.settings = settings;
        this.categoriesService = categoriesService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
    }

    _createClass(CategoryHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.categoriesService.getAll();

            this.selectedCategories = new CategorySelectionList();

            this.$scope.$on('$stateChangeStart', function () {
                return _this.closeMenu();
            });

            this.onMouseenterDepartment = debounce(function (department) {
                return _this.$scope.$apply(function () {
                    return _this.selectDepartment(department);
                });
            }, this.settings.pies ? this.settings.pies.overlayOnHoverDelay : 150, { leading: false, trailing: true });
        }
    }, {
        key: 'onMouseleaveDepartment',
        value: function onMouseleaveDepartment() {
            this.onMouseenterDepartment.cancel();
        }
    }, {
        key: 'onTouchDepartment',
        value: function onTouchDepartment(department) {
            this.toggleMenu(department);
        }
    }, {
        key: 'onKeydownDepartment',
        value: function onKeydownDepartment(department, $event) {
            // space or enter
            if ($event.which === 32 || $event.which === 13) {
                $event.preventDefault();
                this.toggleMenu(department);
            }
        }
    }, {
        key: 'selectDepartment',
        value: function selectDepartment(department) {
            // If we are opening the menu for the page we are currently on, we use the
            // selected categories so we can highlight the current page category.
            this.selectedCategories = this.categoriesService.currentCategories.department === department ? this.categoriesService.currentCategories.clone() : new CategorySelectionList(this.categoriesService.getCategoryTree(department.NodeId));

            this.shopPageStateService.toggleBodyScroll(false);

            this.moveFocus('.categoryHeader-menuHeaderLink:first-of-type');
        }
    }, {
        key: 'selectCategory',
        value: function selectCategory(category) {
            this.selectedCategories = new CategorySelectionList(this.categoriesService.getCategoryTree(category.NodeId));

            this.moveFocus('._subCategoryNav .categoriesNavigation-link:first-of-type');
        }
    }, {
        key: 'onKeydownHeader',
        value: function onKeydownHeader($event) {
            // escape
            if ($event.which === 27) {
                this.moveFocus('._departmentNav .categoryHeader-navigationLink.is-active', true);
                this.closeMenu();
            }
        }
    }, {
        key: 'toggleMenu',
        value: function toggleMenu(department) {
            if (this.isMenuOpen && this.selectedCategories.department === department) {
                this.closeMenu();
            } else {
                this.selectDepartment(department);
            }
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            this.selectedCategories = new CategorySelectionList();
            this.shopPageStateService.toggleBodyScroll(true);
        }
    }, {
        key: 'isActiveDepartment',
        value: function isActiveDepartment(department) {
            return department === (this.selectedCategories.department || this.categoriesService.currentCategories.department);
        }
    }, {
        key: 'isMenuOpen',
        get: function get() {
            return this.selectedCategories.hasSelectedCategories;
        }
    }]);

    return CategoryHeaderController;
}();

var categoryHeaderComponentDefinition = {
    transclude: true,
    controller: ['$scope', '$timeout', 'Settings', 'CategoriesService', 'ShopPageStateService', 'MoveFocus', CategoryHeaderController],
    template: __webpack_require__(411).trim()
};

module.exports = {
    CategoryHeaderController: CategoryHeaderController,
    categoryHeaderComponentDefinition: categoryHeaderComponentDefinition
};

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeader\" oly-slideup=\"'.corporateHeader--horizontal'\" ng-mouseleave=\"$ctrl.closeMenu()\" ng-keydown=\"$ctrl.onKeydownHeader($event)\">\r\n    <nav class=\"categoryHeader-navigation _departmentNav\" aria-label=\"Departments\">\r\n        <a class=\"categoryHeader-navigationLink\"\r\n            aria-haspopup=\"true\"\r\n            aria-expanded=\"{{ $ctrl.isMenuOpen && $ctrl.isActiveDepartment(department) }}\"\r\n            aria-controls=\"categoryHeader-menu\"\r\n            ng-class=\"{ 'is-active': $ctrl.isActiveDepartment(department), 'is-special': department.IsSpecial }\"\r\n            ng-repeat=\"department in $ctrl.categoriesService.rootCategory.Children track by department.NodeId\"\r\n            wow-category-sref=\"::department\"\r\n            ui-sref-opts=\"{ reload: true, inherit: false }\"\r\n            oly-on-touchend=\"$ctrl.onTouchDepartment(department)\"\r\n            ng-mouseenter=\"$ctrl.onMouseenterDepartment(department)\"\r\n            ng-mouseleave=\"$ctrl.onMouseleaveDepartment()\"\r\n            ng-keydown=\"$ctrl.onKeydownDepartment(department, $event)\"\r\n            ng-click=\"$event.preventDefault()\">\r\n            {{ ::department.Description }}\r\n        </a>\r\n    </nav>\r\n\r\n    <div id=\"categoryHeader-menu\" class=\"categoryHeader-menu\" ng-if=\"$ctrl.isMenuOpen\" oly-slideup=\"::$ctrl.megamenuEffectiveOffset\" tabindex=\"-1\">\r\n        <div class=\"categoryHeader-menuHeader\">\r\n            <div class=\"categoryHeader-menuHeaderTitle heading2\">\r\n                <div class=\"categoryHeader-menuHeaderIconContainer\">\r\n                    <img ng-src=\"/content/wowpiescategoryimages/{{ $ctrl.selectedCategories.department.UrlFriendlyName }}.svg\" oly-error-src class=\"categoryHeader-menuHeaderIcon\">\r\n                </div>\r\n                {{ $ctrl.selectedCategories.department.Description }}\r\n            </div>\r\n\r\n            <!-- Ensure All Specials is not being shown due to performance problems (temporary solution) -->\r\n            <nav class=\"categoryHeader-menuHeaderList\" ng-if=\"!$ctrl.selectedCategories.department.IsSpecial\">\r\n                <span ng-repeat=\"categoryChildren in $ctrl.selectedCategories.department.Children | limitTo:2\">\r\n                    <a ng-if=\"categoryChildren.IsBundle\" class=\"categoryHeader-menuHeaderLink\"\r\n                        wow-category-sref=\"categoryChildren\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                        {{ categoryChildren.Description }}\r\n                        <i class=\"iconww-ArrowRight\"></i>\r\n                    </a>\r\n                    <a ng-if=\"categoryChildren.IsSpecial\" class=\"categoryHeader-menuHeaderLink\"\r\n                        wow-category-sref=\"categoryChildren\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                        {{ categoryChildren.Description }}\r\n                        <i class=\"iconww-ArrowRight\"></i>\r\n                    </a>\r\n                </span>\r\n                <a class=\"categoryHeader-menuHeaderLink\"\r\n                    wow-category-sref=\"$ctrl.selectedCategories.department\"\r\n                    ui-sref-active=\"is-active\"\r\n                    ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                    Show all {{ $ctrl.selectedCategories.department.Description }}\r\n                    <i class=\"iconww-ArrowRight\"></i>\r\n                </a>\r\n            </nav>\r\n        </div>\r\n\r\n        <div class=\"categoryHeader-menuPanel\">\r\n            <wow-categories-navigation\r\n                class=\"categoryHeader-menuCategoryNav _categoryNav\"\r\n                class-modifier=\"category\"\r\n                category=\"$ctrl.selectedCategories.department\"\r\n                selected=\"$ctrl.selectedCategories.category\"\r\n                on-select=\"$ctrl.selectCategory(category)\"\r\n                should-show-arrow=\"true\"\r\n                oly-hover-menu=\"nav\"\r\n                oly-hover-menu-dir=\"right\">\r\n            </wow-categories-navigation>\r\n\r\n            <wow-categories-navigation\r\n                class=\"categoryHeader-menuSubcategoryNav _subCategoryNav\"\r\n                class-modifier=\"subcategory\"\r\n                category=\"$ctrl.selectedCategories.category\"\r\n                should-show-arrow=\"true\"\r\n                should-show-show-all=\"true\"\r\n                should-show-specials=\"true\"\r\n                should-show-bundles=\"true\"\r\n                should-show-separator=\"!!$ctrl.selectedCategories.category\">\r\n\r\n                <div ng-if=\"!$ctrl.selectedCategories.category\" class=\"categoryHeader-menuNotSelected\">\r\n                    <div class=\"categoryHeader-menuNotSelectedContent\">\r\n                        <i class=\"iconww-Cart categoryHeader-menuNotSelectedIcon\"></i>\r\n                        <span class=\"categoryHeader-menuNotSelectedText\">Select from the<br />categories on the left.</span>\r\n                    </div>\r\n                </div>\r\n            </wow-categories-navigation>\r\n\r\n            <span class=\"u-flexSpacer\"></span>\r\n\r\n            <wow-category-header-banners\r\n                class=\"categoryHeader-menuBanners\"\r\n                category=\"$ctrl.selectedCategories.category || $ctrl.selectedCategories.department\">\r\n            </wow-category-header-banners>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"categoryHeader-mask\"\r\n        ng-click=\"$ctrl.closeMenu()\"\r\n        ng-mouseenter=\"$ctrl.closeMenu()\"\r\n        ng-show=\"$ctrl.isMenuOpen\">\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryHeaderSmallFormatController = function () {
    function CategoryHeaderSmallFormatController($scope, $element, $state, categoriesService, moveFocus) {
        _classCallCheck(this, CategoryHeaderSmallFormatController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.categoriesService = categoriesService;
        this.moveFocus = moveFocus;
    }

    _createClass(CategoryHeaderSmallFormatController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.open = false;

            this.categoriesService.getAll();

            this.$scope.$on('$stateChangeStart', function () {
                return _this.closeMenu();
            });
        }
    }, {
        key: 'onSelectCategory',
        value: function onSelectCategory(category) {
            this.selectedCategories.pushCategory(category);
            this.moveFocus('#categoryHeaderSmallFormat-browseButton');
            this.fixIOSMomentumScrolling();
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            this.selectedCategories.popCategory();
            this.fixIOSMomentumScrolling();
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen() {
            this.open = !this.open;
            if (this.open) {
                // Set selected categories
                this.selectedCategories = this.categoriesService.currentCategories.clone();
                // Navigate to the parent category
                this.onBack();
            }
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            if (this.open) {
                this.toggleOpen();
            }
        }

        /**
         * On iOS, if the content of a scrollable container with -webkit-overflow-scrolling: scroll
         * is shorter than the height of the container (causing it to not be scrollable) and then
         * changes to become taller (causing it to be scrollable) Safari will not realise this and
         * the container will not be scrollable. This happens when going from a short list of categories
         * to a long list of categories.
         *
         * The fix is to toggle this property to get Safari to check the container again and apply scrolling to it.
         */

    }, {
        key: 'fixIOSMomentumScrolling',
        value: function fixIOSMomentumScrolling() {
            var _this2 = this;

            this.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'auto');
            setTimeout(function () {
                return _this2.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'touch');
            });
        }
    }, {
        key: 'rootCategory',
        get: function get() {
            return this.categoriesService.rootCategory;
        }
    }, {
        key: 'currentCategory',
        get: function get() {
            return this.selectedCategories.current || this.rootCategory;
        }
    }]);

    return CategoryHeaderSmallFormatController;
}();

var categoryHeaderSmallFormatComponentDefinition = {
    controller: ['$scope', '$element', '$state', 'CategoriesService', 'MoveFocus', CategoryHeaderSmallFormatController],
    template: __webpack_require__(413).trim()
};

module.exports = {
    CategoryHeaderSmallFormatController: CategoryHeaderSmallFormatController,
    categoryHeaderSmallFormatComponentDefinition: categoryHeaderSmallFormatComponentDefinition
};

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeaderSmallFormat-mask\" ng-if=\"$ctrl.open\" ng-click=\"$ctrl.closeMenu()\"></div>\r\n\r\n<div role=\"menu\" class=\"categoryHeaderSmallFormat\" oly-sticky=\"'.corporateHeader--horizontal'\">\r\n    <button id=\"categoryHeaderSmallFormat-browseButton\" class=\"categoryHeaderSmallFormat-browseButton\" ng-click=\"$ctrl.toggleOpen()\" aria-expanded=\"{{ $ctrl.open }}\">\r\n        <h3 class=\"categoryHeaderSmallFormat-browseButtonText\" ng-switch=\"!!$ctrl.categoriesService.currentCategory\">\r\n            <span ng-switch-when=\"false\">Browse Groceries</span>\r\n            <span ng-switch-when=\"true\">Browsing:  {{ $ctrl.categoriesService.currentCategory.Description }}</span>\r\n        </h3>\r\n        <i class=\"categoryHeaderSmallFormat-browseButtonIcon\" ng-class=\"$ctrl.open ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n    </button>\r\n\r\n    <div class=\"categoryHeaderSmallFormat-list\" ng-if=\"$ctrl.open\">\r\n        <div class=\"categoryHeaderSmallFormat-listHeader\" ng-if=\"$ctrl.selectedCategories.current\">\r\n            <button aria-label=\"Change to Click to browse parent categories\" class=\"categoryHeaderSmallFormat-listHeaderBack\" ng-click=\"$ctrl.onBack()\">\r\n                <i class=\"categoryHeaderSmallFormat-listHeaderBackIcon iconww-ArrowLeft\"></i>\r\n            </button>\r\n            <h3 class=\"categoryHeaderSmallFormat-listHeaderText\">{{ $ctrl.selectedCategories.current.Description }}</h3>\r\n        </div>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"!$ctrl.selectedCategories.current\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.rootCategory\"\r\n            on-select=\"$ctrl.onSelectCategory(category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\">\r\n        </wow-categories-navigation>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"$ctrl.selectedCategories.department && $ctrl.selectedCategories.department === $ctrl.selectedCategories.current\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.selectedCategories.department\"\r\n            on-select=\"$ctrl.onSelectCategory(category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\"\r\n            should-show-show-all=\"!$ctrl.selectedCategories.department.IsSpecial\"\r\n            should-show-specials=\"true\">\r\n        </wow-categories-navigation>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"$ctrl.selectedCategories.category && $ctrl.selectedCategories.category === $ctrl.selectedCategories.current\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.selectedCategories.category\"\r\n            on-select=\"$ctrl.onSelectCategory(category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\"\r\n            should-show-show-all=\"true\"\r\n            should-show-specials=\"true\">\r\n        </wow-categories-navigation>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var categoryHeaderBannersController = function () {
    function categoryHeaderBannersController(bannersService) {
        _classCallCheck(this, categoryHeaderBannersController);

        this.bannersService = bannersService;
    }

    _createClass(categoryHeaderBannersController, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.getBanners();
        }
    }, {
        key: 'getBanners',
        value: function getBanners() {
            this.bannersService.getBanners({
                CategoryId: this.category.NodeId,
                IsSpecialRoot: false
            });
        }
    }]);

    return categoryHeaderBannersController;
}();

var categoryHeaderBannersComponentDefinition = {
    bindings: {
        category: '<'
    },
    controller: ['BannersService', categoryHeaderBannersController],
    template: __webpack_require__(415).trim()
};

module.exports = {
    categoryHeaderBannersController: categoryHeaderBannersController,
    categoryHeaderBannersComponentDefinition: categoryHeaderBannersComponentDefinition
};

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeaderBanners\">\r\n    <wow-banner\r\n        banner=\"banner\"\r\n        ng-repeat=\"banner in $ctrl.bannersService.banners[$ctrl.category.NodeId] track by banner.ID\">\r\n    </wow-banner>\r\n</div>\r\n"

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var NewProductsService = __webpack_require__(417);
var newProductsNavigationDirectiveDefinition = __webpack_require__(418);

var _require = __webpack_require__(420),
    newProductsTileListComponentDefinition = _require.newProductsTileListComponentDefinition;

angular.module('wowApp.shop').service('NewProductsService', ['Restangular', NewProductsService]).directive('wowNewProductsNav', [newProductsNavigationDirectiveDefinition]).component('wowNewProductsTileList', newProductsTileListComponentDefinition);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = {};

function NewProductsService(restangular) {
    this._api = restangular.one('/Products/New');
}

NewProductsService.prototype.getProducts = function (pageSize, pageNumber, sortType) {
    var _this = this;

    var key = [pageSize, pageNumber, sortType].join('.');
    if (!(key in cache)) {
        cache[key] = this._api.get({ pageSize: pageSize, pageNumber: pageNumber, sortType: sortType });
    }

    return cache[key].then(function (response) {
        _this.totalRecordCount = response.TotalRecordCount;

        return response;
    });
};

NewProductsService.prototype.invalidate = function () {
    this.totalRecordCount = null;
    cache = {};
};

module.exports = NewProductsService;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function NewProductsNavController(newProductsService) {
    this.newProducts = newProductsService;
}

module.exports = function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'newNavCtrl',
        controller: ['NewProductsService', NewProductsNavController],
        template: __webpack_require__(419).trim()
    };
};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation navigation-container\">\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <a ui-sref=\"shop.new\" ui-sref-active=\"is-active\" class=\"navigation-link\" ng-switch=\"newNavCtrl.newProducts.totalRecordCount != null\">\r\n                New Products\r\n                <span ng-switch-when=\"true\" ng-show=\"newNavCtrl.newProducts.totalRecordCount > 0\">({{newNavCtrl.newProducts.totalRecordCount}})</span>\r\n                <wow-loading-spinner class=\"searchCountSpinner\" ng-switch-when=\"false\"></wow-loading-spinner>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</nav>"

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(7),
    createProductTiles = _require.createProductTiles;

var NewProductsTileListController = function () {
    function NewProductsTileListController(settings, newProductsService, sortByKeys) {
        _classCallCheck(this, NewProductsTileListController);

        this.settings = settings;
        this.newProductsService = newProductsService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(NewProductsTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.new.sortOptions, sortContext: this.sortByKeys.NEW_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(response) {
            return {
                items: createProductTiles(response.Items),
                totalRecordCount: response.TotalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.newProductsService.getProducts(pageSize, pageNumber, sortType).then(function (response) {
                return _this.createTiles(response);
            });
        }
    }]);

    return NewProductsTileListController;
}();

NewProductsTileListController.$inject = ['Settings', 'NewProductsService', 'SortByKeys'];

var newProductsTileListComponentDefinition = {
    bindings: {
        pageNumber: '<',
        sortBy: '<'
    },
    controller: NewProductsTileListController,
    template: '\n        <wow-tile-list\n            list-title="\'New Products\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n\n            <zero-result>\n                <div class="newProductsTileList-zeroResult">\n                    <h1 class="newProductsZeroResult-title">No new products found</h1>\n                    <p>Sorry, no new products were found. Please check back soon.</p>\n                </div>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    NewProductsTileListController: NewProductsTileListController,
    newProductsTileListComponentDefinition: newProductsTileListComponentDefinition
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var PartnerService = __webpack_require__(422);
var partnerDirectiveDefinition = __webpack_require__(423);
var partnerSmallFormatDirectiveDefinition = __webpack_require__(425);

var _require = __webpack_require__(427),
    conveniencePackTileListComponentDefinition = _require.conveniencePackTileListComponentDefinition;

angular.module('wowApp.shop').service('PartnerService', ['Restangular', PartnerService]).directive('wowPartner', ['AddressService', 'PartnerService', '$state', partnerDirectiveDefinition]).directive('wowPartnerSmallFormat', [partnerSmallFormatDirectiveDefinition]).component('wowConveniencePackTileList', conveniencePackTileListComponentDefinition);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

function PartnerService(restangular) {
    this._api = restangular.one('partners');
}

PartnerService.prototype.getPartner = _.memoize(function (id) {
    return this._api.one(id).get();
});

PartnerService.prototype.getBranch = _.memoize(function (id) {
    return this._api.one('branches', id).get();
});

module.exports = PartnerService;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (addressService, partnerService, $state) {
    return {
        restrict: 'E',
        scope: {},
        link: function link(scope) {
            scope.statePicker = {};

            scope.selectedBranch = function (branch) {
                addressService.setPartnerDeliveryAddress(branch);
            };

            if ($state.params.id) {
                partnerService.getPartner($state.params.id).then(function (response) {
                    scope.branchAddresses = response.PartnerBranchAddress;

                    scope.states = _.uniq(_.map(scope.branchAddresses, 'State'));
                    scope.statePicker.currentState = scope.states[0];
                });
            }
        },

        template: __webpack_require__(424).trim()
    };
};

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<div class=\"partner\" ng-if=\"branchAddresses\">\r\n    <wow-select-container>\r\n        <label for=\"states\">Filter by state</label>\r\n        <select id=\"states\" ng-model=\"statePicker.currentState\" ng-options=\"state for state in states\"></select>\r\n    </wow-select-container>\r\n\r\n    <ul class=\"partner-addressWrapper\" wow-scrollbar wow-hide-scroll>\r\n        <li ng-repeat=\"branch in branchAddresses\" ng-if=\"branch.State == statePicker.currentState\">\r\n            <a class=\"partner-addressLink\" ui-sref=\"shop.partnerbranch({ id: branch.PartnerBranchId })\" ng-click=\"selectedBranch(branch)\">\r\n                <div class=\"partner-addressSuburb\">{{branch.Name}}</div>\r\n                <div class=\"partner-addressStreet\">{{branch.Street1}}</div>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        template: __webpack_require__(426).trim()
    };
};

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "<div class=\"partner-smallFormat\" wow-scrollbar wow-hide-scroll>\r\n    <div class=\"partner-smallFormat-content u-xsContentHeight\">\r\n        <oly-dynamic-content class=\"dynamic-content2-panelTop\" oly-dc-url-schedule></oly-dynamic-content>\r\n        <ng-transclude></ng-transclude>\r\n        <oly-dynamic-content class=\"dynamic-content2-panelBottom\" oly-dc-url-schedule=\"bottom\"></oly-dynamic-content>\r\n    </div>\r\n</div>"

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    map = _require.map,
    _require2 = __webpack_require__(7),
    createBundleTiles = _require2.createBundleTiles;

var ConveniencePackTileListController = function () {
    function ConveniencePackTileListController(settings, trolleyService, productGroupService) {
        _classCallCheck(this, ConveniencePackTileListController);

        this.settings = settings;
        this.trolleyService = trolleyService;
        this.productGroupService = productGroupService;
    }

    _createClass(ConveniencePackTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.productGroupService.getSortOptions();
        }
    }, {
        key: 'createTiles',
        value: function createTiles(bundles) {
            return {
                items: createBundleTiles(bundles.items),
                totalRecordCount: bundles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';

            return this.productGroupService.selectProductGroup(this.packId).then(function () {
                return _this.productGroupService.getProducts({ pageNumber: pageNumber, pageSize: pageSize, sortType: sortType });
            }).then(function (bundles) {
                return _this.createTiles(bundles);
            });
        }
    }, {
        key: 'addAll',
        value: function addAll() {
            var _this2 = this;

            this.productGroupService.getProducts({ pageNumber: 0, pageSize: this.productGroupService.selectedGroupTotalCount, sortType: 'Name' }).then(function (response) {
                _this2.trolleyService.addItemsToTrolley(map(response.items, function (item) {
                    return item.Products[0];
                }));
            });
        }
    }]);

    return ConveniencePackTileListController;
}();

ConveniencePackTileListController.$inject = ['Settings', 'TrolleyService', 'ProductGroupService'];

var conveniencePackTileListComponentDefinition = {
    bindings: {
        packId: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: ConveniencePackTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.productGroupService.selectedGroup.Name"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n\n            <top-right>\n                <button class="button button--primary" ng-click="$ctrl.addAll()">\n                    Add all ({{ $ctrl.productGroupService.selectedGroupTotalCount }})\n                </button>\n            </top-right>\n        </wow-tile-list>\n    '
};

module.exports = {
    ConveniencePackTileListController: ConveniencePackTileListController,
    conveniencePackTileListComponentDefinition: conveniencePackTileListComponentDefinition
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp.shop');

wowApp.component('wowPrice', __webpack_require__(429).priceControllerComponentDefinition);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PriceController = function () {
    function PriceController(currencyFilter) {
        _classCallCheck(this, PriceController);

        this.currencyFilter = currencyFilter;
    }

    _createClass(PriceController, [{
        key: '$onInit',
        value: function $onInit() {
            this.buildDisplayPrice(this.price);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(change) {
            this.buildDisplayPrice(change.price.currentValue);
        }
    }, {
        key: 'buildDisplayPrice',
        value: function buildDisplayPrice(price) {
            if (price === undefined) {
                return;
            }

            var displayPrice = this.currencyFilter(price);

            this.currencySymbol = displayPrice.slice(0, 1);

            var _displayPrice$slice$s = displayPrice.slice(1).split('.');

            var _displayPrice$slice$s2 = _slicedToArray(_displayPrice$slice$s, 2);

            this.priceDollar = _displayPrice$slice$s2[0];
            this.priceCents = _displayPrice$slice$s2[1];
        }
    }]);

    return PriceController;
}();

var priceControllerComponentDefinition = {
    bindings: {
        price: '<',
        classModifier: '@?'
    },
    controller: ['currencyFilter', PriceController],
    template: '\n        <div class="price" ng-class="::$ctrl.classModifier">\n            <span class="price-symbol">{{ ::$ctrl.currencySymbol }}</span>\n            <span class="price-dollars">{{ $ctrl.priceDollar }}</span>\n            <span class="price-cents">{{ $ctrl.priceCents }}</span>\n        </div>\n    '
};

module.exports = {
    PriceController: PriceController,
    priceControllerComponentDefinition: priceControllerComponentDefinition
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var productGroupDirectiveDefinition = __webpack_require__(431);

var _require = __webpack_require__(433),
    productGroupTileListComponentDefinition = _require.productGroupTileListComponentDefinition;

angular.module('wowApp.shop').directive('wowProductGroup', ['ProductGroupService', 'OfferGroupService', productGroupDirectiveDefinition]).component('wowProductGroupTileList', productGroupTileListComponentDefinition);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (productGroupService, offerGroupService) {
    return {
        restrict: 'E',
        scope: {
            groupType: '='
        },
        link: function link(scope) {
            var groupService = scope.groupType === 'OfferGroup' ? offerGroupService : productGroupService;

            scope.isGroupLoading = function () {
                return groupService.selectedGroup === undefined;
            };

            scope.isCountLoading = function () {
                return groupService.selectedGroupTotalCount === undefined;
            };

            scope.productGroupName = function () {
                return groupService.selectedGroup.Description;
            };

            scope.productsCount = function () {
                return groupService.selectedGroupTotalCount;
            };
        },

        template: __webpack_require__(432).trim()
    };
};

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation\" ng-if=\"!isGroupLoading()\">\r\n    <h2 class=\"sr-only\">Product Group Navigation</h2>\r\n\r\n    <a class=\"navigation-link is-active\" ui-sref=\".\" ui-sref-opts=\"{ reload: true }\">\r\n        <span>\r\n            {{ productGroupName() }}\r\n            <span ng-if=\"!isCountLoading()\">({{ productsCount() }})</span>\r\n        </span>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(7),
    createBundleTiles = _require.createBundleTiles;

var ProductGroupTileListController = function () {
    function ProductGroupTileListController(settings, productGroupService) {
        _classCallCheck(this, ProductGroupTileListController);

        this.settings = settings;
        this.productGroupService = productGroupService;
    }

    _createClass(ProductGroupTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.productGroupService.getSortOptions();
        }
    }, {
        key: 'title',
        value: function title() {
            var description = this.productGroupService.selectedGroup.Description;

            return this.productGroupService.selectedGroupTotalCount != null ? description + ' (' + this.productGroupService.selectedGroupTotalCount + ')' : description;
        }
    }, {
        key: 'createTiles',
        value: function createTiles(products) {
            return {
                items: createBundleTiles(products.items),
                totalRecordCount: products.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';

            return this.productGroupService.selectProductGroup(this.productGroupId).then(function () {
                return _this.productGroupService.getProducts({ pageSize: pageSize, pageNumber: pageNumber, sortType: sortType });
            }).then(function (products) {
                return _this.createTiles(products);
            });
        }
    }]);

    return ProductGroupTileListController;
}();

ProductGroupTileListController.$inject = ['Settings', 'ProductGroupService'];

var productGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: ProductGroupTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.title()"\n            page-number="$ctrl.pageNumber"\n            total-record-count="$ctrl.productGroupService.selectedGroupTotalCount"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    ProductGroupTileListController: ProductGroupTileListController,
    productGroupTileListComponentDefinition: productGroupTileListComponentDefinition
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp.shop');

wowApp.service('ShelfProductService', ['Restangular', 'DetailProductService', 'TrolleyService', __webpack_require__(435)]);
wowApp.service('DetailProductService', ['Restangular', '$rootScope', 'BreakpointsService', __webpack_require__(436)]);

wowApp.component('wowShelfBundleTile', __webpack_require__(437).shelfBundleTileComponentDefinition);
wowApp.component('wowShelfProductVariant', __webpack_require__(439).shelfProductVariantComponentDefinition);

wowApp.component('wowShelfProductTile', __webpack_require__(441).shelfProductTileComponentDefinition);
wowApp.component('wowShelfProductTileOffer', __webpack_require__(443).shelfProductTileOfferComponentDefinition);
wowApp.component('wowShelfProductTagCenter', __webpack_require__(445).shelfProductTagCenterComponentDefinition);
wowApp.component('wowShelfProductTagImage', __webpack_require__(447).shelfProductTagImageComponentDefinition);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);
var UrlInfo = __webpack_require__(19);

var _api = void 0,
    _browseApi = void 0,
    _detailProductService = void 0,
    _trolleyService = void 0;

var ShelfProductService = function ShelfProductService(Restangular, detailProductService, trolleyService) {
    _api = Restangular.all('products');
    _detailProductService = detailProductService;
    _trolleyService = trolleyService;
    _browseApi = Restangular.one('browse/category');
};

/*
 * Calls /products/<stockcode>
 */
ShelfProductService.prototype.getProductDetail = function (stockcode) {
    return _api.get(stockcode);
};

/*
 * Calls /products/<stockcodes>
 */
ShelfProductService.prototype.getProductsByStockcodes = function (stockcodes, excludeUnavailable, source) {
    return _api.get(stockcodes.join(), {
        excludeUnavailable: !!excludeUnavailable,
        source: source
    });
};

/*
 * calls /products?filters
 */
ShelfProductService.prototype.getProducts = function (args) {
    return _api.getList(args).then(function (response) {

        // At the moment we are only adding from Visual Shopping, once we introduce another
        // way to populate the products container this code will need to be re-evaluated.
        _.forEach(response, function (bundle) {
            _.forEach(bundle.Products, function (product) {
                // Set the add to trolley source for analytics.
                product.Source = 'VisualShopping';
            });
        });

        return response;
    });
};

ShelfProductService.prototype.processTrolleyProductTagLink = function (tagLink) {

    // breaks the link with the urlInfo
    var url = new UrlInfo(tagLink);
    var search = url.getSearchObject();
    var path = url.pathname();

    // Only AddToTrolley and AddMultiToTrolley should change,
    // the other tags will follow the link as usual
    if (path.indexOf('AddToTrolley') >= 0 || path.indexOf('AddMultiToTrolley') >= 0) {
        var codes = search.stockcode.split(',');
        for (var i = 0; i < codes.length; i++) {
            this.addItemToTrolley(codes[i], search.quantity, search.source);
        }

        return true;
    }

    return false;
};

ShelfProductService.prototype.addItemToTrolley = function (stockCode, quantity, source) {

    // Quantity is undefined when add multiple items to the trolley
    quantity = quantity !== undefined ? parseInt(quantity) : 1;
    return _detailProductService.getProductDetail(stockCode).then(function (result) {
        var product = result.Product;
        if (product.IsInTrolley) {
            var addQuantity = product.QuantityInTrolley + quantity;
            _trolleyService.updateTrolleyItem(product, addQuantity);
        } else {
            _trolleyService.addItemToTrolley(product, quantity, source);
        }
    });
};

/*
 * calls /browse?filters
 */
ShelfProductService.prototype.getBrowsePage = function (args) {
    return _browseApi.get(args);
};

module.exports = ShelfProductService;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ShelfProductDetailService = function ShelfProductDetailService(Restangular, $rootScope, breakpointsService) {
    var _this = this;

    this._api = Restangular.one('product');
    this.breakpointsService = breakpointsService;

    // We invalidate when the trolley updates because product detail
    // objects contain information about quantity in trolley.
    $rootScope.$on('trolley:update', function () {
        _this.invalidate();
    });
};

var detailsCache = {};

ShelfProductDetailService.prototype.getProductDetail = function (productStockcode, aisle, category, validateUrl) {
    return productStockcode in detailsCache ? detailsCache[productStockcode] : detailsCache[productStockcode] = this._api.one('detail', productStockcode).get({ aisle: aisle, category: category, validateUrl: validateUrl, isMobile: this.breakpointsService.isInSmallFormat });
};

ShelfProductDetailService.prototype.invalidate = function () {
    detailsCache = {};
};

module.exports = ShelfProductDetailService;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfBundleTileController = function ShelfBundleTileController() {
    _classCallCheck(this, ShelfBundleTileController);
};

var shelfBundleTileComponentDefinition = {
    bindings: {
        bundle: '<'
    },
    controller: ShelfBundleTileController,
    template: __webpack_require__(438).trim()
};

module.exports = {
    ShelfBundleTileController: ShelfBundleTileController,
    shelfBundleTileComponentDefinition: shelfBundleTileComponentDefinition
};

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfBundleTile tile\">\r\n    <div class=\"shelfBundleTile-title\" ng-bind-html=\"::$ctrl.bundle.Name | sanitize\"></div>\r\n\r\n    <ul class=\"shelfBundleTile-list\">\r\n        <li class=\"shelfBundleTile-item\" ng-repeat=\"product in ::$ctrl.bundle.Products | orderBy:'UnitWeightInGrams' track by product.Stockcode\">\r\n            <wow-shelf-product-variant total-variants=\"::$ctrl.bundle.Products.length\" product=\"::product\"></wow-shelf-product-variant>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productClickAnalyticsMapper = __webpack_require__(25);

var ShelfProductVariantController = function () {
    function ShelfProductVariantController(config, trolleyService, gtmService) {
        _classCallCheck(this, ShelfProductVariantController);

        this.config = config;
        this.trolleyService = trolleyService;
        this.gtmService = gtmService;
    }

    _createClass(ShelfProductVariantController, [{
        key: '$onInit',
        value: function $onInit() {
            this.defaultImagePath = this.config.DefaultProductImageSmall;
        }
    }, {
        key: 'gtmProductClickDataPush',
        value: function gtmProductClickDataPush() {
            this.gtmService.push(this.product, productClickAnalyticsMapper);
        }
    }]);

    return ShelfProductVariantController;
}();

var shelfProductVariantComponentDefinition = {
    bindings: {
        product: '<',
        totalVariants: '='
    },
    controller: ['config', 'TrolleyService', 'GtmService', ShelfProductVariantController],
    template: __webpack_require__(440).trim()
};

module.exports = {
    ShelfProductVariantController: ShelfProductVariantController,
    shelfProductVariantComponentDefinition: shelfProductVariantComponentDefinition
};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductVariant\" ng-class=\"'shelfProductVariant--' + $ctrl.totalVariants\">\r\n    <a ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName})\"\r\n        ng-click=\"::$ctrl.gtmProductClickDataPush()\"\r\n        class=\"shelfProductVariant-product\">\r\n        <div class=\"shelfProductVariant-details\">\r\n            <div class=\"shelfProductVariant-variant\">\r\n                {{::$ctrl.product.PackageSize}}\r\n            </div>\r\n\r\n            <div class=\"shelfProductVariant-price\">\r\n                {{::$ctrl.product.Price | currency}}\r\n            </div>\r\n\r\n            <div class=\"shelfProductVariant-cup\" ng-show=\"::$ctrl.product.HasCupPrice\">\r\n                {{::$ctrl.product.CupString}}\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"shelfProductVariant-imageContainer\">\r\n            \r\n            <img class=\"shelfProductVariant-imageTag\"\r\n                ng-if=\"::$ctrl.product.ImageTag.TagContent\" \r\n                ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\"\r\n                alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\"/>\r\n\r\n            <img class=\"shelfProductVariant-image\"\r\n                alt=\"{{ ::$ctrl.product.Name }}\"\r\n                ng-src=\"{{ ::$ctrl.product.MediumImageFile }}\"\r\n                oly-error-src=\"{{::$ctrl.defaultImagePath}}\"\r\n            />\r\n        </div>\r\n    </a>\r\n\r\n    <div class=\"shelfProductVariant-controls\">\r\n        <wow-product-save-to-list\r\n            product=\"::$ctrl.product\">\r\n        </wow-product-save-to-list>\r\n\r\n        <wow-cart-controls\r\n            shelf-product=\"::$ctrl.product\"\r\n            trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\"\r\n            source=\"{{ ::$ctrl.product.Source }}\">\r\n        </wow-cart-controls>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var restrictionTypes = {
    NONE: 'NONE',
    PM_DELIVERY: 'PM_DELIVERY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
    COLLECTION_ONLY: 'COLLECTION_ONLY'
};

var ShelfProductTileController = function () {
    function ShelfProductTileController(config, settings, trolleyService) {
        _classCallCheck(this, ShelfProductTileController);

        this.config = config;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.restrictionTypes = restrictionTypes;
    }

    _createClass(ShelfProductTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.productRestriction = this.getRestriction();
            this.shouldShowSavingsTag = this.product.IsOnSpecial && this.product.HasHeaderTag && this.product.HeaderTag.Promotion !== 'Special' && this.product.SavingsAmount > 0;

            if (this.productRestriction === 'PM_DELIVERY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPmDelivery;
            }

            if (this.productRestriction === 'DELIVERY_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionDeliveryOnly;
            }

            if (this.productRestriction === 'COLLECTION_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPickUpOnly;
            }
        }
    }, {
        key: 'getRestriction',
        value: function getRestriction() {
            if (this.product.IsPmDelivery) {
                return this.restrictionTypes.PM_DELIVERY;
            } else if (this.product.IsForCollection && !this.product.IsForDelivery) {
                return this.restrictionTypes.COLLECTION_ONLY;
            } else if (!this.product.IsForCollection && this.product.IsForDelivery) {
                return this.restrictionTypes.DELIVERY_ONLY;
            }
            return this.restrictionTypes.NONE;
        }
    }]);

    return ShelfProductTileController;
}();

var shelfProductTileComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['config', 'Settings', 'TrolleyService', ShelfProductTileController],
    template: __webpack_require__(442).trim()
};

module.exports = {
    ShelfProductTileController: ShelfProductTileController,
    shelfProductTileComponentDefinition: shelfProductTileComponentDefinition
};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTile tile\" ng-class=\"::{'has-header': $ctrl.product.HeaderTag.Content}\">\r\n    <div class=\"shelfProductTile-content\">\r\n\r\n        <a ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\">\r\n            <span class=\"sr-only\">{{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}</span>\r\n            <img class=\"shelfProductTile-image\" ng-src=\"{{ ::$ctrl.product.MediumImageFile }}\" alt=\"\" oly-error-src=\"{{ ::$ctrl.config.DefaultProductImage }}\">\r\n        </a>\r\n\r\n        <div class=\"shelfProductTile-information\">\r\n            <h3>\r\n                <a class=\"shelfProductTile-descriptionLink\" ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\">\r\n                    {{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}\r\n                </a>\r\n            </h3>\r\n\r\n            <wow-shelf-product-tag-image product=\"::$ctrl.product\"></wow-shelf-product-tag-image>\r\n\r\n            <wow-shelf-product-tile-offer\r\n                header-tag=\"::$ctrl.product.HeaderTag\">\r\n            </wow-shelf-product-tile-offer>\r\n\r\n            <div class=\"shelfProductTile-ribbonWrapper\">\r\n                <div class=\"shelfProductTile-ribbon\" ng-if=\"::$ctrl.product.IsNew\">\r\n                    New\r\n                </div>\r\n            </div>\r\n\r\n            <wow-shelf-product-tag-center product=\"::$ctrl.product\" ng-if=\"::$ctrl.product.IsCentreTag && !$ctrl.product.IsDeliveryPass\"></wow-shelf-product-tag-center>\r\n\r\n            <div class=\"shelfProductTile-savings\" ng-if=\"::$ctrl.shouldShowSavingsTag\">\r\n                <p class=\"shelfProductTile-savingsText\">\r\n                    Save {{ ::$ctrl.product.SavingsAmount | wowCurrencyCents }}\r\n                </p>\r\n            </div>\r\n\r\n            <div class=\"shelfProductTile-price\" ng-if=\"::$ctrl.product.IsAvailable\">\r\n                <div>\r\n                    <wow-price price=\"::$ctrl.product.Price\"></wow-price>\r\n\r\n                    <div class=\"shelfProductTile-wasPrice\" ng-if=\"::($ctrl.product.IsOnSpecial && !$ctrl.product.HideWasSavedPrice)\">\r\n                        Was {{ ::($ctrl.product.WasPrice | currency) }}\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"shelfProductTile-cupPrice\" ng-if=\"::$ctrl.product.HasCupPrice\">\r\n                    {{ ::$ctrl.product.CupString }}\r\n                </div>\r\n            </div>\r\n\r\n            <wow-tile-in-cart product=\"::$ctrl.product\"></wow-tile-in-cart>\r\n        </div>\r\n    </div>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <a ng-href=\"{{::$ctrl.product.HeaderTag.TagLink}}\" ng-if=\"::($ctrl.product.HasHeaderTag && $ctrl.productRestriction === 'NONE' && $ctrl.product.HeaderTag.TagLink)\" class=\"shelfProductTile-offerLink\">\r\n        View all products in this offer</span>\r\n    </a>\r\n\r\n    <div class=\"shelfProductTile-restriction\" ng-if=\"::($ctrl.productRestriction !== 'NONE' && !$ctrl.product.HeaderTag.TagLink)\">{{$ctrl.restrictionDelivery}}</div>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <div class=\"shelfProductTile-controls\">\r\n        <wow-product-save-to-list product=\"::$ctrl.product\"></wow-product-save-to-list>\r\n\r\n        <wow-cart-controls\r\n            shelf-product=\"::$ctrl.product\"\r\n            trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\"\r\n            source=\"{{ ::$ctrl.product.Source }}\">\r\n        </wow-cart-controls>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfProductTileOfferController = function () {
    function ShelfProductTileOfferController($sce) {
        _classCallCheck(this, ShelfProductTileOfferController);

        this.$sce = $sce;
    }

    _createClass(ShelfProductTileOfferController, [{
        key: '$onInit',
        value: function $onInit() {
            this.getTagStyles();
        }
    }, {
        key: 'getTagStyles',
        value: function getTagStyles() {
            if (!this.headerTag) {
                return;
            }

            if (this.headerTag.BorderColor) {
                this.containerStyle = { border: '2px solid ' + this.headerTag.BorderColor };
            }

            this.tagStyle = {
                background: this.headerTag.BackgroundColor,
                'border-bottom-color': this.headerTag.BorderColor,
                color: this.headerTag.TextColor
            };
        }
    }]);

    return ShelfProductTileOfferController;
}();

var shelfProductTileOfferComponentDefinition = {
    bindings: {
        headerTag: '<',
        classModifier: '@?'
    },
    controller: ['$sce', ShelfProductTileOfferController],
    template: __webpack_require__(444).trim()
};

module.exports = {
    ShelfProductTileOfferController: ShelfProductTileOfferController,
    shelfProductTileOfferComponentDefinition: shelfProductTileOfferComponentDefinition
};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTileOffer\" ng-style=\"::$ctrl.containerStyle\" ng-class=\"::$ctrl.classModifier\">\r\n    <p\r\n        class=\"shelfProductTileOffer-text\"\r\n        ng-style=\"::$ctrl.tagStyle\"\r\n        ng-bind-html=\"::$ctrl.$sce.trustAsHtml($ctrl.headerTag.Content)\">\r\n    </p>\r\n</div>\r\n"

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productClickAnalyticsMapper = __webpack_require__(25);

var ShelfProductTagCenterController = function () {
    function ShelfProductTagCenterController($sce, shelfProductService, gtmService) {
        _classCallCheck(this, ShelfProductTagCenterController);

        this.$sce = $sce;
        this.shelfProductService = shelfProductService;
        this.gtmService = gtmService;

        this.product.CentreTag.displayContent = this.getTagContent(this.product.CentreTag);
        this.tag = this.product.CentreTag;
    }

    _createClass(ShelfProductTagCenterController, [{
        key: 'getTagContent',
        value: function getTagContent() {
            var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.product.CentreTag;

            return tag.TagType === 'Html' ? this.$sce.trustAsHtml(tag.TagContent) : tag.TagContent;
        }
    }, {
        key: 'tagClick',
        value: function tagClick(event) {
            // addToTrolley or addMultipleToTrolley are not links anymore
            // they prevent the link to follow href
            if (this.shelfProductService.processTrolleyProductTagLink(this.tag.TagLink)) {
                event.preventDefault();
            }
            this.gtmService.push(this.product, productClickAnalyticsMapper);
        }
    }, {
        key: 'htmlTagClick',
        value: function htmlTagClick(event) {
            // Same as above, however we need to extract the tag link before processing the link
            var regex = /href="(.*?)"|href='(.*?)'/gm;
            var tagLink = this.tag.TagContent.match(regex);
            if (tagLink && this.shelfProductService.processTrolleyProductTagLink(tagLink[0])) {
                event.preventDefault();
            }
        }
    }, {
        key: 'gtmStaticTextOnProductPush',
        value: function gtmStaticTextOnProductPush() {
            this.gtmService.push({ event: 'staticTextOnProductFooterClick' });
        }
    }, {
        key: 'staticTextClick',
        value: function staticTextClick(event) {
            return this.product.CentreTag.TagType === 'Html' ? this.htmlTagClick(event) : this.gtmStaticTextOnProductPush();
        }
    }]);

    return ShelfProductTagCenterController;
}();

var shelfProductTagCenterComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['$sce', 'ShelfProductService', 'GtmService', ShelfProductTagCenterController],
    template: __webpack_require__(446).trim()
};

module.exports = {
    ShelfProductTagCenterController: ShelfProductTagCenterController,
    shelfProductTagCenterComponentDefinition: shelfProductTagCenterComponentDefinition
};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTagCenter\">\r\n    <a ng-if=\"::$ctrl.product.CentreTag.TagLink\" ng-href=\"{{::$ctrl.product.CentreTag.TagLink}}\" ng-click=\"::$ctrl.tagClick($event)\">\r\n        <span ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n    </a>\r\n    <span ng-if=\"::!$ctrl.product.CentreTag.TagLink\" ng-click=\"::$ctrl.staticTextClick($event)\" ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n</div>"

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productClickAnalyticsMapper = __webpack_require__(25);

var ShelfProductTagImageController = function () {
    function ShelfProductTagImageController(shelfProductService, gtmService) {
        _classCallCheck(this, ShelfProductTagImageController);

        this.shelfProductService = shelfProductService;
        this.gtmService = gtmService;
    }

    _createClass(ShelfProductTagImageController, [{
        key: 'tagClick',
        value: function tagClick(event) {
            // addToTrolley or addMultipleToTrolley are not links anymore
            // they prevent the link to follow href
            if (this.shelfProductService.processTrolleyProductTagLink(this.product.ImageTag.TagLink)) {
                event.preventDefault();
            }

            this.gtmService.push(this.product, productClickAnalyticsMapper);
        }
    }, {
        key: 'gtmStaticTagClickPush',
        value: function gtmStaticTagClickPush() {
            this.gtmService.push({ event: 'staticTagImageClick' });
        }
    }]);

    return ShelfProductTagImageController;
}();

var shelfProductTagImageComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['ShelfProductService', 'GtmService', ShelfProductTagImageController],
    template: __webpack_require__(448).trim()
};

module.exports = {
    ShelfProductTagImageController: ShelfProductTagImageController,
    shelfProductTagImageComponentDefinition: shelfProductTagImageComponentDefinition
};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"::(!!$ctrl.product.ImageTag.TagLink)\">\r\n    <a ng-switch-when=\"true\" ng-href=\"{{::$ctrl.product.ImageTag.TagLink}}\" class=\"shelfProductTagImage-tag\" ng-click=\"::$ctrl.tagClick($event)\">\r\n        <img ng-show=\"::($ctrl.product.ImageTag && $ctrl.product.ImageTag.TagContent)\" ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\"\r\n            alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\" class=\"shelfProductTagImage-image\" oly-error-src />\r\n    </a>\r\n    <span ng-switch-when=\"false\" class=\"shelfProductTagImage-tag u-noPointerEvents\" ng-click=\"::$ctrl.gtmStaticTagClickPush()\">\r\n        <img ng-show=\"::($ctrl.product.ImageTag && $ctrl.product.ImageTag.TagContent)\" ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\" alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\" class=\"shelfProductTagImage-image\" oly-error-src />\r\n    </span>\r\n</div>"

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(0).module('wowApp.shop').service('StoreService', ['Restangular', 'StoreFilterService', 'LocationService', __webpack_require__(450)]).service('StoreFilterService', [__webpack_require__(451)]);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var StoreService = function () {
    function StoreService(restangular, storeFilterService, locationService) {
        var _this = this;

        _classCallCheck(this, StoreService);

        this._storeLocatorApi = restangular.one('StoreLocator');
        this._suburbsApi = this._storeLocatorApi.one('Suburbs');
        this._storesApi = this._storeLocatorApi.one('Stores');

        this.filterService = storeFilterService;
        this.locationService = locationService;
        this.isGeolocationEnabled = false;

        locationService.getCurrentLocation().then(function (isEnabled) {
            _this.isGeolocationEnabled = isEnabled;
        });
    }

    _createClass(StoreService, [{
        key: 'getDefaultLocation',
        value: function getDefaultLocation() {
            return this._storeLocatorApi.one('DefaultLanding').get();
        }
    }, {
        key: 'searchStoresByRoute',
        value: function searchStoresByRoute(route) {
            return this._storesApi.get({
                RoutePoint: route.overview_polyline,
                Division: this.filterService.getDivisionCodes().join(','),
                Facility: this.filterService.getFacilityCodes().join(',')
            }).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'searchStoresByCoordinates',
        value: function searchStoresByCoordinates(coordinates) {
            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
            var divisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.filterService.getSelectedDivisions();
            var facilities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.filterService.getSelectedFacilities();

            return this._storesApi.get(_.assign({}, coordinates, {
                Division: this.filterService.getDivisionCodes(divisions).join(','),
                Facility: this.filterService.getFacilityCodes(facilities).join(','),
                Max: max
            })).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
            var divisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.filterService.getSelectedDivisions();
            var facilities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.filterService.getSelectedFacilities();

            return this._storesApi.get({
                PostCode: postcode,
                Division: this.filterService.getDivisionCodes(divisions).join(','),
                Facility: this.filterService.getFacilityCodes(facilities).join(','),
                Max: max
            }).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            return this._suburbsApi.get({
                SearchTerm: searchTerm
            }).then(function (response) {
                return response && response.Suburbs ? response.Suburbs : [];
            });
        }
    }, {
        key: 'getStore',
        value: function getStore(storeNo, division) {
            return this._storeLocatorApi.one('Store').get({ StoreNo: storeNo, Division: division }).then(function (response) {
                return response.plain();
            });
        }

        /**
        * Gets a unique identifier for a store. (Store numbers are not unique).
        * @param {any} store
        */

    }, {
        key: 'getStoreKey',
        value: function getStoreKey(store) {
            return '' + store.Division + store.AddressLine1;
        }
    }, {
        key: 'getStoreUrl',
        value: function getStoreUrl(store) {
            var url = store.State.trim() + ' ' + store.Suburb.trim() + ' ' + store.StoreNo.trim();

            if (store.Division !== 'SUPERMARKETS') {
                url = url + '-' + store.Division;
            }

            return url.replace(/[^a-zA-Z0-9]/g, ' ').replace(/\s+/g, '-');
        }
    }, {
        key: 'getStoreInfoFromUrlParams',
        value: function getStoreInfoFromUrlParams(storeParam) {
            var storeInfo = void 0;
            var params = storeParam.split('-');
            var lastIndexOfParams = params.length - 1;
            var division = null;

            // check that we have enough parameters
            if (params.length >= 3) {
                // parse store number
                var storeNo = parseInt(params[lastIndexOfParams], 10);

                // if the last parameter is not a number, then it is the division
                if (_.isNaN(storeNo)) {
                    storeNo = parseInt(params[lastIndexOfParams - 1], 10);
                    division = params[lastIndexOfParams];
                }

                // only continue if storeNo is a valid number
                if (storeNo) {
                    // get the suburb
                    var suburbArray = params.slice(1, division ? lastIndexOfParams - 1 : lastIndexOfParams);

                    storeInfo = {
                        storeNo: storeNo,
                        suburb: suburbArray.join(' '),
                        state: params[0],
                        division: division || 'SUPERMARKETS'
                    };
                }
            }

            return storeInfo;
        }
    }, {
        key: 'urlParametersValid',
        value: function urlParametersValid(store, parameters) {
            return store.State === parameters.state && store.Suburb === parameters.suburb && parseInt(store.StoreNo) === parameters.storeNo;
        }
    }, {
        key: 'setSelectedStore',
        value: function setSelectedStore(store) {
            this.selectedStore = store;
        }
    }, {
        key: 'isStoreEqual',
        value: function isStoreEqual(store1, store2) {
            return this.getStoreKey(store1) === this.getStoreKey(store2);
        }
    }, {
        key: 'isSelectedStore',
        value: function isSelectedStore(store) {
            return !!(this.selectedStore && this.isStoreEqual(this.selectedStore, store));
        }
    }, {
        key: 'getFormattedAddress',
        value: function getFormattedAddress(store) {
            if (!store) return '';
            var addressLine1 = !store.AddressLine1 || store.AddressLine1 === '' ? '' : store.AddressLine1 + ', ';
            var suburb = !store.Suburb || store.Suburb === '' ? '' : store.Suburb + ', ';
            var state = !store.State || store.State === '' ? '' : store.State + ', ';
            var postcode = !store.Postcode || store.Postcode === '' ? '' : store.Postcode + ', ';
            return '' + addressLine1 + suburb + state + postcode + 'Australia';
        }
    }]);

    return StoreService;
}();

module.exports = StoreService;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var StoreFilterService = function () {
    function StoreFilterService() {
        _classCallCheck(this, StoreFilterService);
    }

    _createClass(StoreFilterService, [{
        key: 'setDivisions',
        value: function setDivisions(divisions) {
            this.divisions = divisions;
        }
    }, {
        key: 'setFacilities',
        value: function setFacilities(facilities) {
            this.facilities = facilities;
        }
    }, {
        key: 'getSelectedDivisions',
        value: function getSelectedDivisions() {
            var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.divisions;

            return _.filter(divisions, 'Selected');
        }
    }, {
        key: 'getDivisionCodes',
        value: function getDivisionCodes() {
            var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedDivisions();

            return _.map(divisions, 'Division');
        }
    }, {
        key: 'getSelectedFacilities',
        value: function getSelectedFacilities() {
            var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.facilities;

            return _.filter(facilities, 'Selected');
        }
    }, {
        key: 'getFacilityCodes',
        value: function getFacilityCodes() {
            var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedFacilities();

            return _.map(facilities, 'Facility');
        }
    }, {
        key: 'isStoreMatching',
        value: function isStoreMatching(store) {
            var isInDivision = _.includes(this.getDivisionCodes(), store.Division);

            var selectedFacilityLabels = _.map(this.getSelectedFacilities(), 'Label');
            var hasAllFacilities = !selectedFacilityLabels.length || _.intersection(selectedFacilityLabels, store.Facilities).length >= selectedFacilityLabels.length;

            return isInDivision && hasAllFacilities;
        }
    }]);

    return StoreFilterService;
}();

module.exports = StoreFilterService;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp.shop');

wowApp.component('wowProductSaveToList', __webpack_require__(453).productSaveToListComponentDefinition);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED'
};

var ProductSaveToListController = function () {
    function ProductSaveToListController($scope, $element, $state, sessionStorage, savedListsService, shopperService, loginService, moveFocus) {
        _classCallCheck(this, ProductSaveToListController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;

        this.showDropdown = false;
        this.lastSavedList = '';

        this.buttonStates = buttonState;
        this.buttonState = buttonState.DEFAULT;
    }

    _createClass(ProductSaveToListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.pendingSaveToListStorageKey = 'ProductSaveToListController:pendingSaveToList:' + this.product.Stockcode;

            if (!this.shopperService.IsGuest) {
                this.savedListsService.listSavedLists().then(function () {
                    var _ref = _this.sessionStorage.getJsonAndRemove(_this.pendingSaveToListStorageKey) || {},
                        stockcode = _ref.stockcode;

                    if (stockcode === _this.product.Stockcode) {
                        _this.save();
                        _this.moveFocus(_this.$element.find('._saveToListButton'));
                    }
                });
            }
        }
    }, {
        key: 'getButtonSrMessage',
        value: function getButtonSrMessage() {
            return this.buttonState === buttonState.SAVED ? 'Choose a list to save ' + this.product.Name : 'Save ' + this.product.Name + ' to default list';
        }
    }, {
        key: 'save',
        value: function save() {
            if (!this.savedListsService.isServiceAvailable()) {
                this.showServiceError();
                return;
            }

            if (this.shopperService.IsGuest) {
                this.promptForGuest();
                return;
            }

            if (this.lastSavedList === '') {
                this.saveToList({}, false, true); // save to default list
            } else {
                this.toggleDropdown(true);
            }
        }
    }, {
        key: 'saveToList',
        value: function saveToList(list, shouldCloseDropdown, shouldSaveToDefault) {
            var _this2 = this;

            if (!this.savedListsService.savedLists || this.savedListsService.savedLists.length === 0) {
                this.savedListsService.listSavedLists().then(function () {
                    return _this2.saveToList(list, shouldCloseDropdown, shouldSaveToDefault);
                });
                return;
            }

            if (shouldSaveToDefault) {
                list = this.savedListsService.savedLists[0];
            }

            this.lastSavedList = this.isDefaultList(list.ListId) ? 'Default' : list.Name;
            this.buttonState = buttonState.SAVED;

            this.savedListsService.addToList(list.ListId, this.product.Stockcode, this.product.DisplayQuantity).then(function () {
                _this2.srMessage = _this2.product.Name + ' has been saved to ' + _this2.lastSavedList;
                _this2.savedListsService.listSavedLists().finally(function () {
                    _this2.toggleDropdown(shouldCloseDropdown);
                });
            });
        }
    }, {
        key: 'showServiceError',
        value: function showServiceError() {
            var _this3 = this;

            this.showErrorMessage = true;
            this.toggleDropdown(false);
            this.moveFocus(function () {
                return _this3.$element.find('._productSaveToListError');
            });
        }
    }, {
        key: 'promptForGuest',
        value: function promptForGuest() {
            var _this4 = this;

            this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, function () {
                _this4.sessionStorage.setJson(_this4.pendingSaveToListStorageKey, { stockcode: _this4.product.Stockcode });
            });
        }
    }, {
        key: 'toggleDropdown',
        value: function toggleDropdown(shouldMoveFocus) {
            var _this5 = this;

            this.showDropdown = !this.showDropdown;

            if (this.showDropdown) {
                if (shouldMoveFocus) {
                    this.moveFocus(function () {
                        return _this5.$element.find('.productSaveToList-listItem > label').first();
                    });
                }
                $('body').on('click.productSaveToList', function (e) {
                    return _this5.closeDropdownOnOutsideClick(e);
                });
            }
        }
    }, {
        key: 'closeDropdownOnOutsideClick',
        value: function closeDropdownOnOutsideClick(event) {
            if (!($(event.target).closest('wow-product-save-to-list')[0] === this.$element[0])) {
                this.showDropdown = false;
                this.$scope.$apply();
                $('body').off(event);
            }
        }
    }, {
        key: 'wasLastSavedList',
        value: function wasLastSavedList(list) {
            if (this.lastSavedList === 'Default') {
                return this.isDefaultList(list.ListId);
            }
            return this.lastSavedList === list.Name;
        }
    }, {
        key: 'isDefaultList',
        value: function isDefaultList(listId) {
            return this.savedListsService.savedLists[0].ListId === listId;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $('body').off('click.productSaveToList');
        }
    }]);

    return ProductSaveToListController;
}();

var productSaveToListComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['$scope', '$element', '$state', 'SessionStorageWrapper', 'SavedListsService', 'ShopperService', 'LoginService', 'MoveFocus', ProductSaveToListController],
    template: __webpack_require__(454).trim()
};

module.exports = {
    ProductSaveToListController: ProductSaveToListController,
    productSaveToListComponentDefinition: productSaveToListComponentDefinition
};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productSaveToList\">\r\n    <div ng-if=\"!!$ctrl.showDropdown\" class=\"productSaveToList-list\">\r\n        <span class=\"productSaveToList-listItem productSaveToList-listHeader\">\r\n            Add to a list\r\n        </span>\r\n\r\n        <ul class=\"productSaveToList-listItems\" ng-if=\"!$ctrl.showErrorMessage\">\r\n            <li ng-repeat=\"list in $ctrl.savedListsService.savedLists track by list.ListId\" class=\"productSaveToList-listItem\">\r\n                <input\r\n                type=\"radio\"\r\n                id=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\"\r\n                class=\"wowRadio\"\r\n                name=\"productSaveToList{{::$ctrl.product.Stockcode}}\"\r\n                ng-value=\"::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name\"\r\n                ng-model=\"$ctrl.lastSavedList\"\r\n                ng-click=\"::$ctrl.saveToList(list, true)\"\r\n                tabindex=\"-1\" />\r\n                <label class=\"productSaveToList-listItemLabel\" for=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\" >\r\n                    <span class=\"sr-only\">Save to </span>{{::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name}}\r\n                </label>\r\n            </li>\r\n        </ul>\r\n        <ul class=\"productSaveToList-listItems\" ng-if=\"$ctrl.showErrorMessage\">\r\n            <li class=\"productSaveToList-listItem _productSaveToListError\" wow-html-setting setting-group=\"Lists\" setting-name=\"NoListsShortErrorMessage\"></li>\r\n        </ul>\r\n    </div>\r\n    <oly-sr-notification message=\"{{$ctrl.srMessage}}\"></oly-sr-notification>\r\n    <button class=\"button productSaveToList-button _saveToListButton\" ng-click=\"$ctrl.save()\"\r\n        ng-class=\"{'is-saved': $ctrl.buttonState === $ctrl.buttonStates.SAVED}\"\r\n        title=\"Save to list\">\r\n        <span class=\"sr-only\">{{$ctrl.getButtonSrMessage()}}</span><i class=\"iconww-List\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(456),
    ghostTileComponentDefinition = _require.ghostTileComponentDefinition;

var _require2 = __webpack_require__(458),
    tileListComponentDefinition = _require2.tileListComponentDefinition;

var _require3 = __webpack_require__(460),
    tileComponentDefinition = _require3.tileComponentDefinition;

var _require4 = __webpack_require__(462),
    sortByKeys = _require4.sortByKeys;

angular.module('wowApp.shop').constant('SortByKeys', sortByKeys).component('wowGhostTile', ghostTileComponentDefinition).component('wowTileList', tileListComponentDefinition).component('wowTile', tileComponentDefinition);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GhostTileController = function GhostTileController(breakpointsService) {
    _classCallCheck(this, GhostTileController);

    this.breakpointsService = breakpointsService;
};

GhostTileController.$inject = ['BreakpointsService'];

var ghostTileComponentDefinition = {
    controller: GhostTileController,
    template: __webpack_require__(457).trim()
};

module.exports = {
    GhostTileController: GhostTileController,
    ghostTileComponentDefinition: ghostTileComponentDefinition
};

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tile\">\r\n    <div class=\"ghostTile ghostTile-animation\" ng-switch=\"$ctrl.breakpointsService.isInSmallFormat\">\r\n        <div class=\"ghostTile ghostTile-lf\" ng-switch-when=\"false\">\r\n            <!-- Top Header -->\r\n            <div class=\"ghostTile-background ghostTile-lf-topBottomMargin\"></div>\r\n            <!-- Image -->\r\n            <div class=\"ghostTile-lf-image\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-imageProductTextSpacing\"></div>\r\n            <!-- Product Text Line 1 -->\r\n            <div class=\"ghostTile-lf-productTextLine\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-productTextLineAfter1\"></div>\r\n            </div>\r\n            <!-- Spacing between lines -->\r\n            <div class=\"ghostTile-background ghostTile-lf-productTextLineSpacing\"></div>\r\n            <!-- Product Text Line 2 -->\r\n            <div class=\"ghostTile-lf-productTextLine\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-productTextLineAfter2\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-productTextPriceSpacing\"></div>\r\n            <!-- Pricing -->\r\n            <div class=\"ghostTile-lf-price\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-priceAfter\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-priceControlSpacing\"></div>\r\n            <!-- Controls -->\r\n            <div class=\"ghostTile-lf-control\">\r\n                <div class=\"ghostTile-background ghostTile-lf-controlHeight ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-controlHeight ghostTile-lf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-topBottomMargin\"></div>\r\n        </div>\r\n\r\n        <div class=\"ghostTile ghostTile-sf\" ng-switch-when=\"true\">\r\n            <!-- Top Header -->\r\n            <div class=\"ghostTile-background ghostTile-sf-topBottomMargin\"></div>\r\n            <!-- Content -->\r\n            <div class=\"ghostTile-sf-content\">\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n                <!-- Image -->\r\n                <div class=\"ghostTile-sf-contentImage\"></div>\r\n                <div class=\"ghostTile-background ghostTile-sf-contentImageTextSpacer\"></div>\r\n                <div class=\"ghostTile-sf-contentTextWrapper\">\r\n                    <!-- Product Text -->\r\n                    <div class=\"ghostTile-sf-contentProductText\"></div>\r\n                    <div class=\"ghostTile-background ghostTile-sf-contentProductTextPriceSpacer\"></div>\r\n                    <!-- Pricing -->\r\n                    <div class=\"ghostTile-sf-priceWrapper\">\r\n                        <div class=\"ghostTile-sf-priceText\"></div>\r\n                        <div class=\"ghostTile-background ghostTile-sf-priceAfter\"></div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-sf-spacer\"></div>\r\n            <!-- Controls -->\r\n            <div class=\"ghostTile-sf-controlWrapper\">\r\n                <div class=\"ghostTile-background ghostTile-sf-controlBefore\"></div>\r\n                <div class=\"ghostTile-sf-controlAddtocart\"></div>\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-sf-topBottomMargin\"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    find = _require.find,
    fill = _require.fill,
    get = _require.get,
    remove = _require.remove,
    _require2 = __webpack_require__(22),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var GHOST_TILE_ITEM = {
    type: 'ghost'
};

var TileListController = function () {
    function TileListController($q, $timeout, $location, $transclude, $state, localStorageWrapper, moveFocus, settingsByBreakpointService, shopPageStateService, inspirationService, sortByKeys) {
        _classCallCheck(this, TileListController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$transclude = $transclude;
        this.$state = $state;
        this.localStorageWrapper = localStorageWrapper;
        this.moveFocus = moveFocus;
        this.settingsByBreakpointService = settingsByBreakpointService;
        this.shopPageStateService = shopPageStateService;
        this.inspirationService = inspirationService;
        this.sortByKeys = sortByKeys;

        this.pageSize = this.settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
            largeFormat: 'LargeFormatPageSize',
            mediumFormat: 'MediumFormatPageSize',
            smallFormat: 'SmallFormatPageSize'
        });
    }

    _createClass(TileListController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this = this;

            if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
                this.sortType = this.getSortType();
            }

            if (changes.filter && !changes.filter.isFirstChange() || changes.sortBy && !changes.sortBy.isFirstChange() || changes.pageNumber && !changes.pageNumber.isFirstChange()) {
                this.update().then(function () {
                    return _this.focusOnFirstTile();
                });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            if (this.sortOptions) {
                this.sortOptions.sortContext = this.sortOptions.sortContext === undefined ? this.sortByKeys.DEFAULT_KEY : this.sortOptions.sortContext;
            }

            this.items = [];
            this.shouldShowControlBar = this.sortOptions || this.$transclude.isSlotFilled('topRightSlot');
            this.shouldGetInspirationCards = this.shouldGetInspirationCards !== false;
            this.update();
        }
    }, {
        key: 'getSortType',
        value: function getSortType() {
            // Priority: URL -> Local Storage -> First one in list
            return find(this.sortOptions.sortTypes, { Value: this.sortBy }) || find(this.sortOptions.sortTypes, { Value: this.localStorageWrapper.get(this.sortOptions.sortContext) }) || this.sortOptions.sortTypes[0];
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            this.loadingTiles = true;

            return this.$q.all([this.getTiles({ pageSize: this.pageSize, pageNumber: this.pageNumber, sortType: get(this.sortType, 'Value'), filter: this.filter }), this.shouldGetInspirationCards ? this.inspirationService.getCardsForUrl(this.$location.pathAndSearch()) : { Cards: [] }, this.generateGhostTiles()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    _ref2$ = _ref2[0],
                    items = _ref2$.items,
                    totalRecordCount = _ref2$.totalRecordCount,
                    inspiration = _ref2[1].Cards;

                _this2.items = mergeInspirationTiles(items, inspiration, { pageNumber: _this2.pageNumber, pageSize: _this2.pageSize });
                _this2.totalRecordCount = totalRecordCount;
            }).finally(function () {
                return _this2.loadingTiles = false;
            });
        }
    }, {
        key: 'generateGhostTiles',
        value: function generateGhostTiles() {
            var _this3 = this;

            // -1 from the page size is more aesthetically pleasing
            var amountOfGhostTiles = this.totalRecordCount ? Math.min(this.totalRecordCount, this.pageSize - 1) : this.pageSize - 1;

            // The timeout is needed to ensure that the animations run
            this.items = [];
            return this.$timeout(function () {
                _this3.items = fill(Array(amountOfGhostTiles), GHOST_TILE_ITEM);
            });
        }
    }, {
        key: 'onSortByChanged',
        value: function onSortByChanged(option) {
            this.sortBy = option.Value;
            this.localStorageWrapper.set(this.sortOptions.sortContext, this.sortBy);
            this.pageNumber = 1;
            this.$state.go('.', { sortBy: option.Value, pageNumber: undefined });
        }
    }, {
        key: 'onPageSelected',
        value: function onPageSelected() {
            this.shopPageStateService.resetCenterPanelScroll();
        }
    }, {
        key: 'focusOnFirstTile',
        value: function focusOnFirstTile() {
            return this.moveFocus('.tileList-tile:first-child');
        }
    }, {
        key: 'onRemove',
        value: function onRemove(item) {
            if (this.onRemoveItem) {
                this.onRemoveItem({ item: item });
            }

            remove(this.items, item);

            if (this.items.length === 0) {
                this.$state.go('.', { pageNumber: Math.max(1, this.pageNumber - 1) }, { reload: true });
            }
        }
    }]);

    return TileListController;
}();

TileListController.$inject = ['$q', '$timeout', '$location', '$transclude', '$state', 'LocalStorageWrapper', 'MoveFocus', 'SettingsByBreakpointService', 'ShopPageStateService', 'InspirationService', 'SortByKeys'];

var tileListComponentDefinition = {
    bindings: {
        listTitle: '<?',
        pageNumber: '<?',
        filter: '<?',
        totalRecordCount: '<',
        sortBy: '<?',
        sortOptions: '<?',
        shouldGetInspirationCards: '<?',
        isEditing: '<?',
        onRemoveItem: '&?',
        getTiles: '&'
    },
    controller: TileListController,
    transclude: {
        topRightSlot: '?topRight',
        zeroResultSlot: '?zeroResult',
        controlSlot: '?control'
    },
    template: __webpack_require__(459).trim()
};

module.exports = {
    TileListController: TileListController,
    tileListComponentDefinition: tileListComponentDefinition
};

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tileList-container\" ng-show=\"$ctrl.totalRecordCount !== 0 || $ctrl.loadingTiles\">\r\n    <div class=\"tileList\">\r\n        <h1 class=\"tileList-title\" ng-if=\"$ctrl.listTitle\">{{ $ctrl.listTitle }}</h1>\r\n\r\n        <div class=\"tileList-controls\" ng-if=\"::$ctrl.shouldShowControlBar\">\r\n            <div class=\"tileList-sortBy\" ng-if=\"::$ctrl.sortOptions\">\r\n                <div class=\"tileList-sortByLabel\">Sort by:</div>\r\n                <oly-inline-dropdown\r\n                    label-key=\"Text\"\r\n                    ng-model=\"$ctrl.sortType\"\r\n                    options=\"$ctrl.sortOptions.sortTypes\"\r\n                    on-change=\"$ctrl.onSortByChanged(option)\">\r\n                </oly-inline-dropdown>\r\n            </div>\r\n\r\n            <div ng-transclude=\"topRightSlot\"></div>\r\n        </div>\r\n\r\n        <div class=\"tileList-tiles\">\r\n            <wow-tile\r\n                class=\"tileList-repeatAnimation\"\r\n                ng-repeat=\"item in $ctrl.items track by item.id || $index\"\r\n                item=\"item\"\r\n                on-remove=\"$ctrl.onRemove(item)\"\r\n                is-editing=\"$ctrl.isEditing\">\r\n            </wow-tile>\r\n        </div>\r\n\r\n        <oly-paging\r\n            ng-if=\"!$ctrl.loadingTiles && $ctrl.totalRecordCount > 0 && $ctrl.pageNumber\"\r\n            page-size=\"$ctrl.pageSize\"\r\n            total-count=\"$ctrl.totalRecordCount\"\r\n            current-page=\"$ctrl.pageNumber\"\r\n            on-page-select=\"$ctrl.onPageSelected()\">\r\n        </oly-paging>\r\n    </div>\r\n\r\n    <div ng-transclude=\"controlSlot\"></div>\r\n</div>\r\n\r\n<div ng-transclude=\"zeroResultSlot\" ng-if=\"$ctrl.totalRecordCount === 0\"></div>\r\n"

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TileController = function TileController() {
    _classCallCheck(this, TileController);
};

var tileComponentDefinition = {
    bindings: {
        item: '<',
        isEditing: '<?',
        onRemove: '&?'
    },
    controller: TileController,
    template: __webpack_require__(461).trim()
};

module.exports = {
    TileController: TileController,
    tileComponentDefinition: tileComponentDefinition
};

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tile-container\" ng-switch=\"$ctrl.item.type\" ng-class=\"'tile-' + $ctrl.item.type\">\r\n    <wow-ghost-tile ng-switch-when=\"ghost\"></wow-ghost-tile>\r\n    <wow-shelf-product-tile product=\"::$ctrl.item.data.product\" ng-switch-when=\"product\"></wow-shelf-product-tile>\r\n    <wow-shelf-bundle-tile bundle=\"::$ctrl.item.data.bundle\" ng-switch-when=\"bundle\"></wow-shelf-bundle-tile>\r\n    <wow-recipe-tile recipe=\"::$ctrl.item.data.recipe\" ng-switch-when=\"recipe\"></wow-recipe-tile>\r\n    <wow-inspiration-tile card=\"::$ctrl.item.data.inspirationTile\" ng-switch-when=\"inspiration\"></wow-inspiration-tile>\r\n    <wow-inspiration-detail-tile card=\"::$ctrl.item.data.inspirationTile\" ng-switch-when=\"inspirationdetail\"></wow-inspiration-detail-tile>\r\n\r\n    <button type=\"button\" class=\"iconButton tile-remove\" ng-if=\"$ctrl.item.type !== 'ghost' && $ctrl.isEditing\" ng-click=\"$ctrl.onRemove({item: $ctrl.item})\">\r\n        <span class=\"sr-only\">Remove this product from list.</span>\r\n        <i class=\"iconww-Cross\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sortByKeys = Object.freeze({
    DEFAULT_KEY: 'sortByPreference',
    SPECIALS_KEY: 'sortByPreference_specials',
    SEARCH_RESULTS_KEY: 'sortByPreference_search',
    BROWSE_KEY: 'sortByPreference_browse',
    LISTS_KEY: 'sortByPreference_lists',
    PRODUCT_GROUPS_KEY: 'sortByPreference_productGroups',
    NEW_KEY: 'sortByPreference_new',
    RECIPE_KEY: 'sortByPreference_recipe'
});

module.exports = {
    sortByKeys: sortByKeys
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

angular.module('wowApp.shop').service('TrolleyService', ['$rootScope', 'Restangular', '$q', 'GtmService', 'BootstrapService', 'LoginService', 'ShopperService', 'SettingsService', 'DeliveryPassService', 'InspirationService', 'TrolleySource', 'BreakpointsService', 'RichRelevanceService', 'FeatureService', 'AnalyticsService', __webpack_require__(464)]).constant('TrolleySource', __webpack_require__(471));

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = __webpack_require__(1),
    _require = __webpack_require__(31),
    trolleyQuantityValidation = _require.trolleyQuantityValidation;

var _shopperService = void 0;
var _gtmService = void 0;
var _trolleySourceCz = void 0;
var _breakpointsService = void 0;
var _analyticsService = void 0;
var _eventsDtm = void 0;
var _settingsService = void 0;

var addToTrolleyAnalyticsMapper = __webpack_require__(465);
var addAllToTrolleyAnalyticsMapper = __webpack_require__(466);
var productClickTrolleyAnalyticsMapper = __webpack_require__(467);
var productClickAddAllTrolleyAnalyticsMapper = __webpack_require__(468);
var dynamicContentAnalyticsMapper = __webpack_require__(469);

var trolleyDtmMapper = __webpack_require__(470);

/* This service contains combined changes from
 * story WOS-2279 (move filtering to server side)
 * and story WOS-2281 (reduce client side watchers)
 */

var TrolleyService = function TrolleyService($rootScope, restangular, $q, gtm, bootstrap, loginService, shopperService, settingsService, deliveryPassService, inspirationService, trolleySource, breakpointsService, richRelevanceService, featureService, analyticsService) {
    var _this = this;

    /*
     * Service for interacting with the trolley.
     * Supports actions like adding, removing, updating, and clearing.
     * Depends on Restangular.
     */
    this._trolleyRoute = restangular.one('Trolley');

    this.$rootScope = $rootScope;

    this.$q = $q;

    this._loginService = loginService;
    _shopperService = shopperService;
    _gtmService = gtm;
    _trolleySourceCz = trolleySource.collectionZone;
    _analyticsService = analyticsService;
    _eventsDtm = analyticsService.eventsDtm;
    _settingsService = settingsService;
    this.inspirationService = inspirationService;
    this.guestTrolleyLoginReminderShown = false;
    // The items
    this.trolleyProducts = [];

    // Products that are being added or removed on user action for analytics
    this.recentlyChangedItems = [];

    // Totals information
    this.salePriceTotal = 0;
    this.listPriceTotal = 0;
    this.deliveryFee = 0;
    this.savedPrice = 0;

    this.isTotalReady = false;
    this.wowRewardsSummary = {};

    this.srMessage = ''; // this is for sr (Screen Reader) only.

    this.deliveryPassService = deliveryPassService;

    // First initialization
    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.Trolley)) {
        this._updateTrolley(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Trolley));
    }

    this.deliveryPassLimitReached = {};

    this.showDCPdeliveryPassLimitReachedMsg = false;

    this.maxItemsAllowedForGuestUser = 5; // default value

    settingsService.getSettingValue('Trolley', 'GuestUserMaxItemCount').then(function (response) {
        _this.maxItemsAllowedForGuestUser = parseInt(response);
    });

    this.updateRequestCount = 0;

    _breakpointsService = breakpointsService;

    this.richRelevanceService = richRelevanceService;

    this.featureService = featureService;

    this.$rootScope.$on('trolley:invalidatePricing', function () {
        _this._invalidatePricing();
    });
};

TrolleyService.prototype._invalidatePricing = function () {
    this.getTrolley();
};

function getAllProducts() {
    return _.compact(_.concat(this.trolleyProducts, this.unavailableProducts, this.restrictedProducts, this.restrictedByDeliveryMethodProducts, this.restrictedProductsByDeliPlatters));
}

TrolleyService.prototype._updateTrolley = function (response) {
    this.trolleyProducts = response.AvailableItems;
    this.unavailableProducts = response.UnavailableItems;
    this.restrictedByDeliveryMethodProducts = response.RestrictedByDeliveryMethodItems;
    this.restrictedByDeliveryMethodMessage = response.RestrictedByDeliveryMethodMessage;
    this.restrictedProductsByDeliPlatters = response.RestrictedByDeliPlattersItems;
    this.restrictedProducts = _.concat(response.RestrictedItems, response.RestrictedByDeliPlattersItems);

    this.trolleyProductsByStockcode = _.keyBy(getAllProducts.call(this), function (i) {
        return i.Stockcode;
    });

    this.itemCount = response.TrolleyItemCount;
    this.totalItemQuantity = response.TotalTrolleyItemQuantity;
    this.maximumOrderQuantity = response.MaximumOrderQuantity;

    if (this.deliveryPassService) {
        this.deliveryPassService.deliveryPassPrompt = response.ShopperDeliveryPassPromptResponse;
    }

    // Update Totals
    this.salePriceTotal = response.Totals.Total;
    this.savedPrice = response.Totals.TotalSavings;
    this.deliveryFee = response.DeliveryFee.Total;
    this.wowRewardsSummary = response.WowRewardsSummary;
    this.isTotalReady = true;

    // refresh dtm data layer
    this._pushTrolleyDataToDtm(response);

    return response;
};

TrolleyService.prototype.validateDeliveryPassLimit = function (product, quantity) {
    return this._trolleyRoute.post('ValidateDeliveryPass', {
        Stockcode: product.Stockcode,
        Quantity: quantity
    });
};

TrolleyService.prototype.validateQuantity = function (product, quantity) {
    if (quantity === '' || isNaN(quantity)) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    if (this.deliveryPassLimitReached[product.Stockcode]) {
        return { isValid: false, reason: trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED };
    }

    if (quantity > product.SupplyLimit) {
        return { isValid: false, reason: trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED };
    }

    if (quantity < product.MinimumQuantity) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    return { isValid: true, reason: '' };
};

TrolleyService.prototype._manageErrorMessage = function (product, errorType) {
    var trolleyItem = this.trolleyProductsByStockcode[product.Stockcode];

    if (!this.errors) {
        this.errors = {};
    }

    this.errors[product.Stockcode] = errorType;

    if (trolleyItem != null) {
        trolleyItem.HasError = errorType;
    }
};

TrolleyService.prototype._setScreenReaderMessage = function (stockcode, state) {
    var item = this.getTrolleyItem(stockcode);
    if (!item) {
        // If the item is no longer in the trolley for some reason, shortcut the method.
        // This can happen when trying to add too many delivery passes to the trolley.
        return;
    }

    switch (state) {
        case 'add':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' added to trolley. Quantity: ' + item.Quantity;
            break;
        case 'update':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' quantity in trolley has been updated to ' + item.Quantity;
            break;
        case 'remove':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' removed from trolley';
            break;
        case 'clear':
            this.srMessage = 'All products have been removed from the trolley.';
            break;
        case 'clearOOS':
            this.srMessage = 'All out of stock products have been removed from the trolley.';
            break;
    }
};

TrolleyService.prototype.getTrolley = function () {
    this.isTotalReady = false;

    return this._trolleyRoute.get().then(this._updateTrolley.bind(this));
};

TrolleyService.prototype.getTrolleyItem = function (stockcode) {
    var product = null;

    if (this.trolleyProductsByStockcode) {
        product = this.trolleyProductsByStockcode[stockcode];
    }

    if (!product) {
        product = _.find(this.trolleyProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.restrictedProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.unavailableProducts, { Stockcode: stockcode });
    }

    return product;
};

TrolleyService.prototype._pushAddOrRemoveItemToDtm = function (response, isRemovingItemFromTrolley) {
    if (isRemovingItemFromTrolley) {
        _analyticsService.pushEvent(_eventsDtm.REMOVE_FROM_CART);
        this._pushTrolleyDataToDtm(response);
    } else {
        _analyticsService.pushEvent(_eventsDtm.ADD_TO_CART);
        this._pushTrolleyDataToDtm(response);
    }
};
TrolleyService.prototype._pushTrolleyDataToDtm = function (response) {
    var rewardsPointsConversionBase = 1;
    if (_settingsService.settings && _settingsService.settings.loyalty && _settingsService.settings.loyalty.rewardsConversionBase) {
        rewardsPointsConversionBase = _settingsService.settings.loyalty.rewardsConversionBase;
    }
    _analyticsService.push({ data: { Trolley: response, cartChange: this.recentlyChangedItems, rewardsPointsConversionBase: rewardsPointsConversionBase }, dtmMapperFn: trolleyDtmMapper });
};

function formatTrolleyProductSource(source) {
    if (_breakpointsService.isInSmallFormat) {
        return 'SF.' + source;
    }
    if (_breakpointsService.isInMediumFormat) {
        return 'MF.' + source;
    }
    if (_breakpointsService.isInLargeFormat) {
        return 'LF.' + source;
    }

    return '';
}

/**
 * Rejects promises for trolley updates if a later update has been made.
 *
 * Since most trolley API calls return the entire trolley aggregate, it is a waste of resources and also
 * disruptful to the UI to update the trolley when we get a response that has been superseded by a later call.
 *
 * @param {Promise} promise - This promise will be rejected (even if the network call was successful)
 *  if a later request is made (even if the later request fails).
 * @param {boolean} [shouldSerialize=true] - Bypasses the serialization behaviour for
 *  deployment switch purposes.
 * @returns {Promise}
 */
TrolleyService.prototype._rejectIfLaterUpdate = function (promise) {
    var _this2 = this;

    var shouldSerialize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!shouldSerialize) {
        return promise;
    }

    this.updateRequestCount++;
    var requestVersion = this.updateRequestCount;

    return promise.then(function (response) {
        return requestVersion >= _this2.updateRequestCount ? response : _this2.$q.reject('superseded');
    });
};

function postToTrolley(product, quantity, source, searchTerm) {
    var _this3 = this;

    this.isTotalReady = false;

    return this._rejectIfLaterUpdate(this._trolleyRoute.post('Items', { stockcode: product.Stockcode, quantity: quantity, source: formatTrolleyProductSource(source), searchTerm: searchTerm, diagnostics: product.Diagnostics })).then(function (response) {
        _this3._updateTrolley(response);
        _this3._setScreenReaderMessage(product.Stockcode, 'add');
        return response;
    }).then(function (response) {
        _this3.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this3.inspirationService.getContentCardId();
        if (cardId && source !== _trolleySourceCz) {
            _gtmService.push(cardId, dynamicContentAnalyticsMapper);
        }
        var gtmItems = response.RecentlyAddedItems[0];
        gtmItems.Source = product.Source;
        _gtmService.push(gtmItems, productClickTrolleyAnalyticsMapper);
        _gtmService.push(gtmItems, addToTrolleyAnalyticsMapper);

        _this3.recentlyChangedItems = [_this3.getTrolleyItem(product.Stockcode)];
        _this3._pushAddOrRemoveItemToDtm(response, false);
        if (_this3.featureService.isEnabled(_this3.featureService.features.enableRichRelevanceRecommendations)) {
            _this3.richRelevanceService.addToTrolleyRequest(product, _this3.trolleyProducts);
        }

        return response;
    });
}

TrolleyService.prototype.addItemToTrolley = function (product, quantity, source, searchTerm) {
    var _this4 = this;

    if (!this.validateQuantity(product, quantity).isValid) {
        return this.$q.reject('Invalid');
    }

    var shouldShowLoginReminderForMaxItems = this.itemCount === this.maxItemsAllowedForGuestUser - 1 && !this.guestTrolleyLoginReminderShown;
    if (_shopperService.IsGuest && (product.AgeRestricted || shouldShowLoginReminderForMaxItems)) {
        var loginMessage = void 0;
        if (product.AgeRestricted) {
            loginMessage = this._loginService.LoginToAddRestrictedProductMessage;
        } else if (shouldShowLoginReminderForMaxItems) {
            loginMessage = this._loginService.LoginToAddMoreProductsMessage;
        } else {
            loginMessage = undefined;
        }

        this.guestTrolleyLoginReminderShown = true;
        return this._loginService.promptForLogin(loginMessage, null, null, null, function () {
            if (_shopperService.AllowRestrictedDepartment) {
                postToTrolley.call(_this4, product, quantity, source, searchTerm);
            }
        });
    }

    // While we're waiting for the trolley response, use the shelf product for now
    // so the user can see the item in the trolley immediately.
    this.trolleyProducts.unshift(product);

    return postToTrolley.call(this, product, quantity, source, searchTerm);
};

// IIS 6 does not support PUT or DELTE verbs,
// until the server is updated to support these verbs
// we have to use RPC style calls using the POST verb.
function getUpdatePromise(doRpc, params) {
    return doRpc ? this._trolleyRoute.post('UpdateItem', params) : this._trolleyRoute.one('Items', params.stockcode).put(params);
}

TrolleyService.prototype.updateTrolleyItem = function (product, quantity, updateSource, isRemovingItemFromTrolley) {
    var _this5 = this;

    this.isTotalReady = false;

    // copy the updated product and set the quantity to be the amount added or removed. Store this for analytics later.
    var changedProduct = this.getTrolleyItem(product.Stockcode);

    // The product may not be in the trolley yet (waiting on a network response)
    if (changedProduct) {
        var deltaProduct = _.extend({}, changedProduct, { Quantity: Math.abs(changedProduct.Quantity - quantity) });
        this.recentlyChangedItems = [deltaProduct];
    }

    return this._rejectIfLaterUpdate(getUpdatePromise.call(this, true, { stockcode: product.Stockcode, quantity: quantity })).then(function (response) {
        _this5._updateTrolley(response);
        _this5._setScreenReaderMessage(product.Stockcode, 'update');
        return response;
    }).then(function (response) {
        _this5.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this5.inspirationService.getContentCardId();
        if (cardId && updateSource !== _trolleySourceCz) {
            _gtmService.push(cardId, dynamicContentAnalyticsMapper);
        }
        var gtmItems = response.RecentlyAddedItems[0];
        gtmItems.Source = updateSource;

        _gtmService.push(gtmItems, productClickTrolleyAnalyticsMapper);
        _gtmService.push(gtmItems, addToTrolleyAnalyticsMapper);
        _this5._pushAddOrRemoveItemToDtm(response, isRemovingItemFromTrolley);
        return response;
    });
};

TrolleyService.prototype.removeTrolleyItem = function (stockcode) {
    var _this6 = this;

    this.isTotalReady = false;

    // Immediately remove the product from the trolley products list so the UI
    // can update while we wait for the trolley response.
    this.recentlyChangedItems = [].concat(_toConsumableArray(_.remove(this.trolleyProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.unavailableProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.restrictedByDeliveryMethodProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.restrictedProducts, { Stockcode: stockcode })));

    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({ Stockcode: stockcode }, 'Remove')).then(function (response) {
        _this6._setScreenReaderMessage(stockcode, 'remove');
        _this6._updateTrolley(response);
        _this6._pushAddOrRemoveItemToDtm(response, true);
        _this6.$rootScope.$broadcast('trolley:update');
        return response;
    });
};

TrolleyService.prototype.removeItems = function (stockcodes) {
    var _this7 = this;

    this.isTotalReady = false;

    this.recentlyChangedItems = _.filter(getAllProducts.call(this), function (product) {
        return _.includes(stockcodes, product.Stockcode);
    });

    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({ Stockcodes: stockcodes }, 'RemoveItems')).then(function (response) {
        _this7._updateTrolley(response);
        _this7._pushAddOrRemoveItemToDtm(response, true);
        _this7.$rootScope.$broadcast('trolley:update');
    });
};

TrolleyService.prototype.clearOutOfStockTrolleyItems = function () {
    var _this8 = this;

    this.isTotalReady = false;
    this.getTrolley().then(function () {
        var outOfStockItemsStockcodes = _.map(_this8.unavailableProducts, 'Stockcode');
        _this8.removeItems(outOfStockItemsStockcodes).then(function (response) {
            _this8._setScreenReaderMessage('', 'clearOOS');
            return response;
        });
    });
};

TrolleyService.prototype.clearTrolley = function () {
    var _this9 = this;

    this.isTotalReady = false;

    this.recentlyChangedItems = getAllProducts.call(this);
    return this._rejectIfLaterUpdate(this._trolleyRoute.doPOST({}, 'Clear')).then(function (response) {
        _this9._updateTrolley(response);
        _this9._pushAddOrRemoveItemToDtm(response, true);
        _this9.$rootScope.$broadcast('trolley:update');
        _this9._setScreenReaderMessage('', 'clear');
    });
};

TrolleyService.prototype.addItemsToTrolley = function (items) {
    var _this10 = this;

    this.isTotalReady = false;
    var mappedProducts = _.map(_.filter(items, function (product) {
        return product.IsAvailable === true && product.DisplayQuantity > 0;
    }), function (item) {
        var newQty = item.QuantityInTrolley !== 0 ? item.QuantityInTrolley + item.DisplayQuantity : item.DisplayQuantity;
        return { stockcode: item.Stockcode, quantity: newQty, source: item.Source };
    });

    return this._rejectIfLaterUpdate(this._trolleyRoute.post('AddItems', { products: mappedProducts })).then(function (response) {
        _this10._updateTrolley(response);
        _this10._setScreenReaderMessage('', 'items added');
        return response;
    }).then(function (response) {
        _this10.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this10.inspirationService.getContentCardId();
        if (cardId) {
            _gtmService.push(cardId, dynamicContentAnalyticsMapper);
        }

        response.RecentlyAddedItems.Source = mappedProducts[0].source === undefined ? null : mappedProducts[0].source;
        _gtmService.push(response.RecentlyAddedItems, productClickAddAllTrolleyAnalyticsMapper);
        _gtmService.push(response.RecentlyAddedItems, addAllToTrolleyAnalyticsMapper);

        // We need to find the item within the response for full product details
        var addedStockcodes = _.map(items, 'stockcode');
        _this10.recentlyChangedItems = _.filter(getAllProducts.call(_this10), function (product) {
            return _.includes(addedStockcodes, product.Stockcode);
        });
        // We push to analytics directly because adding multiple items is separate from adding a single item
        // The caller of addItemsToTrolley should specify an event to push
        _this10._pushTrolleyDataToDtm(response);
        return response;
    });
};

TrolleyService.prototype.saveTrolleyAsList = function (name) {
    _analyticsService.pushEvent(_eventsDtm.SAVE_TROLLEY_LIST);
    return this._trolleyRoute.one('SaveAsList').doPOST({ Name: name });
};

TrolleyService.prototype.hasAvailableProducts = function () {
    return this.trolleyProducts.length > 0;
};

module.exports = TrolleyService;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (item) {
    return {
        event: 'addToTrolley',
        ecommerce: {
            currencyCode: 'AUD',
            add: {
                products: [{
                    name: item.Name,
                    quantity: item.Quantity,
                    id: item.Stockcode,
                    listprice: item.ListPrice,
                    price: item.SalePrice,
                    variant: item.PackageSize,
                    missedpromotions: _.map(item.MissedPromotions, function (missedPromotion) {
                        return {
                            id: missedPromotion.ID,
                            description: missedPromotion.Description,
                            link: missedPromotion.Link,
                            ismultibuy: missedPromotion.IsMultiBuy,
                            ispackageprice: missedPromotion.IsPackagePrice,
                            isbonusoffer: missedPromotion.IsBonusOffer,
                            isproductgrouppercentageoff: missedPromotion.IsProductGroupPercentageOff
                        };
                    }),
                    matchedpromotions: _.map(item.MatchedPromotions, function (matchedpromotion) {
                        return {
                            id: matchedpromotion.ID,
                            description: matchedpromotion.Description,
                            link: matchedpromotion.Link,
                            ismultibuy: matchedpromotion.IsMultiBuy,
                            ispackageprice: matchedpromotion.IsPackagePrice,
                            isbonusoffer: matchedpromotion.IsBonusOffer,
                            isproductgrouppercentageoff: matchedpromotion.IsProductGroupPercentageOff
                        };
                    })
                }]
            }
        }
    };
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (items) {
    return {
        event: 'addToTrolley',
        ecommerce: {
            currencyCode: 'AUD',
            add: {
                products: _.map(items, function (item) {
                    return {
                        name: item.Name,
                        quantity: item.Quantity,
                        id: item.Stockcode,
                        listprice: item.ListPrice,
                        price: item.SalePrice,
                        variant: item.PackageSize,

                        missedpromotions: _.map(item.MissedPromotions, function (missedPromotion) {
                            return {
                                id: missedPromotion.ID,
                                description: missedPromotion.Description,
                                link: missedPromotion.Link,
                                ismultibuy: missedPromotion.IsMultiBuy,
                                ispackageprice: missedPromotion.IsPackagePrice,
                                isbonusoffer: missedPromotion.IsBonusOffer,
                                isproductgrouppercentageoff: missedPromotion.IsProductGroupPercentageOff
                            };
                        }),

                        matchedpromotions: _.map(item.MatchedPromotions, function (matchedpromotion) {
                            return {
                                id: matchedpromotion.ID,
                                description: matchedpromotion.Description,
                                link: matchedpromotion.Link,
                                ismultibuy: matchedpromotion.IsMultiBuy,
                                ispackageprice: matchedpromotion.IsPackagePrice,
                                isbonusoffer: matchedpromotion.IsBonusOffer,
                                isproductgrouppercentageoff: matchedpromotion.IsProductGroupPercentageOff
                            };
                        })
                    };
                })
            }
        }
    };
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (item) {
    return {
        event: 'productClick',
        ecommerce: {
            currencyCode: 'AUD',
            click: {
                actionField: {
                    list: item.Source
                },
                products: [{
                    name: item.Name,
                    quantity: item.Quantity,
                    id: item.Stockcode,
                    listprice: item.ListPrice,
                    price: item.SalePrice,
                    variant: item.PackageSize,
                    missedpromotions: _.map(item.MissedPromotions, function (missedPromotion) {
                        return {
                            id: missedPromotion.ID,
                            description: missedPromotion.Description,
                            link: missedPromotion.Link,
                            ismultibuy: missedPromotion.IsMultiBuy,
                            ispackageprice: missedPromotion.IsPackagePrice,
                            isbonusoffer: missedPromotion.IsBonusOffer,
                            isproductgrouppercentageoff: missedPromotion.IsProductGroupPercentageOff
                        };
                    }),
                    matchedpromotions: _.map(item.MatchedPromotions, function (matchedpromotion) {
                        return {
                            id: matchedpromotion.ID,
                            description: matchedpromotion.Description,
                            link: matchedpromotion.Link,
                            ismultibuy: matchedpromotion.IsMultiBuy,
                            ispackageprice: matchedpromotion.IsPackagePrice,
                            isbonusoffer: matchedpromotion.IsBonusOffer,
                            isproductgrouppercentageoff: matchedpromotion.IsProductGroupPercentageOff
                        };
                    })
                }]
            }
        }
    };
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (items) {
    return {
        event: 'productClick',
        ecommerce: {
            currencyCode: 'AUD',
            click: {
                actionField: {
                    list: items.Source
                },
                products: _.map(items, function (item) {
                    return {
                        name: item.Name,
                        quantity: item.Quantity,
                        id: item.Stockcode,
                        listprice: item.ListPrice,
                        price: item.SalePrice,
                        variant: item.PackageSize,

                        missedpromotions: _.map(item.MissedPromotions, function (missedPromotion) {
                            return {
                                id: missedPromotion.ID,
                                description: missedPromotion.Description,
                                link: missedPromotion.Link,
                                ismultibuy: missedPromotion.IsMultiBuy,
                                ispackageprice: missedPromotion.IsPackagePrice,
                                isbonusoffer: missedPromotion.IsBonusOffer,
                                isproductgrouppercentageoff: missedPromotion.IsProductGroupPercentageOff
                            };
                        }),

                        matchedpromotions: _.map(item.MatchedPromotions, function (matchedpromotion) {
                            return {
                                id: matchedpromotion.ID,
                                description: matchedpromotion.Description,
                                link: matchedpromotion.Link,
                                ismultibuy: matchedpromotion.IsMultiBuy,
                                ispackageprice: matchedpromotion.IsPackagePrice,
                                isbonusoffer: matchedpromotion.IsBonusOffer,
                                isproductgrouppercentageoff: matchedpromotion.IsProductGroupPercentageOff
                            };
                        })
                    };
                })
            }
        }
    };
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (id) {
    return {
        event: 'dynamicContentCard',
        ecommerce: {
            dynamicContent: { id: id }
        }
    };
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var productMapper = __webpack_require__(26);
var loyaltyPointsCalculator = __webpack_require__(14);
var _ = __webpack_require__(1);

module.exports = function (data) {
    return {
        cart: {
            price: {
                basePrice: data.Trolley.Totals ? data.Trolley.Totals.Total : '',
                totalSavings: data.Trolley.Totals.TotalSavings,
                wowRewardsToSpend: data.Trolley.WowRewardsSummary ? data.Trolley.WowRewardsSummary.WowRewardsToSpend : '',
                wowRewardsEarned: data.Trolley.WowRewardsSummary ? loyaltyPointsCalculator(data.Trolley.WowRewardsSummary.WowRewardsEarned, data.rewardsPointsConversionBase, false) : '',
                currency: 'AUD',
                taxRate: data.Trolley.TaxRate
            },
            item: _.map(_.compact(_.concat(data.Trolley.AvailableItems, data.Trolley.UnavailableItems, data.Trolley.RestrictedItems)), function (currentProduct) {
                return productMapper({
                    product: currentProduct,
                    Quantity: currentProduct.Quantity,
                    Price: currentProduct.SalePrice
                });
            }),
            cartChange: _.map(data.cartChange, function (currentProduct) {
                return productMapper({
                    product: currentProduct,
                    Quantity: currentProduct.Quantity,
                    Price: currentProduct.SalePrice
                });
            }),
            attributes: {}
        }
    };
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    collectionZone: 'Collection Zone'
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var TrackMyOrderService = __webpack_require__(473);

var _require = __webpack_require__(474),
    trackMyOrderGuestFormComponentDefinition = _require.trackMyOrderGuestFormComponentDefinition;

angular.module('wowApp.shop').service('TrackMyOrderService', ['Restangular', TrackMyOrderService]).component('wowTrackmyorderGuestForm', trackMyOrderGuestFormComponentDefinition);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function TrackMyOrderService(Restangular) {
    this._api = Restangular.one('/TrackMyOrder');
    this._restangular = Restangular;
}

TrackMyOrderService.prototype.getOrders = function () {
    return this._api.get();
};

TrackMyOrderService.prototype.getOrderInfo = function (orderId) {
    return this._restangular.one('/TrackMyOrder', orderId).get();
};

module.exports = TrackMyOrderService;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    forEach = _require.forEach,
    map = _require.map;

var TrackMyOrderGuestFormController = function () {
    function TrackMyOrderGuestFormController($scope, $state, $timeout, tmoService, analyticsService, moveFocus) {
        _classCallCheck(this, TrackMyOrderGuestFormController);

        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.tmoService = tmoService;
        this.analyticsService = analyticsService;
        this.moveFocus = moveFocus;
    }

    _createClass(TrackMyOrderGuestFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.values = {
                OrderNumber: undefined
            };

            if (this.$state.params.OrderNumber) {
                this.values.OrderNumber = parseInt(this.$state.params.OrderNumber);
            }
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            if (this.values.OrderNumber) {
                this.submit();
            }
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this._clearTmoDisplay();
            this._validateTmoForm();

            if (!this.tmoForm.$valid) {
                return;
            }

            this.isLoading = true;
            this.selectedOrderId = this.values.OrderNumber;
            this.tmoService.getOrderInfo(this.selectedOrderId).then(function (response) {
                _this.tmoInfo = response;
                _this.isClickAndCollect = response.IsClickAndCollect;
                if (_this.tmoInfo.InfoMessage || _this.tmoInfo.ErrorMessage) {
                    _this.moveFocus('#trackmyorderGuestForm-messagesContainer');
                    _this.errorMessage = _this.tmoInfo.ErrorMessage;
                    _this.infoMessage = _this.tmoInfo.InfoMessage;
                    if (_this.tmoInfo.ErrorMessage) {
                        _this.analyticsService.pushError(_this.tmoInfo.ErrorMessage);
                    }
                } else {
                    _this.errorMessage = undefined;
                    _this.infoMessage = undefined;
                }
                _this.submitClicked = true;
                _this.isLoading = false;
            }).catch(function (response) {
                _this.isLoading = false;
                _this.serverErrors = {};
                if (response.data && response.data.ResponseStatus) {
                    forEach(response.data.ResponseStatus.Errors, function (n) {
                        if (_this.tmoForm[n.FieldName]) {
                            _this.tmoForm[n.FieldName].$setValidity('serverError', false);
                            _this.tmoForm.$invalid = true;
                        }
                        _this.serverErrors[n.FieldName] = n.Message;
                    });
                    _this.analyticsService.pushErrors(map(response.data.ResponseStatus.Errors, 'Message'));
                }
                _this.submitClicked = false;
            });
        }
    }, {
        key: 'clearValidationErrors',
        value: function clearValidationErrors() {
            this.serverErrors = {};
            if (!this.tmoForm.OrderNumber.$valid) {
                this.tmoForm.OrderNumber.$setValidity('required', 'true');
                this.tmoForm.OrderNumber.$setValidity('number', 'true');
                this.tmoForm.OrderNumber.$setValidity('serverError', 'true');
            }
        }
    }, {
        key: 'resetTmoPanel',
        value: function resetTmoPanel() {
            var _this2 = this;

            this._clearTmoForm();
            this.$timeout(function () {
                _this2.moveFocus('#trackmyorderGuestForm');
            });
        }
    }, {
        key: '_clearTmoDisplay',
        value: function _clearTmoDisplay() {
            this.tmoInfo = undefined;
            this.isClickAndCollect = undefined;
            this.IsOrderDelivered = undefined;
            this.TimeIntervalToStartMovingInSeconds = undefined;
            this.TimeIntervalToDeliveryInSeconds = undefined;
            this.StartLocationLatitude = undefined;
            this.StartLocationLongitude = undefined;
            this.DeliveryLocationLatitude = undefined;
            this.DeliveryLocationLongitude = undefined;
            this.errorMessage = undefined;
            this.infoMessage = undefined;
            this.isLoading = false;
        }
    }, {
        key: '_validateTmoForm',
        value: function _validateTmoForm() {
            if (!this.tmoForm.$valid) {
                return;
            }
            if (this.tmoForm.OrderNumber.$viewValue === undefined) {
                this.tmoForm.OrderNumber.$setTouched();
                this.tmoForm.OrderNumber.$setValidity('required', false);
            }
        }
    }, {
        key: '_clearTmoForm',
        value: function _clearTmoForm() {
            this.values.OrderNumber = '';
            this.clearValidationErrors();
            this._clearTmoDisplay();
            this.tmoForm.$setPristine();
            this.submitClicked = undefined;
        }
    }]);

    return TrackMyOrderGuestFormController;
}();

var trackMyOrderGuestFormComponentDefinition = {
    controller: ['$scope', '$state', '$timeout', 'TrackMyOrderService', 'AnalyticsService', 'MoveFocus', TrackMyOrderGuestFormController],
    template: __webpack_require__(475).trim()
};

module.exports = {
    TrackMyOrderGuestFormController: TrackMyOrderGuestFormController,
    trackMyOrderGuestFormComponentDefinition: trackMyOrderGuestFormComponentDefinition
};

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "<div class=\"trackmyorderGuestForm\" id=\"trackmyorderGuestForm\" tabindex=\"-1\">\r\n    <div class=\"trackmyorderGuestForm-header\">\r\n        <h1 class=\"trackmyorderGuestForm-headerTitle heading2\">\r\n            <span class=\"trackmyorderGuestForm-deliveryIcon\"><i class=\"iconww-Delivery\"></i></span>\r\n            Track my order\r\n        </h1>\r\n        <button ng-if=\"$ctrl.tmoInfo\" class=\"iconButton\" ng-click=\"$ctrl.resetTmoPanel()\">\r\n            <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Reset track my order form</span>\r\n        </button>\r\n    </div>\r\n\r\n    <form id=\"tmoForm\" name=\"$ctrl.tmoForm\" ng-submit=\"$ctrl.submit()\" ng-model-options=\"{updateOn: 'submit'}\" wow-analytics-form-errors novalidate>\r\n        <wow-input-container class=\"trackmyorderGuestForm-input\">\r\n            <label>Order number *</label>\r\n            <input id=\"tmoForm-orderNumber\" type=\"number\" pattern=\"\\d*\" name=\"OrderNumber\" ng-model=\"$ctrl.values.OrderNumber\" required ng-readonly=\"$ctrl.submitClicked\"/>\r\n            <span role=\"alert\" ng-messages=\"$ctrl.tmoForm.OrderNumber.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Order number is required.</span>\r\n                <span ng-message=\"number\" class=\"wowInput-error\">Order number must be numeric</span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{ $ctrl.serverErrors.OrderNumber }}</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <div class=\"trackmyorderGuestForm-submit\">\r\n            <button type=\"submit\" class=\"button button--primary\" ng-if=\"!$ctrl.submitClicked\" ng-click=\"$ctrl.clearValidationErrors()\">View Order</button>\r\n        </div> \r\n    </form>\r\n\r\n    <wow-loading-spinner ng-if=\"$ctrl.isLoading\"></wow-loading-spinner>\r\n    <div id=\"trackmyorderGuestForm-messagesContainer\" tabindex=\"-1\">\r\n        <p class=\"alert alert--error\" ng-if=\"$ctrl.errorMessage\">{{ $ctrl.errorMessage }}</p>\r\n        <p class=\"alert alert--info\" ng-if=\"$ctrl.infoMessage\">{{ $ctrl.infoMessage }}</p>\r\n    </div>\r\n\r\n    <div id=\"trackmyorderGuestForm-infoContainer\" class=\"trackmyorderGuestForm-infoContainer\" tabindex=\"-1\" ng-if=\"$ctrl.tmoInfo.DeliveryInfo.TimeLabel && $ctrl.isClickAndCollect\">\r\n        <div class=\"trackmyorderGuestForm-section\">\r\n            <h2 class=\"heading4 trackmyorderGuestForm-heading\">{{ $ctrl.tmoInfo.DeliveryInfo.TimeLabel }}</h2>\r\n            <p>\r\n                {{ $ctrl.tmoInfo.DeliveryInfo.Date }}<br/>\r\n                {{ $ctrl.tmoInfo.DeliveryInfo.Hour }}\r\n            </p>\r\n        </div>\r\n        <div class=\"trackmyorderGuestForm-section\">\r\n            <h2 class=\"heading4 trackmyorderGuestForm-heading\">{{ $ctrl.tmoInfo.DeliveryInfo.AddressLabel }}</h2>\r\n            <p>\r\n                {{ $ctrl.tmoInfo.DeliveryInfo.AddressLine1 }}<br/>\r\n                {{ $ctrl.tmoInfo.DeliveryInfo.AddressLine2 }}\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div id=\"trackmyorderGuestForm-infoContainer\" class=\"trackmyorderGuestForm-infoContainer\" tabindex=\"-1\" ng-if=\"$ctrl.tmoInfo.DeliveryInfo.TimeLabel && !$ctrl.isClickAndCollect\">\r\n        <div class=\"trackmyorderGuestForm-section\">\r\n            <h2 class=\"heading4 trackmyorderGuestForm-heading\">Delivery date</h2>\r\n            <p>{{ $ctrl.tmoInfo.DeliveryInfo.Date }}</p>\r\n        </div>\r\n        <div class=\"trackmyorderGuestForm-section\">\r\n            <h2 class=\"heading4 trackmyorderGuestForm-heading\">Estimated delivery time</h2>\r\n            <p>{{ $ctrl.tmoInfo.DeliveryInfo.Hour }} <i>(indicative only)</i></p>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-setting setting-group=\"TrackMyOrderETA\" setting-name=\"Disclaimer\"></wow-setting>\r\n</div>\r\n"

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var OfferGroupService = __webpack_require__(477);

var _require = __webpack_require__(478),
    offerGroupTileListComponentDefinition = _require.offerGroupTileListComponentDefinition;

angular.module('wowApp.shop').service('OfferGroupService', ['Restangular', '$q', 'Settings', 'SortByKeys', OfferGroupService]).component('wowOfferGroupTileList', offerGroupTileListComponentDefinition);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferGroupService = function () {
    function OfferGroupService(restangular, $q, settings, sortByKeys) {
        _classCallCheck(this, OfferGroupService);

        this._offerGroupRoute = restangular.one('OfferGroup');
        this.selectedGroup = undefined;
        this.settings = settings;
        this.sortByKeys = sortByKeys;
        this.$q = $q;
        this._groupCache = {};
    }

    _createClass(OfferGroupService, [{
        key: 'selectOfferGroup',
        value: function selectOfferGroup(id) {
            var _this = this;

            if (!(id in this._groupCache)) {
                this._groupCache[id] = this._offerGroupRoute.one(id).get();
            }
            this.offerGroupPromise = this._groupCache[id].then(function (response) {
                _this.selectedGroup = response;
                return response;
            });
            return this.offerGroupPromise;
        }
    }, {
        key: 'getSelectedOfferGroup',
        value: function getSelectedOfferGroup() {
            return this.offerGroupPromise ? this.offerGroupPromise : this.$q.when(null);
        }
    }, {
        key: 'getProducts',
        value: function getProducts(args) {
            var _this2 = this;

            this.selectedGroupTotalCount = undefined;
            return this._offerGroupRoute.one('Products').one(this.selectedGroup.Url).get(this.createArgs(args)).then(function (response) {
                _this2.selectedGroupTotalCount = response.TotalRecordCount;
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount
                };
            });
        }
    }, {
        key: 'getSortOptions',
        value: function getSortOptions() {
            return {
                sortTypes: this.settings.browse.sortOptions,
                sortContext: this.sortByKeys.BROWSE_KEY
            };
        }
    }, {
        key: 'createArgs',
        value: function createArgs(args) {
            return {
                pageNumber: args.pageNumber,
                pageSize: args.pageSize || 10,
                sortType: args.sortType
            };
        }
    }]);

    return OfferGroupService;
}();

module.exports = OfferGroupService;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(7),
    createBundleTiles = _require.createBundleTiles;

var OfferGroupTileListController = function () {
    function OfferGroupTileListController(settings, offerGroupService) {
        _classCallCheck(this, OfferGroupTileListController);

        this.settings = settings;
        this.offerGroupService = offerGroupService;
    }

    _createClass(OfferGroupTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.offerGroupService.getSortOptions();
        }
    }, {
        key: 'title',
        value: function title() {
            var description = this.offerGroupService.selectedGroup.Description;

            return this.offerGroupService.selectedGroupTotalCount != null ? description + ' (' + this.offerGroupService.selectedGroupTotalCount + ')' : description;
        }
    }, {
        key: 'createTiles',
        value: function createTiles(products) {
            return {
                items: createBundleTiles(products.items),
                totalRecordCount: products.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';

            return this.offerGroupService.selectOfferGroup(this.offerGroupId).then(function () {
                return _this.offerGroupService.getProducts({ pageSize: pageSize, pageNumber: pageNumber, sortType: sortType });
            }).then(function (products) {
                return _this.createTiles(products);
            });
        }
    }]);

    return OfferGroupTileListController;
}();

OfferGroupTileListController.$inject = ['Settings', 'OfferGroupService'];

var offerGroupTileListComponentDefinition = {
    bindings: {
        offerGroupId: '<?',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: OfferGroupTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.title()"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    OfferGroupTileListController: OfferGroupTileListController,
    offerGroupTileListComponentDefinition: offerGroupTileListComponentDefinition
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

angular.module('wowApp.shop')
// Service
.service('RichRelevanceService', ['Restangular', '$window', '$q', '$rootScope', '$http', '$timeout', 'config', 'ShopperService', 'FeatureService', 'Settings', 'BreakpointsService', 'GtmService', 'AnalyticsService', __webpack_require__(480)])

// Showing Placements
.component('wowRrPlacementCallback', __webpack_require__(481).richRelevancePlacementCallbackComponentDefinition).component('wowRrProducts', __webpack_require__(482).richRelevanceProductsComponentDefinition)

// Instrumentation
.component('wowRrHomeInstrumentation', __webpack_require__(484).richRelevanceHomeInstrumentationComponentDefinition).component('wowRrCategoryInstrumentation', __webpack_require__(485).richRelevanceCategoryInstrumentationComponentDefinition).component('wowRrWishlistInstrumentation', __webpack_require__(486).richRelevanceWishlistInstrumentationComponentDefinition).component('wowRrMypageInstrumentation', __webpack_require__(487).richRelevanceMypageInstrumentationComponentDefinition).component('wowRrErrorInstrumentation', __webpack_require__(488).richRelevanceErrorInstrumentationComponentDefinition).component('wowRrSearchInstrumentation', __webpack_require__(489).richRelevanceSearchInstrumentationComponentDefinition).component('wowRrGenericInstrumentation', __webpack_require__(490).richRelevanceGenericInstrumentationComponentDefinition).component('wowRrCartInstrumentation', __webpack_require__(491).richRelevanceCartInstrumentationComponentDefinition).component('wowRrItemInstrumentation', __webpack_require__(492).richRelevanceItemInstrumentationComponentDefinition).component('wowRrPurchasedInstrumentation', __webpack_require__(493).richRelevancePurchasedInstrumentationComponentDefinition).component('wowRrCarousel', __webpack_require__(494).rrCarouselComponentDefinition);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    keys = _require.keys,
    find = _require.find,
    forEach = _require.forEach,
    endsWith = _require.endsWith,
    union = _require.union;

var RichRelevanceService = function () {
    function RichRelevanceService(restangular, $window, $q, rootScope, $http, $timeout, config, shopperService, featureService, settings, breakpointsService, gtm, analyticsService) {
        var _this = this;

        _classCallCheck(this, RichRelevanceService);

        this._api = restangular.one('RichRelevance');
        this.placementCallbacks = {};
        this.placementsCache = {};
        this.$window = $window;
        this.config = config;
        this.shopperService = shopperService;
        this.$q = $q;
        this.$http = $http;
        this.$timeout = $timeout;
        this.features = featureService;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.gtm = gtm;
        this.analyticsService = analyticsService;
        this.currentProducts = [];
        this.placementTimeouts = {};
        this.maxPlacementDisplayDelay = 0;
        this.homepagePlacement = 'home_page.carousel';
        this.specialsGroupPlacement = 'category_page.specials_group';
        this.mySpecialsPlacement = 'category_page.trader_myspecials';
        this.categoryPlacement = 'category_page.vs_category';
        this.categoryLevelOne = 'category_page.category_level1';
        this.categoryLevelTwo = 'category_page.category_level2';
        this.categoryLevelThree = 'category_page.category_level3';
        this.itemPageRankOne = 'item_page.rank1';
        this.itemPageRankTwo = 'item_page.rank2';
        this.mySpecialsGroupId = 'specialsgroup.-1';
        this.rrSourceName = 'RR';

        this.initPromise = null;

        this.serverSideApiPlacements = [this.homepagePlacement, this.categoryPlacement, this.specialsGroupPlacement, this.mySpecialsPlacement, this.categoryLevelOne, this.categoryLevelTwo, this.categoryLevelThree, this.itemPageRankOne, this.itemPageRankTwo, this.homepagePlacement + '_mobile', this.categoryPlacement + '_mobile', this.specialsGroupPlacement + '_mobile', this.mySpecialsPlacement + '_mobile', this.categoryLevelOne + '_mobile', this.categoryLevelTwo + '_mobile', this.categoryLevelThree + '_mobile', this.itemPageRankOne + '_mobile', this.itemPageRankTwo + '_mobile'];

        rootScope.$on('$stateChangeSuccess', function () {
            // when the stateChange happens,
            // placements in cache are no longer valid.
            _this.placementCallbacks = {};
            _this.placementsCache = {};
            _this.currentProducts = [];
            _this.placementTimeouts = {};
        });
    }

    _createClass(RichRelevanceService, [{
        key: 'getInformation',
        value: function getInformation() {
            var _this2 = this;

            if (!this.features.isEnabled(this.features.features.enableRichRelevanceRecommendations) || !this.$window.RR) {
                return this.$q.reject('rr is disabled');
            }

            this.cleanupR3();

            var promise = this.shopperService.RichRelevanceSessionId !== undefined && this.shopperService.FulfilmentStoreId !== undefined ? this.$q.all({ RichRelevanceSessionId: this.shopperService.RichRelevanceSessionId, FulfilmentStoreId: this.shopperService.FulfilmentStoreId }) : this.shopperService.getCurrentShopper();

            return promise.then(function (response) {
                window.R3_COMMON = new _this2.$window.r3_common(); // eslint-disable-line new-cap
                _this2.$window.R3_COMMON.setApiKey(_this2.config.RichRelevanceApiKey);
                _this2.$window.R3_COMMON.setBaseUrl(window.location.protocol + _this2.config.RichRelevanceRequestUrl);
                _this2.$window.R3_COMMON.setClickthruServer(window.location.protocol + '//' + window.location.host);
                _this2.$window.R3_COMMON.setSessionId(response.RichRelevanceSessionId);
                _this2.$window.R3_COMMON.setUserId(_this2.shopperService.IsGuest ? '' : _this2.shopperService.Id); // if no user ID is available, please leave this blank
                _this2.$window.R3_COMMON.setRegionId(response.FulfilmentStoreId);

                return _this2.$window.R3_COMMON;
            });
        }
    }, {
        key: 'recordPlacementsRequested',
        value: function recordPlacementsRequested(placementId) {
            this.placementTimeouts[placementId] = new Date().getTime() + this.settings.richRelevance.maxPlacementDisplayDelay * 1000;
        }
    }, {
        key: 'onPlacementsReceived',
        value: function onPlacementsReceived(placements) {
            var _this3 = this;

            // if server side api is on and placement has products, add callbacks.
            if (this.useServerSideResults(placements)) {
                if (!placements || !placements.Products) {
                    return;
                }

                var currentPlacementkeys = keys(this.placementCallbacks);

                if (placements && currentPlacementkeys) {
                    // only fire callback function when placement name is in both serverSideApiPlacements and placementCallbacks keys
                    if (this.serverSideApiPlacements.indexOf(placements.placement_name) >= 0 && currentPlacementkeys.indexOf(placements.placement_name) >= 0) {
                        this.currentProducts = union(this.currentProducts, placements.Items);
                        this.placementCallbacks[placements.placement_name](placements);
                    }
                }
                return;
            }

            var receiveTime = new Date().getTime();
            forEach(placements, function (placement) {
                if (!placement || placement == null) return;
                var timeout = _this3.placementTimeouts[placement.placement_name];
                if (placement.placement_name in _this3.placementCallbacks) {
                    if (!timeout || timeout >= receiveTime) {
                        _this3.placementCallbacks[placement.placement_name](placement);
                        _this3.currentProducts = _this3.currentProducts.concat(placement.items);
                        _this3.placementsCache[placement.placement_name] = placement;
                    }
                    if (timeout) {
                        _this3.gtm.push({
                            event: 'richRelevanceResponse',
                            eventCategory: 'RichRelevance',
                            eventLabel: 'CarouselDisplay',
                            eventValue: timeout >= receiveTime ? 'Y' : 'N'
                        });
                        if (timeout < receiveTime) {
                            _this3.analyticsService.pushEvent(_this3.analyticsService.eventsDtm.RICH_RELEVANCE_TIMEOUT);
                        }
                    }
                }
                _this3.placementTimeouts[placement.placement_name] = null;
            });
        }

        // registers a callback to be called when placements are received.
        // Callback must handle being called with no data or null, as this can happen
        // if placements are cleared. see clearPlacements();

    }, {
        key: 'registerPlacementCallback',
        value: function registerPlacementCallback(placement, callback) {
            this.placementCallbacks[placement] = callback;
            if (this.placementsCache[placement]) {
                callback(this.placementsCache[placement]);
            } else if (this.placementsCache[this.getOriginalPlacementId(placement)]) {
                // When change LF to SF or SF to LF, make sure call callback method, even if placement has changed.
                callback(this.placementsCache[this.getOriginalPlacementId(placement)]);
            }
        }
    }, {
        key: 'addToTrolleyRequest',
        value: function addToTrolleyRequest(product, trolleyProducts) {
            var _this4 = this;

            this.getInformation().then(function () {
                var addToCartRequest = _this4.$timeout(function () {
                    _this4.getInformation().then(function () {
                        _this4.rrAddToCartPageRequest(product.Stockcode, product.Source);
                    });
                }, 100);

                addToCartRequest.then(function () {
                    _this4.$timeout(function () {
                        _this4.getInformation().then(function () {
                            _this4.rrCartPageRequest(trolleyProducts);
                        });
                    }, 100);
                });
            });
        }
    }, {
        key: 'rrCartPageRequest',
        value: function rrCartPageRequest(trolleyProducts) {
            var _this5 = this;

            if (!trolleyProducts || !trolleyProducts.length) {
                return;
            }

            this.$window.R3_CART = new this.$window.r3_cart(); // eslint-disable-line new-cap

            forEach(trolleyProducts, function (product) {
                _this5.$window.R3_CART.addItemId(product.Stockcode.toString());
            });

            this.$window.rr_flush_onload();
            this.$window.r3();
        }
    }, {
        key: 'rrItemPageRequest',
        value: function rrItemPageRequest(product) {
            this.$window.R3_ITEM = new window.r3_item(); // eslint-disable-line new-cap
            this.$window.R3_ITEM.setId(product.Stockcode.toString()); // This must pass a string value, as RR calls indexOf() on this internally, possibly to URL encode it.
            this.$window.R3_ITEM.setName(product.Name);

            this.$window.rr_flush_onload();
            this.$window.r3();
        }
    }, {
        key: 'rrItemDetailsPageRequest',
        value: function rrItemDetailsPageRequest(stockcode, source) {
            var product = find(this.currentProducts, { id: stockcode.toString() });
            var isRRitem = (source || '').indexOf(this.rrSourceName) !== -1;
            if (product && product.linkURL && isRRitem) {
                this.$http.get(product.linkURL);
            }
        }
    }, {
        key: 'rrAddToCartPageRequest',
        value: function rrAddToCartPageRequest(stockcode, source) {
            this.$window.R3_ADDTOCART = new window.r3_addtocart(); // eslint-disable-line new-cap
            this.$window.R3_ADDTOCART.addItemIdToCart(stockcode);

            this.$window.rr_flush_onload();
            this.$window.r3();

            this.rrItemDetailsPageRequest(stockcode, source);
        }
    }, {
        key: 'clearPlacements',
        value: function clearPlacements() {
            forEach(this.placementCallbacks, function (callback) {
                // call each callback with null;
                callback(null);
            });
        }
    }, {
        key: 'cleanupR3',
        value: function cleanupR3() {
            // RR script checks for the existance of these objects
            // to decide what to send to their server.
            // They use the typeof operator
            // eg: if (typeof window.R3_COMMON !== "undefined" )
            // rather than if (!window.R3_*) so null or false would not work.

            // R3_COMMON also needs to be cleared, as placement
            // types are registered on it. (R3_COMMON.addPlacementType(...))
            // So when the page changes R3_COMMON needs to be reinitialized
            // to not have the old placements.

            window.R3_COMMON = undefined;
            window.R3_HOME = undefined;
            window.R3_ADDTOCART = undefined;
            window.R3_BRAND = undefined;
            window.R3_CATEGORY = undefined;
            window.R3_GENERIC = undefined;
            window.R3_ITEM = undefined;
            window.R3_PURCHASED = undefined;
            window.R3_WISHLIST = undefined;
            window.R3_ADDTOREGISTRY = undefined;
            window.R3_CART = undefined;
            window.R3_ERROR = undefined;
            window.R3_PERSONAL = undefined;
            window.R3_SEARCH = undefined;
        }
    }, {
        key: 'invalidate',
        value: function invalidate() {
            this.initPromise = null;
        }
    }, {
        key: 'refreshPlacements',
        value: function refreshPlacements() {
            var _this6 = this;

            forEach(this.placementsCache, function (placements, placementId) {
                var callback = _this6.placementCallbacks[placementId];
                if (callback) {
                    callback(placements);
                }
            });
        }
    }, {
        key: 'getEffectivePlacementId',
        value: function getEffectivePlacementId(placementId) {
            return this.breakpointsService.isInSmallFormat && !endsWith(placementId, '_mobile') ? placementId + '_mobile' : placementId;
        }
    }, {
        key: 'getOriginalPlacementId',
        value: function getOriginalPlacementId(placementId) {
            return this.breakpointsService.isInSmallFormat ? placementId.replace('_mobile', '') : placementId + '_mobile';
        }
    }, {
        key: 'getPlacementIdsForSpecialsGroup',
        value: function getPlacementIdsForSpecialsGroup(category) {
            var placementIds = this.specialsGroupPlacement;
            // When products count is less than minimum count and bank page, don't show recommendation.
            if (category.ProductCount < this.settings.richRelevance.minimumRequiredProductsInSpecialsGroup || category.Url) {
                placementIds = undefined;
            }
            return placementIds;
        }
    }, {
        key: 'getPlacementByCategoryLevel',
        value: function getPlacementByCategoryLevel(categoryLevel) {
            if (!categoryLevel) {
                return null;
            }
            switch (categoryLevel) {
                case 1:
                    return this.categoryLevelOne;
                case 2:
                    return this.categoryLevelTwo;
                case 3:
                    return this.categoryLevelThree;
                default:
                    return null;
            }
        }
    }, {
        key: 'useServerSideResults',
        value: function useServerSideResults(placements) {
            return this.settings.richRelevance.removeDuplicatedProducts || placements && placements.placement_name === this.mySpecialsPlacement;
        }
    }]);

    return RichRelevanceService;
}();

module.exports = RichRelevanceService;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevancePlacementCallbackController = function RichRelevancePlacementCallbackController(richRelevanceService, $window) {
    _classCallCheck(this, RichRelevancePlacementCallbackController);

    if ($window.RR && $window.RR.jsonCallback) {
        $window.RR.jsonCallback = function () {
            if ($window.RR.data.JSON.placements && $window.RR.data.JSON.placements.length > 0) {
                richRelevanceService.onPlacementsReceived($window.RR.data.JSON.placements);
            }
        };
    }
};

var richRelevancePlacementCallbackComponentDefinition = {
    controller: ['RichRelevanceService', '$window', RichRelevancePlacementCallbackController]
};

module.exports = {
    RichRelevancePlacementCallbackController: RichRelevancePlacementCallbackController,
    richRelevancePlacementCallbackComponentDefinition: richRelevancePlacementCallbackComponentDefinition
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var RichRelevanceProductsController = function () {
    function RichRelevanceProductsController(richRelevanceService, shelfProductService, settingsService, breakpointsService) {
        _classCallCheck(this, RichRelevanceProductsController);

        this.products = [];
        this.title = '';
        this.richRelevanceService = richRelevanceService;
        this.shelfProductService = shelfProductService;
        this.settingsService = settingsService;
        this.breakpointsService = breakpointsService;

        if (_.isNil(this.showTitle)) {
            // by default we show the title
            this.showTitle = true;
        }
    }

    _createClass(RichRelevanceProductsController, [{
        key: 'refreshProducts',
        value: function refreshProducts() {
            var _this = this;

            // this.placementId is from the directive attribute
            this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), function (placements) {

                if (!placements) {
                    _this.products = null;
                    _this.title = null;
                    return;
                }

                _this.title = placements.message;

                _this.shelfProductService.getProductsByStockcodes(_.map(placements.items, 'id'), true).then(function (wowProducts) {
                    _this.products = wowProducts;
                    if (_this.onProductsLoaded) {
                        _this.onProductsLoaded();
                    }
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.refreshProducts();
        }
    }]);

    return RichRelevanceProductsController;
}();

var richRelevanceProductsComponentDefinition = {
    bindings: {
        placementId: '@', // defines which placement ID the controller should use to get RR products.
        showTitle: '=', // provide a true, when the directive displays RR title.
        onProductsLoaded: '&' // call back method for after product load.
    },
    controller: ['RichRelevanceService', 'ShelfProductService', 'SettingsService', 'BreakpointsService', RichRelevanceProductsController],
    controllerAs: 'richRelevanceProductsCtrl',
    template: __webpack_require__(483).trim()
};

module.exports = {
    RichRelevanceProductsController: RichRelevanceProductsController,
    richRelevanceProductsComponentDefinition: richRelevanceProductsComponentDefinition
};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<wow-card-list>\r\n    <h2 class=\"cardList-header hidden-xs\" ng-if=\"richRelevanceProductsCtrl.showTitle\">{{richRelevanceProductsCtrl.title}}</h2>\r\n    <wow-shelf-product-tile ng-repeat=\"product in richRelevanceProductsCtrl.products\" product=\"product\"></wow-shelf-product-tile>\r\n</wow-card-list>\r\n"

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceHomeInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceHomeInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceHomeInstrumentationController($scope, $window, featureService, richRelevanceService, restangular, settings) {
        _classCallCheck(this, RichRelevanceHomeInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceHomeInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceHomeInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this._api = restangular.one('RichRelevance');
        _this.richRelevanceService = richRelevanceService;
        _this.settings = settings;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceHomeInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                if (_this2.settings.richRelevance.removeDuplicatedProducts) {
                    var placementIdArray = _this2.placementTypes();

                    if (!placementIdArray || !placementIdArray.length) {
                        return;
                    }

                    _this2.sendServerInstrumentation(placementIdArray).then(function (placement) {
                        _this2.richRelevanceService.onPlacementsReceived(placement);
                    });
                } else {
                    _this2.$window.R3_HOME = new _this2.$window.r3_home(); // eslint-disable-line new-cap
                    _this2.addPlacementTypesIfEnabled();
                    _this2.$window.rr_flush_onload();
                    _this2.$window.r3();
                }
            });
        }
    }, {
        key: 'sendServerInstrumentation',
        value: function sendServerInstrumentation(placementId) {
            // Send request to Trader server
            return this._api.several('Placements', placementId).doGET();
        }
    }]);

    return RichRelevanceHomeInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceHomeInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Restangular', 'Settings', RichRelevanceHomeInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceHomeInstrumentationController: RichRelevanceHomeInstrumentationController,
    richRelevanceHomeInstrumentationComponentDefinition: richRelevanceHomeInstrumentationComponentDefinition
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);
var _ = __webpack_require__(1);

var RichRelevanceCategoryInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceCategoryInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceCategoryInstrumentationController($scope, $window, featureService, richRelevanceService, settings) {
        _classCallCheck(this, RichRelevanceCategoryInstrumentationController);

        // opt-out from state change notifications.
        // category changes are handled using scope changes.
        var baseControllerConfig = {
            instrumentOnStateChange: false
        };

        var _this = _possibleConstructorReturn(this, (RichRelevanceCategoryInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceCategoryInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService, baseControllerConfig));

        _this.richRelevanceService = richRelevanceService;
        _this.selectedCategory = {};
        _this.lastInstrumentedPageNumber = -1; // will be updated on first show.
        _this.settings = settings;
        return _this;
    }

    _createClass(RichRelevanceCategoryInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            this.setAisleOrCategory(this.currentCategory);
        }
    }, {
        key: 'setAisleOrCategory',
        value: function setAisleOrCategory(currentCategory) {
            // If we're requesting placements server-side, don't send the p13n call on Browse except specials category.
            if (this.settings.richRelevance.removeDuplicatedProducts && currentCategory && !currentCategory.IsSpecial) {
                return;
            }
            // current category is reinitialized when user clicks on items (view item details) .etc.
            // we dont want to send instrumentation if the actual values didn't change.
            if (!currentCategory || _.isEqual(currentCategory, this.selectedCategory) && this.lastInstrumentedPageNumber === this.pageNumber) {
                return;
            }
            this.selectedCategory = currentCategory;
            this.setCategoryIdAndName(currentCategory);
        }
    }, {
        key: 'setCategoryIdAndName',
        value: function setCategoryIdAndName(category) {
            var _this2 = this;

            this.richRelevanceService.clearPlacements();

            this.richRelevanceService.getInformation().then(function () {
                if (category.NodeId && !category.IsSpecial) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.NodeId); // category ID must match a category id as passed in catalog feed
                    window.R3_CATEGORY.setName(category.Description); // category name as it should be displayed to customers, overrides the value provided in the catalog feed for this category ID
                } else if (category.RichRelevanceId) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.RichRelevanceId);
                    window.R3_CATEGORY.setName(category.Description);
                } else {
                    // if there is no category id or it's a special category, call generic page request.
                    window.R3_GENERIC = new window.r3_generic(); // eslint-disable-line new-cap
                }
                if (!_this2.settings.richRelevance.removeDuplicatedProducts && (_this2.pageNumber === undefined || _this2.pageNumber < 2)) {
                    // only add placements if it's infinite scroll (pageNumber === undefined)
                    // or page 1 (pageNumber === 1)
                    _this2.addPlacementTypesIfEnabled();
                }
                _this2.lastInstrumentedPageNumber = _this2.pageNumber;
                window.rr_flush_onload();
                window.r3();
            });
        }
    }, {
        key: 'setPlacementIdsForSpecialsGroup',
        value: function setPlacementIdsForSpecialsGroup(category) {
            this.placementIds = this.richRelevanceService.getPlacementIdsForSpecialsGroup(category);
        }
    }, {
        key: 'setPlacementIdsForCategory',
        value: function setPlacementIdsForCategory(category) {
            if (category && category.NodeLevel) {
                this.placementIds = this.richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {

            if (changes.currentCategory || changes.pageNumber && changes.pageNumber.currentValue !== this.lastInstrumentedPageNumber) {
                var category = changes.currentCategory ? changes.currentCategory.currentValue : this.selectedCategory;

                if (category && category.RichRelevanceId) {
                    this.setPlacementIdsForSpecialsGroup(category);
                } else if (category && category.NodeId === this.richRelevanceService.mySpecialsGroupId) {
                    this.placementIds = this.richRelevanceService.mySpecialsPlacement;
                } else {
                    this.setPlacementIdsForCategory(category);
                }
                this.setAisleOrCategory(category);
            }
        }
    }]);

    return RichRelevanceCategoryInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceCategoryInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceCategoryInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
        currentCategory: '<',
        pageNumber: '<',
        isSpecialsGroup: '='
    }
};

module.exports = {
    RichRelevanceCategoryInstrumentationController: RichRelevanceCategoryInstrumentationController,
    richRelevanceCategoryInstrumentationComponentDefinition: richRelevanceCategoryInstrumentationComponentDefinition
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceWishlistInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceWishlistInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceWishlistInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceWishlistInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceWishlistInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceWishlistInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceWishlistInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_WISHLIST = new _this2.$window.r3_wishlist(); // eslint-disable-line new-cap
                _this2.$window.rr_flush_onload();

                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceWishlistInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceWishlistInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceWishlistInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceWishlistInstrumentationController: RichRelevanceWishlistInstrumentationController,
    richRelevanceWishlistInstrumentationComponentDefinition: richRelevanceWishlistInstrumentationComponentDefinition
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceMypageInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceMypageInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceMypageInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceMypageInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceMypageInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceMypageInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceMypageInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_PERSONAL = new _this2.$window.r3_personal(); // eslint-disable-line new-cap
                _this2.$window.rr_flush_onload();

                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceMypageInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceMypageInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceMypageInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceMypageInstrumentationController: RichRelevanceMypageInstrumentationController,
    richRelevanceMypageInstrumentationComponentDefinition: richRelevanceMypageInstrumentationComponentDefinition
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevanceErrorInstrumentationController = function RichRelevanceErrorInstrumentationController($window, richRelevanceService) {
    _classCallCheck(this, RichRelevanceErrorInstrumentationController);

    richRelevanceService.getInformation().then(function () {
        $window.R3_ERROR = new $window.r3_error(); // eslint-disable-line new-cap
        $window.rr_flush_onload();

        $window.r3();
    });
};

var richRelevanceErrorInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceErrorInstrumentationController]
};

module.exports = {
    RichRelevanceErrorInstrumentationController: RichRelevanceErrorInstrumentationController,
    richRelevanceErrorInstrumentationComponentDefinition: richRelevanceErrorInstrumentationComponentDefinition
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceSearchInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceSearchInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceSearchInstrumentationController($scope, $window, featureService, richRelevanceService, settings) {
        _classCallCheck(this, RichRelevanceSearchInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceSearchInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceSearchInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.settings = settings;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceSearchInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            // If we're requesting placements server-side, don't send the p13n call on Search.
            if (this.settings.richRelevance.removeDuplicatedProducts) {
                return;
            }
            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_SEARCH = new _this2.$window.r3_search(); // eslint-disable-line new-cap
                _this2.$window.R3_SEARCH.setTerms(_this2.searchTerm);

                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceSearchInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceSearchInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceSearchInstrumentationController],
    bindings: {
        searchTerm: '<',
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceSearchInstrumentationController: RichRelevanceSearchInstrumentationController,
    richRelevanceSearchInstrumentationComponentDefinition: richRelevanceSearchInstrumentationComponentDefinition
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceGenericInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceGenericInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceGenericInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceGenericInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceGenericInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceGenericInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceGenericInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_GENERIC = new _this2.$window.r3_generic(); // eslint-disable-line new-cap
                _this2.addPlacementTypesIfEnabled();
                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceGenericInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceGenericInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceGenericInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceGenericInstrumentationController: RichRelevanceGenericInstrumentationController,
    richRelevanceGenericInstrumentationComponentDefinition: richRelevanceGenericInstrumentationComponentDefinition
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevanceCartInstrumentationController = function RichRelevanceCartInstrumentationController($window, richRelevanceService) {
    var _this = this;

    _classCallCheck(this, RichRelevanceCartInstrumentationController);

    richRelevanceService.getInformation().then(function () {
        $window.R3_CART = new $window.r3_cart(); // eslint-disable-line new-cap

        _this.products.forEach(function (product) {
            $window.R3_CART.addItemId(product.Stockcode);
        });

        $window.rr_flush_onload();
        $window.r3();
    });
};

var richRelevanceCartInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceCartInstrumentationController],
    bindings: {
        products: '<'
    }
};

module.exports = {
    RichRelevanceCartInstrumentationController: RichRelevanceCartInstrumentationController,
    richRelevanceCartInstrumentationComponentDefinition: richRelevanceCartInstrumentationComponentDefinition
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(11);

var RichRelevanceItemInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceItemInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceItemInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceItemInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceItemInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceItemInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService, { instrumentOnStateChange: false }));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceItemInstrumentationController, [{
        key: '$onInit',
        value: function $onInit() {
            // we handle this manually since this is instantiated after
            // $stateChangeSuccess on product details page.
            this.sendInstrumentation();
        }
    }, {
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_ITEM = new _this2.$window.r3_item(); // eslint-disable-line new-cap
                _this2.$window.R3_ITEM.setId(_this2.itemId.toString()); // This must pass a string value, as RR calls indexOf() on this internally, possibly to URL encode it.
                _this2.$window.R3_ITEM.setName(_this2.itemName);
                _this2.addPlacementTypesIfEnabled();
                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceItemInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceItemInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceItemInstrumentationController],
    bindings: {
        itemId: '<',
        itemName: '<',
        pageGroup: '@',
        placementIds: '<'
    }
};

module.exports = {
    RichRelevanceItemInstrumentationController: RichRelevanceItemInstrumentationController,
    richRelevanceItemInstrumentationComponentDefinition: richRelevanceItemInstrumentationComponentDefinition
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevancePurchasedInstrumentationController = function () {
    function RichRelevancePurchasedInstrumentationController($window, richRelevanceService) {
        var _this = this;

        _classCallCheck(this, RichRelevancePurchasedInstrumentationController);

        this.$window = $window;
        richRelevanceService.getInformation().then(function () {

            $window.R3_PURCHASED = new $window.r3_purchased(); // eslint-disable-line new-cap

            $window.R3_PURCHASED.setOrderNumber(_this.order.OrderId);
            _this.order.Products.forEach(function (product) {
                _this.addProduct(product);
            });

            $window.rr_flush_onload();
            $window.r3();
        });
    }

    _createClass(RichRelevancePurchasedInstrumentationController, [{
        key: 'addProduct',
        value: function addProduct(product) {
            // WOS-5077 RichRelevance cannot accept decimal quantity and doesn't want to boost product by loose items and B2B customers quantity.
            // Therefore, we always send the qunatity as 1 and price should be line total.
            this.$window.R3_PURCHASED.addItemIdPriceQuantity(product.Stockcode, product.Subtotal, 1);
        }
    }]);

    return RichRelevancePurchasedInstrumentationController;
}();

var richRelevancePurchasedInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevancePurchasedInstrumentationController],
    bindings: {
        order: '<'
    }
};

module.exports = {
    RichRelevancePurchasedInstrumentationController: RichRelevancePurchasedInstrumentationController,
    richRelevancePurchasedInstrumentationComponentDefinition: richRelevancePurchasedInstrumentationComponentDefinition
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1),
    $ = __webpack_require__(2),
    scrollSize = __webpack_require__(20);

var globalClassName = 'productCarousel-hides-cardlist-header'; // This is a CSS Feature class. See _features.less

var RrCarouselController = function () {
    function RrCarouselController($scope, $element, $timeout, $q, shelfProductService, richRelevanceService, settings) {
        var _this = this;

        _classCallCheck(this, RrCarouselController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.shelfProductService = shelfProductService;
        this.richRelevanceService = richRelevanceService;
        this.settings = settings;

        if (!this.placementId) {
            this.placementId = this.dynamicPlacementId;
        }

        $scope.$on('$destroy', function () {
            return _this.removeGlobalClass();
        });
        $scope.$on('window:widthResize', function () {
            return _this.initLayout();
        });
    }

    _createClass(RrCarouselController, [{
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            // We do this in postLink rather than onInit because it triggers DOM manipulation.
            // DOM manipulation is not safe before $postLink has fired.
            this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), function (placement) {
                _this2.removeGlobalClass();
                _this2.products = null;
                _this2.title = null;

                if (placement) {
                    _this2.onPlacement(placement);
                }
            });

            // if a product rich relevance placment object being passed in it requires onPlacementsReceived being called
            if (this.rrPlacement) {
                this.richRelevanceService.onPlacementsReceived(this.rrPlacement);
            }
        }
    }, {
        key: 'onPlacement',
        value: function onPlacement(placement) {
            var _this3 = this;

            this.title = placement.message;

            var productsPromise = this.richRelevanceService.useServerSideResults(placement) && placement.Products ? this.$q.when(placement.Products) : this.shelfProductService.getProductsByStockcodes(_.map(placement.items, 'id'), true, this.richRelevanceService.rrSourceName);

            productsPromise.then(function (products) {
                return _this3.products = products;
            }).then(function () {
                return _this3.$timeout(function () {
                    return _this3.getCarouselElements();
                }, 0, false);
            }).then(function () {
                return _this3.initLayout();
            });
        }
    }, {
        key: 'getCarouselElements',
        value: function getCarouselElements() {
            this.$scrollWrapper = this.$element.find('._productCarousel-scrollWrapper');
            this.$scrollContainer = this.$element.find('._productCarousel-scrollContainer');
            this.$items = this.$element.find('._productCarousel-item');
        }
    }, {
        key: 'initLayout',
        value: function initLayout() {
            var _this4 = this;

            if (!this.products || this.products.length === 0) return;

            this.$scrollWrapper.height(this.$scrollContainer.outerHeight() - scrollSize());

            this.carouselScrollWidth = this.$scrollContainer.get(0).scrollWidth;
            this.carouselOffsetWidth = this.$scrollContainer.width();
            this.itemWidth = this.$items.width();

            this.addGlobalClass();
            this.displayArrow();

            this.$scrollContainer.off('scrollstop').on('scrollstop', function () {
                _this4.$scope.$apply(function () {
                    return _this4.updateArrow();
                });
            });
        }
    }, {
        key: 'addGlobalClass',
        value: function addGlobalClass() {
            // we add a class to html tag which will be used to hide
            // the extra space between the carousel and the card list
            // in category spaces. (Done in css).  This space is used
            // to move down the  card list to prevent overlapping with
            // the sliding panel  arrows, which is no longer the case
            // when carousel is at  the top.
            $('html').addClass(globalClassName);
        }
    }, {
        key: 'removeGlobalClass',
        value: function removeGlobalClass() {
            $('html').removeClass(globalClassName);
        }

        /**
         * Decides whether or not the carousel should display arrows.
         *
         * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
         * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'displayArrow',
        value: function displayArrow() {
            var carouselOffsetWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.carouselOffsetWidth;
            var carouselScrollWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.carouselScrollWidth;

            this.isScrollable = carouselScrollWidth >= carouselOffsetWidth;

            if (this.isScrollable) {
                this.updateArrow();
            }
        }

        /**
         * Toggles enabled state of left and right arrows based on current scroll position.
         *
         * @param {Number} [scrollLeft=this.carouselScrollLeft]
         * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
         * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'updateArrow',
        value: function updateArrow() {
            var scrollLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.carouselScrollLeft;
            var carouselScrollWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.carouselScrollWidth;
            var carouselOffsetWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.carouselOffsetWidth;

            this.isLeftArrowDisabled = scrollLeft <= 0;
            this.isRightArrowDisabled = scrollLeft >= carouselScrollWidth - carouselOffsetWidth;
        }

        /**
         * Calculates the new leftScroll value after scrolling left or right.
         * Scrolls by one viewport width.
         *
         * @param {Boolean} right
         * @param {Number} [itemWidth=this.itemWidth]
         * @param {Number} [scrollLeft=this.carouselScrollLeft]
         * @param {Number} [carouselWidth=this.carouselOffsetWidth]
         * @returns {Number}
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'calculateNewScrollPosition',
        value: function calculateNewScrollPosition(right) {
            var itemWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.itemWidth;
            var scrollLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.carouselScrollLeft;
            var carouselWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.carouselOffsetWidth;

            var numItemsViewable = carouselWidth / itemWidth;

            var targetScroll = 0;

            if (right) {
                // move the carousel one viewport to the right
                targetScroll = scrollLeft + numItemsViewable * itemWidth;
                // round to the nearest visible card.
                targetScroll = Math.floor(targetScroll / itemWidth) * itemWidth; // anchor to left corner of card
            } else {
                // move the carousel one viewport to the left
                targetScroll = scrollLeft - numItemsViewable * itemWidth;
                // round to the nearest fully visible card
                targetScroll = Math.ceil(targetScroll / itemWidth) * itemWidth;
            }

            return targetScroll;
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            this.animateScrolling(this.calculateNewScrollPosition(false));
        }
    }, {
        key: 'scrollRight',
        value: function scrollRight() {
            this.animateScrolling(this.calculateNewScrollPosition(true));
        }
    }, {
        key: 'animateScrolling',
        value: function animateScrolling(targetScroll) {
            this.$scrollContainer.animate({
                scrollLeft: targetScroll
            }, 200);
        }
    }, {
        key: 'carouselScrollLeft',
        get: function get() {
            return this.$scrollContainer.scrollLeft();
        }
    }]);

    return RrCarouselController;
}();

var rrCarouselComponentDefinition = {
    bindings: {
        placementId: '@',
        dynamicPlacementId: '=',
        rrPlacement: '=?'
    },
    controller: ['$scope', '$element', '$timeout', '$q', 'ShelfProductService', 'RichRelevanceService', 'Settings', RrCarouselController],
    template: __webpack_require__(495).trim()
};

module.exports = {
    RrCarouselController: RrCarouselController,
    rrCarouselComponentDefinition: rrCarouselComponentDefinition
};

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productCarousel tileList-container\" ng-if=\"$ctrl.products && $ctrl.products.length\">\r\n\t<h2 class=\"productCarousel-header\" ng-show=\"$ctrl.title\">\r\n\t\t{{$ctrl.title}}\r\n\t</h2>\r\n\r\n    <div class=\"productCarousel-buttonWrapper\">\r\n        <button class=\"productCarousel-nav productCarousel-leftArrow\" ng-show=\"$ctrl.isScrollable\" ng-click=\"$ctrl.scrollLeft()\" ng-disabled=\"$ctrl.isLeftArrowDisabled\">\r\n            <i class=\"iconww-ArrowLeft productCarousel-navIcon\"></i>\r\n            <span class=\"sr-only\">Previous</span>\r\n        </button>\r\n\r\n        <div class=\"productCarousel-panel _productCarousel-scrollWrapper\"> <!-- This div hides the scrollbar -->\r\n            <div class=\"productCarousel-items _productCarousel-scrollContainer\"> <!-- This is the scrollable div -->\r\n                <wow-shelf-product-tile\r\n                    class=\"_productCarousel-item\"\r\n                    product=\"product\"\r\n                    ng-repeat=\"product in $ctrl.products track by $index\">\r\n                </wow-shelf-product-tile>\r\n            </div>\r\n        </div>\r\n\r\n        <button class=\"productCarousel-nav productCarousel-rightArrow\" ng-show=\"$ctrl.isScrollable\" ng-click=\"$ctrl.scrollRight()\" ng-disabled=\"$ctrl.isRightArrowDisabled\">\r\n            <i class=\"iconww-ArrowRight productCarousel-navIcon\"></i>\r\n            <span class=\"sr-only\">Next</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(497),
    notificationPanelComponentDefinition = _require.notificationPanelComponentDefinition;

__webpack_require__(0).module('wowApp.shop').component('wowNotificationPanel', notificationPanelComponentDefinition);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotificationPanelController = function () {
    function NotificationPanelController($scope, shopperService, loginService, gtm, sessionStorage) {
        _classCallCheck(this, NotificationPanelController);

        this.$scope = $scope;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.gtm = gtm;
        this.sessionStorage = sessionStorage;

        this.shouldDisplayDynamicSuburbDialog = false;
    }

    _createClass(NotificationPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var sessionStorageKey = 'pendingDynamicSuburbsPopup';

            this.$scope.$on('login:success', function () {
                _this.sessionStorage.set(sessionStorageKey, true);
            });

            if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
                this.showDynamicSuburbsDialog();
            }
        }
    }, {
        key: 'showDynamicSuburbsDialog',
        value: function showDynamicSuburbsDialog() {
            this.shouldDisplayDynamicSuburbDialog = !this.shopperService.IsGuest && this.shopperService.ShouldShowDeliveryWindowDialog && this.loginService.loginContext !== 'checkout';

            if (this.shouldDisplayDynamicSuburbDialog) {
                this.gtm.push({ event: 'dynamic suburbs popup presented' });
            }
        }
    }]);

    return NotificationPanelController;
}();

NotificationPanelController.$inject = ['$scope', 'ShopperService', 'LoginService', 'GtmService', 'SessionStorageWrapper'];

var notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: __webpack_require__(498).trim()
};

module.exports = {
    NotificationPanelController: NotificationPanelController,
    notificationPanelComponentDefinition: notificationPanelComponentDefinition
};

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "<wow-dynamic-suburb-dialog ng-if=\"$ctrl.shouldDisplayDynamicSuburbDialog\"></wow-dynamic-suburb-dialog>"

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(500),
    expressAddressPanelControllerComponentDefinition = _require.expressAddressPanelControllerComponentDefinition;

var _require2 = __webpack_require__(502),
    expressCartItemCountControllerComponentDefinition = _require2.expressCartItemCountControllerComponentDefinition;

angular.module('wowApp.shop').component('wowExpressAddressPanel', expressAddressPanelControllerComponentDefinition).component('wowExpressCartItemCount', expressCartItemCountControllerComponentDefinition);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressAddressPanelController = function () {
    function ExpressAddressPanelController() {
        _classCallCheck(this, ExpressAddressPanelController);
    }

    _createClass(ExpressAddressPanelController, [{
        key: 'onSetEntryMode',
        value: function onSetEntryMode(mode) {
            this.addressEntryMode = mode;
        }
    }]);

    return ExpressAddressPanelController;
}();

var expressAddressPanelControllerComponentDefinition = {
    controller: [ExpressAddressPanelController],
    template: __webpack_require__(501).trim()
};

module.exports = {
    ExpressAddressPanelController: ExpressAddressPanelController,
    expressAddressPanelControllerComponentDefinition: expressAddressPanelControllerComponentDefinition
};

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressAddressPanel\">\r\n    <h2 class=\"expressAddressPanel-title\">\r\n        I'd like my groceries Express Delivered in 1hr at:\r\n    </h2>\r\n    <div class=\"expressAddressPanel-address\">\r\n        <wow-address-entry-form\r\n            input-id=\"signupDelivery\"\r\n            should-retain-input=\"true\"\r\n            on-set-entry-mode=\"$ctrl.onSetEntryMode(mode)\"\r\n            class=\"expressAddressPanel-addressForm\">\r\n        </wow-address-entry-form>\r\n        <div ng-switch=\"$ctrl.addressEntryMode\">\r\n            <button ng-switch-when=\"SEARCH\" class=\"expressAddressPanel-addressButton button button--primary\">\r\n                Shop Express now\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n            <button ng-switch-when=\"MANUAL\" class=\"expressAddressPanel-addressButton button button--primary\">\r\n                Search Express Now\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n        </span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressCartItemCountController = function () {
    function ExpressCartItemCountController($scope, shopPageStateService, settings, trolleyService) {
        var _this = this;

        _classCallCheck(this, ExpressCartItemCountController);

        this.trolleyService = trolleyService;
        this.settings = settings;
        this.shopPageStateService = shopPageStateService;

        $scope.$watch(function () {
            return _this.trolleyService.totalItemQuantity;
        }, function () {
            return _this.updateItemCounts();
        });
    }

    _createClass(ExpressCartItemCountController, [{
        key: '$onInit',
        value: function $onInit() {
            // default values
            this.remainingItems = 0;
            this.exceededItems = 0;
            this.hasExceededLimit = false;

            this.orderLimitExceededWarningError = this.settings.deliveryWindowAlerts.orderLimitExceededWarningError;
        }
    }, {
        key: 'updateItemCounts',
        value: function updateItemCounts() {
            this.remainingItems = this.trolleyService.maximumOrderQuantity - this.trolleyService.totalItemQuantity;
            this.exceededItems = this.trolleyService.totalItemQuantity - this.trolleyService.maximumOrderQuantity;
            this.hasExceededLimit = this.exceededItems > 0;

            if (this.hasExceededLimit && !this.shopPageStateService.isCartOpen) {
                this.shopPageStateService.isCartOpen = true;
            }
        }
    }]);

    return ExpressCartItemCountController;
}();

var expressCartItemCountControllerComponentDefinition = {
    controller: ['$scope', 'ShopPageStateService', 'Settings', 'TrolleyService', ExpressCartItemCountController],
    template: __webpack_require__(503).trim()
};

module.exports = {
    ExpressCartItemCountController: ExpressCartItemCountController,
    expressCartItemCountControllerComponentDefinition: expressCartItemCountControllerComponentDefinition
};

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressCartItemCount\">\r\n    <div class=\"expressCartItemCount-valid\" ng-if=\"!$ctrl.hasExceededLimit\">\r\n        <div class=\"expressCartItemCount-validDisplay\">\r\n            <i class=\"expressCartItemCount-validDisplayIcon iconww-Cart\"></i>\r\n            <p class=\"expressCartItemCount-validDisplayCount\">\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n        <div class=\"expressCartItemCount-validMessage\">\r\n            <p class=\"expressCartItemCount-validMessageCount\">You have\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n                in your cart\r\n            </p>\r\n            <p class=\"expressCartItemCount-validMessageRemaining\">\r\n                You can add\r\n                <ng-pluralize\r\n                    count=\"$ctrl.remainingItems\"\r\n                    when=\"{'one': '{} more item', 'other': '{} more items'}\">\r\n                </ng-pluralize>\r\n                for express delivery\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div class=\"expressCartItemCount-invalid alert alert--error\" ng-if=\"$ctrl.hasExceededLimit\">\r\n        <div class=\"expressCartItemCount-invalidDisplay\">\r\n            <i class=\"expressCartItemCount-invalidDisplayIcon iconww-Cart\"></i>\r\n            <p class=\"expressCartItemCount-invalidDisplayCount\">\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n        <div class=\"expressCartItemCount-invalidMessage\">\r\n            <p class=\"expressCartItemCount-invalidMessageWarning\">\r\n                {{::$ctrl.orderLimitExceededWarningError}}\r\n            </p>\r\n            <p class=\"expressCartItemCount-invalidMessageExcess\">\r\n                Remove\r\n                <ng-pluralize\r\n                    count=\"$ctrl.exceededItems\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars

var olyCommonModule = __webpack_require__(4);
var wowCommonModule = __webpack_require__(5);

var InspirationService = __webpack_require__(505);

var _require = __webpack_require__(506),
    inspirationNavigationComponentDefinition = _require.inspirationNavigationComponentDefinition;

var _require2 = __webpack_require__(508),
    inspirationTileComponentDefinition = _require2.inspirationTileComponentDefinition;

var _require3 = __webpack_require__(510),
    inspirationDetailTileComponentDefinition = _require3.inspirationDetailTileComponentDefinition;

var _require4 = __webpack_require__(512),
    inspirationDetailTileListComponentDefinition = _require4.inspirationDetailTileListComponentDefinition;

var _require5 = __webpack_require__(513),
    inspirationDetailComponentDefinition = _require5.inspirationDetailComponentDefinition;

var inspirationModuleName = 'wowApp.inspiration';

angular.module(inspirationModuleName, [olyCommonModule, wowCommonModule, uiRouter, 'restangular']).service('InspirationService', ['Restangular', '$rootScope', '$window', 'LocalStorageWrapper', InspirationService]).component('wowInspirationNavigation', inspirationNavigationComponentDefinition).component('wowInspirationTile', inspirationTileComponentDefinition).component('wowInspirationDetailTile', inspirationDetailTileComponentDefinition).component('wowInspirationDetailTileList', inspirationDetailTileListComponentDefinition).component('wowInspirationDetail', inspirationDetailComponentDefinition);

module.exports = inspirationModuleName;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

function InspirationService(Restangular, $rootScope, $window, localStorageWrapper) {
    this._api = Restangular.one('inspiration');
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.localStorageWrapper = localStorageWrapper;
}

InspirationService.prototype.getNavigationItems = function () {
    this._leftPaneItems = this._leftPaneItems || this._api.one('navigation').getList();

    return this._leftPaneItems;
};

InspirationService.prototype.findNavigationItemsByName = function (navItems, parentName, childName) {
    var navItem = _.find(navItems, { UrlPart: parentName });

    if (childName !== undefined && navItem && _.some(navItem.Items)) {
        navItem = _.find(navItem.Items, { UrlPart: childName });
    }

    return navItem;
};

InspirationService.prototype.getCardsByPageID = function (pageId) {
    return this._api.one('page', pageId).get();
};

InspirationService.prototype.getCardsForUrl = function (url) {
    return this._api.one('cards').get({ url: url });
};

InspirationService.prototype.getDiscoverPathForCard = function (cardId) {
    return this._api.one('cards', cardId).one('DiscoverPath').get();
};

InspirationService.prototype.setContentCardId = function (cardId) {
    var _this = this;

    // Disabled due to https://github.com/eslint/eslint/issues/5692
    // Please re-enable if the issue is fixed.
    /* eslint-disable prefer-const */
    var stateChangeErrorOff = void 0;
    this._removeDataSessionStorage('dynamicContentCardId'); // just in case


    var clickContentCardOff = this.$rootScope.$on('$stateChangeSuccess', function () {
        _this.ContentCardId = cardId;
        stateChangeErrorOff();
        clickContentCardOff();

        var navigateAwayOff = _this.$rootScope.$on('$stateChangeStart', function () {
            _this.ContentCardId = null;
            navigateAwayOff();
        });
    });

    stateChangeErrorOff = this.$rootScope.$on('$stateChangeError', function () {
        _this.ContentCardId = null;
        stateChangeErrorOff();
        clickContentCardOff();
    });
    /* eslint-enable prefer-const */
};

// Attributes that controls the center panel's behavior for SmallFormat when the item has no children items
InspirationService.prototype.setChildlessItem = function (childlessItem) {
    this._isChildLessItem = childlessItem;
};

InspirationService.prototype.isChildlessItem = function () {
    return this._isChildLessItem;
};

InspirationService.prototype.setDynamicContentCardIdSessionStorage = function (cardId) {
    this._setDataSessionStorage('dynamicContentCardId', cardId);
};

InspirationService.prototype._setNavigateAwayOff = function () {
    var _this2 = this;

    var navigateAwayOff = this.$rootScope.$on('$stateChangeSuccess', function () {
        _this2._removeDataSessionStorage('dynamicContentCardId');
        navigateAwayOff();
    });
};

InspirationService.prototype.getContentCardId = function () {
    this._setNavigateAwayOff();
    return this.ContentCardId ? this.ContentCardId : this._getDataSessionStorage('dynamicContentCardId');
};

// private session storage apis

/**
 * Create an item in DOM sessionStorage.
 * @param {String} name
 * @param {Object} data
 */
InspirationService.prototype._setDataSessionStorage = function (name, data) {
    this.localStorageWrapper.set(name, data);

    return data;
};

/**
 * Remove an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._removeDataSessionStorage = function (name) {
    this.localStorageWrapper.remove(name);

    // allow chaining
    return this;
};

/**
 * Gets an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._getDataSessionStorage = function (name) {
    return this.localStorageWrapper.get(name) || null;
};

module.exports = InspirationService;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationNavigationController = function () {
    function InspirationNavigationController($state) {
        _classCallCheck(this, InspirationNavigationController);

        this.$state = $state;
    }

    _createClass(InspirationNavigationController, [{
        key: 'isOpen',
        value: function isOpen(category) {
            return this.$state.includes('shop.inspiration.parent', { parent: category.UrlPart });
        }
    }]);

    return InspirationNavigationController;
}();

var inspirationNavigationComponentDefinition = {
    bindings: {
        menuItems: '='
    },
    controller: ['$state', InspirationNavigationController],
    template: __webpack_require__(507).trim()
};

module.exports = {
    InspirationNavigationController: InspirationNavigationController,
    inspirationNavigationComponentDefinition: inspirationNavigationComponentDefinition
};

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation treeNavigation\" aria-label=\"Discover\">\r\n    <ul class=\"navigation-items\">\r\n        <li ng-repeat=\"item in ::$ctrl.menuItems\">\r\n            <a\r\n                id=\"{{ ::item.UrlPart }}\"\r\n                class=\"navigation-link navigation-header treeNavigation-parent\"\r\n                ng-attr-aria-expanded=\"{{ item.Items.length > 0 ? $ctrl.isOpen(item) : undefined }}\"\r\n                ng-attr-controls=\"{{ item.Items.length > 0 ? item.UrlPart + '-children' : undefined }}\"\r\n                ng-class=\"{ 'is-open': $ctrl.isOpen(item) }\"\r\n                ui-sref=\"shop.inspiration.parent({ parent: item.UrlPart })\"\r\n                ui-sref-active-eq=\"is-active\"\r\n                ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                <span ng-switch=\"item.Items.length > 0\">\r\n                    {{ ::item.Name }}&nbsp;<span ng-switch-when=\"true\"><i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i></span><i class=\"iconww-ArrowRight\" ng-switch-when=\"false\"></i>\r\n                </span>\r\n            </a>\r\n\r\n            <ul\r\n                id=\"{{ ::item.UrlPart }}-children\"\r\n                class=\"navigation-items treeNavigation-children\"\r\n                aria-labelledby=\"{{ ::item.UrlPart }}\">\r\n\r\n                <li ng-repeat=\"level2 in ::item.Items\">\r\n                    <a\r\n                        class=\"navigation-link\"\r\n                        ui-sref=\"shop.inspiration.parent.child({ parent: item.UrlPart, child: level2.UrlPart })\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                        <span>{{ ::level2.Name }}&nbsp;<i class=\"iconww-ArrowRight\"></i></span>\r\n                    </a>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationTileController = function () {
    function InspirationTileController($state, breakpointsService, trolleyService) {
        _classCallCheck(this, InspirationTileController);

        this.$state = $state;
        this.trolleyService = trolleyService;
        this.breakpointsService = breakpointsService;
    }

    _createClass(InspirationTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.linkTarget = this.card.PromoOpenInNewTab ? '_blank' : undefined;
            this.linkHref = this.getLink();
        }
    }, {
        key: 'getLink',
        value: function getLink() {
            if (this.card.CardLinkTarget) {
                return this.card.CardLinkTarget;
            } else if (this.card.ProductGroupId) {
                return this.$state.href('shop.productgroup', { Id: this.card.ProductGroupId });
            } else if (this.card.Product) {
                return this.$state.href('shop.productdetails', { productId: this.card.Product.Stockcode, productName: this.card.Product.UrlFriendlyName, product: this.card.Product });
            } else if (this.card.RecipeId) {
                return this.$state.href('shop.recipedetail', { recipeId: this.card.RecipeId });
            }
            return this.$state.href('shop.inspirationcard', { id: this.card.ID, name: this.card.UrlPart });
        }
    }]);

    return InspirationTileController;
}();

var inspirationTileComponentDefinition = {
    bindings: {
        card: '<',
        onClick: '&?'
    },
    controller: ['$state', 'BreakpointsService', 'TrolleyService', InspirationTileController],
    template: __webpack_require__(509).trim()
};

module.exports = {
    InspirationTileController: InspirationTileController,
    inspirationTileComponentDefinition: inspirationTileComponentDefinition
};

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationTile tile\" ng-class=\"::{'has-homepage-small-image' : $ctrl.card.HomepageSmallImagePath, 'inspirationTile--product': !!$ctrl.card.Product}\">\r\n    <a class=\"inspirationTile-imageContainer\"\r\n        ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n        ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n        ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n        <img class=\"inspirationTile-image\"\r\n            ng-src=\"{{ ($ctrl.card.HomepageSmallImagePath && $ctrl.breakpointsService.isInSmallFormat) ? $ctrl.card.HomepageSmallImagePath : $ctrl.card.LargeImagePath }}\"\r\n            alt=\"{{ ::($ctrl.card.ImageAltText || $ctrl.card.Name) }}\" />\r\n    </a>\r\n\r\n    <div class=\"inspirationTile-information\">\r\n        <a class=\"heading4 inspirationTile-name\"\r\n            ng-class=\"{'has-description' : $ctrl.card.Description}\"\r\n            ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n            ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n            ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n            {{ ::$ctrl.card.Name }}\r\n        </a>\r\n\r\n        <p class=\"inspirationTile-description\" ng-if=\"::$ctrl.card.Description\">\r\n            {{ ::$ctrl.card.Description }}\r\n        </p>\r\n\r\n        <a class=\"button inspirationTile-button\"\r\n            ng-if=\"::!$ctrl.card.Product\"\r\n            ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n            ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n            ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n            {{ ::$ctrl.card.LinkText }}\r\n        </a>\r\n\r\n        <div class=\"inspirationTile-productControls\" ng-if=\"::$ctrl.card.Product\">\r\n            <wow-product-save-to-list\r\n                product=\"::$ctrl.card.Product\">\r\n            </wow-product-save-to-list>\r\n\r\n            <wow-cart-controls\r\n                shelf-product=\"::$ctrl.card.Product\"\r\n                trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.card.Product.Stockcode]\">\r\n            </wow-cart-controls>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-tile-in-cart product=\"::$ctrl.card.Product\" class-modifier=\"inspirationTile-tileInCart\"></wow-tile-in-cart>\r\n\r\n    <span class=\"sr-only\" ng-if=\"::$ctrl.card.PromoOpenInNewTab\">, opens in a new window</span>\r\n</div>\r\n"

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationDetailTileController = function () {
    function InspirationDetailTileController($scope, $element, $state, moveFocus, inspirationService) {
        _classCallCheck(this, InspirationDetailTileController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.inspirationService = inspirationService;
    }

    _createClass(InspirationDetailTileController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on('window:resize', function () {
                if (_this.isDetailExpanded()) {
                    _this.expand();
                }
            });

            this.$scope.$watch(function () {
                return _this.$state.params.cardId;
            }, function (cardId) {
                return _this.card.ID === cardId ? _this.expand() : _this.shrink();
            });
        }
    }, {
        key: 'openCardDetail',
        value: function openCardDetail() {
            this.$state.go('.', { cardId: this.card.ID, name: this.card.UrlPart });
        }
    }, {
        key: 'closeCardDetail',
        value: function closeCardDetail() {
            this.$state.go('.', { cardId: undefined, name: undefined });
        }
    }, {
        key: 'isDetailExpanded',
        value: function isDetailExpanded() {
            return this.card.ID === this.$state.params.cardId;
        }
    }, {
        key: 'shrink',
        value: function shrink() {
            this.$element.find('._inspirationDetailTile').css('margin-bottom', '');
        }
    }, {
        key: 'expand',
        value: function expand() {
            var $tile = this.$element.find('._inspirationDetailTile');
            var $detail = this.$element.find('._inspirationDetailTile-detail');

            $tile.css('margin-bottom', $detail.height() + 20);

            $detail.css('top', $tile.position().top + $tile.height());
        }
    }, {
        key: 'goToCard',
        value: function goToCard($event) {
            if (this.card.CardLinkTarget || this.card.ProductGroupId || this.card.Product || this.card.RecipeId) {
                this.inspirationService.setContentCardId(this.card.ID);
            } else if ($event.button === 0) {
                $event.preventDefault();
                this.openCardDetail();
                this.moveFocus('._inspirationDetailTile-detail');
            }
        }
    }]);

    return InspirationDetailTileController;
}();

InspirationDetailTileController.$inject = ['$scope', '$element', '$state', 'MoveFocus', 'InspirationService'];

var inspirationDetailTileComponentDefinition = {
    bindings: {
        card: '<'
    },
    controller: InspirationDetailTileController,
    template: __webpack_require__(511).trim()
};

module.exports = {
    InspirationDetailTileController: InspirationDetailTileController,
    inspirationDetailTileComponentDefinition: inspirationDetailTileComponentDefinition
};

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationDetailTile _inspirationDetailTile\">\r\n    <wow-inspiration-tile id=\"inspirationCard-{{ ::$ctrl.card.ID }}\" card=\"::$ctrl.card\" on-click=\"$ctrl.goToCard($event)\"></wow-inspiration-tile>\r\n\r\n    <div class=\"inspirationDetailTile-selectedPointer\" ng-show=\"$ctrl.isDetailExpanded()\"></div>\r\n</div>\r\n\r\n<div class=\"inspirationDetailTile-detail _inspirationDetailTile-detail\" tabindex=\"-1\" ng-if=\"$ctrl.isDetailExpanded()\">\r\n    <button ng-click=\"$ctrl.closeCardDetail()\" class=\"iconButton inspirationDetailTile-close\" oly-move-focus=\"inspirationCard-{{ ::$ctrl.card.ID }}\">\r\n        <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Close details</span>\r\n    </button>\r\n\r\n    <!-- The ng-click on this element is a hack to support resizing when using expanding elements added via dynamic content (e.g. accordians written by the content team) -->\r\n    <wow-inspiration-detail card=\"::$ctrl.card\" onload=\"$ctrl.expand()\" oly-grab-focus=\"true\" tabindex=\"-1\" ng-click=\"$ctrl.expand()\"></wow-inspiration-detail>\r\n</div>\r\n"

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(23),
    createInspirationTiles = _require.createInspirationTiles,
    _require2 = __webpack_require__(22),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var InspirationDetailTileListController = function () {
    function InspirationDetailTileListController($location, $q, inspirationService) {
        _classCallCheck(this, InspirationDetailTileListController);

        this.$location = $location;
        this.$q = $q;
        this.inspirationService = inspirationService;
    }

    _createClass(InspirationDetailTileListController, [{
        key: 'createTiles',
        value: function createTiles(pageCards, urlCards) {
            return {
                items: mergeInspirationTiles(createInspirationTiles(pageCards, 'inspirationdetail'), urlCards, { type: 'inspirationdetail' })
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles() {
            var _this = this;

            return this.$q.all([this.inspirationService.getCardsByPageID(this.pageId), this.inspirationService.getCardsForUrl(this.$location.pathAndSearch())]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    pageCards = _ref2[0].InspirationCards,
                    urlCards = _ref2[1].Cards;

                return _this.createTiles(pageCards, urlCards);
            });
        }
    }]);

    return InspirationDetailTileListController;
}();

InspirationDetailTileListController.$inject = ['$location', '$q', 'InspirationService'];

var inspirationDetailTileListComponentDefinition = {
    bindings: {
        pageId: '<'
    },
    controller: InspirationDetailTileListController,
    template: '\n        <wow-tile-list\n            should-get-inspiration-cards="false"\n            get-tiles="$ctrl.getTiles()">\n        </wow-tile-list>\n    '
};

module.exports = {
    InspirationDetailTileListController: InspirationDetailTileListController,
    inspirationDetailTileListComponentDefinition: inspirationDetailTileListComponentDefinition
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(514),
    detailMapper = _require.detailMapper;

var InspirationDetailController = function () {
    function InspirationDetailController($scope, $element, $location, gtm) {
        _classCallCheck(this, InspirationDetailController);

        this.$scope = $scope;
        this.$element = $element;
        this.$location = $location;
        this.gtm = gtm;
    }

    _createClass(InspirationDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.gtm.push({ card: this.card, list: this.$location.path() }, detailMapper);

            this.scheduleKey = this.card.ID + '-card-schedule';
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            this.$element[0].addEventListener('load', function () {
                // Re-triggers load whenever new images finish downloading in order
                // to correctly resize.
                _this.$scope.$apply(function () {
                    return _this.onload();
                });
            }, true);
        }
    }]);

    return InspirationDetailController;
}();

InspirationDetailController.$inject = ['$scope', '$element', '$location', 'GtmService'];

var inspirationDetailComponentDefinition = {
    bindings: {
        card: '<',
        onload: '&'
    },
    controller: InspirationDetailController,
    template: __webpack_require__(515).trim()
};

module.exports = {
    InspirationDetailController: InspirationDetailController,
    inspirationDetailComponentDefinition: inspirationDetailComponentDefinition
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function clickMapper(data) {
    return {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: { list: data.list },
                products: [{
                    name: data.card.Name,
                    id: 'dis_' + data.card.ID,
                    position: data.position
                }]
            }
        }
    };
}

function detailMapper(data) {
    return {
        event: 'productDetail',
        ecommerce: {
            detail: {
                actionField: { list: data.list },
                products: [{
                    name: data.card.Name,
                    id: 'dis_' + data.card.ID
                }]
            }
        }
    };
}

module.exports = {
    clickMapper: clickMapper,
    detailMapper: detailMapper
};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationDetail text-left\">\r\n    <oly-dynamic-content\r\n        schedule-key=\"$ctrl.scheduleKey\"\r\n        onload=\"$ctrl.onload()\">\r\n    </oly-dynamic-content>\r\n</div>\r\n"

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var ngSanitize = __webpack_require__(17);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars

var olyCommonModule = __webpack_require__(4);
var wowCommonModule = __webpack_require__(5);

var _require = __webpack_require__(517),
    SearchService = _require.SearchService;

var _require2 = __webpack_require__(518),
    searchMultisearchComponentDefinition = _require2.searchMultisearchComponentDefinition;

var _require3 = __webpack_require__(520),
    searchNavigationComponentDefinition = _require3.searchNavigationComponentDefinition;

var _require4 = __webpack_require__(522),
    searchNavigationLinkComponentDefinition = _require4.searchNavigationLinkComponentDefinition;

var _require5 = __webpack_require__(524),
    searchProductTileListComponentDefinition = _require5.searchProductTileListComponentDefinition;

var _require6 = __webpack_require__(525),
    searchRecipeTileListComponentDefinition = _require6.searchRecipeTileListComponentDefinition;

var _require7 = __webpack_require__(526),
    searchInspirationTileListComponentDefinition = _require7.searchInspirationTileListComponentDefinition;

var _require8 = __webpack_require__(527),
    searchTermTileListUpdaterComponentDefinition = _require8.searchTermTileListUpdaterComponentDefinition;

var searchModuleName = 'wowApp.search';

angular.module(searchModuleName, [olyCommonModule, wowCommonModule, ngSanitize, uiRouter, 'restangular']).service('SearchService', SearchService).service('SearchPhraseActionService', ['Restangular', '$state', 'LoginService', 'ShopperService', '$window', 'MoveFocus', '$q', 'BootstrapService', 'SearchMultisearchService', 'SearchService', __webpack_require__(528)]).service('SearchMultisearchService', ['Restangular', 'BreakpointsService', '$stateParams', __webpack_require__(529)]).component('wowMultisearch', searchMultisearchComponentDefinition).component('wowSearchNavigation', searchNavigationComponentDefinition).component('wowSearchNavigationLink', searchNavigationLinkComponentDefinition).component('wowSearchProductTileList', searchProductTileListComponentDefinition).component('wowSearchRecipeTileList', searchRecipeTileListComponentDefinition).component('wowSearchInspirationTileList', searchInspirationTileListComponentDefinition).component('wowSearchTermTileListUpdater', searchTermTileListUpdaterComponentDefinition).directive('wowSearchZeroResults', ['$sce', 'SettingsService', '$state', '$sanitize', __webpack_require__(530)]).directive('wowSearchExternalResult', ['$sce', 'SettingsService', '$stateParams', 'SearchPhraseActionService', '$state', 'ShopperService', __webpack_require__(532)]);

module.exports = searchModuleName;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    chain = _require.chain,
    set = _require.set;

var SearchService = function () {
    function SearchService(Restangular, categoriesService) {
        _classCallCheck(this, SearchService);

        this.api = Restangular.one('Search');
        this.categoriesService = categoriesService;

        this.categories = [];
        this.searchCounts = {};
    }

    _createClass(SearchService, [{
        key: 'determineStateToShow',
        value: function determineStateToShow(searchTerm, multisearchItems) {
            var params = { searchTerm: searchTerm, multisearchItems: multisearchItems };

            if (searchTerm.toLowerCase().indexOf('recipe') > -1) {
                if (this.searchCounts.RecipeCount > 0) {
                    return { name: 'shop.search.recipes', params: params };
                } else if (this.searchCounts.ProductCount > 0) {
                    return { name: 'shop.search.products', params: params };
                } else if (this.searchCounts.ArticleCount > 0) {
                    return { name: 'shop.search.articles', params: params };
                }

                return { name: 'shop.search.zero-result', params: params };
            }

            if (this.searchCounts.ProductCount > 0) {
                return { name: 'shop.search.products', params: params };
            } else if (this.searchCounts.RecipeCount > 0) {
                return { name: 'shop.search.recipes', params: params };
            } else if (this.searchCounts.ArticleCount > 0) {
                return { name: 'shop.search.articles', params: params };
            }

            return { name: 'shop.search.zero-result', params: params };
        }
    }, {
        key: 'getSearchSuggestion',
        value: function getSearchSuggestion(searchTerm) {
            return this.api.one('suggestion').get({
                Key: searchTerm
            });
        }
    }, {
        key: 'getSearchCounts',
        value: function getSearchCounts(searchTerm) {
            var _this = this;

            this.searchCounts = { loadingCount: true };

            return this.api.one('count').get({
                SearchTerm: searchTerm
            }).then(function (data) {
                _this.searchCounts = data.SearchCount;
            }).finally(function () {
                _this.searchCounts.loadingCount = false;
            });
        }
    }, {
        key: 'getCategoriesFromAggregation',
        value: function getCategoriesFromAggregation(aggregations) {
            var _this2 = this;

            if (!aggregations) return [];

            return chain(aggregations).find({ Name: 'Category' }).get('Results', []).map(function (r) {
                return set(_this2.categoriesService.getById(r.Term), 'ProductCount', r.Count);
            }).filter(function (r) {
                return r && r.NodeLevel === 1 && r.IsSpecial === false;
            }).value();
        }
    }, {
        key: 'doSearch',
        value: function doSearch(searchTerm, pageSize, pageNumber, sortType, isSpecial, filters) {
            var _this3 = this;

            return this.api.post('products', {
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType,
                IsSpecial: isSpecial,
                Filters: filters ? filters.filters : []
            }).then(function (data) {
                _this3.categories = _this3.getCategoriesFromAggregation(data.Aggregations);

                return {
                    items: data.Products,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }, {
        key: 'doSearchSpecials',
        value: function doSearchSpecials(searchTerm, pageSize, pageNumber, sortType, filters) {
            var _this4 = this;

            return this.api.post('specials', {
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType,
                Filters: filters ? filters.filters : []
            }).then(function (data) {
                _this4.categories = _this4.getCategoriesFromAggregation(data.Aggregations);

                return {
                    items: data.Products,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }, {
        key: 'doSearchRecipes',
        value: function doSearchRecipes(searchTerm, pageSize, pageNumber, sortType) {
            return this.api.one('recipes').get({
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType
            }).then(function (data) {
                return {
                    items: data.Recipes,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }, {
        key: 'doSearchArticles',
        value: function doSearchArticles(searchTerm, pageSize, pageNumber) {
            return this.api.one('articles').get({
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber
            }).then(function (data) {
                return {
                    items: data.Cards,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }]);

    return SearchService;
}();

SearchService.$inject = ['Restangular', 'CategoriesService'];

module.exports = { SearchService: SearchService };

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(0);

var _require = __webpack_require__(1),
    compact = _require.compact,
    each = _require.each,
    replace = _require.replace,
    uniqBy = _require.uniqBy;

var key = { esc: 27 };
var newlineCharacter = '\n';

var SearchMultisearchController = function () {
    function SearchMultisearchController($state, $timeout, $window, moveFocus, settings, searchMultisearchService) {
        _classCallCheck(this, SearchMultisearchController);

        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchMultisearchService = searchMultisearchService;
    }

    _createClass(SearchMultisearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.multisearchText = '';
            this.searchLimitErrorMessage = '';
            this.showSearchLimitError = false;
            this.searchLimitErrorMessage = this.settings.search.searchItemLimitReached;
            this.maximumItemsToSearch = this.settings.search.maximumItemsToSearch;
        }
    }, {
        key: 'getMultisearchList',
        value: function getMultisearchList() {
            // Split each line by the new line character then remove duplicates, remove empty rows, trim
            return uniqBy(compact(each(this.multisearchText.trim().split(newlineCharacter), function (value) {
                return value.trim();
            })));
        }
    }, {
        key: 'toggleMultisearch',
        value: function toggleMultisearch() {
            var _this = this;

            if (this.isActive) {
                this.$timeout(function () {
                    _this.isActive = false;
                    _this.moveFocus('#headerSearch');
                });
            } else {
                this.searchMultisearchService.updateMultisearchItems().then(function (multisearchItems) {
                    if (multisearchItems && multisearchItems.length > 0) {
                        _this.multisearchText = multisearchItems.join(newlineCharacter);
                    }
                });
                this.$timeout(function () {
                    _this.isActive = true;
                    _this.moveFocus('#multisearch-textbox');
                });
            }
        }
    }, {
        key: 'onPaste',
        value: function onPaste($event) {
            var _this2 = this;

            $event.preventDefault();
            var clipboardData = this.$window.clipboardData ? this.$window.clipboardData.getData('Text') : $event.originalEvent.clipboardData.getData('text/plain');

            if (clipboardData === undefined || !clipboardData.trim()) {
                return;
            }

            clipboardData = clipboardData.trim();
            // Convert a comma seperated list to newline seperated list (must not be already newline seperated)
            // Regex will replace all commas and also trim (\s*)
            if (clipboardData.indexOf(newlineCharacter) === -1) {
                clipboardData = replace(clipboardData, /\s*,\s*/g, newlineCharacter);
            }

            // Find out where the cursor is
            var cursorStart = $event.currentTarget.selectionStart;
            var cursorEnd = $event.currentTarget.selectionEnd;
            // Insert and replace selection (if there is any)
            this.multisearchText = this.multisearchText.substr(0, cursorStart) + clipboardData + this.multisearchText.substr(cursorEnd);

            // Move the cursor to the end of the pasted string
            var targetCursorPosition = cursorStart + clipboardData.length;
            this.$timeout(function () {
                $event.currentTarget.setSelectionRange(targetCursorPosition, targetCursorPosition);
                _this2.updateScroll($event.currentTarget, targetCursorPosition);
            });
        }
    }, {
        key: 'updateScroll',
        value: function updateScroll(textareaElement, cursorPosition) {
            var lineHeight = 41; // Line height is from search-multisearch.component.less
            var lineNumberOfCursor = this.getNumberofItems(each(this.multisearchText.substring(0, cursorPosition).trim().split(newlineCharacter)));
            var bottomOfContent = lineHeight * lineNumberOfCursor;
            var topOfContent = bottomOfContent - lineHeight > 0 ? bottomOfContent - lineHeight : 0;

            if (bottomOfContent > textareaElement.scrollTop) {
                textareaElement.scrollTop = topOfContent;
            }
        }
    }, {
        key: 'onKeydown',
        value: function onKeydown($event) {
            switch ($event.keyCode) {
                // Escape
                case key.esc:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.toggleMultisearch();
                    break;
                // Others
                default:
                    break;
            }
        }
    }, {
        key: 'getNumberofItems',
        value: function getNumberofItems() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getMultisearchList();

            return items.length;
        }
    }, {
        key: 'isOverMaximumLimit',
        value: function isOverMaximumLimit() {
            var listLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getNumberofItems();

            return listLength > this.maximumItemsToSearch;
        }
    }, {
        key: 'executeMultisearch',
        value: function executeMultisearch() {
            var _this3 = this;

            var multisearchList = this.getMultisearchList();

            // Validation check
            if (this.isOverMaximumLimit(multisearchList.length)) {
                return;
            }

            this.searchMultisearchService.updateMultisearchItems(multisearchList.join(',')).then(function (multisearchItems) {
                var firstItem = multisearchItems[0];
                if (!firstItem || firstItem.length < 1) {
                    return;
                }

                _this3.$state.go('shop.search', { searchTerm: firstItem, multisearchItems: multisearchItems.join(',') }, { inherit: false, reload: true });

                if (angular.isFunction(_this3.onMultisearch)) {
                    _this3.onMultisearch();
                }
            });
        }
    }]);

    return SearchMultisearchController;
}();

var searchMultisearchComponentDefinition = {
    bindings: {
        isActive: '=?',
        searchTerm: '=?',
        onMultisearch: '&?'
    },
    controller: ['$state', '$timeout', '$window', 'MoveFocus', 'Settings', 'SearchMultisearchService', SearchMultisearchController],
    template: __webpack_require__(519).trim()
};

module.exports = {
    SearchMultisearchController: SearchMultisearchController,
    searchMultisearchComponentDefinition: searchMultisearchComponentDefinition
};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<div class=\"searchMultisearch-wrapper\" ng-class=\"{'is-active': $ctrl.isActive}\" ng-switch=\"$ctrl.isActive\">\r\n    <div id=\"multisearchLinkContainer\" ng-switch-when=\"false\">\r\n        <button\r\n            class=\"searchMultisearch-activateButton\"\r\n            type=\"button\"\r\n            ng-click=\"$ctrl.toggleMultisearch()\">\r\n                <div class=\"searchMultisearch-activateButtonWrapper\">\r\n                    <i class=\"iconww-List searchMultisearch-activateButtonIcon\"></i>\r\n                    <span>Search for a list of items</span>\r\n                </div>\r\n        </button>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"true\">\r\n        <h5 class=\"searchMultisearch-activeHeader\">\r\n          <i class=\"iconww-List searchMultisearch-activeHeaderIcon\"></i>\r\n          <span>Type or paste your list below</span>\r\n        </h5>\r\n\r\n        <div class=\"searchMultisearch-textboxWrapper\">\r\n            <label id=\"multisearch-srMessage\" for=\"multisearch-textbox\" class=\"sr-only\">\r\n                <span id=\"multisearchErrorMessage\" ng-if=\"$ctrl.isOverMaximumLimit()\">{{::$ctrl.searchLimitErrorMessage}} There are currently {{$ctrl.getNumberofItems()}} items.</span>\r\n                <span>Search with a list of items. Begin by typing an item and pressing the enter key to enter another item.</span>\r\n            </label>\r\n            <textarea\r\n              id=\"multisearch-textbox\"\r\n              name=\"multisearch\"\r\n              class=\"searchMultisearch-textbox\"\r\n              autocomplete=\"off\"\r\n              placeholder=\"e.g. milk &#x000A;bread &#x000A;cheese\"\r\n              ng-model=\"$ctrl.multisearchText\"\r\n              ng-paste=\"$ctrl.onPaste($event)\"\r\n              ng-keydown=\"$ctrl.onKeydown($event)\">\r\n            </textarea>\r\n        </div>\r\n        <div class=\"searchMultisearch-errorMessage\" ng-show=\"$ctrl.isOverMaximumLimit()\">{{::$ctrl.searchLimitErrorMessage}}</div>\r\n\r\n        <div class=\"searchMultisearch-actionsWrapper\">\r\n            <button\r\n                class=\"linkButton searchMultisearch-iconButton\"\r\n                type=\"button\"\r\n                ng-click=\"$ctrl.toggleMultisearch()\"><i class=\"searchMultisearch-cancelButton iconww-Cross\"></i>   Cancel</button>\r\n            <button\r\n                class=\"button button--primary searchMultisearch-searchButton\"\r\n                type=\"button\"\r\n                ng-click=\"$ctrl.executeMultisearch()\"\r\n                ng-disabled=\"$ctrl.isOverMaximumLimit()\">\r\n                    <div class=\"searchMultisearch-searchButtonWrapper\">\r\n                        <span class=\"searchMultisearch-searchButtonText\">Search</span>\r\n                        <i class=\"iconww-Search\"></i>\r\n                    </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    find = _require.find;

var SearchNavigationController = function () {
    function SearchNavigationController($scope, $state, breakpointsService, searchService, multisearchService) {
        _classCallCheck(this, SearchNavigationController);

        this.$scope = $scope;
        this.$state = $state;

        this.breakpointsService = breakpointsService;
        this.searchService = searchService;
        this.multisearchService = multisearchService;
    }

    _createClass(SearchNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isCategoriesExpanded = this.filter ? !!find(this.filter.filters, function (f) {
                return f.Key === 'Category';
            }) : !this.breakpointsService.isInSmallFormat;
            this.isMultisearch = this.multisearchService.isSearchMultisearch();
            this.searchTerms = this.isMultisearch ? this.multisearchItems.split(',') : [this.searchTerm];
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.filter && !changes.filter.isFirstChange()) {
                // This is a hack to update active styles on navigation links.
                // Because search state has `reloadOnSearch: false` it does not trigger
                // $stateChangeSuccess event whenver the query params change. ui-sref-active
                // listens for $stateChangeSuccess in order to update itself. This means the
                // nav links do not get highlighted correctly without this.
                //
                // As long as no children of this scope depend on this event being real this
                // should be safe.
                this.$scope.$broadcast('$stateChangeSuccess');
            }
        }
    }, {
        key: 'getMultisearchParam',
        value: function getMultisearchParam() {
            return this.multisearchItems ? '\'' + this.multisearchItems + '\'' : 'undefined';
        }
    }, {
        key: 'shouldShowCategories',
        value: function shouldShowCategories() {
            return (this.$state.includes('shop.search.products') || this.$state.includes('shop.search.specials')) && this.searchService.categories.length > 0;
        }
    }, {
        key: 'isActiveCategory',
        value: function isActiveCategory(category) {
            var categoryFilter = this.filter ? this.filter.filters.find(function (f) {
                return f.Key === 'Category';
            }) : {};

            return category.NodeId === (categoryFilter && categoryFilter.Items ? categoryFilter.Items[0].Term : null);
        }
    }, {
        key: 'toggleCategories',
        value: function toggleCategories() {
            this.isCategoriesExpanded = !this.isCategoriesExpanded;
        }
    }]);

    return SearchNavigationController;
}();

SearchNavigationController.$inject = ['$scope', '$state', 'BreakpointsService', 'SearchService', 'SearchMultisearchService'];

var searchNavigationComponentDefinition = {
    bindings: {
        searchTerm: '<',
        multisearchItems: '<',
        filter: '<',
        disableNavigationLinks: '<'
    },
    controller: SearchNavigationController,
    template: __webpack_require__(521).trim()
};

module.exports = {
    SearchNavigationController: SearchNavigationController,
    searchNavigationComponentDefinition: searchNavigationComponentDefinition
};

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation\" aria-labelledby=\"searchNavigation-title\">\r\n    <h2 id=\"searchNavigation-title\" class=\"sr-only\">Search results navigation</h2>\r\n\r\n    <ul class=\"navigation-items\">\r\n        <li ng-repeat=\"searchTerm in ::$ctrl.searchTerms track by searchTerm\">\r\n            <a\r\n                aria-controls=\"{{ ::searchTerm }}\"\r\n                aria-expanded=\"{{ ::(searchTerm === $ctrl.searchTerm) }}\"\r\n                ui-sref=\"shop.search({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                ui-sref-opts=\"{ inherit: false, reload: true }\"\r\n                ng-class=\"::($ctrl.isMultisearch ? 'navigation-link' : 'navigation-header navigation-link is-inert')\">\r\n                <span>\r\n                    {{ ::(!$ctrl.isMultisearch ? 'Search: ' : '') + searchTerm }}\r\n                    <span ng-if=\"!$ctrl.searchService.searchCounts.loadingCount && $ctrl.searchTerm === searchTerm && $ctrl.isMultisearch\" class=\"multisearch-count\">({{ ::$ctrl.searchService.searchCounts.Total }})</span>\r\n                    <i ng-if=\"$ctrl.isMultisearch\" ng-class=\"::($ctrl.searchTerm === searchTerm ? 'iconww-ArrowUp' : 'iconww-ArrowDown')\"></i>\r\n                    <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"$ctrl.searchService.searchCounts.loadingCount && isActiveMultisearchItem(searchTerm)\"></wow-loading-spinner>\r\n                </span>\r\n            </a>\r\n\r\n            <ul id=\"{{ ::searchTerm }}\" class=\"navigation-items\" aria-label=\"{{ ::searchTerm }} results\" ng-if=\"::searchTerm === $ctrl.searchTerm\">\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.ProductCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.products({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                        link-text=\"All Products\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.SpecialProductCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.specials({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                        link-text=\"All Specials\"\r\n                        class-modifier=\"is-special\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.RecipeCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.recipes({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }} })\"\r\n                        link-text=\"All Recipes\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.ArticleCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.articles({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }} })\"\r\n                        link-text=\"Articles\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n\r\n    <div ng-if=\"$ctrl.shouldShowCategories()\">\r\n        <button class=\"linkButton navigation-header navigation-link treeNavigation-parent\"\r\n            ng-class=\"{ 'is-open': $ctrl.isCategoriesExpanded }\"\r\n            ng-click=\"$ctrl.toggleCategories()\"\r\n            aria-controls=\"_searchResultCategories\"\r\n            aria-expanded=\"{{ $ctrl.isCategoriesExpanded }}\">\r\n            <span>\r\n                Results by Aisle&nbsp;<i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i>\r\n            </span>\r\n        </button>\r\n\r\n        <ul id=\"_searchResultCategories\" aria-label=\"Search result categories\" class=\"treeNavigation-children\">\r\n            <li ng-repeat=\"category in $ctrl.searchService.categories track by (category.NodeId + $ctrl.isSpecial)\">\r\n                <a class=\"navigation-link\"\r\n                    ui-sref=\"{ searchTerm: '{{ ::$ctrl.searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: 'Category({{ ::category.NodeId }})' }\"\r\n                    ui-sref-opts=\"{ inherit: false }\"\r\n                    ng-class=\"{ 'is-active': $ctrl.isActiveCategory(category) }\">\r\n\r\n                    <span class=\"navigation-linkText\">\r\n                        {{ ::category.Description }}&nbsp;{{ (!$ctrl.searchService.searchCounts.loadingCount && category.ProductCount) ? '(' + category.ProductCount + ')' : '' }}&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n                    </span>\r\n                </a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</nav>\r\n"

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchNavigationLinkController = function SearchNavigationLinkController(searchService) {
    _classCallCheck(this, SearchNavigationLinkController);

    this.searchService = searchService;
};

SearchNavigationLinkController.$inject = ['SearchService'];

var searchNavigationLinkComponentDefinition = {
    bindings: {
        count: '<',
        isDisabled: '<',
        sref: '@',
        linkText: '@',
        classModifier: '@?'
    },
    controller: SearchNavigationLinkController,
    template: __webpack_require__(523).trim()
};

module.exports = {
    SearchNavigationLinkController: SearchNavigationLinkController,
    searchNavigationLinkComponentDefinition: searchNavigationLinkComponentDefinition
};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<a\r\n    class=\"navigation-link\"\r\n    ng-class=\"[$ctrl.classModifier, { 'is-disabled': ($ctrl.count <= 0 || $ctrl.isDisabled) }]\"\r\n    ui-sref=\"{{ $ctrl.sref }}\"\r\n    ui-sref-opts=\"{ inherit: false }\"\r\n    ui-sref-active-eq=\"is-active\">\r\n\r\n    <span>\r\n        {{ ::$ctrl.linkText }}\r\n        <span ng-show=\"!$ctrl.searchService.searchCounts.loadingCount && $ctrl.count != null\">({{ $ctrl.count }})&nbsp;<i class=\"iconww-ArrowRight\"></i></span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"$ctrl.searchService.searchCounts.loadingCount\"></wow-loading-spinner>\r\n    </span>\r\n</a>\r\n"

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    filter = _require.filter,
    some = _require.some,
    _require2 = __webpack_require__(7),
    createProductTiles = _require2.createProductTiles,
    createBundleTiles = _require2.createBundleTiles;

var SearchProductTileListController = function () {
    function SearchProductTileListController(settings, searchService, sortByKeys) {
        _classCallCheck(this, SearchProductTileListController);

        this.settings = settings;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(SearchProductTileListController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.filter) {
                this.sortOptions = {
                    sortContext: this.sortByKeys.SEARCH_RESULTS_KEY,
                    sortTypes: this.getSortTypes(this.settings.search.sortOptions)
                };
            }
        }
    }, {
        key: 'getSortTypes',
        value: function getSortTypes(sortTypes) {
            if (this.isSpecial) {
                sortTypes = filter(sortTypes, function (item) {
                    return item.Value !== 'Special';
                });
            }

            if (this.isList || this.isFilteredByCategory()) {
                sortTypes = filter(sortTypes, function (item) {
                    return item.Value !== 'Aisle';
                });
            }

            return sortTypes;
        }
    }, {
        key: 'isFilteredByCategory',
        value: function isFilteredByCategory() {
            return this.filter && some(this.filter.filters, { Key: 'Category' });
        }
    }, {
        key: 'createTiles',
        value: function createTiles(result) {
            return {
                items: this.isSpecial ? createProductTiles(result.items) : createBundleTiles(result.items),
                totalRecordCount: result.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';
            var searchFilter = arguments[3];

            var cardsPromise = this.isSpecial ? this.searchService.doSearchSpecials(this.searchTerm, pageSize, pageNumber, sortType, searchFilter) : this.searchService.doSearch(this.searchTerm, pageSize, pageNumber, sortType, !!this.isSpecial, searchFilter);

            return cardsPromise.then(function (result) {
                return _this.createTiles(result);
            });
        }
    }]);

    return SearchProductTileListController;
}();

SearchProductTileListController.$inject = ['Settings', 'SearchService', 'SortByKeys'];

var searchProductTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        isSpecial: '<',
        isList: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<'
    },
    controller: SearchProductTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            filter="$ctrl.filter"\n            sort-options="$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n\n            <control>\n                <wow-search-term-tile-list-updater\n                    search-term="$ctrl.searchTerm">\n                </wow-search-term-tile-list-updater>\n            </control>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchProductTileListController: SearchProductTileListController,
    searchProductTileListComponentDefinition: searchProductTileListComponentDefinition
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(21),
    createRecipeTiles = _require.createRecipeTiles;

var SearchRecipeTileListController = function () {
    function SearchRecipeTileListController(settings, searchService, sortByKeys) {
        _classCallCheck(this, SearchRecipeTileListController);

        this.settings = settings;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(SearchRecipeTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.searchService.doSearchRecipes(this.searchTerm, pageSize, pageNumber, sortType).then(function (tiles) {
                return _this.createTiles(tiles);
            });
        }
    }]);

    return SearchRecipeTileListController;
}();

SearchRecipeTileListController.$inject = ['Settings', 'SearchService', 'SortByKeys'];

var searchRecipeTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: SearchRecipeTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchRecipeTileListController: SearchRecipeTileListController,
    searchRecipeTileListComponentDefinition: searchRecipeTileListComponentDefinition
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(23),
    createInspirationTiles = _require.createInspirationTiles;

var SearchInspirationTileListController = function () {
    function SearchInspirationTileListController(settings, searchService) {
        _classCallCheck(this, SearchInspirationTileListController);

        this.settings = settings;
        this.searchService = searchService;
    }

    _createClass(SearchInspirationTileListController, [{
        key: 'createTiles',
        value: function createTiles(result) {
            return {
                items: createInspirationTiles(result.items),
                totalRecordCount: result.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            return this.searchService.doSearchArticles(this.searchTerm, pageSize, pageNumber).then(function (result) {
                return _this.createTiles(result);
            });
        }
    }]);

    return SearchInspirationTileListController;
}();

SearchInspirationTileListController.$inject = ['Settings', 'SearchService'];

var searchInspirationTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<'
    },
    controller: SearchInspirationTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber)">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchInspirationTileListController: SearchInspirationTileListController,
    searchInspirationTileListComponentDefinition: searchInspirationTileListComponentDefinition
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchTermTileListUpdaterController = function () {
    function SearchTermTileListUpdaterController() {
        _classCallCheck(this, SearchTermTileListUpdaterController);
    }

    _createClass(SearchTermTileListUpdaterController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.searchTerm && !changes.searchTerm.isFirstChange()) {
                this.tileList.update();
            }
        }
    }]);

    return SearchTermTileListUpdaterController;
}();

/**
 * @ngdoc component
 * @name wowSearchTermTileListUpdater
 *
 * This component is transcluded into tile list for the purpose of updating
 * the products whenever the search term is changed.
 *
 * This is not useful for the search page itself since changing the search
 * term causes a reload there - this is intended for use in lists when doing
 * free text tags search. Therefore this component is not needed for recipe
 * or inspiration search since those searches are not performed outside of search.
 */


var searchTermTileListUpdaterComponentDefinition = {
    bindings: {
        searchTerm: '<'
    },
    require: {
        tileList: '^wowTileList'
    },
    controller: SearchTermTileListUpdaterController
};

module.exports = {
    SearchTermTileListUpdaterController: SearchTermTileListUpdaterController,
    searchTermTileListUpdaterComponentDefinition: searchTermTileListUpdaterComponentDefinition
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

var SearchPhraseActionService = function SearchPhraseActionService(Restangular, $state, loginService, shopperService, $window, moveFocus, $q, bootstrap, searchMultisearchService, searchService) {
    this._api = Restangular.one('Search');
    this._state = $state;
    this._window = $window;
    this._q = $q;
    this.loginService = loginService;
    this.shopper = shopperService;
    this.multisearchService = searchMultisearchService;
    this.searchService = searchService;
    this._moveFocus = moveFocus;

    this.action = {
        login: 'PromptLogin',
        navigate: 'GoToUrl'
    };

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SearchPhraseActions)) {
        this._setSearchPhraseActions.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SearchPhraseActions));
    }
};

SearchPhraseActionService.prototype._setSearchPhraseActions = function (searchPhraseActions) {
    this.searchPhraseActions = _.keyBy(searchPhraseActions.SearchPhraseActions, function (searchPhraseAction) {
        return searchPhraseAction.Phrase.toLowerCase();
    });
};

SearchPhraseActionService.prototype.getSearchPhraseAction = function (searchTerm) {
    if (this.searchPhraseActions) {
        return this._q.when(searchTerm.toLowerCase() in this.searchPhraseActions && this.searchPhraseActions[searchTerm.toLowerCase()]);
    }

    return this._api.one('SearchPhraseAction').get({
        SearchTerm: searchTerm
    });
};

SearchPhraseActionService.prototype.actionPromptsForLogin = function (searchPhraseAction) {
    return searchPhraseAction.Action === this.action.login && this.shopper.IsGuest;
};

SearchPhraseActionService.prototype.performSearchPhraseAction = function (searchPhraseAction) {
    var _this = this;

    return this._q(function (resolve, reject) {
        if (_this.actionPromptsForLogin(searchPhraseAction)) {
            _this._moveFocus('#loginForm-Email');
            return _this.loginService.promptForLogin(_this.loginService.LoginToContinueMessage).then(resolve);
        } else if (searchPhraseAction.Action === _this.action.navigate) {
            if (searchPhraseAction.Target === 'Blank') {
                _this._state.go('shop.search.external-result', { searchTerm: searchPhraseAction.Phrase }, { inherit: false });
                _this._window.open(searchPhraseAction.URL, '_blank');
            } else {
                _this._window.location.href = searchPhraseAction.URL;
            }
            return reject();
        }
        return resolve();
    });
};

SearchPhraseActionService.prototype.searchRequiresLogin = function (searchPhrase) {
    var _this2 = this;

    return this._q(function (resolve) {
        if (!searchPhrase || searchPhrase === '') {
            resolve(false);
        }
        _this2.getSearchPhraseAction(searchPhrase).then(function (action) {
            if (action) {
                resolve(_this2.actionPromptsForLogin(action) && !_this2.multisearchService.isSearchMultisearch());
            }
            resolve(false);
        });
    });
};

module.exports = SearchPhraseActionService;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SearchMultisearchService = function SearchMultisearchService(Restangular, breakpointsService, $stateParams) {
    this._api = Restangular.one('Search');
    this.breakpoints = breakpointsService;
    this._stateParams = $stateParams;
};

SearchMultisearchService.prototype.updateMultisearchItems = function (multisearchItems) {
    return this._api.one('Multisearch').doPOST({ MultisearchKeys: multisearchItems }).then(function (response) {
        return response.MultisearchItems;
    });
};

SearchMultisearchService.prototype.isSearchTermPartOfMultisearchList = function (searchTerm, multisearchItems) {
    if (!this._stateParams.multisearchItems && !multisearchItems) {
        return false;
    }
    if (!this._stateParams.searchTerm && !searchTerm) {
        return false;
    }

    var searchPhrase = searchTerm || this._stateParams.searchTerm;
    var items = multisearchItems ? multisearchItems.split(',') : this._stateParams.multisearchItems.split(',');
    var listIndex = items.indexOf(searchPhrase);
    if (listIndex < 0) {
        return false;
    }

    return true;
};

SearchMultisearchService.prototype.isSearchMultisearch = function () {
    return this._stateParams.multisearchItems && this.isSearchTermPartOfMultisearchList();
};

module.exports = SearchMultisearchService;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($sce, settingsService, $state, $sanitize) {
    return {
        restrict: 'E',
        scope: {
            isRecipes: '='
        },
        link: function link($scope) {
            $scope.searchTerm = '';
            $scope.originalSearchTerm = $sanitize($state.params.searchTerm);

            $scope.pageName = 'results';
            if ($state.current.name === 'shop.search.products') {
                $scope.pageName = 'products';
            } else if ($state.current.name === 'shop.search.specials') {
                $scope.pageName = 'specials';
            } else if ($state.current.name === 'shop.search.recipes') {
                $scope.pageName = 'recipes';
            } else if ($state.current.name === 'shop.search.articles') {
                $scope.pageName = 'articles';
            }

            settingsService.getSettingValue('Search', 'ZeroSearchResultsMessage').then(function (setting) {
                var emptyProductSearchMessageBeforeAfter = setting.split('{search}');
                $scope.SearchTerm = $state.params.searchTerm;
                $scope.EmptyProductSearchMessageBefore = $sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[0]);
                $scope.EmptyProductSearchMessageAfter = $sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[1]);
            });
        },

        template: __webpack_require__(531).trim()
    };
};

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search-zero-results-wrapper\">\r\n    <h1 class=\"search-zero-results-wrapper-header\">No {{pageName}} found</h1>\r\n    <div class=\"search-zero-results-wrapper-blurb\">\r\n        <span ng-bind-html=\"EmptyProductSearchMessageBefore\"></span>\r\n        {{ SearchTerm }}\r\n        <span ng-bind-html=\"EmptyProductSearchMessageAfter\"></span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($sce, settingsService, $stateParams, searchPhraseActionService, $state, shopper) {
    function SearchExternalResultsController() {
        var _this = this;

        // If the search phrase isn't associated with an action
        // Or if the action was to prompt for login and user is not a guest, do normal search
        searchPhraseActionService.getSearchPhraseAction($stateParams.searchTerm).then(function (action) {
            if (!action || action.Action === searchPhraseActionService.action.login && !shopper.IsGuest) {
                $state.go('shop.search', { searchTerm: $stateParams.searchTerm, multisearchItems: $stateParams.multisearchItems }, { inherit: false, reload: true, location: 'replace' });
            }
        });

        settingsService.getSettingValue('Search', 'SearchResultInNewTab').then(function (setting) {
            var externalResultMessageBeforeAfter = setting.split('{searchTerm}');
            _this.SearchTerm = $stateParams.searchTerm;
            _this.ExternalResultMessageBefore = $sce.trustAsHtml(externalResultMessageBeforeAfter[0]);
            _this.ExternalResultMessageAfter = $sce.trustAsHtml(externalResultMessageBeforeAfter[1]);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SearchExternalResultsController],
        template: '<div class="search-zero-results-wrapper"><div class="search-zero-results-wrapper-blurb"><span ng-bind-html="ctrl.ExternalResultMessageBefore"></span>{{ctrl.SearchTerm}}<span ng-bind-html="ctrl.ExternalResultMessageAfter"></span></div></div>'
    };
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars
var olyDialog = __webpack_require__(13);

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(4);

var orderModuleName = 'wowApp.order';

angular.module(orderModuleName, [olyCommonModule, wowCommonModule, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(534);
__webpack_require__(546);
__webpack_require__(548);
__webpack_require__(563);
__webpack_require__(566);

module.exports = orderModuleName;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp.shop');

wowApp.component('wowCheckoutConfirmation', __webpack_require__(535).checkoutConfirmationControllerComponentDefinition);
wowApp.component('wowOrderConfirmationExportOptions', __webpack_require__(539).orderConfirmationExportOptionsControllerComponentDefinition);
wowApp.component('wowOrderConfirmationPanel', __webpack_require__(541).orderConfirmationPanelControllerComponentDefinition);
wowApp.service('OrderConfirmationEmailService', ['Restangular', __webpack_require__(543)]);
wowApp.component('wowOrderConfirmationPrint', __webpack_require__(544).orderConfirmationPrintControllerComponentDefinition);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var preposition = {
    courier: 'To:',
    pickup: 'From:'
};

var orderAnalyticsMapper = __webpack_require__(536),
    _ = __webpack_require__(1),
    $ = __webpack_require__(2);
var orderAnalyticsDtmMapper = __webpack_require__(537);

var CheckoutConfirmationController = function () {
    function CheckoutConfirmationController($scope, gtm, shopperService, settingsService, analytics, deploymentSwitchService, packagingPreferenceService, settings) {
        _classCallCheck(this, CheckoutConfirmationController);

        this.orderId = this.confirmation.Order.OrderId;
        this.orderStatus = this.confirmation.Order.OrderStatus;
        this.orderCancelled = this.orderStatus === 'Cancelled';
        this.$scope = $scope;
        this.gtm = gtm;
        this.shopperService = shopperService;
        this.settingsService = settingsService;
        this.analytics = analytics;
        this.deploymentSwitchService = deploymentSwitchService;
        this.packagingPreferenceService = packagingPreferenceService;
        this.settings = settings;
    }

    _createClass(CheckoutConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var deliveryMethod = this.confirmation.Order.DeliveryMethod.toLowerCase();
            this.completedOrder = this.confirmation.Order;

            this.orderMethodMessage = deliveryMethod === 'courier' ? this.settings.checkoutConfirmation.deliveryMethodMessageDeliver : this.settings.checkoutConfirmation.deliveryMethodMessagePickup;

            this.orderMethodPreposition = preposition[deliveryMethod];
            this.orderRecipient = this.getRecipientText(deliveryMethod);

            this.settingsService.getSettingValue('EverydayRewards', 'CardName').then(function (setting) {
                _this.RewardsCardName = setting;
            });
            this.settingsService.getSettingValue('Checkout', 'EVoucherDisplayName').then(function (setting) {
                _this.EVoucherDisplayName = setting;
            });

            if (this.confirmation.Order) {
                var orderWithoutDetail = _.cloneDeep(this.confirmation.Order);
                delete orderWithoutDetail.PaymentBreakdown;
                var analyticsObj = {
                    data: {
                        order: orderWithoutDetail,
                        orderDetails: this.confirmation.Order,
                        shopper: this.shopperService,
                        shopperDetails: undefined,
                        rewardsPointsConversionBase: this.settingsService.settings.loyalty.rewardsConversionBase
                    }
                };
                if (!this.confirmation.IsPushedToGtm) {
                    analyticsObj.gtmMapperFn = orderAnalyticsMapper;
                }
                if (!this.confirmation.IsPushedToDtm) {
                    analyticsObj.dtmMapperFn = orderAnalyticsDtmMapper;
                }
                this.analytics.push(analyticsObj);
                if (this.deploymentSwitchService.wos6359 && this.settings.checkout.enablePackagingPreference) {
                    this.packagingPreferenceService.pushToAnalytics(orderWithoutDetail.PackagingPreference);
                }
            }

            this.settingsService.getSettingValue('SiteCensus', 'ResponsysTrackingPixel').then(function (urlSetting) {
                if (urlSetting) {
                    _this.addResponsysTrackingPixelToBody(_this.createSourceString(urlSetting));
                }
            });
        }
    }, {
        key: 'getRecipientText',
        value: function getRecipientText(deliveryMethod) {
            return deliveryMethod === 'courier' ? this.completedOrder.FirstName + ' ' + this.completedOrder.LastName : this.completedOrder.PickUpStoreName;
        }
    }, {
        key: 'stringFormat',
        value: function stringFormat(string, args) {
            _.forEach(args, function (value, key) {
                string = string.replace('{' + key + '}', value);
            });
            return string;
        }
    }, {
        key: 'calculateQuantity',
        value: function calculateQuantity(products) {
            return _.reduce(products, function (sum, product) {
                return sum + product.Quantity;
            }, 0);
        }
    }, {
        key: 'createSourceString',
        value: function createSourceString(urlSetting) {
            return this.stringFormat(urlSetting, {
                OrderID: this.completedOrder.OrderId,
                OrderTotal: this.completedOrder.TotalIncludingGst,
                OrderQty: this.calculateQuantity(this.completedOrder.Products),
                ShopperID: this.shopperService.Id
            });
        }
    }, {
        key: 'addResponsysTrackingPixelToBody',
        value: function addResponsysTrackingPixelToBody(sourceString) {
            $('<img id="responsysTrackingPixel" src="' + sourceString + '">').appendTo('body');

            this.$scope.$on('$destroy', function () {
                $('#responsysTrackingPixel').remove();
            });
        }
    }]);

    return CheckoutConfirmationController;
}();

var checkoutConfirmationControllerComponentDefinition = {
    bindings: {
        confirmation: '=',
        showSaveCard: '=saveCard'
    },
    controller: ['$scope', 'GtmService', 'ShopperService', 'SettingsService', 'AnalyticsService', 'DeploymentSwitchService', 'PackagingPreferenceService', 'Settings', CheckoutConfirmationController],
    template: __webpack_require__(538).trim()
};

module.exports = {
    CheckoutConfirmationController: CheckoutConfirmationController,
    checkoutConfirmationControllerComponentDefinition: checkoutConfirmationControllerComponentDefinition
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

module.exports = function (data) {
    return {
        event: 'purchase',
        shopper: {
            Id: data.shopper.Id,
            ABN: data.shopper.ABN,
            OrderCount: data.shopper.OrderCount
        },
        ecommerce: {
            currencyCode: 'AUD',
            purchase: {
                actionField: {
                    id: data.order.OrderId,
                    affiliation: data.order.PickupStoreName,
                    revenue: data.order.TotalIncludingGst,
                    shipping: data.order.DeliveryFee,
                    coupon: data.order.CouponIDs.join('|')
                },
                products: _.map(data.order.Products, function (product) {
                    return {
                        name: product.Name,
                        id: product.Stockcode,
                        price: product.SalePrice,
                        brand: product.Brand,
                        quantity: product.Quantity
                    };
                })
            }
        }
    };
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);
var loyaltyPointsCalculator = __webpack_require__(14);
var getCategories = __webpack_require__(33);

function formatDisplayDate(dateObject) {
    return dateObject ? _.padStart(dateObject.getDate(), 2, 0) + '/' + _.padStart(dateObject.getMonth() + 1, 2, 0) + '/' + dateObject.getFullYear() : '';
}

function buildDeliveryTime(order) {
    return formatDisplayDate(new Date(order.DeliveryDate)) + ' between ' + order.DeliveryStartTime + ' and ' + order.DeliveryEndTime;
}

function sumTransactionTotal(paymentBreakdown) {
    return paymentBreakdown.Account + paymentBreakdown.CreditCard + paymentBreakdown.PayPal + paymentBreakdown.GiftCard + paymentBreakdown.WowRewards + paymentBreakdown.Coupon + paymentBreakdown.eVoucher;
}

/**
 * Adobe Digital Data Transaction node DataLayer.
 */
module.exports = function (data) {
    return {
        transaction: {
            transactionID: data.orderDetails.OrderId,
            profile: {
                status: data.orderDetails.ShopperStatusId,
                shippingAddress: {
                    deliveryTime: buildDeliveryTime(data.orderDetails)
                }
            },
            total: {
                basePrice: _.reduce(data.orderDetails.Products, function (result, curProduct) {
                    return result + curProduct.Subtotal;
                }, 0),
                promoCode: data.orderDetails.CouponIDs.join('|'),
                woolworthsRewards: data.orderDetails.RewardsCardNumber,
                voucherDiscount: data.orderDetails.StoreCreditTotal,
                currency: 'AUD',
                taxRate: data.orderDetails.TaxRate,
                staffDiscount: data.orderDetails.TeamDiscount,
                shipping: data.orderDetails.DeliveryFee,
                shippingMethod: data.orderDetails.DeliveryMethod,
                priceWithTax: data.orderDetails.TotalIncludingGst,
                transactionTotal: sumTransactionTotal(data.orderDetails.PaymentBreakdown),
                transactionTotalSplitCC: data.orderDetails.PaymentBreakdown.CreditCard,
                transactionTotalSplitPayPal: data.orderDetails.PaymentBreakdown.PayPal,
                transactionTotalSplitGC: data.orderDetails.PaymentBreakdown.GiftCard,
                transactionTotalSplitRewards: data.orderDetails.PaymentBreakdown.WowRewards,
                transactionTotalSplitPromoCodes: data.orderDetails.PaymentBreakdown.Coupon,
                transactionTotalSplitEVoucher: data.orderDetails.PaymentBreakdown.eVoucher,
                transactionTotalSplitOnAccount: data.orderDetails.PaymentBreakdown.Account,
                totalPointsEarned: loyaltyPointsCalculator(data.orderDetails.TotalDeferredPoints, data.rewardsPointsConversionBase, false),
                paymentType: _.reduce(data.orderDetails.PaymentBreakdown, function (result, current, key) {
                    // Append paymentType only when the payment type is used in the order.
                    if (current === 0) return result;

                    if (result === '') {
                        return '' + key;
                    }
                    return result + '|' + key;
                }, '')
            },
            item: _.map(data.orderDetails.Products, function (product) {
                return {
                    product: {
                        productInfo: {
                            productID: product.Stockcode,
                            productName: product.Name,
                            price: product.SalePrice,
                            variant: product.Unit
                        },
                        category: {
                            primaryCategory: getCategories(product.Source).primaryCategory,
                            subCategory: getCategories(product.Source).subCategory,
                            productBrand: product.Brand,
                            sapDepartment: product.SapCategories ? product.SapCategories.SapDepartmentName : '',
                            sapCategory: product.SapCategories ? product.SapCategories.SapCategoryName : '',
                            sapSubCategory: product.SapCategories ? product.SapCategories.SapSubCategoryName : '',
                            sapSegment: product.SapCategories ? product.SapCategories.SapSegmentName : ''
                        },
                        quantity: product.Quantity,
                        price: product.Subtotal,
                        attributes: {
                            promotionType: product.IsBundle ? 'Bundle' : ''
                        }
                    }
                };
            })
        }
    };
};

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkoutConfirmation\" ng-if=\"$ctrl.orderId\">\r\n    <div class=\"checkoutConfirmation-message\" ng-switch=\"$ctrl.orderStatus\">\r\n        <div wow-html-setting ng-switch-when=\"Placed\" setting-group=\"Order\" setting-name=\"OrderConfirmedMessage\"></div>\r\n        <div wow-html-setting ng-switch-when=\"Cancelled\" setting-group=\"Order\" setting-name=\"OrderCancelledMessage\"></div>\r\n        <div wow-html-setting ng-switch-default></div>\r\n    </div>\r\n    <div class=\"checkoutConfirmation-orderDetails\">\r\n        <div class=\"checkoutConfirmation-orderDetailsRow\">\r\n            <div class=\"checkoutConfirmation-label\">Order number: </div>\r\n            <div class=\"checkoutConfirmation-orderDetailsText\">{{$ctrl.orderId}}</div>\r\n        </div>\r\n        <div class=\"checkoutConfirmation-orderDetailsRow\">\r\n            <div class=\"checkoutConfirmation-label\">Order created: </div>\r\n            <div class=\"checkoutConfirmation-orderDetailsText\">{{$ctrl.completedOrder.CreatedDate | date: 'dd MMM yyyy'}}</div>\r\n        </div>\r\n        <div ng-if=\"!$ctrl.orderCancelled\">\r\n            <div class=\"checkoutConfirmation-orderMethod\">\r\n                {{$ctrl.orderMethodMessage}}\r\n            </div>\r\n            <div class=\"checkoutConfirmation-orderMethodBlock\">\r\n                <div class=\"checkoutConfirmation-orderMethodBlockLabel\">{{orderMethodPreposition}}</div>\r\n                <div class=\"checkoutConfirmation-orderMethodBlockDescription\">\r\n                    {{$ctrl.orderRecipient}}<br/>\r\n                    {{$ctrl.completedOrder.DeliveryStreet1}}<br/>\r\n                    <span ng-show=\"$ctrl.completedOrder.DeliveryStreet2\">{{$ctrl.completedOrder.DeliveryStreet2}}<br /></span>\r\n                    {{$ctrl.completedOrder.DeliverySuburb}}, {{$ctrl.completedOrder.DeliveryPostalCode}}\r\n                </div>\r\n            </div>\r\n            <div class=\"checkoutConfirmation-orderMethodBlock\">\r\n                <div class=\"checkoutConfirmation-orderMethodBlockLabel\">On:</div>\r\n                <div class=\"checkoutConfirmation-orderMethodBlockDescription\">\r\n                    {{$ctrl.completedOrder.DeliveryDate | date: 'EEEE dd MMM'}} <br/>\r\n                    between {{$ctrl.completedOrder.DeliveryStartTime}} and {{$ctrl.completedOrder.DeliveryEndTime}}.\r\n                </div>\r\n            </div>\r\n            <div class=\"checkoutConfirmation-summary\">\r\n                <div class=\"checkoutConfirmation-summaryRow\">\r\n                    <div class=\"checkoutConfirmation-summaryLabel\">Subtotal</div>\r\n                    <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.Subtotal | currency}}</div>\r\n                </div>\r\n                <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.OrderDiscountWithoutTeamDiscount > 0\">\r\n                    <div class=\"checkoutConfirmation-summaryLabel\">Order discount</div>\r\n                    <div class=\"checkoutConfirmation-summaryDeduction\">-{{$ctrl.completedOrder.OrderDiscountWithoutTeamDiscount | currency}}</div>\r\n                </div>\r\n                <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.TeamDiscount > 0\">\r\n                    <div class=\"checkoutConfirmation-summaryLabel\">Staff discount</div>\r\n                    <div class=\"checkoutConfirmation-summaryDeduction\">-{{$ctrl.completedOrder.TeamDiscount | currency}}</div>\r\n                </div>\r\n                <div class=\"checkoutConfirmation-summaryRow\">\r\n                    <div class=\"checkoutConfirmation-summaryLabel\">Delivery fee</div>\r\n                    <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.DeliveryFee | currency}}</div>\r\n                </div>\r\n                <div class=\"checkoutConfirmation-summaryTotal\">\r\n                    <div class=\"checkoutConfirmation-summaryTotalLabel\">Total <span class=\"checkoutConfirmation-summaryTotalSideNote\">(incl GST)</span></div>\r\n                    <div class=\"checkoutConfirmation-summaryTotalAmount\">{{$ctrl.completedOrder.TotalIncludingGst | currency}}</div>\r\n                </div>\r\n\r\n                <div ng-if=\"$ctrl.completedOrder.PaymentBreakdown\">\r\n                    <hr/>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.Coupon > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by Coupon</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.Coupon | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.eVoucher > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by {{$ctrl.EVoucherDisplayName}}</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.eVoucher | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.WowRewards > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by {{::$ctrl.RewardsCardName}}</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.WowRewards | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.GiftCard > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by Gift Card</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.GiftCard | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.CreditCard > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by Credit Card</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.CreditCard | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.Account > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Charged to Account</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.Account | currency}}</div>\r\n                    </div>\r\n                    <div class=\"checkoutConfirmation-summaryRow\" ng-if=\"$ctrl.completedOrder.PaymentBreakdown.PayPal > 0\">\r\n                        <div class=\"checkoutConfirmation-summaryLabel\">Paid by PayPal</div>\r\n                        <div class=\"checkoutConfirmation-summaryAmount\">{{$ctrl.completedOrder.PaymentBreakdown.PayPal | currency}}</div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div ng-if=\"!$ctrl.orderCancelled\">\r\n        <div class=\"checkoutConfirmation-saveCard\" ng-if=\"$ctrl.showSaveCard\">\r\n            <wow-save-card order-id=\"{{$ctrl.orderId}}\"></wow-save-card>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationExportOptionsController = function () {
    function OrderConfirmationExportOptionsController(settingsService, $state, $element, orderConfirmationEmailService, moveFocus, $q, $timeout, breakpointsService, analyticsService) {
        _classCallCheck(this, OrderConfirmationExportOptionsController);

        this.showPrintOption = false;
        this.showEmailOption = false;
        this.showDownloadOption = false;
        this.isEmailFormVisible = false;
        this.settingsService = settingsService;
        this.$state = $state;
        this.$element = $element;
        this.orderConfirmationEmailService = orderConfirmationEmailService;
        this.moveFocus = moveFocus;
        this.$q = $q;
        this.$timeout = $timeout;
        this.breakpointsService = breakpointsService;
        this.analyticsService = analyticsService;
    }

    _createClass(OrderConfirmationExportOptionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.formSendOrderConfirmation = {};
            if (this.$state.params.orderId) {
                this.orderId = this.$state.params.orderId;
            }

            this.settingsService.getSettingValue('OneSite', 'EnableOrderConfirmationExportOptions').then(function (exportOptions) {
                if (exportOptions.length > 0) {
                    exportOptions.forEach(function (option) {
                        var cleanedOption = option.trim().toLowerCase();
                        switch (cleanedOption) {
                            case 'print':
                                _this.showPrintOption = true;
                                break;
                            case 'email':
                                _this.showEmailOption = true;
                                break;
                            case 'download':
                                _this.showDownloadOption = true;
                                break;
                            default:
                        }
                    });
                }
            });
        }
    }, {
        key: 'showExportOptions',
        value: function showExportOptions() {
            return (this.showPrintOption || this.showEmailOption || this.showDownloadOption) && this.$state.includes('shop.confirmation');
        }
    }, {
        key: 'toggleEmailSection',
        value: function toggleEmailSection() {
            this.isEmailFormVisible = !this.isEmailFormVisible;
            if (this.isEmailFormVisible) {
                this.resetOrderConfirmFormEmail();
            }
            this.errorMessage = undefined;
        }
    }, {
        key: 'resetOrderConfirmFormEmail',
        value: function resetOrderConfirmFormEmail() {
            if (this.sendOrderConfirmationForm) {
                this.sendOrderConfirmationForm.$setPristine();
                this.sendOrderConfirmationForm.$setUntouched();
                this.confirm = {};
            }
            this.emailSentMessage = null;
            this.errorMessage = null;
        }
    }, {
        key: 'emailSentSuccessfull',
        value: function emailSentSuccessfull() {
            var _this2 = this;

            this.errorMessage = null;
            this.emailSentMessage = 'Order confirmation email has been sent successfully';
            this.moveFocus('.orderConfirmationExportOptions-sendEmail');
            this.$timeout(function () {
                _this2.resetOrderConfirmFormEmail();
            }, 5000);
        }
    }, {
        key: 'showEmailErrorMessage',
        value: function showEmailErrorMessage(message) {
            this.emailSentMessage = null;
            this.errorMessage = message;
            this.analyticsService.pushError(message);
        }
    }, {
        key: 'sendOrderConfirmation',
        value: function sendOrderConfirmation() {
            var _this3 = this;

            if (this.$element != null && this.$element.find('#sendOrderConfirmationForm-Email').val().length === 0) {
                // It is a hack as ng-model (scope.confirm.email) is not updated until email is entered in right format
                this.showEmailErrorMessage('Email address is required.');
            } else if (!this.sendOrderConfirmationForm.$valid) {
                // don't submit to server if client side is not valid
                this.showEmailErrorMessage('Email address is required to be in the format of example@example.com.');
            } else if (this.emailSentMessage) {
                this.resetOrderConfirmFormEmail();
            } else {
                this.sendingEmail = true;
                this.orderConfirmationEmailService.sendOrderConfirmationEmail(this.orderId, this.confirm.email).then(function (isEmailSend) {
                    if (isEmailSend) {
                        _this3.emailSentSuccessfull();
                    } else {
                        _this3.showEmailErrorMessage('There is an error sending the email.');
                    }
                    _this3.sendingEmail = false;
                });
            }
        }
    }]);

    return OrderConfirmationExportOptionsController;
}();

var orderConfirmationExportOptionsControllerComponentDefinition = {
    bindings: {
        emailFormVisibility: '='
    },
    controller: ['SettingsService', '$state', '$element', 'OrderConfirmationEmailService', 'MoveFocus', '$q', '$timeout', 'BreakpointsService', 'AnalyticsService', OrderConfirmationExportOptionsController],
    template: __webpack_require__(540).trim()
};

module.exports = {
    OrderConfirmationExportOptionsController: OrderConfirmationExportOptionsController,
    orderConfirmationExportOptionsControllerComponentDefinition: orderConfirmationExportOptionsControllerComponentDefinition
};

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderConfirmationExportOptions\">\r\n    <span aria-live=\"polite\" class=\"sr-only\" aria-atomic=\"true\" ng-bind=\"$ctrl.emailSentMessage\"></span>\r\n    <div class=\"orderConfirmationExportOptions-exportOptions\" ng-show=\"$ctrl.showExportOptions()\">\r\n        <a class=\"orderConfirmationExportOptions-exportOptionLink\" ng-href=\"/Checkout/PrintConfirmation?OrderID={{$ctrl.orderId}}\" target=\"_blank\">\r\n            <span class=\"sr-only\">Print order confirmation</span>\r\n            <i ng-show=\"$ctrl.showPrintOption\" class=\"icon-printer orderConfirmationExportOptions-exportOptionIcon\"></i>\r\n        </a>\r\n        <a class=\"orderConfirmationExportOptions-exportOptionLink _orderConfirmationExportOptions-sendEmailIcon\" href=\"javascript://\" ng-click=\"$ctrl.toggleEmailSection()\" oly-move-focus=\"sendOrderConfirmationForm-Email\">\r\n            <span class=\"sr-only\">Send order confirmation email</span>\r\n            <i ng-show=\"$ctrl.showEmailOption\" class=\"icon-email orderConfirmationExportOptions-exportOptionIcon\"></i>\r\n        </a>\r\n    </div>\r\n    <div class=\"orderConfirmationExportOptions-sendEmailContainer\" ng-show=\"$ctrl.isEmailFormVisible\">\r\n        <form name=\"$ctrl.sendOrderConfirmationForm\" ng-submit=\"$ctrl.sendOrderConfirmation()\" role=\"form\" novalidate>\r\n            <oly-form-validation-summary user-message=\"{{$ctrl.errorMessage}}\"></oly-form-validation-summary>\r\n            <fieldset>\r\n                <legend class=\"sr-only\">Send order confirmation</legend>\r\n                <div class=\"emailInputContainer\">\r\n                    <wow-input-container class=\"sendOrderConfirmationForm-input\">\r\n                        <label for=\"sendOrderConfirmationForm-Email\" class=\"inputLabel\">\r\n                            Please enter a email address\r\n                        </label>\r\n                        <input id=\"sendOrderConfirmationForm-Email\" type=\"email\" name=\"Email\" class=\"addNew\" ng-model=\"$ctrl.confirm.email\" required aria-required=\"true\" autocomplete=\"off\" wow-email-validator />\r\n                    </wow-input-container>\r\n                    <div class=\"orderConfirmationExportOptions-sendContainer\">\r\n                        <oly-button class=\"orderConfirmationExportOptions-sendEmailButton\" loading=\"{state: sendingEmail, message: 'Please wait, sending email'}\">\r\n                            <button type=\"submit\" ng-model=\"button\" class=\"button button--primary orderConfirmationExportOptions-sendEmail\">\r\n                                <span ng-hide=\"$ctrl.emailSentMessage\">\r\n                                    Send\r\n                                    <span ng-if=\"$ctrl.sendingEmail\" class=\"sr-only\">order confirmation email for order id {{$ctrl.orderId}}</span>\r\n                                </span>\r\n                                <i class=\"orderConfirmationExportOptions-tickMark iconww-Tick\" id=\"successful-tick\" ng-show=\"$ctrl.emailSentMessage\"></i>\r\n                            </button>\r\n                        </oly-button>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n         <button type=\"button\" class=\"linkButton orderConfirmationExportOptions-cancelButton\" ng-click=\"$ctrl.toggleEmailSection()\">Cancel</button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationPanelController = function () {
    function OrderConfirmationPanelController() {
        _classCallCheck(this, OrderConfirmationPanelController);
    }

    _createClass(OrderConfirmationPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            this.status = 'loading';
            this.confirmation = this.order;
            // Todo: unwrap confirmation so that we're just dealing with the order :/
            this.orderCancelled = this.order.Order.OrderStatus === 'Cancelled';
            if (this.confirmation) {
                this.status = 'ordercomfirmation';
            }
        }
    }]);

    return OrderConfirmationPanelController;
}();

var orderConfirmationPanelControllerComponentDefinition = {
    bindings: {
        order: '=',
        saveCard: '='
    },
    controller: OrderConfirmationPanelController,
    template: __webpack_require__(542).trim()
};

module.exports = {
    OrderConfirmationPanelController: OrderConfirmationPanelController,
    orderConfirmationPanelControllerComponentDefinition: orderConfirmationPanelControllerComponentDefinition
};

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderConfirmationPanel orderConfirmationPanel-scrollingContent\" ng-switch=\"$ctrl.status\">\r\n    <wow-checkout-confirmation ng-switch-when=\"ordercomfirmation\" confirmation=\"::$ctrl.confirmation\" save-card=\"::$ctrl.saveCard\"></wow-checkout-confirmation>\r\n    <wow-order-confirmation-export-options ng-switch-when=\"ordercomfirmation\" ng-if=\"!$ctrl.orderCancelled\"></wow-order-confirmation-export-options>\r\n    <wow-loading-spinner ng-switch-when=\"loading\"></wow-loading-spinner>\r\n</div>\r\n"

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OrderConfirmationEmailService = function OrderConfirmationEmailService(restangular) {
    this._api = restangular.one('Checkout');
};

OrderConfirmationEmailService.prototype.sendOrderConfirmationEmail = function (orderId, toAddress) {
    return this._api.post('ConfirmOrderEmail', { OrderId: orderId, ToAddress: toAddress });
};

module.exports = OrderConfirmationEmailService;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationPrintController = function () {
    function OrderConfirmationPrintController($timeout, settings) {
        _classCallCheck(this, OrderConfirmationPrintController);

        this.recipientHeader = this.isDelivery() ? settings.orderConfirmation.deliveryMessage : settings.orderConfirmation.pickupMessage;
        $timeout(function () {
            return window.print();
        }, 0);
    }

    _createClass(OrderConfirmationPrintController, [{
        key: 'isDelivery',
        value: function isDelivery() {
            return this.order.DeliveryMethod === 'Courier' || this.order.DeliveryMethod === 'TPCour';
        }
    }]);

    return OrderConfirmationPrintController;
}();

var orderConfirmationPrintControllerComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: ['$timeout', 'Settings', OrderConfirmationPrintController],
    template: __webpack_require__(545).trim()
};

module.exports = {
    OrderConfirmationPrintController: OrderConfirmationPrintController,
    orderConfirmationPrintControllerComponentDefinition: orderConfirmationPrintControllerComponentDefinition
};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmationprint\">\r\n\t<h1 class=\"confirmationprint-heading\">Confirmation - Thank you for shopping with Woolworths</h1>\r\n\t<div class=\"confirmationprint-wrapper\">\r\n\t\t<div class=\"confirmationprint-header\">\r\n\t\t\t<div class=\"confirmationprint-icon\">\r\n\t\t\t\t<img src=\"/images/trolley/bg-trolley-cart.png\">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"confirmationprint-headerContent\">\r\n\t\t\t\t<h2 class=\"confirmationprint-headerTitle\">Grocery Items</h2>\r\n\r\n\t\t\t\t<div class=\"confirmationprint-headerTop\">\r\n\t\t\t\t\t<label class=\"confirmationprint-headerLabel\">Order Number</label> #{{ ::$ctrl.order.OrderId}}\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"confirmationprint-headerTop\">\r\n\t\t\t\t\t<label class=\"confirmationprint-headerLabel\">Order created</label> {{ ::$ctrl.order.CreatedDate | date: 'dd MMM yyyy'}}\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"confirmationprint-line\"></div>\r\n\t\t<div class=\"confirmationprint-header\">\r\n\t\t\t<div class=\"confirmationprint-headerBottom\">\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\">{{ ::$ctrl.recipientHeader}}</div>\r\n\t\t\t\t<div class=\"\">\r\n\t\t\t\t\t<span ng-if=\"$ctrl.isDelivery()\">{{ ::$ctrl.order.FirstName}} {{ ::$ctrl.order.LastName}}<br/></span> {{ ::$ctrl.order.DeliveryStreet1}}\r\n\t\t\t\t\t<br/>\r\n\t\t\t\t\t<span ng-show=\"$ctrl.order.DeliveryStreet2\">{{ ::$ctrl.order.DeliveryStreet2}}<br /></span> {{ ::$ctrl.order.DeliverySuburb}},\r\n\t\t\t\t\t{{ $ctrl.order.DeliveryPostalCode}}\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"confirmationprint-headerBottom\">\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\" ng-if=\"::$ctrl.isDelivery()\">Delivery date</div>\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\" ng-if=\"::!$ctrl.isDelivery()\">\r\n\t\t\t\t\t<wow-setting setting-group=\"DeliveryInfo\" setting-name=\"PickupDisplayText\"></wow-setting> date\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>{{ ::$ctrl.order.DeliveryDate | date: 'dd MMM'}} between {{ ::$ctrl.order.DeliveryStartTime}} and {{ ::$ctrl.order.DeliveryEndTime}}</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<table class=\"confirmationprint-items\">\r\n\t\t\t<thead class=\"confirmationprint-itemsTitle\">\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader confirmationprint-itemQty\">Qty\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">Item\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">$/Unit\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">Promo Disc\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader confirmationprint-itemsTotal\">Total\r\n\t\t\t\t\t</th>\r\n\t\t\t\t</tr>\r\n\t\t\t</thead>\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr class=\"confirmationprint-itemRow\" ng-repeat=\"product in  $ctrl.order.Products\">\r\n\t\t\t\t\t<td class=\"confirmationprint-itemQty confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.Quantity}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"confirmationprint-itemName confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.Name}} {{product.VolumeSize}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"unit confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.SalePrice | currency}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"promo confirmationprint-itemCol\">\r\n\t\t\t\t\t\t<span ng-if=\"product.Discount > 0\">{{ product.Discount | currency}}</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"total confirmationprint-itemCol confirmationprint-itemsTotal\">\r\n\t\t\t\t\t\t{{product.Subtotal | currency}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t<div class=\"confirmationprint-break\"></div>\r\n\t\t<div class=\"confirmationprint-summary\" layout=\"row\" layout-align=\"end center\">\r\n\t\t\t<table class=\"confirmationprint-summaryTable\">\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Sub Total\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\" id=\"order-subtotals\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.Subtotal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.DiscountableSubtotal !==  $ctrl.order.Subtotal\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\t<wow-html-setting setting-group=\"Checkout\" setting-name=\"DiscountableSubtotalFieldLabel\"></wow-html-setting>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.DiscountableSubtotal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.OrderDiscountWithoutTeamDiscount > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Order Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.OrderDiscountWithoutTeamDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.TeamDiscount > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Team Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.TeamDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\tDelivery Fee\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.DeliveryFeeBeforeDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.DeliveryFeeDiscount\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Delivery Fee Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.DeliveryFeeDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.AdditionalDeductions > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Promotion Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.AdditionalDeductions | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr class=\"confirmationprint-summaryTotal\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\t<strong>Total</strong> <span class=\"confirmationprint-summaryGst\">(including GST)</span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t<strong>{{ ::$ctrl.order.TotalIncludingGst | currency}}</strong>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.Coupon > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by Coupon</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.Coupon | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.eVoucher > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by\r\n\t\t\t\t\t\t\t<wow-setting setting-group=\"Checkout\" setting-name=\"EVoucherDisplayName\"></wow-setting>\r\n\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.eVoucher | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.WowRewards > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by\r\n\t\t\t\t\t\t\t<wow-setting setting-group=\"EverydayRewards\" setting-name=\"CardName\"></wow-setting>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.WowRewards | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.GiftCard > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by Gift Card</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.GiftCard | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.CreditCard > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by Credit Card</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.CreditCard | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.PayPal > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid by PayPal</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.PayPal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.Account > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Charged to Account</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.Account | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>"

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var OrderInstructionsService = __webpack_require__(547);

angular.module('wowApp.shop').service('OrderInstructionsService', OrderInstructionsService);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderInstructionsService = function () {
    function OrderInstructionsService($q, restangular, bootstrap, fulfilmentService) {
        _classCallCheck(this, OrderInstructionsService);

        this.api = restangular.one('Delivery');
        this.fulfilmentService = fulfilmentService;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.DeliveryInfo)) {
            this.deliveryMessage = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).DeliveryInstruction;
            this.pickupMessage = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).PickupInstruction;
        }
    }

    _createClass(OrderInstructionsService, [{
        key: 'getSavedMessage',
        value: function getSavedMessage() {
            return this.fulfilmentService.isDelivery() ? this.deliveryMessage : this.pickupMessage;
        }
    }, {
        key: 'setInstructions',
        value: function setInstructions(message) {
            return this.fulfilmentService.isDelivery() ? this.setDeliveryMessage(message) : this.setPickupMessage(message);
        }
    }, {
        key: 'setDeliveryMessage',
        value: function setDeliveryMessage(message) {
            var _this = this;

            return this.api.one('DeliveryMessage').doPOST({ DeliveryMessage: message }).then(function (response) {
                _this.deliveryMessage = response.SavedDeliveryMessage;
            });
        }
    }, {
        key: 'setPickupMessage',
        value: function setPickupMessage(message) {
            var _this2 = this;

            return this.api.one('PickupMessage').doPOST({ PickupMessage: message }).then(function (response) {
                _this2.pickupMessage = response.SavedPickupMessage;
            });
        }
    }]);

    return OrderInstructionsService;
}();

OrderInstructionsService.$inject = ['$q', 'Restangular', 'BootstrapService', 'FulfilmentService'];

module.exports = OrderInstructionsService;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var OrderManagementService = __webpack_require__(549);

var _require = __webpack_require__(550),
    orderManagementComponentDefinition = _require.orderManagementComponentDefinition;

var _require2 = __webpack_require__(552),
    orderManagementSectionComponentDefinition = _require2.orderManagementSectionComponentDefinition;

var _require3 = __webpack_require__(554),
    orderManagementItemComponentDefinition = _require3.orderManagementItemComponentDefinition;

var _require4 = __webpack_require__(556),
    orderManagementActionsComponentDefinition = _require4.orderManagementActionsComponentDefinition;

var _require5 = __webpack_require__(558),
    orderManagementActionsPendingComponentDefinition = _require5.orderManagementActionsPendingComponentDefinition;

var _require6 = __webpack_require__(560),
    orderManagementEditDeliveryComponentDefinition = _require6.orderManagementEditDeliveryComponentDefinition;

var _require7 = __webpack_require__(562),
    orderManagementCountdownComponentDefinition = _require7.orderManagementCountdownComponentDefinition;

angular.module('wowApp.shop').service('OrderManagementService', ['Restangular', 'BreakpointsService', OrderManagementService]).component('wowOrderManagement', orderManagementComponentDefinition).component('wowOrderManagementSection', orderManagementSectionComponentDefinition).component('wowOrderManagementItem', orderManagementItemComponentDefinition).component('wowOrderManagementActions', orderManagementActionsComponentDefinition).component('wowOrderManagementActionsPending', orderManagementActionsPendingComponentDefinition).component('wowOrderManagementEditDelivery', orderManagementEditDeliveryComponentDefinition).component('wowOrderManagementCountdown', orderManagementCountdownComponentDefinition);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function OrderManagementService(Restangular, _breakpointsService) {
    this._api = Restangular.one('order');
    this._deliveryWindowApi = Restangular.one('DeliveryWindows');
    this.breakpointsService = _breakpointsService;
    this.loadingOrders = null;

    this.timeTable = [];

    this.switchAction = { id: 0, action: '' };
}

OrderManagementService.prototype.invalidate = function () {
    // Call this function before getOrders in order to freshly load
    // orders
    this.loadingOrders = null;
    this.orders = null;
};

OrderManagementService.prototype.setOrders = function (orders) {
    this.orders = orders;
    return orders;
};

OrderManagementService.prototype.getOrders = function () {
    if (this.loadingOrders) {
        // if we have already loaded orders, return the resolved promise.
        return this.loadingOrders;
    }

    this.loadingOrders = this._api.get().then(this.setOrders.bind(this));

    return this.loadingOrders;
};

OrderManagementService.prototype.updateSelectedAction = function (orderId, action) {
    // This function gets updated whenever an option is selected from
    // an order-status-card
    this.switchAction.id = orderId;
    this.switchAction.action = action;
};

OrderManagementService.prototype.updateSelectedPendingOrder = function (orderId) {
    // This function gets updated whenever the dropdown option is clicked on
    // an order-status-card
    this.selectedPendingOrderId = orderId;
};

OrderManagementService.prototype.getPastOrderDeliveryWindow = function (orderId, isDelivery) {
    var _this = this;

    return this._deliveryWindowApi.one('PastOrder').get({ OrderId: orderId, isDelivery: isDelivery }).then(function (response) {
        _this.timeTable = response;
    });
};

OrderManagementService.prototype.savePastOrderDeliveryWindow = function (orderId, deliveryWindowId, windowDate) {
    var _this2 = this;

    return this._deliveryWindowApi.post('ReservePastOrderWindow', { OrderId: orderId, DeliveryWindowId: deliveryWindowId, WindowDate: windowDate }).then(function (response) {
        if (response.IsSuccessful) {
            _this2.updateSelectedAction(0, '');
            return response;
        }
        return response;
    });
};

OrderManagementService.prototype.cancelOrder = function (orderId) {
    var _this3 = this;

    return this._api.post('cancel', { OrderId: orderId }).then(function () {
        _this3.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.changeOrder = function (orderId) {
    var _this4 = this;

    return this._api.post('amend', { OrderId: orderId, OrderDeviceFormat: this.breakpointsService.getDeviceDisplayFormatString() }).then(function () {
        _this4.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.getTotalOrderCount = function () {
    var _this5 = this;

    return this.getOrders().then(function () {
        return _this5.orders.PendingOrders.length + _this5.orders.InProcessOrders.length + _this5.orders.InTransitOrders.length;
    });
};

module.exports = OrderManagementService;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManagementController = function () {
    function OrderManagementController($scope, orderManagementService) {
        var _this = this;

        _classCallCheck(this, OrderManagementController);

        this.orderManagement = orderManagementService;

        $scope.$on('order-change', function () {
            _this.invalidate();
            _this.toggleOrderManagement();
        });
        $scope.$on('order-cancel', function () {
            _this.invalidate();
        });
    }

    _createClass(OrderManagementController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.orderManagement.orders) {
                this.orderManagement.getOrders();
            }
        }
    }, {
        key: 'invalidate',
        value: function invalidate() {
            this.orderManagement.invalidate();
            this.orderManagement.getOrders();
        }
    }]);

    return OrderManagementController;
}();

var orderManagementComponentDefinition = {
    bindings: {
        toggleOrderManagement: '&'
    },
    controller: ['$scope', 'OrderManagementService', OrderManagementController],
    template: __webpack_require__(551).trim()
};

module.exports = {
    OrderManagementController: OrderManagementController,
    orderManagementComponentDefinition: orderManagementComponentDefinition
};

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = "<button type=\"button\" id=\"return-to-cart\" class=\"cartOrderManagement-button cartOrderManagement-return linkButton\" ng-click=\"::$ctrl.toggleOrderManagement()\">\r\n    <span class=\"u-flexCenter\">Return to cart</span>\r\n</button>\r\n\r\n<wow-order-management-section\r\n    ng-if=\"$ctrl.orderManagement.orders.PendingOrders.length > 0\"\r\n    orders=\"::$ctrl.orderManagement.orders.PendingOrders\"\r\n    order-type=\"PENDING\"\r\n    show-timer=\"true\">\r\n</wow-order-management-section>\r\n\r\n<wow-order-management-section\r\n    ng-if=\"$ctrl.orderManagement.orders.InProcessOrders.length > 0\"\r\n    orders=\"::$ctrl.orderManagement.orders.InProcessOrders\"\r\n    order-type=\"PROCESSING\"\r\n    show-timer=\"false\">\r\n</wow-order-management-section>\r\n\r\n<wow-order-management-section\r\n    ng-if=\"$ctrl.orderManagement.orders.InTransitOrders.length > 0\"\r\n    orders=\"::$ctrl.orderManagement.orders.InTransitOrders\"\r\n    order-type=\"TRANSIT\"\r\n    show-timer=\"false\">\r\n</wow-order-management-section>"

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManagementSectionController = function () {
    function OrderManagementSectionController() {
        _classCallCheck(this, OrderManagementSectionController);
    }

    _createClass(OrderManagementSectionController, [{
        key: '$onInit',
        value: function $onInit() {
            this.ariaLabel = 'orderManagment-' + this.orderType + '-Header';
        }
    }]);

    return OrderManagementSectionController;
}();

var orderManagementSectionComponentDefinition = {
    bindings: {
        orders: '<',
        orderType: '@',
        showTimer: '='
    },
    transclude: true,
    controller: [OrderManagementSectionController],
    template: __webpack_require__(553).trim()
};

module.exports = {
    OrderManagementSectionController: OrderManagementSectionController,
    orderManagementSectionComponentDefinition: orderManagementSectionComponentDefinition
};

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = "<section role=\"region\" aria-labelledby=\"{{::$ctrl.ariaLabel}}\">\r\n    <span class=\"sr-only\" id=\"{{::$ctrl.ariaLabel}}\">\r\n        {{::$ctrl.orderType}} order ({{::$ctrl.orders.length}}\r\n        <ng-pluralize count=\"::$ctrl.orders.length\"\r\n                    when=\"{'1': 'order', 'other': 'orders'}\">\r\n        </ng-pluralize>)\r\n    </span>\r\n\r\n    <wow-order-management-item ng-repeat=\"order in ::$ctrl.orders track by order.OrderId\" order=\"::order\" order-type=\"{{$ctrl.orderType}}\" show-timer=\"!!$ctrl.showTimer\">\r\n        \r\n        <wow-order-management-actions-pending order=\"::order\" ng-if=\"$ctrl.orderType === 'PENDING'\"></wow-order-management-actions-pending>\r\n        \r\n        <wow-order-management-actions order=\"::order\" ng-if=\"$ctrl.orderType !== 'PENDING'\"></wow-order-management-actions>\r\n\r\n    </wow-order-management-item>\r\n</section>\r\n"

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var view = {
    OPTIONS: 'OPTIONS',
    DETAILS: 'DETAILS'

};

var orderType = {
    PENDING: 'icon-omgmnt_pending',
    PROCESSING: 'icon-processing',
    TRANSIT: 'icon-mode_delivery'
};

var method = {
    courier: 'Deliver To:',
    pickup: '',
    hubspok: '',
    transit: 'En Route to:'
};

var OrderManagementItemController = function () {
    function OrderManagementItemController(settings) {
        _classCallCheck(this, OrderManagementItemController);

        this.view = view;
        this.settings = settings;
    }

    _createClass(OrderManagementItemController, [{
        key: '$onInit',
        value: function $onInit() {
            method.pickup = this.settings.orderManagement.itemPickupFrom;
            method.hubspok = this.settings.orderManagement.itemHubSpok;

            this.itemView = this.view.DETAILS;

            this.header = '<span class="orderManagementItem-icon" aria-hidden="true"><i class="' + orderType[this.orderType] + '"></i></span>';
            this.header += 'Order:&nbsp;<span class="orderManagementItem-orderNo">#' + this.order.OrderId + '</span>\n                                        (' + this.order.ItemCount + ' ' + (this.order.ItemCount > 1 ? 'items' : 'item') + ')';

            this.method = this.orderType === 'transit' ? method.transit : method[this.order.DeliveryMethod.toLowerCase()];

            this.isEtaAvailable = this.orderType !== 'PENDING' && this.order.DeliveryStartTime && this.order.DeliveryEndTime && this.order.DeliveryStartTime !== this.order.DeliveryEndTime;
        }
    }, {
        key: 'setView',
        value: function setView(newView) {
            this.itemView = newView;
        }
    }]);

    return OrderManagementItemController;
}();

var orderManagementItemComponentDefinition = {
    bindings: {
        order: '<',
        orderType: '@',
        showTimer: '='
    },
    transclude: true,
    controller: ['Settings', OrderManagementItemController],
    template: __webpack_require__(555).trim()
};

module.exports = {
    OrderManagementItemController: OrderManagementItemController,
    orderManagementItemComponentDefinition: orderManagementItemComponentDefinition
};

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderManagementItem\" ng-switch=\"$ctrl.itemView\">\r\n    <button\r\n        ng-switch-when=\"DETAILS\"\r\n        ng-click=\"::$ctrl.setView($ctrl.view.OPTIONS)\"\r\n        class=\"linkButton\">\r\n\r\n        <div class=\"orderManagementItem-button\">\r\n            <span ng-bind-html=\"::$ctrl.header\"></span>&nbsp;<i class=\"iconww-ArrowDown\"></i>\r\n            <span class=\"sr-only\">Expand options for order {{::order.OrderId}}</span>\r\n        </div>\r\n    </button>\r\n\r\n    <button\r\n        ng-switch-when=\"OPTIONS\"\r\n        ng-click=\"::$ctrl.setView($ctrl.view.DETAILS)\"\r\n        class=\"orderManagementItem-button linkButton\">\r\n\r\n        <span ng-bind-html=\"::$ctrl.header\"></span>&nbsp;<i class=\"iconww-ArrowUp\"></i>\r\n        <span class=\"sr-only\">Collapse options for order {{::order.OrderId}}</span>\r\n    </button>\r\n\r\n    <div \r\n        ng-switch-when=\"OPTIONS\"\r\n        class=\"orderManagementItem-options\"\r\n        ng-transclude>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"DETAILS\" class=\"orderManagementItem-order\">\r\n        <div class=\"orderManagementItem-details\">\r\n            <h4 class=\"orderManagementItem-label\">{{::$ctrl.method}}</h4>\r\n            \r\n            <span ng-if=\"::!$ctrl.isEtaAvailable\" class=\"orderManagementItem-detailsText\">\r\n                {{::$ctrl.order.Address}} on {{::$ctrl.order.DeliveryDate | date: 'MMMM dd'}}\r\n                between {{::$ctrl.order.DeliveryWindowStartTime | date: 'h:mma' | lowercase}} - {{::$ctrl.order.DeliveryWindowEndTime | date: 'h:mma' | lowercase}}\r\n            </span>\r\n\r\n            <div ng-if=\"::$ctrl.isEtaAvailable\">\r\n                <span class=\"orderManagementItem-detailsText\">\r\n                    {{::$ctrl.order.Address}}\r\n                </span>\r\n\r\n                <h4 class=\"orderManagementItem-label\">Estimated Arrival:</h4>\r\n                \r\n                <span class=\"orderManagementItem-detailsText\">\r\n                    {{::$ctrl.order.DeliveryDate | date: 'MMMM dd'}}\r\n                    between {{::$ctrl.order.DeliveryStartTime | date: 'h:mma' | lowercase}} - {{::$ctrl.order.DeliveryEndTime | date: 'h:mma' | lowercase}}\r\n                </span>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"orderManagementItem-timer\" ng-if=\"::$ctrl.showTimer\">\r\n            <h4 class=\"sr-only\">Remaining time to review this order</h4>\r\n\r\n            <wow-order-management-countdown class=\"orderManagementItem-timerCounter\" minutes-left=\"$ctrl.order.MinutesUntilChangeOrderCutOff\"></wow-order-management-countdown>\r\n\r\n            <span class=\"orderManagementItem-timerMessage\" aria-hidden=\"true\">Hours left to<br/>review this order</span>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManagementActionsController = function () {
    function OrderManagementActionsController(moveFocus) {
        _classCallCheck(this, OrderManagementActionsController);

        this.moveFocus = moveFocus;
    }

    _createClass(OrderManagementActionsController, [{
        key: 'onActionClick',
        value: function onActionClick() {
            this.moveFocus('#body-container');
            this.itemCtrl.setView('DETAILS');
        }
    }]);

    return OrderManagementActionsController;
}();

var orderManagementActionsComponentDefinition = {
    bindings: {
        order: '<'
    },
    require: {
        itemCtrl: '^wowOrderManagementItem'
    },
    controller: ['MoveFocus', OrderManagementActionsController],
    template: __webpack_require__(557).trim()
};

module.exports = {
    OrderManagementActionsController: OrderManagementActionsController,
    orderManagementActionsComponentDefinition: orderManagementActionsComponentDefinition
};

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"orderManagementActions\">\r\n    <li class=\"orderManagementActions-item\">\r\n        Select an action...\r\n    </li>\r\n    <li>\r\n        <a class=\"orderManagementActions-item orderManagementActions-link\" ui-sref=\"shop.list.pastordershops({orderId: $ctrl.order.OrderId })\" ng-click=\"::$ctrl.onActionClick()\" tabindex=\"0\">\r\n            Shop From Order\r\n        </a>\r\n    </li>\r\n    <li>\r\n        <a class=\"orderManagementActions-item orderManagementActions-link\" ui-sref=\"shop.myaccount.trackmyorder.orderId({orderId: $ctrl.order.OrderId })\" ng-click=\"::$ctrl.onActionClick()\">\r\n            Track My Order\r\n        </a>\r\n    </li>\r\n</ul>"

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dialog = {
    CHANGE: 'CHANGE_ORDER',
    CANCEL: 'CANCEL_ORDER'
};

var view = {
    OPTIONS: 'OPTIONS',
    DELIVERY_WINDOW: 'DELIVERY_WINDOW'
};

var OrderManagementActionsPendingController = function () {
    function OrderManagementActionsPendingController($scope, $state, $rootScope, orderManagementService, trolleyService, pastShopService, dialogRegistry, moveFocus) {
        _classCallCheck(this, OrderManagementActionsPendingController);

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.orderManagementService = orderManagementService;
        this.trolleyService = trolleyService;
        this.pastShopService = pastShopService;
        this.dialogRegistry = dialogRegistry;
        this.moveFocus = moveFocus;

        this.view = view;
        this.dialog = dialog;
    }

    _createClass(OrderManagementActionsPendingController, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentView = this.view.OPTIONS;
        }
    }, {
        key: 'setView',
        value: function setView(newView) {
            this.currentView = newView;
        }
    }, {
        key: 'onActionClick',
        value: function onActionClick() {
            this.moveFocus('#body-container');
            this.itemCtrl.setView('DETAILS');
        }
    }, {
        key: 'cancelDialog',
        value: function cancelDialog(currentDialog) {
            this.moveFocus('._' + currentDialog);
        }
    }, {
        key: 'changeOrder',
        value: function changeOrder() {
            var _this = this;

            var changeDialog = this.dialogRegistry.getDialog(this.dialog.CHANGE);
            if (changeDialog) {
                changeDialog.show().then(function () {
                    _this.orderManagementService.changeOrder(_this.order.OrderId).then(function () {
                        _this.pastShopService.invalidate();
                        _this.$rootScope.$broadcast('order-change');

                        _this.trolleyService.getTrolley().then(function () {
                            return _this.$rootScope.$broadcast('trolley:update');
                        });

                        // TO CONFIRM: don't really know if they still want this redirect
                        if (_this.$state.is('shop.confirmation')) {
                            window.location.href = '/';
                        }
                    });
                });
            }
        }
    }, {
        key: 'cancelOrder',
        value: function cancelOrder() {
            var _this2 = this;

            var cancelDialog = this.dialogRegistry.getDialog(this.dialog.CANCEL);
            if (cancelDialog) {
                cancelDialog.show().then(function () {
                    _this2.orderManagementService.cancelOrder(_this2.order.OrderId).then(function () {
                        _this2.pastShopService.invalidate();
                        _this2.$scope.$emit('order-cancel');

                        // TO CONFIRM: don't really know if they still want this redirect
                        _this2.$state.go('shop.confirmation', { orderId: _this2.order.OrderId }, { reload: true });
                    });
                });
            }
        }
    }]);

    return OrderManagementActionsPendingController;
}();

var orderManagementActionsPendingComponentDefinition = {
    bindings: {
        order: '<'
    },
    require: {
        itemCtrl: '^wowOrderManagementItem'
    },
    controller: ['$scope', '$state', '$rootScope', 'OrderManagementService', 'TrolleyService', 'PastShopService', 'DialogRegistry', 'MoveFocus', OrderManagementActionsPendingController],
    template: __webpack_require__(559).trim()
};

module.exports = {
    OrderManagementActionsPendingController: OrderManagementActionsPendingController,
    orderManagementActionsPendingComponentDefinition: orderManagementActionsPendingComponentDefinition
};

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"$ctrl.currentView\">\r\n    <ul class=\"orderManagementActions\" ng-switch-when=\"OPTIONS\">\r\n        <li class=\"orderManagementActions-item\">\r\n            Select an action...\r\n        </li>\r\n        <li>\r\n            <a href=\"#\" class=\"orderManagementActions-link orderManagementActions-item\" ng-click=\"::$ctrl.setView($ctrl.view.DELIVERY_WINDOW)\" oly-grab-focus=\"true\">Edit Delivery Time</a>\r\n        </li>\r\n        <li>\r\n            <a href=\"#\" class=\"orderManagementActions-link orderManagementActions-item _{{::$ctrl.dialog.CHANGE}}\" ng-click=\"::$ctrl.changeOrder()\">Change Order</a>\r\n        </li>\r\n        <li>\r\n            <a ui-sref=\"shop.list.pastordershops({orderId: $ctrl.order.OrderId })\" class=\"orderManagementActions-link orderManagementActions-item\"\r\n                ng-click=\"::$ctrl.onActionClick()\">Shop From Order</a>\r\n        </li>\r\n        <li>\r\n            <a href=\"#\" class=\"orderManagementActions-link orderManagementActions-item _{{::$ctrl.dialog.CANCEL}}\" ng-click=\"::$ctrl.cancelOrder()\">Cancel Order</a>\r\n        </li>\r\n        <li>\r\n            <a href=\"#\" class=\"orderManagementActions-link orderManagementActions-item\" ui-sref=\"shop.myaccount.trackmyorder.orderId({orderId: $ctrl.order.OrderId })\"\r\n                ng-click=\"::$ctrl.onActionClick()\">Track My Order</a>\r\n        </li>\r\n    </ul>\r\n\r\n    <dialog name=\"{{::$ctrl.dialog.CHANGE}}\" class=\"olyDialog olyDialog--confirmation orderModals-changeModal\">\r\n        <div class=\"olyDialog-scrollableArea\" wow-hide-scroll wow-scrollbar>\r\n            <i class=\"icon-alert_exclamation orderModals-icon\"></i>\r\n            <div class=\"orderModals-textWrapper\">\r\n                <h1 class=\"orderModals-textHeading\">Change order?</h1>\r\n                <p class=\"orderModals-textBody\">\r\n                    <wow-setting setting-group=\"Order\" setting-name=\"AmendOrderDisclaimer\"></wow-setting>\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <footer class=\"olyDialog-buttons\">\r\n            <button oly-dialog-close class=\"button olyDialog-buttonsCancel\" ng-click=\"::$ctrl.cancelDialog($ctrl.dialog.CHANGE)\">No<span class=\" sr-only\">, do not change order</span></button>\r\n            <button oly-dialog-close return=\"true\" class=\"button button--primary olyDialog-buttonsConfirm\">Yes<span class=\"sr-only\">, change order</span></button>\r\n        </footer>\r\n    </dialog>\r\n\r\n    <dialog name=\"{{::$ctrl.dialog.CANCEL}}\" class=\"olyDialog olyDialog--confirmation orderModals-cancelModal\">\r\n        <div class=\"olyDialog-scrollableArea\" wow-hide-scroll wow-scrollbar>\r\n            <i class=\"icon-alert_exclamation orderModals-icon\"></i>\r\n            <div class=\"orderModals-textWrapper\">\r\n                <h1 class=\"orderModals-textHeading\">Are you sure you want to cancel your order?</h1>\r\n                <p class=\"orderModals-textBody\">\r\n                    <wow-setting setting-group=\"Order\" setting-name=\"CancelOrderDisclaimer\"></wow-setting>\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <footer class=\"olyDialog-buttons\">\r\n            <button oly-dialog-close class=\"button olyDialog-buttonsCancel\" ng-click=\"::$ctrl.cancelDialog($ctrl.dialog.CANCEL)\">No<span class=\"sr-only\">, do not cancel order</span></button>\r\n            <button oly-dialog-close return=\"true\" class=\"button button--primary olyDialog-buttonsConfirm\">Yes<span class=\"sr-only\">, cancel order</span></button>\r\n        </footer>\r\n    </dialog>\r\n\r\n    <!--<wow-order-pending-delivery-window order=\"::$ctrl.order\" ng-switch-when=\"DELIVERY_WINDOW\"></wow-order-pending-delivery-window>-->\r\n    <wow-order-management-edit-delivery order=\"::$ctrl.order\" ng-switch-when=\"DELIVERY_WINDOW\"></wow-order-management-edit-delivery>\r\n</div>"

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManagementEditDeliveryController = function () {
    function OrderManagementEditDeliveryController($element, orderManagementService, moveFocus) {
        _classCallCheck(this, OrderManagementEditDeliveryController);

        this.$element = $element;
        this.orderManagementService = orderManagementService;
        this.moveFocus = moveFocus;
    }

    _createClass(OrderManagementEditDeliveryController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.timeTable = [];
            this.isDelivery = this.order.DeliveryMethod === 'Courier';
            this.orderManagementService.getPastOrderDeliveryWindow(this.order.OrderId, this.isDelivery).then(function () {
                _this.timeTable = _this.orderManagementService.timeTable;
            });
        }
    }, {
        key: 'setDate',
        value: function setDate(selectedDate) {
            this.selectedDate = selectedDate;
        }
    }, {
        key: 'setTime',
        value: function setTime(fulfilmentTime) {
            var _this2 = this;

            this.modalMessage = null;
            // Save th delivery info
            this.orderManagementService.savePastOrderDeliveryWindow(this.order.OrderId, fulfilmentTime.Id, this.selectedDate.Date).then(function (response) {
                if (!response.IsSuccessful) {
                    _this2.modalMessage = response.Message;
                } else {
                    // Need to refresh the pending order pages.
                    _this2.orderManagementService.invalidate();
                    _this2.orderManagementService.getOrders();
                }
            });
        }
    }, {
        key: 'resetModalMessage',
        value: function resetModalMessage() {
            this.modalMessage = null;

            var elementToFocus = this.$element.find('.deliveryTimetable-windows .list-group-itemLink.active');

            if (elementToFocus.length === 0) {

                elementToFocus = this.$element.find('.deliveryTimetable-windows .list-group-itemLink:first');
            }

            // Move focus back to active time link
            this.moveFocus(elementToFocus);
        }
    }]);

    return OrderManagementEditDeliveryController;
}();

var orderManagementEditDeliveryComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: ['$element', 'OrderManagementService', 'MoveFocus', OrderManagementEditDeliveryController],
    template: __webpack_require__(561).trim()
};

module.exports = {
    OrderManagementEditDeliveryController: OrderManagementEditDeliveryController,
    orderManagementEditDeliveryComponentDefinition: orderManagementEditDeliveryComponentDefinition
};

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderManagementEditDelivery-window\">\r\n    <div class=\"orderManagementEditDelivery-info\">\r\n        <span>I'd like </span>\r\n        <wow-setting ng-if=\"::$ctrl.isDelivery\" setting-group=\"orderManagement\" setting-name=\"editDeliveryInfoDelivery\"></wow-setting>\r\n        <wow-setting ng-if=\"::!$ctrl.isDelivery\" setting-group=\"orderManagement\" setting-name=\"editDeliveryInfoPickUp\"></wow-setting>\r\n        <span> {{::$ctrl.order.Address}},</span>\r\n        <span class=\"orderManagementEditDelivery-time\" ng-bind-html=\"($ctrl.order.DeliveryDateLongText + ' between ' + $ctrl.order.TimeWindow.replace('-', 'and')) | sanitize\"></span>\r\n    </div>\r\n\r\n    <wow-fulfilment-timetable\r\n        time-table=\"$ctrl.timeTable\"\r\n        on-set-fulfilment-date=\"::$ctrl.setDate(selectedDate)\"\r\n        on-set-fulfilment-time=\"::$ctrl.setTime(fulfilmentTime)\"\r\n        saved-date=\"{{$ctrl.order.DeliveryDate}}\"\r\n        saved-delivery-window-id=\"{{$ctrl.order.DeliveryWindowID}}\"\r\n        is-delivery=\"::$ctrl.isDelivery\">\r\n    </wow-fulfilment-timetable>\r\n</div>\r\n\r\n<wow-dialog dialog-name=\"restricted window\" message=\"{{$ctrl.modalMessage}}\" on-dismiss=\"::$ctrl.resetModalMessage()\" ng-if=\"$ctrl.modalMessage\"></wow-dialog>\r\n"

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManagementCountdownController = function () {
    function OrderManagementCountdownController($interval, $scope, orderManagementService) {
        var _this = this;

        _classCallCheck(this, OrderManagementCountdownController);

        this.orderManagementService = orderManagementService;

        var intervalPromise = $interval(function () {
            _this.setTimeRemaining();
        }, 5000);

        $scope.$on('$destroy', function () {
            $interval.cancel(intervalPromise);
        });
    }

    _createClass(OrderManagementCountdownController, [{
        key: '$onInit',
        value: function $onInit() {
            this.finalDate = new Date(Date.now() + Math.floor(parseFloat(this.minutesLeft) * 60000));
            this.setTimeRemaining();
        }
    }, {
        key: 'setTimeRemaining',
        value: function setTimeRemaining() {
            var msec = this.finalDate.getTime() - Date.now();

            if (msec <= 0) {
                this.orderManagementService.invalidate();
                this.orderManagementService.getOrders();
            }

            var hours = Math.floor(msec / 1000 / 60 / 60);
            msec -= hours * 1000 * 60 * 60;
            var mins = Math.floor(msec / 1000 / 60);

            var hh = hours < 10 ? '0' + hours : hours;
            var mm = mins < 10 ? '0' + mins : mins;

            this.hours = '' + hh;
            this.mins = '' + mm;
            this.srTimeString = hours + ' hours and ' + mins + ' minutes ';
        }
    }]);

    return OrderManagementCountdownController;
}();

var orderManagementCountdownComponentDefinition = {
    bindings: {
        minutesLeft: '='
    },
    controller: ['$interval', '$scope', 'OrderManagementService', OrderManagementCountdownController],
    template: '<span aria-hidden="true">{{$ctrl.hours}}<span class="orderManagementItem-timerUnit">h</span>{{$ctrl.mins}}<span class="orderManagementItem-timerUnit">m</span></span><span class="sr-only">{{$ctrl.srTimeString}}</span>'
};

module.exports = {
    OrderManagementCountdownController: OrderManagementCountdownController,
    orderManagementCountdownComponentDefinition: orderManagementCountdownComponentDefinition
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var PackagingPreferenceService = __webpack_require__(564);

angular.module('wowApp.shop').service('PackagingPreferenceService', PackagingPreferenceService);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var packagingDtmMapper = __webpack_require__(565);

var _require = __webpack_require__(1),
    find = _require.find,
    map = _require.map;

var PackagingPreferenceService = function () {
    function PackagingPreferenceService(restangular, analytics) {
        _classCallCheck(this, PackagingPreferenceService);

        this.api = restangular.one('Delivery');
        this.analytics = analytics;
    }

    _createClass(PackagingPreferenceService, [{
        key: 'getPackagingPreferenceOptions',
        value: function getPackagingPreferenceOptions() {
            var _this = this;

            return this.api.one('PackagingPreferences').get().then(function (response) {
                _this.populatePackagingPreferenceDropdown(response);
            });
        }
    }, {
        key: 'setPackagingPreferenceSession',
        value: function setPackagingPreferenceSession(preferenceId) {
            var _this2 = this;

            this.packagingPreferenceOptions = this.api.one('PackagingPreferences', preferenceId).post().then(function (response) {
                _this2.populatePackagingPreferenceDropdown(response);
                _this2.selectedPackagingPreference = find(_this2.packagingPreferenceOptions, ['id', preferenceId]);
            });
        }
    }, {
        key: 'populatePackagingPreferenceDropdown',
        value: function populatePackagingPreferenceDropdown(source) {
            if (source) {
                // convert backend dto to frontend dropdown object
                this.packagingPreferenceOptions = map(source.PackagingPreferences, function (value) {
                    return {
                        id: value.Id, code: value.Code, text: value.DisplayText, isSelected: value.IsSelected
                    };
                });
                // populate default dropdown selection from session
                this.selectedPackagingPreference = find(this.packagingPreferenceOptions, ['isSelected', true]);
            }
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(data) {
            if (data) {
                this.analytics.push({
                    data: data,
                    dtmMapperFn: packagingDtmMapper
                });
            }
        }
    }]);

    return PackagingPreferenceService;
}();

PackagingPreferenceService.$inject = ['Restangular', 'AnalyticsService'];

module.exports = PackagingPreferenceService;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data) {
    return {
        cart: {
            packagingPreference: data
        }
    };
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(567),
    SavedCardService = _require.SavedCardService;

var _require2 = __webpack_require__(568),
    saveCardComponentDefinition = _require2.saveCardComponentDefinition;

angular.module('wowApp.shop').service('SavedCardService', ['Restangular', SavedCardService]).component('wowSaveCard', saveCardComponentDefinition);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedCardService = function () {
    function SavedCardService(Restangular) {
        _classCallCheck(this, SavedCardService);

        this._api = Restangular.all('SavedCards');
        this._deleteCardApi = Restangular.all('/SavedCards/DeleteSavedCards');
    }

    _createClass(SavedCardService, [{
        key: 'getSavedCard',
        value: function getSavedCard(panNumber) {
            return this._api.get(panNumber);
        }
    }, {
        key: 'getSavedCards',
        value: function getSavedCards() {
            return this._api.getList();
        }
    }, {
        key: 'deleteSavedCard',
        value: function deleteSavedCard(pan) {
            return this._deleteCardApi.post({ Pan: pan });
        }
    }, {
        key: 'saveCardForOrder',
        value: function saveCardForOrder(orderId) {
            return this._api.post({ OrderId: orderId });
        }
    }]);

    return SavedCardService;
}();

module.exports = { SavedCardService: SavedCardService };

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaveCardController = function () {
    function SaveCardController(savedCardService) {
        _classCallCheck(this, SaveCardController);

        this.savedCardService = savedCardService;
    }

    _createClass(SaveCardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.cardSaved = false;
        }
    }, {
        key: 'saveCard',
        value: function saveCard() {
            var _this = this;

            this.cardSaved = true;

            this.savedCardService.saveCardForOrder(this.orderId).then(function () {
                delete _this.error;
            }).catch(function () {
                _this.cardSaved = false;
                _this.error = 'There was an error saving your card.';
            });
        }
    }]);

    return SaveCardController;
}();

SaveCardController.$inject = ['SavedCardService'];

var saveCardComponentDefinition = {
    bindings: {
        orderId: '@'
    },
    controller: SaveCardController,
    template: __webpack_require__(569).trim()
};

module.exports = {
    SaveCardController: SaveCardController,
    saveCardComponentDefinition: saveCardComponentDefinition
};

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.error\" class=\"u-error\">{{ $ctrl.error }}</div>\r\n\r\n<button class=\"button button--primary\" ng-click=\"$ctrl.saveCard()\" ng-if=\"!$ctrl.cardSaved\">\r\n    Save my card for future purchases\r\n</button>\r\n<button class=\"button button--primary\" ng-if=\"$ctrl.cardSaved\" disabled>\r\n    Card saved successfully <i class=\"iconww-Tick\"></i>\r\n</button>\r\n"

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);
var ngMessages = __webpack_require__(9);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(3); // eslint-disable-line no-unused-vars

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(4);

var addressModuleName = 'wowApp.fulfilment';

var fulfilmentService = __webpack_require__(571);
var deliveryFeeService = __webpack_require__(573);

angular.module(addressModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular']).service('FulfilmentService', fulfilmentService).service('DeliveryFeeService', deliveryFeeService);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(574);
__webpack_require__(590);
__webpack_require__(595);
__webpack_require__(598);
__webpack_require__(601);

module.exports = addressModuleName;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var deliveryDtmMapper = __webpack_require__(572);

var FulfilmentService = function () {
    function FulfilmentService($rootScope, restangular, bootstrap, analytics, addressService, settings) {
        _classCallCheck(this, FulfilmentService);

        this.$rootScope = $rootScope;
        this.bootstrap = bootstrap;
        this.api = restangular.one('Fulfilment');
        this.analytics = analytics;
        this.addressService = addressService;
        this.bootstrap = bootstrap;

        this.fulfilmentOptions = {
            pickup: { name: settings.fulfilmentMethod.pickupOptionName, text: settings.fulfilmentMethod.pickupOptionMessage, value: settings.fulfilmentMethod.pickupOptionMessage, icon: 'iconww-Cart', addressText: 'select supermarket' },
            delivery: { name: settings.fulfilmentMethod.deliveryOptionName, text: settings.fulfilmentMethod.deliveryOptionMessage, value: settings.fulfilmentMethod.deliveryOptionMessage, icon: 'iconww-Cart', addressText: 'select address' },
            none: { name: 'none', text: settings.fulfilmentMethod.noneOptionMessage, value: settings.fulfilmentMethod.noneOptionMessage, selected: true, icon: 'iconww-Cart' }
        };

        this.fulfilmentSteps = {
            fulfilmentMethod: 'FULFILMENT_METHOD',
            address: 'ADDRESS',
            timeslot: 'TIMESLOT',
            billing: 'BILLING'
        };

        this.checkoutFulfilmentOptions = {
            pickup: this.fulfilmentOptions.pickup,
            delivery: this.fulfilmentOptions.delivery
        };

        this.selectedFulfilmentMethod = this.fulfilmentOptions.none;

        this.setFulfilmentFromBootstrap();
    }

    _createClass(FulfilmentService, [{
        key: 'setFulfilmentFromBootstrap',
        value: function setFulfilmentFromBootstrap() {
            this.setDeliveryInfo(this.bootstrap.getBootstrappedDataIfPresent(this.bootstrap.bootstrapped.DeliveryInfo));
        }
    }, {
        key: 'setDeliveryInfo',
        value: function setDeliveryInfo(deliveryInfo) {
            if (deliveryInfo == null) return;

            this.selectedFulfilmentMethod = deliveryInfo.DeliveryMethod === 'Courier' ? this.fulfilmentOptions.delivery : this.fulfilmentOptions.pickup;
            this.reservedDate = deliveryInfo.ReservedDate && deliveryInfo.ReservedDate.AbsoluteDateText ? deliveryInfo.ReservedDate : null;
            this.reservedTime = deliveryInfo.ReservedTime && deliveryInfo.ReservedTime.Id > 0 ? deliveryInfo.ReservedTime : null;
            this.isExpress = deliveryInfo.IsExpress;
            this.savedAddress = deliveryInfo.Address && deliveryInfo.Address.AddressId > 0 ? deliveryInfo.Address : null;
        }
    }, {
        key: 'changeFulfilmentTimeslot',
        value: function changeFulfilmentTimeslot() {
            if (!this.savedAddress || this.isNotSet()) {
                this.setFulfilmentFromBootstrap();
            }

            this.$rootScope.$broadcast('fulfilment:changeTimeslot');
        }
    }, {
        key: 'changeFulfilmentMethod',
        value: function changeFulfilmentMethod() {
            this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
            this.$rootScope.$broadcast('fulfilment:changeMethod');
        }
    }, {
        key: 'clearFulfilmentInfo',
        value: function clearFulfilmentInfo() {
            this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
            this.clearAddressAndTime();
        }
    }, {
        key: 'clearAddressAndTime',
        value: function clearAddressAndTime() {
            this.savedAddress = null;
            this.clearTime();
        }
    }, {
        key: 'clearTime',
        value: function clearTime() {
            this.reservedDate = null;
            this.reservedTime = null;
        }
    }, {
        key: 'canOrderBeFulfilled',
        value: function canOrderBeFulfilled() {
            return this.selectedFulfilmentMethod !== this.fulfilmentOptions.none && !!this.savedAddress && !!this.reservedDate && !!this.reservedTime && !!this.addressService.getPrimaryAddress();
        }
    }, {
        key: 'isDelivery',
        value: function isDelivery() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.delivery.name;
        }
    }, {
        key: 'isPickup',
        value: function isPickup() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.pickup.name;
        }
    }, {
        key: 'isNotSet',
        value: function isNotSet() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.none.name;
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(fulfilmentInfo) {
            var _this = this;

            return this.api.doPOST({
                fulfilmentMethod: fulfilmentInfo.fulfilmentMethod,
                addressId: fulfilmentInfo.address.AddressId,
                timeslotId: fulfilmentInfo.fulfilmentWindow.time ? fulfilmentInfo.fulfilmentWindow.time.Id : undefined,
                windowDate: fulfilmentInfo.fulfilmentWindow.date ? fulfilmentInfo.fulfilmentWindow.date.Date : undefined,
                billingAddressId: fulfilmentInfo.billingAddressId
            }).then(function (response) {
                if (fulfilmentInfo.fulfilmentMethod && fulfilmentInfo.address && fulfilmentInfo.fulfilmentWindow.date && fulfilmentInfo.fulfilmentWindow.time) {
                    var DeliveryTime = fulfilmentInfo.fulfilmentWindow.date.AbsoluteDateText + ' between ' + fulfilmentInfo.fulfilmentWindow.time.TimeWindow.replace('-', 'and');
                    _this.analytics.push({
                        data: {
                            DeliveryMethod: fulfilmentInfo.fulfilmentMethod,
                            DeliveryAddress: fulfilmentInfo.address.AddressText,
                            DeliveryTime: DeliveryTime
                        },
                        dtmMapperFn: deliveryDtmMapper
                    });
                }
                return response;
            });
        }
    }]);

    return FulfilmentService;
}();

FulfilmentService.$inject = ['$rootScope', 'Restangular', 'BootstrapService', 'AnalyticsService', 'AddressService', 'Settings'];

module.exports = FulfilmentService;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data) {
    return {
        cart: {
            price: {
                shippingMethod: data.DeliveryMethod,
                deliveryAddress: data.DeliveryAddress,
                deliveryTime: data.DeliveryTime
            }
        }
    };
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryFeeService = function () {
    function DeliveryFeeService(restangular) {
        _classCallCheck(this, DeliveryFeeService);

        this.api = restangular.one('Delivery');
    }

    _createClass(DeliveryFeeService, [{
        key: 'getDeliveryFeeStructure',
        value: function getDeliveryFeeStructure() {
            return this.api.one('DeliveryFeeStructure').get();
        }
    }]);

    return DeliveryFeeService;
}();

DeliveryFeeService.$inject = ['Restangular'];

module.exports = DeliveryFeeService;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(575),
    pickupAddressSearchComponentDefinition = _require.pickupAddressSearchComponentDefinition;

var _require2 = __webpack_require__(577),
    pickupAddressListComponentDefinition = _require2.pickupAddressListComponentDefinition;

var _require3 = __webpack_require__(579),
    pickupAddressComponentDefinition = _require3.pickupAddressComponentDefinition;

var _require4 = __webpack_require__(581),
    savedAddressesComponentDefinition = _require4.savedAddressesComponentDefinition;

var _require5 = __webpack_require__(583),
    manualAddressComponentDefinition = _require5.manualAddressComponentDefinition;

var _require6 = __webpack_require__(585),
    addressEntryFormComponentDefinition = _require6.addressEntryFormComponentDefinition;

var AddressServiceDefinition = __webpack_require__(587);

angular.module('wowApp.fulfilment').constant('AddressEntryModes', {
    manual: 'MANUAL',
    search: 'SEARCH'
}).service('AddressService', AddressServiceDefinition).service('PickupAddressSearchService', ['Restangular', 'StoreService', __webpack_require__(588)]).factory('StateService', ['$rootScope', 'Restangular', __webpack_require__(589)]).component('wowPickupAddressSearch', pickupAddressSearchComponentDefinition).component('wowPickupAddressList', pickupAddressListComponentDefinition).component('wowPickupAddress', pickupAddressComponentDefinition).component('wowSavedAddresses', savedAddressesComponentDefinition).component('wowManualAddress', manualAddressComponentDefinition).component('wowAddressEntryForm', addressEntryFormComponentDefinition);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = __webpack_require__(18);

var LOCATION_SEARCH_TEXT = 'Using your location';

var PickupAddressSearchController = function () {
    function PickupAddressSearchController($element, locationService, pickupAddressSearchService, moveFocus) {
        _classCallCheck(this, PickupAddressSearchController);

        this.$element = $element;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.moveFocus = moveFocus;
    }

    _createClass(PickupAddressSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.searchPending = false;

            this.clearSearch();
            this.getLocation().then(function (location) {
                return _this.search(location);
            });
        }
    }, {
        key: 'onKeyPress',
        value: function onKeyPress($event) {
            this.searchPending = true;
            if ($event && $event.keyCode === 13) {
                $event.preventDefault();
                this.searchPending = false;
                if (!this.searchString) {
                    return;
                }
                this.search(this.searchString);
            }
        }
    }, {
        key: 'onClickSearchInput',
        value: function onClickSearchInput() {
            if (this.searchString === LOCATION_SEARCH_TEXT) {
                this.searchString = '';
            }
        }
    }, {
        key: 'onClickSearch',
        value: function onClickSearch($event) {
            $event.preventDefault();
            if (!this.searchString) {
                return;
            }
            this.searchPending = false;
            this.search(this.searchString);
        }
    }, {
        key: 'search',
        value: function search(searchTerm) {
            var _this2 = this;

            if (this.searchPending) {
                this.searchPending = false;
                return;
            }
            this.searchString = searchTerm instanceof LatLng ? LOCATION_SEARCH_TEXT : searchTerm;
            this.isSearching = true;
            this.hasSearched = true;

            this.performSearch(searchTerm).finally(function () {
                _this2.isSearching = false;
                _this2.moveFocus('._pickupAddressSearch-resultList');
            });
        }
    }, {
        key: 'performSearch',
        value: function performSearch(searchTerm) {
            if (searchTerm instanceof LatLng) {
                return this.searchStoresByGeolocation(searchTerm);
            }

            if (isNaN(searchTerm)) {
                return this.searchSuburbs(searchTerm);
            }

            return this.searchStoresByPostcode(searchTerm);
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            var _this3 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
            return this.pickupAddressSearchService.searchSuburbs(searchTerm).then(function (suburbs) {
                _this3.suburbs = suburbs;
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var _this4 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByPostcode({ postcode: postcode }).then(function (pickupStores) {
                return _this4.setStores({ stores: pickupStores });
            });
        }
    }, {
        key: 'searchStoresByGeolocation',
        value: function searchStoresByGeolocation(position) {
            var _this5 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByGeolocation(position).then(function (pickupStores) {
                return _this5.setStores({ stores: pickupStores });
            });
        }
    }, {
        key: 'getLocation',
        value: function getLocation() {
            return this.locationService.getCurrentLocation();
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.searchPending = false;
            this.hasSearched = false;
            this.isSearching = false;
            this.searchString = '';
            this.setStores({ stores: [] });
        }
    }, {
        key: 'resetSearch',
        value: function resetSearch() {
            this.clearSearch();
            this.moveFocus('._pickupAddressSearch-input');
        }
    }]);

    return PickupAddressSearchController;
}();

var pickupAddressSearchComponentDefinition = {
    bindings: {
        suburbs: '=',
        searchMode: '=',
        isSearching: '=',
        hasSearched: '=',
        searchString: '=',
        setStores: '&'
    },
    controller: ['$element', 'LocationService', 'PickupAddressSearchService', 'MoveFocus', PickupAddressSearchController],
    template: __webpack_require__(576).trim()
};

module.exports = {
    PickupAddressSearchController: PickupAddressSearchController,
    pickupAddressSearchComponentDefinition: pickupAddressSearchComponentDefinition
};

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = "<fieldset class=\"pickupAddressSearch-search\">\r\n    <legend class=\"sr-only\">Pickup store search</legend>\r\n\r\n    <wow-input-container class=\"pickupAddressSearch-inputContainer\">\r\n        <label for=\"pickupAddressSearch-storeSearch\">\r\n            <wow-setting setting-group=\"ClickAndCollect\" setting-name=\"ClickAndCollectStoreSearchLabel\"></wow-setting>\r\n        </label>\r\n\r\n        <input\r\n            id=\"pickupAddressSearch-storeSearch\"\r\n            type=\"search\"\r\n            class=\"pickupAddressSearch-input _pickupAddressSearch-input\"\r\n            ng-model=\"$ctrl.searchString\"\r\n            autocomplete=\"off\"\r\n            ng-keypress=\"$ctrl.onKeyPress($event)\"\r\n            ng-click=\"$ctrl.onClickSearchInput()\"\r\n            oly-grab-focus=\"true\" />\r\n\r\n        <button\r\n            type=\"button\"\r\n            class=\"pickupAddressSearch-inputButton\"\r\n            ng-show=\"$ctrl.hasSearched\"\r\n            ng-click=\"$ctrl.resetSearch()\">\r\n            <span class=\"sr-only\">Reset pickup store search</span>\r\n            <i class=\"icon-close_x\"></i>\r\n        </button>\r\n\r\n        <button\r\n            type=\"submit\"\r\n            class=\"pickupAddressSearch-inputButton\"\r\n            ng-show=\"!$ctrl.hasSearched\"\r\n            ng-click=\"$ctrl.onClickSearch($event)\">\r\n            <span class=\"sr-only\">Search for pickup stores</span>\r\n            <i class=\"icon-search\"></i>\r\n        </button>\r\n\r\n    </wow-input-container>\r\n</fieldset>\r\n\r\n<fieldset class=\"pickupAddress-resultsContainer\" ng-if=\"$ctrl.hasSearched && $ctrl.searchMode === $ctrl.pickupAddressSearchService.searchModes.suburbs\">\r\n    <ul class=\"pickupAddress-results\"\r\n        role=\"listbox\"\r\n        aria-label=\"Pickup {{$ctrl.searchMode}} search results for {{$ctrl.searchString}}\">\r\n\r\n        <li ng-if=\"$ctrl.isSearching\">\r\n            <wow-loading-spinner message=\"Searching for suburbs, please wait...\"></wow-loading-spinner>\r\n        </li>\r\n\r\n        <li\r\n            role=\"option\"\r\n            class=\"pickupAddress-searchResult _pickupAddressSearch-searchResult\"\r\n            ng-if=\"!$ctrl.isSearching && $ctrl.suburbs.length > 0\"\r\n            ng-repeat=\"suburb in $ctrl.suburbs\">\r\n\r\n            <input\r\n                type=\"radio\"\r\n                name=\"suburb\"\r\n                id=\"{{ ::suburb.PostCode }}\"\r\n                class=\"wowRadio\"\r\n                ng-class=\"{'_pickupAddressSearch-resultList': $index === 0}\"\r\n                ng-value=\"::suburb.PostCode\"\r\n                ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.search(suburb.PostCode)\">\r\n\r\n            <label for=\"{{ ::suburb.PostCode }}\" ng-click=\"::$ctrl.search(suburb.PostCode)\">\r\n                <span class=\"sr-only\">Search for stores from</span>\r\n                <p class=\"pickupAddress-storeDescription\">{{::suburb.SuburbStateString}}</p>\r\n            </label>\r\n        </li>\r\n\r\n        <li role=\"option\" ng-if=\"!$ctrl.searching &&  $ctrl.suburbs.length === 0\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"pickupAddress-button linkButton _pickupAddressSearch-resultList\"\r\n                ng-click=\"$ctrl.resetSearch()\">\r\n                No results found. <span class=\"sr-only\">Select to search again.</span>\r\n            </button>\r\n        </li>\r\n    </ul>\r\n</fieldset>\r\n"

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var PickupAddressListController = function () {
    function PickupAddressListController($scope, $element, addressService, stateService, moveFocus) {
        var _this = this;

        _classCallCheck(this, PickupAddressListController);

        this.$scope = $scope;
        this.$element = $element;
        this.stateService = stateService;
        this.moveFocus = moveFocus;

        this.updatePickupStores = _.debounce(function (selectedState) {
            _this.isSearching = true;
            _this.hasSearched = true;
            var args = selectedState && selectedState.Code ? { state: selectedState.Code } : undefined;
            addressService.getPickupAddresses(args).then(function (pickupStores) {
                _this.isSearching = false;
                _this.setStores({ stores: pickupStores });
            });
        }, 500);

        $scope.$watch(function () {
            return _this.states.selectedState;
        }, function () {
            return _this.updatePickupStores(_this.states.selectedState);
        });
    }

    _createClass(PickupAddressListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.states = {
                states: [],
                selectedState: null
            };

            this.moveFocus(this.$element.find('._pickupAddressList-stateSelect'));

            this.stateService.getStates().then(function (states) {
                var selectedState = _.find(states, 'IsStateForDeliveryAddress');

                if (!selectedState) {
                    selectedState = _.first(states);
                }

                _this2.states = {
                    states: states,
                    selectedState: selectedState
                };
            });
        }
    }]);

    return PickupAddressListController;
}();

var pickupAddressListComponentDefinition = {
    bindings: {
        hasSearched: '=',
        isSearching: '=',
        pickupStores: '=',
        setStores: '&'
    },
    controller: ['$scope', '$element', 'AddressService', 'StateService', 'MoveFocus', PickupAddressListController],
    template: __webpack_require__(578).trim()
};

module.exports = {
    PickupAddressListController: PickupAddressListController,
    pickupAddressListComponentDefinition: pickupAddressListComponentDefinition
};

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pickupAddressList\" ng-if=\"$ctrl.states.selectedState\">\r\n    <fieldset class=\"pickupAddressSearch-search\">\r\n        <wow-select-container class=\"pickupaddresslist-stateselect\">\r\n            <label for=\"pickupAddressList-states\">Filter by state</label>\r\n            <select id=\"pickupAddressList-states\"\r\n                    class=\"_pickupAddressList-stateSelect\"\r\n                    ng-model=\"$ctrl.states.selectedState\"\r\n                    ng-options=\"state.Label for state in $ctrl.states.states\"\r\n                    oly-grab-focus=\"true\">\r\n            </select>\r\n        </wow-select-container>\r\n    </fieldset>\r\n</div>\r\n"

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PickupAddressController = function () {
    function PickupAddressController($element, settings, pickupAddressSearchService, featureService, moveFocus) {
        _classCallCheck(this, PickupAddressController);

        this.$element = $element;
        this.pickupAddressSearch = pickupAddressSearchService;
        this.settings = settings;
        this.moveFocus = moveFocus;

        this.isStoreSearchEnabled = featureService.isEnabled(featureService.features.clickAndCollectStoreSearch);
        this.id = $element.attr('id') || '';
    }

    _createClass(PickupAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            this.pickupStores = [];

            this.storesPerPage = this.settings.clickAndCollect.clickAndCollectStoresPerPage;
            this.numberOfStoresToShow = this.storesPerPage;
        }
    }, {
        key: 'setStores',
        value: function setStores(stores) {
            this.pickupStores = stores;
            this.selectedStore = null;
        }
    }, {
        key: 'hasStores',
        value: function hasStores() {
            return !!this.pickupStores && this.pickupStores.length > 0;
        }
    }, {
        key: 'hasMoreStores',
        value: function hasMoreStores() {
            return this.hasStores() && this.numberOfStoresToShow < this.pickupStores.length;
        }
    }, {
        key: 'viewMoreStores',
        value: function viewMoreStores() {
            var _this = this;

            var numberPreviouslyShowing = this.numberOfStoresToShow;

            if (this.hasMoreStores()) {
                this.numberOfStoresToShow += this.storesPerPage;
            }

            this.moveFocus(function () {
                return _this.$element.find('._pickupAddressSearch-searchResult').eq(numberPreviouslyShowing);
            });
        }
    }, {
        key: 'onSelectStore',
        value: function onSelectStore(store) {
            this.selectedStore = store.AddressId;
            this.setPickupAddress({ addr: store });
        }
    }]);

    return PickupAddressController;
}();

var pickupAddressComponentDefinition = {
    bindings: {
        setPickupAddress: '&',
        classModifier: '@?',
        isRequired: '<?'
    },
    controller: ['$element', 'Settings', 'PickupAddressSearchService', 'FeatureService', 'MoveFocus', PickupAddressController],
    template: __webpack_require__(580).trim()
};

module.exports = {
    PickupAddressController: PickupAddressController,
    pickupAddressComponentDefinition: pickupAddressComponentDefinition
};

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pickupAddress\" ng-switch=\"$ctrl.isStoreSearchEnabled\" ng-class=\"::'pickupAddress--' + $ctrl.classModifier\">\r\n    <ng-form name=\"$ctrl.pickupAddress\">\r\n        <div class=\"pickupAddress-filter\">\r\n            <wow-pickup-address-search\r\n                search-string=\"$ctrl.searchString\"\r\n                search-mode=\"$ctrl.searchMode\"\r\n                is-searching=\"$ctrl.isSearching\"\r\n                has-searched=\"$ctrl.hasSearched\"\r\n                suburbs=\"$ctrl.suburbs\"\r\n                set-stores=\"$ctrl.setStores(stores)\"\r\n                ng-switch-when=\"true\">\r\n            </wow-pickup-address-search>\r\n\r\n            <wow-pickup-address-list\r\n                set-stores=\"$ctrl.setStores(stores)\"\r\n                is-searching=\"$ctrl.isSearching\"\r\n                has-searched=\"$ctrl.hasSearched\"\r\n                ng-switch-when=\"false\">\r\n            </wow-pickup-address-list>\r\n        </div>\r\n\r\n        <fieldset class=\"pickupAddress-resultsContainer\" ng-if=\"$ctrl.hasSearched\">\r\n            <ul class=\"pickupAddress-results\"\r\n                role=\"listbox\"\r\n                aria-label=\"Pickup {{$ctrl.searchMode}} search results for {{$ctrl.searchString}}\"\r\n                ng-if=\"$ctrl.searchMode !== $ctrl.pickupAddressSearch.searchModes.suburbs\">\r\n\r\n                <li ng-if=\"$ctrl.isSearching\">\r\n                    <wow-loading-spinner message=\"Searching for stores, please wait...\"></wow-loading-spinner>\r\n                </li>\r\n\r\n                <li role=\"option\" ng-if=\"!$ctrl.isSearching\" class=\"pickupAddress-searchResult _pickupAddressSearch-searchResult\"\r\n                    ng-repeat=\"store in $ctrl.pickupStores | limitTo: $ctrl.numberOfStoresToShow track by store.AddressId\">\r\n\r\n                    <input\r\n                        type=\"radio\"\r\n                        name=\"pickupStore\"\r\n                        id=\"{{ ::$ctrl.id + store.AddressId }}\"\r\n                        class=\"wowRadio\"\r\n                        ng-model=\"$ctrl.selectedStore\"\r\n                        ng-value=\"::store.AddressId\"\r\n                        ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.onSelectStore(store)\">\r\n\r\n                    <label for=\"{{ ::$ctrl.id + store.AddressId }}\" class=\"pickupAddress-storeDetails\" ng-click=\"$ctrl.onSelectStore(store)\">\r\n                        <span class=\"sr-only\">Select </span>\r\n                        <span class=\"pickupAddress-store\">\r\n                            <p class=\"pickupAddress-storeDescription\">{{::store.Description}}</p>\r\n                            <address class=\"pickupAddress-storeAddress\">{{::store.Street1}}</address>\r\n                        </span>\r\n\r\n                        <span class=\"pickupAddress-storeDistance\" ng-show=\"::store.Distance\">{{::store.Distance}}km <span class=\"sr-only\">away</span></span>\r\n\r\n                        <span class=\"sr-only\"> as pickup store.</span>\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </fieldset>\r\n\r\n        <div class=\"pickupAddress-more\" ng-if=\"$ctrl.hasSearched && $ctrl.hasStores() && $ctrl.searchMode !== $ctrl.pickupAddressSearch.searchModes.suburbs\" ng-switch=\"$ctrl.hasMoreStores()\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"pickupAddress-button linkButton\"\r\n                ng-switch-when=\"true\"\r\n                ng-click=\"$ctrl.viewMoreStores()\">View more <i class=\"iconww-Plus pickupAddress-buttonIcon\"></i></button>\r\n            <button type=\"button\" class=\"pickupAddress-button linkButton\" ng-switch-when=\"false\" disabled>No more results to view</button>\r\n        </div>\r\n\r\n        <wow-input-container class=\"pickupAddress-validationMessages\" ng-show=\"$ctrl.pickupAddress.$invalid && $ctrl.pickupAddress.$submitted\">\r\n            <!-- hidden input field for form validation -->\r\n            <input type=\"hidden\" class=\"hidden\" name=\"pickupAddressList\" ng-model=\"$ctrl.selectedStore\" ng-required=\"$ctrl.isRequired\" />\r\n            <span ng-messages=\"$ctrl.pickupAddress.$error\" class=\"wowInput-errors\" id=\"pickupAddressErrors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">A store has not been selected.</span>\r\n            </span>\r\n        </wow-input-container>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedAddressesController = function () {
    function SavedAddressesController(moveFocus, addressService) {
        _classCallCheck(this, SavedAddressesController);

        this.moveFocus = moveFocus;
        this.addressService = addressService;
    }

    _createClass(SavedAddressesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.addressService.getSavedAddresses().then(function () {
                _this.savedAddresses = _this.addressService.savedAddresses;
                if (_this.savedAddresses && _this.savedAddresses.length > 0) {
                    _this.moveFocus('#savedAddresses-results');
                }
            });
        }
    }]);

    return SavedAddressesController;
}();

var savedAddressesComponentDefinition = {
    bindings: {
        isGuest: '<',
        onSavedAddressSelected: '&?',
        onSaveNewManualAddress: '&',
        onSaveNewAutoAddress: '&'
    },
    controller: ['MoveFocus', 'AddressService', SavedAddressesController],
    template: __webpack_require__(582).trim()
};

module.exports = {
    SavedAddressesController: SavedAddressesController,
    savedAddressesComponentDefinition: savedAddressesComponentDefinition
};

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "<div class=\"savedAddresses\">\r\n    <fieldset class=\"savedAddresses-choices\" id=\"savedAddresses-results\" ng-if=\"::!$ctrl.isGuest\">\r\n        <legend class=\"savedAddresses-legend\">\r\n            Previously used addresses\r\n        </legend>\r\n\r\n        <wow-loading-spinner ng-if=\"!$ctrl.savedAddresses\" message=\"Loading your saved addresses.\"></wow-loading-spinner>\r\n\r\n        <p ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length === 0\">\r\n            (0) Saved addresses found\r\n        </p>\r\n\r\n        <div class=\"savedAddresses-savedAddress\"\r\n            ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length > 0\"\r\n            ng-repeat=\"address in $ctrl.savedAddresses track by address.AddressId\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"savedAddress\"\r\n                id=\"address-{{ ::address.AddressId }}\"\r\n                class=\"wowRadio\"\r\n                ng-value=\"address.AddressId\"\r\n                ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.onSavedAddressSelected({ address: address })\"\r\n                ng-checked=\"$first\">\r\n            <label\r\n                for=\"address-{{ ::address.AddressId }}\"\r\n                ng-click=\"$ctrl.onSavedAddressSelected({ address: address })\">\r\n                {{ ::address.AddressText }}\r\n            </label>\r\n        </div>\r\n    </fieldset>\r\n\r\n    <hr class=\"savedAddresses-separator\" ng-if=\"::!$ctrl.isGuest\">\r\n\r\n    <ng-form name=\"$ctrl.savedAddressForm\">\r\n        <fieldset class=\"savedAddresses-addresses\">\r\n            <legend class=\"savedAddresses-legend savedAddresses-search\">\r\n                Enter a new delivery address\r\n            </legend>\r\n\r\n            <wow-address-entry-form\r\n                input-id=\"savedAddress\"\r\n                message-on-error=\"Unable to set address.\"\r\n                on-save-auto-address=\"$ctrl.onSaveNewAutoAddress({ address: address })\"\r\n                on-save-manual-address=\"$ctrl.onSaveNewManualAddress({ address: address })\"\r\n                should-focus-initially=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length === 0\"\r\n                should-reset-mode=\"false\"\r\n                show-submit=\"true\">\r\n            </wow-address-entry-form>\r\n        </fieldset>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    find = _require.find;

var ManualAddressController = function () {
    function ManualAddressController(addressService, moveFocus, $q, settings) {
        _classCallCheck(this, ManualAddressController);

        this.addressService = addressService;
        this.moveFocus = moveFocus;
        this.$q = $q;

        this.maxCharactersManualAddress1 = settings.oneSite.maxCharactersManualAddress1;
        this.maxCharactersManualAddress2 = settings.oneSite.maxCharactersManualAddress2;
    }

    _createClass(ManualAddressController, [{
        key: 'addressChange',
        value: function addressChange() {
            if (this.onAddressChange) {
                this.onAddressChange({ address: this.address });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.moveFocus('#manualAddress');
            if (!this.initialAddress) {
                this.clearInput();
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.initialAddress && this.initialAddress) {
                this.clearInput();
                this.useInitialAddress(this.initialAddress);
            }
        }
    }, {
        key: 'clearInput',
        value: function clearInput() {
            this.address = { postcode: '', street1: '', street2: '', suburbId: null, suburb: '' };
            this.suburbs = [];
        }
    }, {
        key: 'useInitialAddress',
        value: function useInitialAddress(address) {
            var _this = this;

            this.address.postcode = address.postcode;
            this.loadSuburbs().then(function () {
                var initialSuburb = _this.getInitialSuburb(address);
                _this.address = {
                    postcode: address.postcode,
                    street1: address.street1,
                    street2: address.street2,
                    suburbId: initialSuburb.Id,
                    suburb: initialSuburb.Text
                };
                _this.setSuburb({
                    Id: initialSuburb.Id,
                    Text: initialSuburb.Text
                });
            });
        }
    }, {
        key: 'getInitialSuburb',
        value: function getInitialSuburb(address) {
            return address.suburbId ? {
                Id: address.suburbId,
                Text: address.suburbName
            } : this.getSuburbByName(address.suburbName);
        }
    }, {
        key: 'getSuburbByName',
        value: function getSuburbByName(suburbName) {
            return suburbName && this.suburbs && this.suburbs.length ? find(this.suburbs, function (item) {
                return item.Text.toLowerCase() === suburbName.toLowerCase();
            }) : { Id: '', Text: '' };
        }
    }, {
        key: 'setSuburb',
        value: function setSuburb(suburb) {
            if (suburb) {
                this.address.suburbId = !suburb.Id || suburb.Id === 'n/a' ? 0 : suburb.Id;
                this.address.suburb = suburb.Text;
                this.selectedSuburb = suburb;
                this.addressChange();
            }
            return this.selectedSuburb;
        }
    }, {
        key: 'loadSuburbs',
        value: function loadSuburbs() {
            var _this2 = this;

            if (this.address.postcode && this.address.postcode.length === 4) {
                return this.addressService.getSuburbs(this.address.postcode).then(function (suburbs) {
                    _this2.suburbs = suburbs;
                    if (_this2.suburbs && _this2.suburbs.length) {
                        _this2.setSuburb(_this2.suburbs[0]);
                    }

                    _this2.addressChange();
                });
            }
            return this.$q.reject();
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            this.onAddressSaved({ address: this.address });
        }
    }]);

    return ManualAddressController;
}();

var manualAddressComponentDefinition = {
    bindings: {
        initialAddress: '<?',
        messageOnError: '@?',
        onAddressSaved: '&',
        onAddressChange: '&?',
        showSubmit: '<'
    },
    controller: ['AddressService', 'MoveFocus', '$q', 'Settings', ManualAddressController],
    template: __webpack_require__(584).trim()
};

module.exports = {
    ManualAddressController: ManualAddressController,
    manualAddressComponentDefinition: manualAddressComponentDefinition
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.manualAddressForm\" class=\"manualAddress\" id=\"manualAddress\">\r\n    <oly-form-validation-summary user-message=\"{{ ::$ctrl.messageOnError }}\" ng-if=\"$ctrl.messageOnError\"></oly-form-validation-summary>\r\n    <wow-input-container>\r\n        <label for=\"street1\">\r\n            Street Address 1 *\r\n        </label>\r\n        <input\r\n            type=\"text\"\r\n            id=\"manualAddressForm-street1\"\r\n            name=\"street1\"\r\n            ng-model=\"$ctrl.address.street1\"\r\n            ng-change=\"$ctrl.addressChange()\"\r\n            required\r\n            autocomplete=\"off\"\r\n            ng-model-options=\"{ updateOn: 'blur' }\"\r\n            ng-maxlength=\"{{ $ctrl.maxCharactersManualAddress1 }}\"\r\n            oly-grab-focus=\"true\"/>\r\n        <span ng-messages=\"$ctrl.manualAddressForm.street1.$error\" class=\"wowInput-errors\">\r\n            <span ng-message=\"required\" class=\"wowInput-error\">Street address is required.</span>\r\n            <span ng-message=\"maxlength\" class=\"wowInput-error\">\r\n                {{maxCharactersManualAddress1}} characters limit is exceeded.\r\n            </span>\r\n        </span>\r\n    </wow-input-container>\r\n    <wow-input-container>\r\n        <label for=\"street2\">\r\n            Street Address 2<span class=\"sr-only\"> optional</span>\r\n        </label>\r\n        <input\r\n            type=\"text\"\r\n            id=\"manualAddressForm-street2\"\r\n            name=\"street2\"\r\n            ng-model=\"$ctrl.address.street2\"\r\n            ng-change=\"$ctrl.addressChange()\"\r\n            ng-model-options=\"{ updateOn: 'blur' }\"\r\n            ng-maxlength=\"{{ $ctrl.maxCharactersManualAddress2 }}\"/>\r\n        <span ng-messages=\"$ctrl.manualAddressForm.street2.$error\" class=\"wowInput-errors\">\r\n            <span ng-message=\"maxlength\" class=\"wowInput-error\">\r\n                {{maxCharactersManualAddress2}} characters limit is exceeded.\r\n            </span>\r\n        </span>\r\n    </wow-input-container>\r\n    <wow-input-container>\r\n        <label for=\"postCode\">\r\n            Postcode *\r\n        </label>\r\n        <input\r\n            type=\"tel\"\r\n            id=\"manualAddressForm-postCode\"\r\n            name=\"postCode\"\r\n            ng-model=\"$ctrl.address.postcode\"\r\n            class=\"wowInput--small\"\r\n            wow-post-code\r\n            ng-change=\"$ctrl.loadSuburbs()\"\r\n            required\r\n            autocomplete=\"off\"\r\n            ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 200, blur: 0 } }\"/>\r\n        <span ng-messages=\"$ctrl.manualAddressForm.postCode.$error\" class=\"wowInput-errors\">\r\n            <span ng-message=\"required\" class=\"wowInput-error\">Postcode is required.</span>\r\n            <span ng-message=\"invalid\" class=\"wowInput-error\">The postcode entered is invalid.</span>\r\n        </span>\r\n    </wow-input-container>\r\n\r\n    <div class=\"wowInputContainer\">\r\n        <wow-select-container>\r\n            <label for=\"suburb\">Suburb *</label>\r\n            <select name=\"suburb\"\r\n                id=\"manualAddressForm-suburb\"\r\n                ng-model=\"$ctrl.setSuburb\"\r\n                ng-model-options=\"{ updateOn: 'default', getterSetter: true }\"\r\n                ng-options=\"s as s.Text for s in $ctrl.suburbs track by s.Id\"\r\n                ng-class=\"{'is-disabled': !$ctrl.suburbs.length}\"\r\n                ng-required=\"$ctrl.suburbs.length\">\r\n                <option value=\"\" ng-if=\"!$ctrl.suburbs.length\">\r\n                    Please enter a postcode\r\n                </option>\r\n            </select>\r\n        </wow-select-container>\r\n\r\n        <span ng-messages=\"$ctrl.manualAddressForm.suburb.$error\" class=\"wowInput-errors\">\r\n            <span ng-message=\"required\" class=\"wowInput-error\">Suburb is required.</span>\r\n        </span>\r\n    </div>\r\n    <button type=\"submit\"\r\n            class=\"manualAddress-button linkButton\"\r\n            ng-click=\"$ctrl.manualAddressForm.$valid && $ctrl.onSubmit()\"\r\n            ng-if=\"$ctrl.showSubmit\">\r\n        Save\r\n    </button>\r\n</ng-form>\r\n"

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddressEntryFormController = function () {
    function AddressEntryFormController($q, moveFocus, addressService, fulfilmentService, addressEntryModes) {
        _classCallCheck(this, AddressEntryFormController);

        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.addressEntryModes = addressEntryModes;
    }

    _createClass(AddressEntryFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.shouldResetMode = this.shouldResetMode !== undefined ? this.shouldResetMode : true;
            this.shouldFocusInitially = this.shouldFocusInitially !== undefined ? this.shouldFocusInitially : true;
            this.clearInput();
            if (!this.initialAddress) {
                this.addressEntryMode = this.addressEntryModes.search;
            }
            this.address = null;

            if (this.shouldFocusInitially) {
                this.moveFocus('#address-' + this.inputId);
            }
        }
    }, {
        key: 'getItemText',
        value: function getItemText(item) {
            return item.Text;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.initialAddress && this.initialAddress) {
                this.setEntryMode(this.addressEntryModes.manual);
            }
        }
    }, {
        key: 'clearInput',
        value: function clearInput() {
            this.autocompleteText = this.addressQuery ? this.addressQuery.AddressText : '';
        }
    }, {
        key: 'saveSearchedAddress',
        value: function saveSearchedAddress(address) {
            if (this.onSaveAutoAddress) {
                this.onSaveAutoAddress({ address: address });
            }
            if (!this.shouldRetainInput) {
                this.clearInput();
            } else {
                this.autocompleteText = address.Text;
            }
        }
    }, {
        key: 'saveManualAddress',
        value: function saveManualAddress(address) {
            var _this = this;

            if (address.suburbId && address.suburbId > 0) {
                if (this.onSaveManualAddress) {
                    this.$q.when(this.onSaveManualAddress({ address: address })).then(function () {
                        if (_this.shouldResetMode) {
                            _this.setEntryMode(_this.addressEntryModes.search);
                        }
                    });
                }
                if (!this.shouldRetainInput) {
                    this.clearInput();
                }
            }
        }
    }, {
        key: 'setEntryMode',
        value: function setEntryMode(mode) {
            this.addressEntryMode = mode;
            if (mode === this.addressEntryModes.search) {
                this.moveFocus('#address-' + this.inputId);
            }
            this.address = null;
        }
    }, {
        key: 'addressEntryMode',
        set: function set(mode) {
            this.entryMode = mode;
            if (this.onSetEntryMode) {
                this.onSetEntryMode({ mode: mode });
            }
        },
        get: function get() {
            return this.entryMode;
        }
    }]);

    return AddressEntryFormController;
}();

var addressEntryFormComponentDefinition = {
    bindings: {
        inputId: '@',
        addressQuery: '<?',
        showSubmit: '=?',
        messageOnError: '@?',
        shouldFocusInitially: '<?',
        shouldResetMode: '<?',
        shouldRetainInput: '<?',
        onSaveAutoAddress: '&?',
        onSaveManualAddress: '&?',
        onManualAddressChange: '&?',
        onSetEntryMode: '&?',
        initialAddress: '<?'
    },
    controller: ['$q', 'MoveFocus', 'AddressService', 'FulfilmentService', 'AddressEntryModes', AddressEntryFormController],
    template: __webpack_require__(586).trim()
};

module.exports = {
    AddressEntryFormController: AddressEntryFormController,
    addressEntryFormComponentDefinition: addressEntryFormComponentDefinition
};

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = "<div class=\"addressEntryForm\" ng-switch=\"$ctrl.addressEntryMode\">\r\n    <fieldset ng-switch-when=\"SEARCH\">\r\n        <ng-form name=\"$ctrl.autoAddressForm\" novalidate>\r\n            <oly-form-validation-summary user-message=\"{{ ::$ctrl.messageOnError }}\" ng-if=\"$ctrl.messageOnError\"></oly-form-validation-summary>\r\n            <wow-input-container>\r\n                <label for=\"address-{{$ctrl.inputId}}\">\r\n                    Search for a new address *\r\n                </label>\r\n                <oly-autocomplete\r\n                    input-id=\"address-{{$ctrl.inputId}}\"\r\n                    input-name=\"address\"\r\n                    class=\"addressEntryForm-searchAutocompleteWrapper\"\r\n                    text=\"$ctrl.autocompleteText\"\r\n                    items=\"$ctrl.addressService.addressOnType($ctrl.autocompleteText)\"\r\n                    item-text=\"$ctrl.getItemText\"\r\n                    selected-item=\"$ctrl.address\"\r\n                    run-on-select=\"$ctrl.saveSearchedAddress($ctrl.address)\"\r\n                    is-required=\"true\"\r\n                    search-box-class=\"addressEntryForm-searchAutocompleteTextField\"\r\n                    dropdown-class=\"addressEntryForm-searchAutocompleteDropdown\"\r\n                    show-clear-button=\"true\"\r\n                    action-button-wrapper-class=\"addressEntryForm-searchAutocompleteActionsWrapper\"\r\n                    action-button-class=\"addressEntryForm-searchAutocompleteClearButton\">\r\n                    <autocomplete-item>\r\n                        {{ ::item.Text }}\r\n                    </autocomplete-item>\r\n                    <autocomplete-not-found>\r\n                        No addresses found for “{{$ctrl.autocompleteText}}”\r\n                    </autocomplete-not-found>\r\n                </oly-autocomplete>\r\n                <span ng-messages=\"$ctrl.autoAddressForm.address.$error\" class=\"wowInput-errors\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">Address is required.</span>\r\n                </span>\r\n                <p class=\"addressEntryForm-tip\">Enter street number followed by street name</p>\r\n            </wow-input-container>\r\n\r\n            <button\r\n                type=\"button\"\r\n                class=\"addressEntryForm-button linkButton\"\r\n                ng-click=\"::$ctrl.setEntryMode($ctrl.addressEntryModes.manual)\">\r\n                Enter my address manually\r\n            </button>\r\n        </ng-form>\r\n    </fieldset>\r\n\r\n    <fieldset ng-switch-when=\"MANUAL\">\r\n        <wow-manual-address\r\n            initial-address=\"$ctrl.initialAddress\"\r\n            message-on-error=\"{{ ::$ctrl.messageOnError }}\"\r\n            on-address-change=\"$ctrl.onManualAddressChange({address: address})\"\r\n            on-address-saved=\"$ctrl.saveManualAddress(address)\"\r\n            show-submit=\"$ctrl.showSubmit\">\r\n        </wow-manual-address>\r\n\r\n        <button\r\n            type=\"button\"\r\n            class=\"addressEntryForm-button linkButton\"\r\n            ng-click=\"::$ctrl.setEntryMode($ctrl.addressEntryModes.search)\">\r\n            Search for an address\r\n        </button>\r\n    </fieldset>\r\n</div>\r\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    find = _require.find,
    remove = _require.remove;

var AddressService = function () {
    function AddressService($timeout, $q, restangular, trolleyService) {
        _classCallCheck(this, AddressService);

        this._addressRoute = restangular.one('address');
        this.$timeout = $timeout;
        this.$q = $q;
        this.trolleyService = trolleyService;

        this.initialize();
    }

    _createClass(AddressService, [{
        key: 'initialize',
        value: function initialize() {
            this.suburbs = [];
            this.autoAddresses = [];
            this.savedAddress = {};
            this.searchError = {
                Id: '',
                Text: ''
            };

            this.savedError = {
                ErrorType: '',
                ErrorCode: '',
                ErrorMessage: '',
                ErrorResponse: []
            };

            this.isNonServiced = false;
            this.autoAddressSearchTerm = '';
            this.autoAddressSource = ''; // Keep tracking of current template.
            this.nonServicedAddressResult = false;
            this.decideLater = {
                collect: { Description: 'a store which I\'ll set later' },
                delivery: { Description: 'an address which I\'ll set later' }
            };
        }

        // Internal functions

    }, {
        key: '_onSaveSuccess',
        value: function _onSaveSuccess(response) {
            this.isNonServiced = response.IsNonServiced;

            if (response.Address && response.Address.AddressText.length > 0) {
                this.savedAddress = response.Address;
                this.trolleyService.getTrolley();
                this.savedAddressesPromise = null;
                return response;
            }

            if (response.Address && response.Address.AddressId === 0) {
                this.savedError.ErrorType = 'Authentication Error';
                this.savedError.ErrorCode = 'Shopper is guest';
                this.savedError.ErrorMessage = 'Addresses cannot be saved for guest users.';
                return false;
            }

            this.savedError.ErrorType = 'Service Stack Error';
            this.savedError.ErrorCode = 'Invalid response';
            this.savedError.ErrorMessage = 'The address has failed to save.';
            return false;
        }
    }, {
        key: '_onSaveFailure',
        value: function _onSaveFailure(response) {
            this.savedError = response;
            if (response.data.ResponseStatus) {
                this.savedError.ErrorMessage = response.data.ResponseStatus.Message;
            }
            return false;
        }
    }, {
        key: '_clearAutoAddresses',
        value: function _clearAutoAddresses() {
            this.searchError = {
                Id: '',
                Text: ''
            };
            this.autoAddresses = [];
        }

        // global functions.

    }, {
        key: 'search',
        value: function search(query) {
            var _this = this;

            return this._addressRoute.one('search').doPOST({
                Search: query
            }).then(function (response) {
                if (response.Response && response.Response.length > 0 && response.Response[0].Id !== '') {
                    _this.autoAddresses = response.Response;
                } else {
                    _this.searchError = { Id: 'n/a', Text: '(0) Addresses found for ' + query };
                }
                return true;
            }, function () {
                _this.searchError = { Id: 'n/a', Text: 'An error has occured searching for ' + query };
                return false;
            });
        }
    }, {
        key: 'setAddress',
        value: function setAddress(address) {
            this.savedAddress = address;
        }
    }, {
        key: 'delete',
        value: function _delete(address) {
            var _this2 = this;

            remove(this.savedAddresses, function (a) {
                return a === address;
            });
            return this._addressRoute.one('delete').doPOST({ AddressId: address.AddressId }).finally(function () {
                return _this2.savedAddressesPromise = null;
            });
        }
    }, {
        key: 'saveAddress',
        value: function saveAddress(address) {
            var _this3 = this;

            return this._addressRoute.one('auto').doPOST({
                AddressId: address.Id
            }).then(function (response) {
                return _this3._onSaveSuccess(response);
            }, function (response) {
                return _this3._onSaveFailure(response);
            });
        }
    }, {
        key: 'updateAddress',
        value: function updateAddress(savedAddressId, selectedAddress) {
            var _this4 = this;

            return this._addressRoute.one('updateAuto').doPOST({
                SavedAddressId: savedAddressId,
                SelectedAddressId: selectedAddress.Id
            }).then(function (response) {
                return _this4._onSaveSuccess(response);
            }, function (response) {
                return _this4._onSaveFailure(response);
            });
        }
    }, {
        key: 'saveAutoAddress',
        value: function saveAutoAddress(addr) {
            var _this5 = this;

            if (addr && addr.Id !== 'n/a') {
                this._clearAutoAddresses();
                this.autoAddressSearchTerm = '';
                this.autoAddressSource = addr.source;
                return this.saveAddress(addr).then(function (address) {
                    if (address) {
                        _this5.autoAddressSearchTerm = '';
                    }
                    return address;
                });
            }
            return this.$q.when(null);
        }
    }, {
        key: 'saveManualAddress',
        value: function saveManualAddress(address) {
            var _this6 = this;

            return this._addressRoute.one('manual').doPOST({
                Street1: address.street1,
                Street2: address.street2,
                SuburbId: address.suburbId,
                Postcode: address.postcode
            }).then(function (response) {
                return _this6._onSaveSuccess(response);
            }, function (response) {
                return _this6._onSaveFailure(response);
            });
        }
    }, {
        key: 'saveNewManualAddressForBilling',
        value: function saveNewManualAddressForBilling(address) {
            return this._addressRoute.one('manualBilling').doPOST({
                Street1: address.street1,
                Street2: address.street2,
                SuburbId: address.suburbId,
                Postcode: address.postcode
            });
        }
    }, {
        key: 'saveNewAutoAddressForBilling',
        value: function saveNewAutoAddressForBilling(address) {
            this._clearAutoAddresses();
            this.autoAddressSearchTerm = '';
            this.autoAddressSource = address.source;
            return this._addressRoute.one('autoBilling').doPOST({
                AddressId: address.Id
            });
        }
    }, {
        key: 'setSavedAddressAsBilling',
        value: function setSavedAddressAsBilling(addressId) {
            return this._addressRoute.one('billing').doPOST({ addressId: addressId });
        }
    }, {
        key: 'updateManualAddress',
        value: function updateManualAddress(savedAddressId, newAddress) {
            var _this7 = this;

            return this._addressRoute.one('updateManual').doPOST({
                SavedAddressId: savedAddressId,
                Street1: newAddress.street1,
                Street2: newAddress.street2,
                SuburbId: newAddress.suburbId,
                Postcode: newAddress.postcode
            }).then(function (response) {
                return _this7._onSaveSuccess(response);
            }, function (response) {
                return _this7._onSaveFailure(response);
            });
        }
    }, {
        key: 'getSuburbs',
        value: function getSuburbs(query) {
            var _this8 = this;

            return this._addressRoute.one('suburb', query).get().then(function (response) {
                _this8.suburbs = response.Response && response.Response.length > 0 ? response.Response : [{ Id: 'n/a', Text: '(0) Suburbs found for ' + query }];
                return _this8.suburbs;
            }, function () {
                return [{ Id: 'n/a', Text: 'An error has occured searching for ' + query }];
            });
        }
    }, {
        key: 'getPrimaryAddress',
        value: function getPrimaryAddress() {
            return find(this.savedAddresses, { IsPrimary: true });
        }
    }, {
        key: 'setPickupAddress',
        value: function setPickupAddress() {
            var _this9 = this;

            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (address) {
                return this._addressRoute.one('SetPickup').doPOST({ AddressId: address.AddressId }).then(function () {
                    _this9.savedAddress.AddressId = address.AddressId;
                    _this9.savedAddress.AddressText = address.Description;
                });
            }
            this.savedAddress.AddressId = 0;
            this.savedAddress.AddressText = this.decideLater.collect.Description;
            return this.$q.when(this.savedAddress);
        }
    }, {
        key: 'setDeliveryAddress',
        value: function setDeliveryAddress() {
            var _this10 = this;

            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (address) {
                return this._addressRoute.one('SetDelivery').doPOST({ AddressId: address.AddressId }).then(function (data) {
                    _this10.savedAddress.AddressId = address.AddressId;
                    _this10.savedAddress.AddressText = address.AddressText;
                    _this10.isNonServiced = data.IsServiceNotAvailable;
                });
            }
            this.savedAddress.AddressId = 0;
            this.savedAddress.AddressText = this.decideLater.delivery.Description;
            return this.$q.when(this.savedAddress);
        }
    }, {
        key: 'getPickupAddresses',
        value: function getPickupAddresses(args) {
            return this._addressRoute.one('pickupaddresses').get(args).then(function (data) {
                return data.Response;
            });
        }
    }, {
        key: 'getSavedAddresses',
        value: function getSavedAddresses() {
            var _this11 = this;

            if (!this.savedAddressesPromise) {
                this.savedAddressesPromise = this._addressRoute.get().then(function (response) {
                    _this11.savedAddresses = response.Address;
                    return true;
                }, function () {
                    _this11.savedAddresses = [];
                    return false;
                });
            }
            return this.savedAddressesPromise;
        }
    }, {
        key: 'saveSelectedSavedAddress',
        value: function saveSelectedSavedAddress(address) {
            this.savedAddress.AddressId = address.AddressId;
            this.savedAddress.AddressText = address.AddressText;
            this.savedAddress.IsPrimary = address.IsPrimary;
            return this.setDeliveryAddress(address);
        }
    }, {
        key: 'isNonServicedAddress',
        value: function isNonServicedAddress(postcode, amasAddressId) {
            return this._addressRoute.one('IsNonService').get({
                Postcode: postcode,
                AmasAddressId: amasAddressId
            });
        }
    }, {
        key: 'setPartnerDeliveryAddress',
        value: function setPartnerDeliveryAddress(address) {
            var _this12 = this;

            return this._addressRoute.one('SetDelivery').one('PartnerBranch', address.PartnerBranchId).post().then(function () {
                _this12.savedAddress = address;
                _this12.trolleyService.getTrolley();
            });
        }
    }, {
        key: 'removePartnerAddressAssociation',
        value: function removePartnerAddressAssociation(branchId, addressId) {
            return this._addressRoute.post('DeletePartnerBranchAssociation', {
                PartnerBranchId: branchId,
                PartnerBranchAddressId: addressId
            });
        }
    }, {
        key: 'addressOnType',
        value: function addressOnType() {
            var _this13 = this;

            var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.autoAddressSearchTerm;

            this._clearAutoAddresses();
            return this.search(searchTerm).then(function (response) {
                return response ? _this13.autoAddresses : [];
            });
        }
    }, {
        key: 'addressOnSelectNonService',
        value: function addressOnSelectNonService(addr) {
            var _this14 = this;

            this.nonServicedAddressResult = false;
            this.autoAddressSource = addr.source;
            this.isNonServicedAddress(addr.Postcode, addr.Id).then(function (data) {
                if (data.IsNonServiced) {
                    _this14.nonServicedAddressResult = true;
                }
                if (addr && addr.Id !== 'n/a') {
                    _this14._clearAutoAddresses();
                    _this14.autoAddressSearchTerm = addr.Text;
                }
            });
        }
    }]);

    return AddressService;
}();

AddressService.$inject = ['$timeout', '$q', 'Restangular', 'TrolleyService'];

module.exports = AddressService;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1);

function PickupAddressSearchService(Restangular, storeService) {
    this.storeService = storeService;

    this._storeRoute = Restangular.one('PickupStores');

    this._cache = {};

    this.searchModes = {
        suburbs: 'suburbs',
        stores: 'stores',
        states: 'states'
    };
}

PickupAddressSearchService.prototype.searchByPostcode = function (args) {
    if (!(args.postcode in this._cache)) {
        this._cache[args.postcode] = this._storeRoute.one('Search').get(args);
    }

    return this._cache[args.postcode];
};

PickupAddressSearchService.prototype.searchByGeolocation = function (position) {
    return this._storeRoute.one('Search').get(position);
};

PickupAddressSearchService.prototype.searchSuburbs = _.memoize(function (searchTerm) {
    return this.storeService.searchSuburbs(searchTerm);
});

PickupAddressSearchService.prototype.invalidate = function () {
    this._cache = {};
};

module.exports = PickupAddressSearchService;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($rootScope, Restangular) {
    function StateService() {
        this._api = Restangular.one('states');
    }

    var statesPromise = void 0;
    StateService.prototype.getStates = function () {
        if (statesPromise) {
            return statesPromise;
        }

        statesPromise = this._api.get().then(function (states) {
            return states.plain();
        });

        return statesPromise;
    };

    StateService.prototype.invalidate = function () {
        statesPromise = null;
    };

    return new StateService();
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(591),
    deliveryWizardComponentDefinition = _require.deliveryWizardComponentDefinition;

var _require2 = __webpack_require__(593),
    expressDeliveryAlertControllerDefinition = _require2.expressDeliveryAlertControllerDefinition;

angular.module('wowApp.fulfilment').component('wowDeliveryWizard', deliveryWizardComponentDefinition).component('wowExpressDeliveryAlert', expressDeliveryAlertControllerDefinition);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryWizardController = function () {
    function DeliveryWizardController(addressService, timeslotService, shopperService, loginService, fulfilmentSteps) {
        _classCallCheck(this, DeliveryWizardController);

        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.shopperService = shopperService;

        this.timeTable = undefined;
    }

    _createClass(DeliveryWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.currentAddress) {
                this.fetchTimeslots(this.currentAddress.AreaId);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.isActive && changes.isActive.currentValue === false) {
                if (this.currentStep === this.fulfilmentSteps.address) {
                    this.decideAddressLater();
                } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                    this.decideTimeLater();
                }
            }
        }
    }, {
        key: 'fetchTimeslots',
        value: function fetchTimeslots(areaId) {
            var _this = this;

            this.timeTable = [];
            this.timeslotService.listTimeslots(areaId, 'Courier', this.shouldGetDynamicTimetable).then(function (dates) {
                _this.reservedWindow = _this.timeslotService.findReservedWindow(dates);
                _this.timeTable = dates.length === 0 ? null : dates;
                return dates;
            });
        }
    }, {
        key: 'loginToSaveAddress',
        value: function loginToSaveAddress(loginCallback) {
            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, loginCallback);
            } else {
                loginCallback();
            }
        }
    }, {
        key: 'saveNewManualAddressForDelivery',
        value: function saveNewManualAddressForDelivery(address) {
            var _this2 = this;

            this.loginToSaveAddress(function () {
                return _this2.addressService.saveManualAddress(address).then(function (addressResponse) {
                    return _this2.addressSelected(addressResponse.Address);
                });
            });
        }
    }, {
        key: 'saveNewAutoAddressForDelivery',
        value: function saveNewAutoAddressForDelivery(address) {
            var _this3 = this;

            this.loginToSaveAddress(function () {
                return _this3.addressService.saveAutoAddress(address).then(function (addressResponse) {
                    return _this3.addressSelected(addressResponse.Address);
                });
            });
        }
    }, {
        key: 'setDeliveryAddress',
        value: function setDeliveryAddress(address) {
            this.addressSelected(address);
        }
    }, {
        key: 'addressSelected',
        value: function addressSelected(address) {
            this.currentAddress = address;
            this.fetchTimeslots(this.currentAddress.AreaId);

            this.changes();
            this.currentStep = this.fulfilmentSteps.timeslot;
        }
    }, {
        key: 'decideAddressLater',
        value: function decideAddressLater() {
            this.currentAddress = null;
            this.selectedDate = null;
            this.selectedTime = null;
            this.finish();
        }
    }, {
        key: 'setDate',
        value: function setDate(date) {
            this.selectedDate = date;
        }
    }, {
        key: 'setTime',
        value: function setTime(time) {
            this.selectedTime = time;
            this.finish();
        }
    }, {
        key: 'decideTimeLater',
        value: function decideTimeLater() {
            this.selectedDate = null;
            this.selectedTime = null;
            this.finish();
        }
    }, {
        key: 'changes',
        value: function changes() {
            this.onFulfilmentChange(this.getCurrentFulfilmentInfo());
        }
    }, {
        key: 'finish',
        value: function finish() {
            this.onFulfilmentSelected(this.getCurrentFulfilmentInfo());
        }
    }, {
        key: 'getCurrentFulfilmentInfo',
        value: function getCurrentFulfilmentInfo() {
            return {
                fulfilmentInfo: {
                    address: this.currentAddress,
                    fulfilmentMethod: 'Courier', // matches the enum in the api
                    fulfilmentWindow: {
                        date: this.selectedDate,
                        time: this.selectedTime
                    }
                }
            };
        }
    }]);

    return DeliveryWizardController;
}();

DeliveryWizardController.$inject = ['AddressService', 'FulfilmentTimeslotService', 'ShopperService', 'LoginService', 'FulfilmentSteps'];

var deliveryWizardComponentDefinition = {
    controller: DeliveryWizardController,
    bindings: {
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        currentAddress: '<?',
        currentTimeslot: '<?',
        allowDecideLater: '<?',
        currentStep: '=',
        isActive: '<',
        shouldGetDynamicTimetable: '<?'
    },
    template: __webpack_require__(592).trim()
};

module.exports = {
    DeliveryWizardController: DeliveryWizardController,
    deliveryWizardComponentDefinition: deliveryWizardComponentDefinition
};

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address\" id=\"fulfilmentAddress\" class=\"deliveryWizard\">\r\n    <wow-saved-addresses\r\n        is-guest=\"$ctrl.shopperService.IsGuest\"\r\n        on-saved-address-selected=\"$ctrl.setDeliveryAddress(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForDelivery(address)\"\r\n        on-save-new-auto-address=\"$ctrl.saveNewAutoAddressForDelivery(address)\">\r\n    </wow-saved-addresses>\r\n\r\n    <hr class=\"fulfilmentMethodWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"fulfilmentMethodWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideAddressLater()\">\r\n            I'll choose an address later\r\n    </button>\r\n</fieldset>\r\n\r\n<fieldset class=\"fulfilmentMethodWizard-timetable\" id=\"fulfilmentTimetable\" ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">\r\n    <wow-fulfilment-timetable\r\n        time-table=\"$ctrl.timeTable\"\r\n        reserved-date=\"$ctrl.reservedWindow.date\"\r\n        reserved-time=\"$ctrl.reservedWindow.time\"\r\n        on-set-fulfilment-date=\"$ctrl.setDate(selectedDate)\"\r\n        on-set-fulfilment-time=\"$ctrl.setTime(fulfilmentTime)\"\r\n        is-delivery=\"true\">\r\n    </wow-fulfilment-timetable>\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"fulfilmentMethodWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideTimeLater()\">\r\n            I'll choose a time later\r\n    </button>\r\n</fieldset>\r\n"

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressDeliveryAlertController = function () {
    function ExpressDeliveryAlertController(settings) {
        _classCallCheck(this, ExpressDeliveryAlertController);

        this.settings = settings;
    }

    _createClass(ExpressDeliveryAlertController, [{
        key: 'closeAlert',
        value: function closeAlert() {
            this.closed = true;
        }
    }]);

    return ExpressDeliveryAlertController;
}();

ExpressDeliveryAlertController.$inject = ['Settings'];

var expressDeliveryAlertControllerDefinition = {
    controller: ExpressDeliveryAlertController,
    template: __webpack_require__(594).trim()
};

module.exports = {
    ExpressDeliveryAlertController: ExpressDeliveryAlertController,
    expressDeliveryAlertControllerDefinition: expressDeliveryAlertControllerDefinition
};

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"!$ctrl.closed\" class=\"expressDeliveryAlert\">\r\n    <a ng-click=\"$ctrl.closeAlert()\" href=\"javascript:\">\r\n        <i class=\"iconww-Cross expressDeliveryAlert-close-button\"></i>\r\n    </a>\r\n    <i class=\"icon-alert_exclamation expressDeliveryAlert-icon\"></i>\r\n    <div class=\"expressDeliveryAlert-content\">\r\n        <div class=\"expressDeliveryAlert-content-title\">Express Delivery</div>\r\n        <p class=\"expressDeliveryAlert-content-text\">{{ $ctrl.settings.deliveryWindowAlerts.expressDeliveryUnavailableMessage }}</p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(596),
    pickupWizardComponentDefinition = _require.pickupWizardComponentDefinition;

angular.module('wowApp.fulfilment').component('wowPickupWizard', pickupWizardComponentDefinition);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PickupWizardController = function () {
    function PickupWizardController(addressService, timeslotService, fulfilmentSteps, loginService, shopperService) {
        _classCallCheck(this, PickupWizardController);

        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.loginService = loginService;
        this.shopperService = shopperService;

        this.timeTable = [];
        this.hasFinished = false;
    }

    _createClass(PickupWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.currentAddress) {
                this.fetchTimeslots(this.currentAddress.AreaId);
            }

            if (this.currentTimeslot) {
                this.selectedDate = this.currentTimeslot.Date;
                this.selectedTime = this.currentTimeslot.Time;
            }

            var primaryAddress = this.addressService.getPrimaryAddress();

            this.selectedBillingAddressId = primaryAddress ? primaryAddress.AddressId : null;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.isActive) {
                if (changes.isActive.currentValue) {
                    this.hasFinished = false;
                } else if (!this.hasFinished) {
                    if (this.currentStep === this.fulfilmentSteps.address) {
                        this.decideAddressLater();
                    } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                        this.decideTimeLater();
                    }
                }
            }
        }
    }, {
        key: 'ensureLoggedIn',
        value: function ensureLoggedIn(callback) {
            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage);
            } else {
                callback();
            }
        }
    }, {
        key: 'setCollectionAddress',
        value: function setCollectionAddress(address) {
            var _this = this;

            this.ensureLoggedIn(function () {
                _this.currentAddress = address;
                _this.fetchTimeslots(address.AreaId);

                _this.change();
                _this.currentStep = _this.fulfilmentSteps.timeslot;
            });
        }
    }, {
        key: 'fetchTimeslots',
        value: function fetchTimeslots(areaId) {
            var _this2 = this;

            this.timeslotService.listTimeslots(areaId, 'Pickup').then(function (dates) {
                _this2.reservedWindow = _this2.timeslotService.findReservedWindow(dates);
                _this2.timeTable = dates;
                return dates;
            });
        }
    }, {
        key: 'decideAddressLater',
        value: function decideAddressLater() {
            this.currentAddress = null;
            this.selectedTime = null;
            this.selectedDate = null;
            this.finish();
        }
    }, {
        key: 'setDate',
        value: function setDate(date) {
            this.selectedDate = date;
        }
    }, {
        key: 'setTime',
        value: function setTime(time) {
            this.selectedTime = time;
            if (this.shouldShowBilling && !this.addressService.getPrimaryAddress()) {
                this.change();
                this.currentStep = this.fulfilmentSteps.billing;
            } else {
                this.finish();
            }
        }
    }, {
        key: 'decideTimeLater',
        value: function decideTimeLater() {
            this.selectedTime = null;
            this.selectedDate = null;
            this.finish();
        }
    }, {
        key: 'saveNewManualAddressForBilling',
        value: function saveNewManualAddressForBilling(address) {
            var _this3 = this;

            this.addressService.saveNewManualAddressForBilling(address).then(function (addressResponse) {
                _this3.selectedBillingAddressId = addressResponse.Address.AddressId;
                _this3.finish();
            });
        }
    }, {
        key: 'saveNewAutoAddressForBilling',
        value: function saveNewAutoAddressForBilling(address) {
            var _this4 = this;

            this.addressService.saveNewAutoAddressForBilling(address).then(function (addressResponse) {
                _this4.selectedBillingAddressId = addressResponse.Address.AddressId;
                _this4.finish();
            });
        }
    }, {
        key: 'setSavedAddressAsBilling',
        value: function setSavedAddressAsBilling(address) {
            this.selectedBillingAddressId = address.AddressId;
            this.finish();
        }
    }, {
        key: 'change',
        value: function change() {
            this.onFulfilmentChange(this.getFulfilmentInfo());
        }
    }, {
        key: 'finish',
        value: function finish() {
            this.hasFinished = true;
            this.onFulfilmentSelected(this.getFulfilmentInfo());
        }
    }, {
        key: 'getFulfilmentInfo',
        value: function getFulfilmentInfo() {
            return {
                fulfilmentInfo: {
                    address: this.currentAddress,
                    fulfilmentMethod: 'Pickup',
                    fulfilmentWindow: {
                        date: this.selectedDate,
                        time: this.selectedTime
                    },
                    billingAddressId: this.selectedBillingAddressId
                }
            };
        }
    }]);

    return PickupWizardController;
}();

PickupWizardController.$inject = ['AddressService', 'FulfilmentTimeslotService', 'FulfilmentSteps', 'LoginService', 'ShopperService'];

var pickupWizardComponentDefinition = {
    controller: PickupWizardController,
    bindings: {
        shouldShowBilling: '<?',
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        allowDecideLater: '<?',
        currentAddress: '<?',
        currentTimeslot: '<?',
        currentStep: '=',
        isActive: '<'
    },
    template: __webpack_require__(597).trim()
};

module.exports = {
    PickupWizardController: PickupWizardController,
    pickupWizardComponentDefinition: pickupWizardComponentDefinition
};

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address\" id=\"fulfilmentAddress\">\r\n    <legend class=\"pickupWizard-legend pickupWizard-search\">\r\n        Find your local supermarket\r\n    </legend>\r\n\r\n    <wow-pickup-address\r\n        class=\"pickupWizard-storeSelector\"\r\n        id=\"fulfilment-pickup-address\"\r\n        set-pickup-address=\"$ctrl.setCollectionAddress(addr)\">\r\n    </wow-pickup-address>\r\n\r\n    <hr class=\"pickupWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n            class=\"pickupWizard-button linkButton\"\r\n            ng-click=\"$ctrl.decideAddressLater()\">\r\n        I'll choose a store later\r\n    </button>\r\n</fieldset>\r\n\r\n<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">\r\n    <wow-fulfilment-timetable\r\n        time-table=\"$ctrl.timeTable\"\r\n        reserved-date=\"$ctrl.reservedWindow.date\"\r\n        reserved-time=\"$ctrl.reservedWindow.time\"\r\n        on-set-fulfilment-date=\"$ctrl.setDate(selectedDate)\"\r\n        on-set-fulfilment-time=\"$ctrl.setTime(fulfilmentTime)\"\r\n        is-delivery=\"false\">\r\n    </wow-fulfilment-timetable>\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"pickupWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideTimeLater()\">\r\n            I'll choose a time later\r\n    </button>\r\n</fieldset>\r\n\r\n<div ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.billing\" id=\"fulfilmentBillingAddress\">\r\n    <wow-saved-addresses\r\n        heading=\"Enter a new billing address\"\r\n        is-guest=\"$ctrl.shopperService.IsGuest\"\r\n        on-saved-address-selected=\"$ctrl.setSavedAddressAsBilling(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForBilling(address)\"\r\n        on-save-new-auto-address=\"$ctrl.saveNewAutoAddressForBilling(address)\">\r\n    </wow-saved-addresses>\r\n\r\n    <hr class=\"pickupWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"pickupWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideBillingAddressLater()\">\r\n            I'll choose a billing address later\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(599),
    fulfilmentMethodWizardComponentDefinition = _require.fulfilmentMethodWizardComponentDefinition;

angular.module('wowApp.fulfilment').component('wowFulfilmentMethodWizard', fulfilmentMethodWizardComponentDefinition).constant('FulfilmentSteps', Object.freeze({
    fulfilmentMethod: 'FULFILMENT_METHOD',
    address: 'ADDRESS',
    timeslot: 'TIMESLOT',
    billing: 'BILLING'
}));

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RESERVATION_MESSAGE_KEY = 'windowReservationMessage';

var FulfilmentMethodWizardController = function () {
    function FulfilmentMethodWizardController($scope, $window, $timeout, settings, moveFocus, sessionStorage, loadingIndicatorService, shopperService, fulfilmentService, addressService, loginService) {
        var _this = this;

        _classCallCheck(this, FulfilmentMethodWizardController);

        this.$window = $window;
        this.$timeout = $timeout;
        this.settings = settings;
        this.sessionStorage = sessionStorage;
        this.loadingIndicatorService = loadingIndicatorService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.addressService = addressService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;

        this.fulfilmentSteps = fulfilmentService.fulfilmentSteps;

        // The watchers below open method selection panel or fulfilment timetable when a certain event is fired.
        //
        // This is needed for the cart component and the checkout component to trigger the fulfilment method wizard to change the state when
        // errors, such as delivery window/method restricted products cannot be delivered, occurs in the process. The problem is that the
        // components responsible for the trigger is not a direct parent/child of the wizard, which make it difficult to manage the dataflow.
        //
        // All events listed should be fired from the fulfilment service only. Please refer to fulfilment.service.js for its usage.
        //
        // Of course, if possible please kindly avoid using events.
        $scope.$on('fulfilment:changeMethod', function () {
            return _this.openFulfilmentMethodSelection();
        });
        $scope.$on('fulfilment:changeTimeslot', function () {
            return _this.openTimeslots();
        });
    }

    _createClass(FulfilmentMethodWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.modalMessage = this.sessionStorage.getAndRemove(RESERVATION_MESSAGE_KEY);

            this.deliveryMethodMessage = this.settings.trolley.deliveryMethodMessage.replace(' {Firstname}', this.shopperService.IsGuest ? '' : ' ' + this.shopperService.FirstName);

            this.fulfilmentOptions = this.allowDecideLater ? this.fulfilmentService.fulfilmentOptions : this.fulfilmentService.checkoutFulfilmentOptions;

            // Make sure the wizard will go to the correct step when on checkout (allow decide later === false)
            if (!this.allowDecideLater) {
                this.$timeout(function () {
                    return _this2.initializeFulfilmentStep();
                });
            }

            this.shouldShowDeliveryWindowErrorModal = this.shouldShowDeliveryWindowErrorModal !== undefined ? this.shouldShowDeliveryWindowErrorModal : true;
        }
    }, {
        key: 'initializeFulfilmentStep',
        value: function initializeFulfilmentStep() {
            if (this.fulfilmentService.isNotSet()) {
                this.openFulfilmentMethodSelection();
            } else if (!this.fulfilmentService.savedAddress) {
                this.openAddressesSelection();
            } else if (!this.hasSelectedTimeslot()) {
                this.openTimeslots();
            }
        }
    }, {
        key: 'setFulfilmentMethod',
        value: function setFulfilmentMethod(fulfilmentMethod) {
            var _this3 = this;

            this.fulfilmentService.selectedFulfilmentMethod = fulfilmentMethod;

            this.$timeout(function () {
                _this3.currentStep = fulfilmentMethod === _this3.fulfilmentService.fulfilmentOptions.none ? null : _this3.fulfilmentSteps.address;

                if (fulfilmentMethod === _this3.fulfilmentService.fulfilmentOptions.none) {
                    _this3.fulfilmentService.clearFulfilmentInfo();
                }
            });
        }
    }, {
        key: 'ensureLoggedIn',
        value: function ensureLoggedIn(callback) {
            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(fulfilmentInfo) {
            var _this4 = this;

            var wasGuest = this.shopperService.IsGuest;

            this.ensureLoggedIn(function () {
                if (fulfilmentInfo.address) {
                    _this4.loadingIndicatorService.startLoading(true, _this4.settings.delivery.deliveryWindowReloadingMessage, false);
                    _this4.fulfilmentService.saveFulfilment(fulfilmentInfo).then(function (response) {
                        return _this4.onSaveFulfilment(response, wasGuest);
                    }).catch(function () {
                        return _this4.loadingIndicatorService.finishLoading();
                    });
                } else {
                    _this4.currentStep = null;
                    _this4.fulfilmentService.clearAddressAndTime();
                }
            });
        }
    }, {
        key: 'onSaveFulfilment',
        value: function onSaveFulfilment(response, wasGuest) {
            if (wasGuest) return;

            if (response && response.Message) {
                this.sessionStorage.set(RESERVATION_MESSAGE_KEY, response.Message);
            }

            this.$window.location.reload();
        }
    }, {
        key: 'deliveryChange',
        value: function deliveryChange(fulfilmentInfo) {
            this.fulfilmentService.savedAddress = fulfilmentInfo.address;

            if (fulfilmentInfo.fulfilmentWindow) {
                this.fulfilmentService.reservedDate = fulfilmentInfo.fulfilmentWindow.date;
                this.fulfilmentService.reservedTime = fulfilmentInfo.fulfilmentWindow.time;
            }
        }
    }, {
        key: 'hasSelectedTimeslot',
        value: function hasSelectedTimeslot() {
            return !!(this.fulfilmentService.reservedDate && this.fulfilmentService.reservedTime && this.fulfilmentService.reservedDate.DateText && this.fulfilmentService.reservedTime.TimeWindow);
        }
    }, {
        key: 'selectedAddressText',
        value: function selectedAddressText() {
            return this.fulfilmentService.savedAddress ? this.fulfilmentService.savedAddress.AddressText : this.fulfilmentService.selectedFulfilmentMethod.addressText;
        }
    }, {
        key: 'billingAddressText',
        value: function billingAddressText() {
            var primaryAddress = this.addressService.getPrimaryAddress();

            return primaryAddress ? primaryAddress.AddressText : 'select billing address';
        }
    }, {
        key: 'openFulfilmentMethodSelection',
        value: function openFulfilmentMethodSelection() {
            this.changeAnswer(this.fulfilmentSteps.fulfilmentMethod);
            this.currentStep = this.fulfilmentSteps.fulfilmentMethod;
            this.fulfilmentService.savedAddress = null;
            this.moveFocus('#fulfilmentMethod');
        }
    }, {
        key: 'openAddressesSelection',
        value: function openAddressesSelection() {
            this.changeAnswer(this.fulfilmentSteps.address);
            this.currentStep = this.fulfilmentSteps.address;
            this.moveFocus('#fulfilmentAddress');
        }
    }, {
        key: 'openTimeslots',
        value: function openTimeslots() {
            this.changeAnswer(this.fulfilmentSteps.timeslot);
            this.currentStep = this.fulfilmentSteps.timeslot;
            this.moveFocus('#fulfilmentTimetable');
        }
    }, {
        key: 'openBilling',
        value: function openBilling() {
            this.changeAnswer(this.fulfilmentSteps.billing);
            this.currentStep = this.fulfilmentSteps.billing;
            this.moveFocus('#fulfilmentBillingAddress');
        }
    }, {
        key: 'changeAnswer',
        value: function changeAnswer(fulfilmentStep) {
            if (this.onChangeAnswer) {
                this.onChangeAnswer({ stepChanged: fulfilmentStep });
            }
        }
    }, {
        key: 'shouldShowBillingQuestionaire',
        value: function shouldShowBillingQuestionaire() {
            return this.shouldShowBilling && this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.pickup && this.fulfilmentService.reservedTime && this.currentStep !== this.fulfilmentSteps.address && this.currentStep !== this.fulfilmentSteps.timeslot;
        }
    }]);

    return FulfilmentMethodWizardController;
}();

FulfilmentMethodWizardController.$inject = ['$scope', '$window', '$timeout', 'Settings', 'MoveFocus', 'SessionStorageWrapper', 'LoadingIndicatorService', 'ShopperService', 'FulfilmentService', 'AddressService', 'LoginService'];

var fulfilmentMethodWizardComponentDefinition = {
    bindings: {
        shouldShowBilling: '<?',
        allowDecideLater: '<',
        isActive: '<',
        onChangeAnswer: '&?',
        shouldGetDynamicTimetable: '<?',
        shouldShowDeliveryWindowErrorModal: '<?'
    },
    controller: FulfilmentMethodWizardController,
    template: __webpack_require__(600).trim()
};

module.exports = {
    FulfilmentMethodWizardController: FulfilmentMethodWizardController,
    fulfilmentMethodWizardComponentDefinition: fulfilmentMethodWizardComponentDefinition
};

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.fulfilmentWizard\" novalidate>\r\n    <div class=\"fulfilmentMethodWizard\" ng-class=\"{'is-editing': $ctrl.currentStep != null}\">\r\n        <div class=\"fulfilmentMethodWizard-questionnaire\">\r\n            <i class=\"fulfilmentMethodWizard-questionnaireIcon\" ng-class=\"[$ctrl.fulfilmentService.selectedFulfilmentMethod.icon, { 'is-active': !$ctrl.fulfilmentService.isDecideLater() }]\"></i>\r\n\r\n            <div>\r\n                <div class=\"fulfilmentMethodWizard-questionnaireHeading\">\r\n                    {{ $ctrl.fulfilmentService.canOrderBeFulfilled()\r\n                            ? $ctrl.fulfilmentService.selectedFulfilmentMethod.name + ' Confirmed'\r\n                            : $ctrl.settings.fulfilmentMethod.questionnaireHeading }}\r\n                </div>\r\n\r\n                <p>{{ ::$ctrl.deliveryMethodMessage }}</p>\r\n\r\n                <div class=\"fulfilmentMethodWizard-questions\">\r\n                    I'd like\r\n\r\n                    <a href=\"javascript://\" ng-click=\"$ctrl.openFulfilmentMethodSelection()\">\r\n                        {{ $ctrl.fulfilmentService.selectedFulfilmentMethod.text }}\r\n                        <i ng-class=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.fulfilmentMethod ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n                    </a>\r\n\r\n                    <span ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod !== $ctrl.fulfilmentService.fulfilmentOptions.none && $ctrl.currentStep !== $ctrl.fulfilmentSteps.fulfilmentMethod\">\r\n                        {{ $ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup ? 'from' :'to' }}\r\n                        <a href=\"javascript://\" ng-click=\"$ctrl.openAddressesSelection()\">\r\n                            {{ $ctrl.selectedAddressText() }}\r\n                            <i ng-class=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n                        </a>\r\n                    </span>\r\n\r\n                    <span ng-if=\"$ctrl.fulfilmentService.savedAddress && $ctrl.currentStep !== $ctrl.fulfilmentSteps.address\">\r\n                        <span ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">at <a href=\"javascript://\">select timeslot <i class=\"iconww-ArrowUp\"></i></a></span>\r\n                        <a href=\"javascript://\" ng-click=\"$ctrl.openTimeslots()\" ng-if=\"$ctrl.currentStep !== $ctrl.fulfilmentSteps.timeslot\">\r\n                            <span ng-if=\"$ctrl.hasSelectedTimeslot()\">\r\n                                <span ng-bind-html=\"$ctrl.fulfilmentService.reservedDate.DateText\"></span>\r\n                                <span ng-show=\"!$ctrl.fulfilmentService.isExpress\">between</span>\r\n                                {{ $ctrl.fulfilmentService.reservedTime.TimeWindow }}\r\n                            </span>\r\n                            <span ng-if=\"!$ctrl.hasSelectedTimeslot()\">\r\n                                I'll confirm a timeslot later\r\n                            </span>\r\n                            <i class=\"iconww-ArrowDown\"></i>\r\n                        </a>\r\n                    </span>\r\n\r\n                    <span ng-if=\"$ctrl.shouldShowBillingQuestionaire()\">\r\n                        My billing address is\r\n                        <span ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.billing\"><a href=\"javascript://\">select billing address <i class=\"iconww-ArrowUp\"></i></a></span>\r\n                        <a href=\"javascript://\" ng-click=\"$ctrl.openBilling()\" ng-if=\"$ctrl.currentStep !== $ctrl.fulfilmentSteps.billing\">\r\n                            {{ $ctrl.billingAddressText() }}\r\n                            <i class=\"iconww-ArrowDown\"></i>\r\n                        </a>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <fieldset class=\"fulfilmentMethodWizard-choices\" id=\"fulfilmentMethod\" ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.fulfilmentMethod\">\r\n            <legend class=\"fulfilmentMethodWizard-legend\">\r\n                Select <span class=\"sr-only\">how you would like to receive your groceries.</span>...\r\n            </legend>\r\n\r\n            <div class=\"fulfilmentMethodWizard-fulfilmentMethod\" ng-repeat=\"fulfilmentMethod in ::$ctrl.fulfilmentOptions track by fulfilmentMethod.name\">\r\n                <input\r\n                    type=\"radio\"\r\n                    name=\"fulfilmentMethod\"\r\n                    id=\"{{ ::fulfilmentMethod.name }}\"\r\n                    class=\"wowRadio\"\r\n                    ng-model=\"$ctrl.fulfilmentService.selectedFulfilmentMethod\"\r\n                    ng-value=\"fulfilmentMethod\"\r\n                    ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.setFulfilmentMethod(fulfilmentMethod);\">\r\n                <label for=\"{{ ::fulfilmentMethod.name }}\" ng-click=\"$ctrl.setFulfilmentMethod(fulfilmentMethod);\">{{ ::fulfilmentMethod.text }}</label>\r\n            </div>\r\n        </fieldset>\r\n\r\n        <div ng-if=\"$ctrl.currentStep && $ctrl.currentStep !== $ctrl.fulfilmentSteps.fulfilment\">\r\n            <wow-pickup-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                should-show-billing=\"$ctrl.shouldShowBilling\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.fulfilmentService.savedAddress\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                is-active=\"$ctrl.isActive\">\r\n            </wow-pickup-wizard>\r\n\r\n            <wow-delivery-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.delivery\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.fulfilmentService.savedAddress\"\r\n                is-active=\"$ctrl.isActive\"\r\n                should-get-dynamic-timetable=\"$ctrl.shouldGetDynamicTimetable\">\r\n            </wow-delivery-wizard>\r\n        </div>\r\n\r\n        <wow-timeslot-alert\r\n            reserved-timeslot=\"$ctrl.fulfilmentService.reservedTime\"\r\n            is-express=\"$ctrl.fulfilmentService.isExpress\">\r\n        </wow-timeslot-alert>\r\n\r\n        <wow-dialog\r\n            ng-if=\"$ctrl.modalMessage && $ctrl.shouldShowDeliveryWindowErrorModal\"\r\n            dialog-name=\"saved delivery window\"\r\n            message=\"{{ $ctrl.modalMessage }}\"\r\n            on-dismiss=\"::$ctrl.modalMessage = null\">\r\n        </wow-dialog>\r\n    </div>\r\n</form>\r\n"

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

var _require = __webpack_require__(602),
    FulfilmentTimeslotService = _require.FulfilmentTimeslotService;

var _require2 = __webpack_require__(603),
    fulfilmentTimetableComponentDefinition = _require2.fulfilmentTimetableComponentDefinition;

var _require3 = __webpack_require__(605),
    timeslotAlertComponentDefinition = _require3.timeslotAlertComponentDefinition;

angular.module('wowApp.fulfilment').service('FulfilmentTimeslotService', FulfilmentTimeslotService).component('wowFulfilmentTimetable', fulfilmentTimetableComponentDefinition).component('wowTimeslotAlert', timeslotAlertComponentDefinition);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    forEach = _require.forEach;

var FulfilmentTimeslotService = function () {
    function FulfilmentTimeslotService(restangular) {
        _classCallCheck(this, FulfilmentTimeslotService);

        this._api = restangular.all('Timeslots');
    }

    _createClass(FulfilmentTimeslotService, [{
        key: 'listTimeslots',
        value: function listTimeslots(areaId, fulfilmentMethod) {
            var getMergedResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            return this._api.getList({ areaId: areaId, fulfilmentMethod: fulfilmentMethod, getMergedResults: getMergedResults });
        }
    }, {
        key: 'findReservedWindow',
        value: function findReservedWindow(timeTable) {
            var reservedWindow = null;

            forEach(timeTable, function (date) {
                forEach(date.Times, function (time) {
                    if (time.IsReserved) {
                        reservedWindow = { date: date, time: time };
                        return false;
                    }

                    return true;
                });
            });

            return reservedWindow;
        }
    }]);

    return FulfilmentTimeslotService;
}();

FulfilmentTimeslotService.$inject = ['Restangular'];

module.exports = { FulfilmentTimeslotService: FulfilmentTimeslotService };

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var FulfilmentTimetableController = function () {
    function FulfilmentTimetableController(moveFocus, shopperService, addressService, settings) {
        _classCallCheck(this, FulfilmentTimetableController);

        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.addressService = addressService;
        this.settings = settings;
    }

    _createClass(FulfilmentTimetableController, [{
        key: '$onInit',
        value: function $onInit() {
            this.initialize();
            this.moveFocus('#fulfilmentTimetable');
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changed) {
            if (changed.timeTable) {
                this.selectFirstAvailableDate();
            }
        }
    }, {
        key: 'getFulfilmentMethod',
        value: function getFulfilmentMethod() {
            return this.isDelivery ? 'delivery' : this.settings.fulfilmentMethod.timetablePickupName;
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            this.availableTimes = this.availableTimes || [];

            if (this.reservedDate) {
                this.savedTime = {
                    time: this.reservedTime,
                    date: this.reservedDate
                };
            }
        }
    }, {
        key: 'selectFirstAvailableDate',
        value: function selectFirstAvailableDate() {
            var _this = this;

            if (this.timeTable && this.timeTable.length > 0) {
                this.initialize();

                // get index of first available date
                var index = this.savedDate && this.savedDeliveryWindowId ? _.findIndex(this.timeTable, function (deliveryWindow) {
                    return deliveryWindow.Date.substring(0, 11) === _this.savedDate.substring(0, 11);
                }) : _.findIndex(this.timeTable, function (date) {
                    return date.Available;
                });

                // _.findIndex will return -1 if the date list is unretrievable.
                // This will set index to 0 if no dates are available.
                index = index > 0 ? index : 0;

                // set focus on the first available date or first item
                this.moveFocus('.fulfilmentTimetable-days .list-group-itemLink:eq(' + index + ')');

                this.selectedDate = this.timeTable[index];
                this.availableTimes = this.selectedDate.Times;
            }
        }
    }, {
        key: 'saveSelectedDate',
        value: function saveSelectedDate(selectedDate) {
            if (this.onSetFulfilmentDate) {
                this.onSetFulfilmentDate({ selectedDate: selectedDate });
            }
            this.selectedDate = selectedDate;
            this.availableTimes = this.selectedDate.Times;
        }
    }, {
        key: 'setDate',
        value: function setDate(selectedDate) {
            this.selectedDate = selectedDate;
            this.availableTimes = this.selectedDate.Times;

            this.moveFocus(this.selectedDate.Available ? '.fulfilmentTimetable-windows .list-group-itemLink:eq(0)' : '.fulfilmentTimetable ._no-window');
        }
    }, {
        key: 'setTime',
        value: function setTime(fulfilmentTime) {
            this.saveSelectedDate(this.selectedDate);
            this.selectedTime = fulfilmentTime;

            if (this.onSetFulfilmentTime) {
                this.onSetFulfilmentTime({ fulfilmentTime: fulfilmentTime });
            }
        }
    }, {
        key: 'screenReaderLabelForDeliveryTime',
        value: function screenReaderLabelForDeliveryTime(fulfilmentTime) {
            var labelTxt = fulfilmentTime.TimeWindow + '.';
            var priceTxt = '';
            var isSelectedDateEligibleForDeliverySaver = this.selectedDate && this.selectedDate.EligibleForDeliverySaver;
            if (!isSelectedDateEligibleForDeliverySaver && fulfilmentTime.Price !== undefined) {

                if (!(fulfilmentTime.Price > 0)) {
                    priceTxt = ' free';
                } else {
                    var isDiscountedPrice = fulfilmentTime.SalePrice < fulfilmentTime.Price;
                    if (isDiscountedPrice) {
                        priceTxt = ' Was $' + fulfilmentTime.Price + ' now $' + fulfilmentTime.SalePrice;
                    } else {
                        priceTxt = ' $' + fulfilmentTime.Price;
                    }
                }
            } else {
                priceTxt = ' free';
            }

            labelTxt = '' + labelTxt + priceTxt + '. ' + fulfilmentTime.Status;

            if (this.selectedTime === fulfilmentTime) {
                labelTxt += ' selected';
            }

            var needToConfirmReminder = 'Press enter to confirm your selection.';
            if (fulfilmentTime.Status !== 'Closed') {
                labelTxt += needToConfirmReminder;
            }
            return labelTxt;
        }
    }, {
        key: 'moveFocusToFirstTimeslot',
        value: function moveFocusToFirstTimeslot() {
            if (this.availableTimes.length > 0) {
                this.moveFocus('#' + this.availableTimes[0].Id);
            }
        }
    }]);

    return FulfilmentTimetableController;
}();

var fulfilmentTimetableComponentDefinition = {
    bindings: {
        timeTable: '<',
        reservedDate: '<',
        reservedTime: '<',
        onSetFulfilmentDate: '&?',
        onSetFulfilmentTime: '&?',
        savedDate: '@',
        savedDeliveryWindowId: '@',
        isDelivery: '<'
    },
    controller: ['MoveFocus', 'ShopperService', 'AddressService', 'Settings', FulfilmentTimetableController],
    template: __webpack_require__(604).trim()
};

module.exports = {
    FulfilmentTimetableController: FulfilmentTimetableController,
    fulfilmentTimetableComponentDefinition: fulfilmentTimetableComponentDefinition
};

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentTimetable\" id=\"fulfilmentTimetable\">\r\n    <p class=\"fulfilmentTimetable-heading heading5\" ng-if=\"$ctrl.timeTable\">Select a date and time for {{ ::$ctrl.getFulfilmentMethod() }}</p>\r\n\r\n    <wow-loading-spinner ng-if=\"$ctrl.timeTable && $ctrl.timeTable.length === 0 && !$ctrl.addressService.isNonServiced\"></wow-loading-spinner>\r\n\r\n    <div class=\"fulfilmentTimetable-timeSelector\" ng-if=\"$ctrl.timeTable && $ctrl.timeTable.length !== 0\">\r\n        <section class=\"fulfilmentTimetable-timeSelectorDate\" aria-labelledby=\"fulfilmentTimetableDate\" class=\"u-displayInline\">\r\n            <span id=\"fulfilmentTimetableDate\" class=\"sr-only\">Select a {{ ::$ctrl.getFulfilmentMethod() }} date</span>\r\n\r\n            <div class=\"fulfilmentTimetable-timeSelectorItem\"\r\n                ng-repeat=\"fulfilmentDate in $ctrl.timeTable\"\r\n                ng-class=\"{ disabled: !fulfilmentDate.Available }\">\r\n                <input type=\"radio\"\r\n                    class=\"wowRadio\"\r\n                    name=\"selectedDate\"\r\n                    id=\"{{ ::fulfilmentDate.Date | date:'yyyy-MM-dd' }}\"\r\n                    value=\"{{ ::fulfilmentDate.Date }}\"\r\n                    ng-click=\"::$ctrl.setDate(fulfilmentDate)\"\r\n                    ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.moveFocusToFirstTimeslot()\"\r\n                    ng-disabled=\"!fulfilmentDate.Available\"\r\n                    ng-checked=\"$ctrl.selectedDate.Date === fulfilmentDate.Date\">\r\n                <label for=\"{{ ::fulfilmentDate.Date | date:'yyyy-MM-dd' }}\" class=\"fulfilmentTimetable-label\" ng-bind-html=\"fulfilmentDate.DateText | sanitize\"></label>\r\n            </div>\r\n        </section>\r\n\r\n        <section aria-labelledby=\"fulfilmentTimetableTime\" class=\"fulfilmentTimetable-timeSelectorTime\" ng-if=\"$ctrl.selectedDate.Available\">\r\n            <span class=\"sr-only\" id=\"fulfilmentTimetableTime\">Select a {{ ::$ctrl.getFulfilmentMethod() }} time</span>\r\n            <div class=\"fulfilmentTimetable-timeSelectorItem\"\r\n                ng-repeat=\"fulfilmentTime in $ctrl.availableTimes\"\r\n                ng-class=\"{ disabled: !fulfilmentTime.Available }\">\r\n                <input type=\"radio\"\r\n                    class=\"wowRadio\"\r\n                    name=\"selectedTime\"\r\n                    id=\"{{ ::fulfilmentTime.Id }}\"\r\n                    value=\"{{ ::fulfilmentDate.Date }}\"\r\n                    ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.setTime(fulfilmentTime)\"\r\n                    ng-disabled=\"!fulfilmentTime.Available\"\r\n                    ng-checked=\"::fulfilmentTime.Id == $ctrl.savedDeliveryWindowId\">\r\n                <label for=\"{{ ::fulfilmentTime.Id }}\" class=\"fulfilmentTimetable-label\" ng-click=\"$ctrl.setTime(fulfilmentTime)\">\r\n                    <span class=\"sr-only\">{{ ::$ctrl.screenReaderLabelForDeliveryTime(fulfilmentTime) }}</span>\r\n                    {{::fulfilmentTime.TimeWindow}}\r\n                    <div ng-if=\"::!($ctrl.selectedDate && $ctrl.selectedDate.EligibleForDeliverySaver)\" tabindex=\"-1\" aria-hidden=\"true\">\r\n                        <span class=\"fulfilmentTimetable-price\" ng-class=\"::{'fulfilmentTimetable-obsoletePrice': fulfilmentTime.SalePrice < fulfilmentTime.Price}\">\r\n                            {{::(fulfilmentTime.Price | wowCurrencyFull)}}\r\n                        </span>\r\n                        <span class=\"fulfilmentTimetable-saleprice\" ng-if=\"::(fulfilmentTime.SalePrice < fulfilmentTime.Price)\">\r\n                            {{::(fulfilmentTime.SalePrice | wowCurrencyFull)}}\r\n                        </span>\r\n                    </div>\r\n                    <div ng-if=\"$ctrl.selectedDate && $ctrl.selectedDate.EligibleForDeliverySaver\" tabindex=\"-1\" aria-hidden=\"true\">FREE</div>\r\n                    <div class=\"fulfilmentTimetable-windowStatus\" tabindex=\"-1\" aria-hidden=\"true\">{{::fulfilmentTime.Status}}</div>\r\n                </label>\r\n            </div>\r\n        </section>\r\n\r\n        <div class=\"fulfilmentTimetable-textOnly _no-window\" tabindex=\"-1\" ng-if=\"$ctrl.timeTable.length !== 0 && !$ctrl.selectedDate.Available\">\r\n            {{ $ctrl.availableTimes.length > 1 ? $ctrl.selectedDate.ClosedText : $ctrl.availableTimes[0].Status }}\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"fulfilmentTimetable-error alert alert--error\" ng-if=\"!$ctrl.timeTable\">\r\n        {{ $ctrl.settings.fulfilmentTimetable.noAvailableTimesMessage }}\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimeslotAlertController = function () {
    function TimeslotAlertController($scope, $timeout, settings, shopPageStateService, fulfilmentService) {
        var _this = this;

        _classCallCheck(this, TimeslotAlertController);

        this.$timeout = $timeout;
        this.settings = settings;

        this.shopPageStateService = shopPageStateService;
        this.fulfilmentService = fulfilmentService;

        $scope.$on('http:success', function () {
            return _this.scheduleReservationExpiredAlert();
        });
    }

    _createClass(TimeslotAlertController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.reservedTimeslot && this.reservedTimeslot.TimeWindow) {
                /* Values for debugging */

                // For debugging window cutoffs
                // this.reservedTimeslot.MinutesToCutOff = 15 / 60;
                // this.settings.deliveryWindowAlerts.closingSoonAlertPeriod = 10 / 60;
                // this.settings.deliveryWindowAlerts.closingNowAlertPeriod = 5 / 60;

                // For debugging window reservation expiry
                // this.settings.deliveryWindows.reservationTimeout = 1 / 60;

                /* end debug values */

                this.scheduleReservationExpiredAlert();

                // ORDER MATTERS HERE, if these fire at the same time (e.g. we are in both the closing now and closing soon period)
                this.scheduleTimeslotClosingSoonAlert();
                this.scheduleTimeslotClosingNowAlert();
                this.scheduleTimeslotClosedAlert();
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.unscheduleAlerts();
        }
    }, {
        key: 'scheduleReservationExpiredAlert',
        value: function scheduleReservationExpiredAlert() {
            var _this2 = this;

            this.$timeout.cancel(this.reservationExpiryTimer);

            this.reservationExpiryTimer = this.scheduleAlert(function () {
                _this2.unscheduleAlerts();
                _this2.showAlert(_this2.settings.deliveryWindowAlerts.reservationExpiredAlertMessage);
                _this2.changeTimeslot();
            }, this.settings.deliveryWindows.reservationTimeout);
        }
    }, {
        key: 'scheduleTimeslotClosedAlert',
        value: function scheduleTimeslotClosedAlert() {
            var _this3 = this;

            this.$timeout.cancel(this.closedTimer);

            this.closedTimer = this.scheduleAlert(function () {
                _this3.showAlert(_this3.settings.deliveryWindowAlerts.closedAlertMessage);
                _this3.changeTimeslot();
                if (_this3.isExpress) _this3.isExpressClosed = true;
            }, this.reservedTimeslot.MinutesToCutOff);
        }
    }, {
        key: 'scheduleTimeslotClosingNowAlert',
        value: function scheduleTimeslotClosingNowAlert() {
            var _this4 = this;

            this.$timeout.cancel(this.closedTimer);

            this.closingNowTimer = this.scheduleAlert(function () {
                _this4.showAlert(_this4.settings.deliveryWindowAlerts.closingNowAlertMessage);
            }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingNowAlertPeriod);
        }
    }, {
        key: 'scheduleTimeslotClosingSoonAlert',
        value: function scheduleTimeslotClosingSoonAlert() {
            var _this5 = this;

            this.$timeout.cancel(this.closingSoonTimer);

            this.closingSoonTimer = this.scheduleAlert(function () {
                _this5.showAlert(_this5.settings.deliveryWindowAlerts.closingSoonAlertMessage);
            }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingSoonAlertPeriod);
        }
    }, {
        key: 'scheduleAlert',
        value: function scheduleAlert(callback, minutesFromNow) {
            return this.$timeout(callback, minutesFromNow * 60 * 1000);
        }
    }, {
        key: 'unscheduleAlerts',
        value: function unscheduleAlerts() {
            this.$timeout.cancel(this.reservationExpiryTimer);
            this.$timeout.cancel(this.closingNowTimer);
            this.$timeout.cancel(this.closingSoonTimer);
            this.$timeout.cancel(this.closedTimer);
            this.isExpressClosed = false;
        }
    }, {
        key: 'hideAlert',
        value: function hideAlert() {
            this.alertMessage = null;
        }
    }, {
        key: 'showAlert',
        value: function showAlert(alertMessage) {
            this.alertMessage = alertMessage;
        }
    }, {
        key: 'changeTimeslot',
        value: function changeTimeslot() {
            this.shopPageStateService.isCartOpen = true;
            this.fulfilmentService.changeFulfilmentTimeslot();
        }
    }]);

    return TimeslotAlertController;
}();

TimeslotAlertController.$inject = ['$scope', '$timeout', 'Settings', 'ShopPageStateService', 'FulfilmentService'];

var timeslotAlertComponentDefinition = {
    bindings: {
        reservedTimeslot: '<',
        isExpress: '<'
    },
    controller: TimeslotAlertController,
    template: __webpack_require__(606).trim()
};

module.exports = {
    TimeslotAlertController: TimeslotAlertController,
    timeslotAlertComponentDefinition: timeslotAlertComponentDefinition
};

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "<wow-express-delivery-alert ng-if=\"$ctrl.isExpressClosed\">\r\n</wow-express-delivery-alert>\r\n\r\n<div class=\"timeslotAlert\"\r\n    ng-if=\"!$ctrl.isExpressClosed\" ng-show=\"$ctrl.alertMessage\" role=\"alert\">\r\n    <h4 class=\"timeslotAlert-heading\">\r\n        {{ ::$ctrl.settings.deliveryWindowAlerts.alertTitle }}\r\n    </h4>\r\n\r\n    <p>{{ $ctrl.alertMessage }}</p>\r\n\r\n    <button class=\"linkButton\" ng-click=\"$ctrl.hideAlert()\">\r\n        OK, I understand<span class=\"sr-only\">, close message</span>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(0).module('wowApp');

wowApp.config(['RestangularProvider', __webpack_require__(608)]);
wowApp.config(['$urlMatcherFactoryProvider', __webpack_require__(609).urlMatcherConfig]);
wowApp.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', __webpack_require__(611)]);
wowApp.config(['$httpProvider', '$provide', __webpack_require__(644)]);
wowApp.config(['$provide', __webpack_require__(645)]);
wowApp.config(['$provide', __webpack_require__(646)]);
wowApp.config(['$compileProvider', __webpack_require__(647)]);
wowApp.config(['$ocLazyLoadProvider', __webpack_require__(648)]);

wowApp.run(['$rootScope', '$state', 'ShopperService', 'LoginService', 'PageMetadataService', 'MemoScrollService', 'MoveFocus', __webpack_require__(649)]);

// Setup Page Analytics.
wowApp.service('PageAnalytics', ['AnalyticsService', '$rootScope', '$location', '$window', '$document', 'BreakpointsService', 'ShopperService', 'ShopperAnalyticsService', __webpack_require__(650)]);

// Run Initial Page Load Analytics.
wowApp.run(['PageAnalytics', 'Settings', __webpack_require__(652)]);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function restAngularConfiguration(RestangularProvider) {
    RestangularProvider.setBaseUrl('/apis/ui');
    RestangularProvider.setRestangularFields({ id: 'Stockcode' });
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(610),
    filterType = _require.filterType;

function urlMatcherConfig($urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $urlMatcherFactoryProvider.type('filter', filterType);
}

module.exports = { urlMatcherConfig: urlMatcherConfig };

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1),
    map = _require.map,
    reduce = _require.reduce,
    isObject = _require.isObject;

var filterType = {

    /**
     * Encodes a filter object into a URL friendly string to be used in query params.
     *
     * @param {object} filter - A filter object for Olympic Search.
     * @returns {string}
     */
    encode: function encode(filter) {
        if (!filter) {
            return '';
        }

        return map(filter.filters, function (_ref) {
            var Key = _ref.Key,
                Items = _ref.Items;
            return Key + '(' + Items.map(function (i) {
                return i.Term;
            }).join(',') + ')';
        }).join(';');
    },


    /**
     * Decodes a filter param from the URL into a filter object for Olympic Search.
     *
     * @param {string} filterParam - Filter parameter of the format 'Key1(Term,Term);Key2(Term,Term)'
     * @returns {object}
     */
    decode: function decode(filterParam) {
        if (!filterParam) {
            return { filters: [] };
        }

        return {
            filters: reduce(filterParam.split(';'), function (filters, filterString) {
                // matches eg 'Category(1_03F7B3C,1_03F7B3C)' -> ['Category(1_03F7B3C,1_03F7B3C)', 'Category', '1_03F7B3C,1_03F7B3C']
                var parts = filterString.match(/([a-z]+)\(([a-z0-9_\-,]+)\)/i);

                if (parts && parts.length === 3) {
                    filters.push({
                        Key: parts[1],
                        Items: parts[2].split(',').map(function (i) {
                            return { Term: i };
                        })
                    });
                }
                return filters;
            }, [])
        };
    },
    is: function is(item) {
        return isObject(item) && 'filters' in item;
    }
};

module.exports = { filterType: filterType };

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var leftPanel = __webpack_require__(612).trim(),
    centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.hashPrefix('!');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    // Configuring the stateProvider is actually quite expensive and so in tests, the below feature is 'enabled'
    // This is a HACK, temporary. Should be replaced with mocking stateProvider or switching routing library.
    if (window.wowFeatures.isEnabled('route-config-test-mode')) {
        return;
    }

    // Declares the root state
    __webpack_require__(613)($stateProvider);

    // If you add a route here that doesn't exist on the old site (ShopController)
    // you must also add it to RouteConfig.cs to prevent errors.
    $stateProvider.state('shop', {
        url: '/shop?accessToken',
        parent: 'root',
        onEnter: ['$stateParams', '$state', function ($stateParams, $state) {
            if ($stateParams.accessToken) {
                $state.go('root');
            }
        }],
        views: {
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-generic-instrumentation></wow-rr-generic-instrumentation>'
            },
            'content@root': {
                template: leftPanel + ' ' + centerPanel + ' ' + rightPanel
            }
        }
    }).state('shop.trackmyorder', {
        url: '/trackmyorder?OrderNumber',
        resolve: {
            authenticationMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod();
            }]
        },
        onEnter: ['$state', 'ShopperService', 'authenticationMethod', function ($state, shopperService, authenticationMethod) {
            if (!shopperService.IsGuest && authenticationMethod.AuthenticationMethod !== 'RememberMe') {
                $state.transition.then(function () {
                    return $state.go('shop.myaccount.trackmyorder.orderId', { orderId: $state.params.OrderNumber }, { location: 'replace' });
                });
            }
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.trackmyorder': {
                template: '<wow-trackmyorder-guest-form></wow-trackmyorder-guest-form>'
            }
        }
    }).state('shop.unsubscribeedm', {
        url: '/unsubscribeedm?shopperID&checksum&documentID',
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.unsubscribeedm': {
                template: '<wow-unsubscribe-edm></wow-unsubscribe-edm>'
            }
        }
    });

    // Feature routes
    __webpack_require__(615)($stateProvider);
    __webpack_require__(616)($stateProvider);
    __webpack_require__(617)($stateProvider);
    __webpack_require__(618)($stateProvider);
    __webpack_require__(619)($stateProvider);
    __webpack_require__(620)($stateProvider);
    __webpack_require__(622)($stateProvider);
    __webpack_require__(625)($stateProvider);
    __webpack_require__(626)($stateProvider);
    __webpack_require__(628)($stateProvider);
    __webpack_require__(630)($stateProvider);
    __webpack_require__(631)($stateProvider);
    __webpack_require__(632)($stateProvider);
    __webpack_require__(633)($stateProvider);
    __webpack_require__(634)($stateProvider);
    __webpack_require__(635)($stateProvider);
    __webpack_require__(636)($stateProvider);
    __webpack_require__(637)($stateProvider);
    __webpack_require__(639)($stateProvider);
    __webpack_require__(640)($stateProvider);
    __webpack_require__(641)($stateProvider);
    __webpack_require__(642)($stateProvider);

    // Other states
    __webpack_require__(643)($stateProvider);

    $urlRouterProvider.otherwise('/ResourceNotFound');
};

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "<div id=\"left-panel\" class=\"shop-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shop = __webpack_require__(614).trim(),
    centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('root', {
        url: '',
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata(null, false, null, 'Home');
            }]
        },
        views: {
            '@': {
                template: shop
            },
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@root': {
                template: '<wow-rr-carousel placement-id="home_page.carousel" support-compact="false"></wow-rr-carousel>'
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-home-instrumentation page-group="Homepage" placement-ids="home_page.carousel"></wow-rr-home-instrumentation>'
            },
            'notification-panel@root': {
                template: '<wow-notification-panel></wow-notification-panel>'
            }
        }
    });
};

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=\"rr-instrumentation-panel\"></div>\r\n<div ui-view=\"notification-panel\"></div>\r\n\r\n<div id=\"header-panel\" class=\"shop-header\">\r\n    <wow-header></wow-header>\r\n</div>\r\n\r\n<div id=\"content-container\" class=\"shop-content\" ui-view=\"content\"></div>\r\n\r\n<wow-footer></wow-footer>\r\n"

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(24),
    categoryLevels = _require.categoryLevels,
    _require2 = __webpack_require__(1),
    find = _require2.find;

var browseRouteConfigBuilder = function browseRouteConfigBuilder(level, uriParam, parentParam) {
    var _resolve;

    return {
        url: '/:' + uriParam,
        reloadOnSearch: false,
        resolve: (_resolve = {}, _defineProperty(_resolve, uriParam, ['$stateParams', parentParam, function ($stateParams, parentCategory) {
            // Find the category object matching the url friendly name in the url.
            // Searches all of the states at the given state level (department, category, subcategory).
            // At department level this is the top level categories.
            if (parentCategory && parentCategory.Children) {
                return find(parentCategory.Children, { UrlFriendlyName: $stateParams[uriParam] });
            }
            return undefined;
        }]), _defineProperty(_resolve, 'isRestricted', ['ShopperService', uriParam, function (shopperService, category) {
            return shopperService.IsGuest && category && category.IsRestricted;
        }]), _resolve),
        onEnter: ['$state', 'CategoriesService', 'LoginService', 'isRestricted', uriParam, function ($state, categoriesService, loginService, isRestricted, category) {
            if (!category) {
                $state.go('root', null, { location: 'replace' });
            } else if (isRestricted) {
                $state.transition.then(function () {
                    if ($state.includes('**.' + uriParam)) {
                        loginService.promptForLogin(loginService.LoginToViewCategoryMessage);
                    }
                });
            } else {
                categoriesService.currentCategories.pushCategory(category);
            }
        }],
        onExit: ['CategoriesService', function (categoriesService) {
            categoriesService.currentCategories.popCategory();
        }],
        views: {
            'center-panel@shop': {
                controller: [uriParam, 'isRestricted', '$state', 'RichRelevanceService', function (category, isRestricted, $state, richRelevanceService) {
                    this.category = category;
                    this.isRestricted = isRestricted;
                    this.$state = $state;
                    if (category && category.NodeLevel) {
                        if (category.NodeId === richRelevanceService.mySpecialsGroupId) {
                            this.dynamicPlacementId = richRelevanceService.mySpecialsPlacement;
                        } else if (category.RichRelevanceId) {
                            this.dynamicPlacementId = richRelevanceService.specialsGroupPlacement;
                        } else {
                            this.dynamicPlacementId = richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
                        }
                    }
                }],
                controllerAs: '$ctrl',
                template: '\n                    <wow-browse-tile-list\n                        ng-if="::!$ctrl.isRestricted"\n                        category="$ctrl.category"\n                        page-number="$ctrl.$state.params.pageNumber || 1"\n                        sort-by="$ctrl.$state.params.sortBy">\n                    </wow-browse-tile-list>\n\n                    <wow-rr-carousel dynamic-placement-id="$ctrl.dynamicPlacementId"></wow-rr-carousel>\n                '
            },
            'left-panel@shop': {
                controller: [categoryLevels[0], parentParam, uriParam, function (departmentCategory, parentCategory, category) {
                    this.departmentCategory = departmentCategory;
                    this.category = category.Children.length ? category : parentCategory;
                    this.isSpecial = category.IsSpecial;
                    this.isBundle = category.IsBundle;
                }],
                controllerAs: '$ctrl',
                template: '<wow-browse-left-panel department-category="$ctrl.departmentCategory" category="$ctrl.category" is-special="$ctrl.isSpecial" is-bundle="$ctrl.isBundle" ng-if="!$breakpoints.isInSmallFormat"></wow-browse-left-panel>'
            },
            'rr-instrumentation-panel@root': {
                controller: [uriParam, '$state', function (category, $state) {
                    this.category = category;
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-category-instrumentation page-group="Category" page-number="$state.params.pageNumber" current-category="$ctrl.category"></wow-rr-category-instrumentation>'
            }
        }
    };
};

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.browse', {
        url: '/browse?{pageNumber:int}&{sortBy}',
        abstract: true,
        resolve: {
            departments: ['CategoriesService', function (categoriesService) {
                return categoriesService.getAll().then(function (categories) {
                    return { Children: categories };
                });
            }]
        }
    }).state('shop.browse.department', browseRouteConfigBuilder(0, categoryLevels[0], 'departments')).state('shop.browse.department.category', browseRouteConfigBuilder(1, categoryLevels[1], categoryLevels[0])).state('shop.browse.department.category.subcategory', browseRouteConfigBuilder(2, categoryLevels[2], categoryLevels[1]));
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.catalogue', {
        url: '/catalogue',
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            }
        },
        data: {
            optOutOfScrollRestore: true
        }
    });
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.search', {
        url: '/search?{searchTerm}&{multisearchItems}&{pageNumber:int}&{sortBy}',
        onEnter: ['$q', '$state', '$stateParams', 'SearchPhraseActionService', 'SearchMultisearchService', 'SearchService', function ($q, $state, $stateParams, searchActionService, searchMultisearchService, searchService) {
            $q.all([searchActionService.getSearchPhraseAction($stateParams.searchTerm || ''), $state.transition, searchService.getSearchCounts($stateParams.searchTerm)]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    searchAction = _ref2[0];

                if (searchAction && !searchMultisearchService.isSearchMultisearch()) {
                    return searchActionService.performSearchPhraseAction(searchAction);
                }

                return $q.resolve();
            }).then(function () {
                // If there are no *product* results for the search term but there are *other* results (specials, recipes, articles),
                // this will figure out which state to redirect to. This must be called after getting the search counts
                // in order to know which types of results are available for the search term.
                var nextState = searchService.determineStateToShow($stateParams.searchTerm, $stateParams.multisearchItems);

                if ($state.is('shop.search') && !$state.is(nextState.name)) {
                    $state.go(nextState.name, nextState.params, { location: 'replace' });
                }
            });
        }],
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="false">\n                        </wow-search-navigation>\n                    '
            },
            'rr-instrumentation-panel@root': {
                controller: ['$stateParams', '$scope', function ($searchParams, $scope) {
                    $scope.searchTerm = $searchParams.searchTerm;
                }],
                template: '<wow-rr-search-instrumentation search-term="searchTerm"></wow-rr-search-instrumentation>'
            }
        },
        data: {
            pageMetadata: ['$state', function ($state) {
                return $state.params.searchTerm ? {
                    title: $state.params.searchTerm + ' - Woolworths Online',
                    metaDescription: $state.params.searchTerm + ' - Woolworths Online',
                    metaRobot: 'noindex'
                } : {
                    title: 'Search - Woolworths Online',
                    metaDescription: 'Search - Woolworths Online',
                    metaRobot: 'noindex'
                };
            }],
            authenticate: ['SearchPhraseActionService', 'SearchMultisearchService', '$q', 'toParams', function (searchActionService, multisearchService, $q, toParams) {
                var isMultisearch = toParams.multisearchItems && multisearchService.isSearchTermPartOfMultisearchList(toParams.searchTerm, toParams.multisearchItems);
                if (toParams && toParams.searchTerm && !isMultisearch) {
                    return searchActionService.searchRequiresLogin(toParams.searchTerm);
                }

                return $q.when(false);
            }]
        }
    }).state('shop.search.products', {
        url: '/products?{filter:filter}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-product-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            is-special="false"\n                            is-list="false"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            filter="$ctrl.$state.params.filter">\n                        </wow-search-product-tile-list>\n                    '
            }
        }
    }).state('shop.search.specials', {
        url: '/specials?{filter:filter}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-product-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            is-special="true"\n                            is-list="false"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            filter="$ctrl.$state.params.filter">\n                        </wow-search-product-tile-list>\n                    '
            }
        }
    }).state('shop.search.recipes', {
        url: '/recipes',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-recipe-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-search-recipe-tile-list>\n                    '
            }
        }
    }).state('shop.search.articles', {
        url: '/articles',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-inspiration-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            page-number="$ctrl.$state.params.pageNumber || 1">\n                        </wow-search-inspiration-tile-list>\n                    '
            }
        }
    }).state('shop.search.zero-result', {
        url: '/zeroresult',
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="true">\n                        </wow-search-navigation>\n                    '
            },
            'center-panel@shop': {
                template: '<wow-search-zero-results></wow-search-zero-results>'
            }
        }
    }).state('shop.search.external-result', {
        url: '/externalresult',
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="true">\n                        </wow-search-navigation>\n                    '
            },
            'center-panel@shop': {
                template: '<wow-search-external-result></wow-search-external-result>'
            }
        }
    });
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    var _this = this;

    $stateProvider // Recipes
    .state('shop.recipes', {
        url: '/recipes?{pageNumber:int}&{sortBy}',
        resolve: {
            categories: ['RecipeCategoriesService', function (recipeCategoriesService) {
                return recipeCategoriesService.getAll();
            }]
        },
        views: {
            'left-panel@shop': {
                controller: ['RecipeCategoriesService', function (recipeCategoriesService) {
                    this.recipeCategoriesService = recipeCategoriesService;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-navigation ng-if="!$breakpoints.isInSmallFormat" current-category="$ctrl.recipeCategoriesService.currentCategory"></wow-recipe-navigation>'
            }
        },
        onExit: ['RecipeCategoriesService', function (recipeCategoriesService) {
            recipeCategoriesService.resetCurrentCategory();
        }]
    }).state('shop.recipes.recipenotfound', {
        url: '/recipenotfound',
        views: {
            'center-panel@shop': {
                template: '<wow-error-page error-page="\'recipeNotFound\'"></wow-error-page>'
            }
        },
        data: {
            shouldGetMetadata: false
        }
    }).state('shop.recipes.savedList', {
        url: '/mykeptrecipes',
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-recipe-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-recipe-list-tile-list>\n                    '
            }
        }
    }).state('shop.recipes.noSavedRecipes', {
        url: '/nokeptrecipes'
    }).state('shop.recipes.category', {
        abstract: true,
        url: '/:category'
    }).state('shop.recipes.category.subCategory', {
        url: '/:subCategory',
        reloadOnSearch: false,
        onEnter: ['$stateParams', 'RecipeCategoriesService', function ($stateParams, recipeCategoriesService) {
            recipeCategoriesService.setCategoryByName($stateParams.category, $stateParams.subCategory);
        }],
        views: {
            'center-panel@shop': {
                controller: ['$state', 'RecipeCategoriesService', function ($state, recipeCategoriesService) {
                    this.$state = $state;
                    this.recipeCategoriesService = recipeCategoriesService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-recipe-tile-list\n                            current-category="$ctrl.recipeCategoriesService.currentCategory"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-recipe-tile-list>\n                    '
            }
        },
        data: {
            pageMetadata: ['$state', 'PageMetadataService', 'RecipeCategoriesService', function ($state, pageMetadataService, recipeCategoryService) {
                var category = recipeCategoryService.getCategoryByName($state.params.category, $state.params.subCategory);
                return pageMetadataService.getMetadata({ name: category.aisle.Name }, false, '/Shop/Recipes/' + $state.params.category + '/' + $state.params.subCategory, 'RecipeCategory');
            }]
        }
    }).state('shop.recipedetail', {
        url: '/recipedetail/{recipeId}/{recipeTitle}',
        resolve: {
            recipe: ['$stateParams', 'RecipeService', function ($stateParams, recipeService) {
                return recipeService.getRecipe($stateParams.recipeId);
            }]
        },
        onEnter: ['$state', 'recipe', function ($state, recipe) {
            if (!recipe) {
                _this.$state.go('error.404', null, { location: 'replace' });
            }
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.recipedetail': {
                controller: ['recipe', function (recipe) {
                    this.recipe = recipe;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-detail recipe="$ctrl.recipe"></wow-recipe-detail>'
            }
        },
        data: {
            pageMetadata: ['RecipeService', 'PageMetadataService', 'config', '$stateParams', function (recipeService, pageMetadataService, config, $stateParams) {
                if (!$stateParams.recipeId) {
                    return pageMetadataService.getMetadata(null, null, null, 'Recipe');
                }

                return recipeService.getRecipe($stateParams.recipeId).then(function (details) {
                    return details ? pageMetadataService.getMetadata({ name: details.Title, site: config.SiteShortName }, null, '/Shop/Recipe', 'Recipe') : pageMetadataService.getMetadata(null, null, null, 'Recipe');
                });
            }]
        }
    });
};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.inspiration', {
        url: '/discover?{name}&{cardId:int}',
        resolve: {
            navigationItems: ['InspirationService', function (inspirationService) {
                return inspirationService.getNavigationItems();
            }]
        },
        onEnter: ['$state', '$timeout', 'FeatureService', 'navigationItems', function ($state, $timeout, featureService, navigationItems) {
            if (featureService.isEnabled(featureService.features.enableDiscoverLandingPage)) {
                return;
            }

            $state.transition.then(function () {
                if ($state.is('shop.inspiration')) {
                    $state.go('shop.inspiration.parent', { parent: navigationItems[0].UrlPart }, { location: 'replace' });
                }
            });
        }],
        views: {
            'left-panel@shop': {
                controller: ['navigationItems', function (navigationItems) {
                    this.menuItems = navigationItems;
                }],
                controllerAs: '$ctrl',
                template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({ name: 'Discover - Woolworths Online' });
            }]
        }
    }).state('shop.inspirationcard', {
        url: '/discover/card/{id}?name',
        views: {
            'center-panel@shop': {
                template: '<wow-loading-spinner></wow-loading-spinner>'
            },
            'left-panel@shop': {
                controller: ['$state', '$stateParams', 'InspirationService', function ($state, $stateParams, inspirationService) {
                    inspirationService.getDiscoverPathForCard($stateParams.id).then(function (pathToCard) {
                        if (pathToCard.Page === null || pathToCard.Page.Parent === null) {
                            $state.go('error.404', null, { location: 'replace' });
                        }

                        $state.go('shop.inspiration.parent.child', {
                            parent: pathToCard.Parent.Page.UrlPart,
                            child: pathToCard.Page.UrlPart,
                            cardId: $stateParams.id,
                            name: $stateParams.name
                        }, {
                            location: 'replace'
                        });
                    });
                }]
            }
        }
    }).state('shop.inspiration.parent', {
        url: '/:parent',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-inspiration-detail-tile-list\n                            page-id="$ctrl.$state.params.parent">\n                        </wow-inspiration-detail-tile-list>\n                    '
            }
        }
    }).state('shop.inspiration.parent.child', {
        url: '/:child',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-inspiration-detail-tile-list\n                            page-id="$ctrl.$state.params.child">\n                        </wow-inspiration-detail-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(1),
    authenticationHandler = __webpack_require__(621);

module.exports = function ($stateProvider) {
    $stateProvider
    // My Account
    .state('shop.myaccount', {
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                /*
                * Checkout module is also lazy loaded in the My Account Page. Woolworths Rewards section requires the Chekout Service from the module
                * to handle the vaildation of the card number.
                */
                return $ocLazyLoad.load(['myaccount', 'checkout']);
            }],
            authMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod().then(function (response) {
                    return response.AuthenticationMethod;
                });
            }]
        },
        url: '/myaccount',
        onEnter: ['$state', '$q', 'LoginService', 'authMethod', _.partialRight(authenticationHandler, 'Please reauthenticate before accessing My Account')],
        views: {
            'left-panel@shop': {
                template: '<wow-my-account-nav-links></wow-my-account-nav-links>'
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>'
            }
        },
        data: {
            authenticate: true,
            pageMetadata: {
                title: 'Account Details',
                metaDescription: 'Account Details'
            }
        }
    }).state('shop.myaccount.accessibility', {
        url: '/accessibility',
        views: {
            'center-panel@shop': {
                template: '<wow-shopper-accessibility></wow-shopper-accessibility>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.preferences', {
        url: '/preferences',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-shopper-preferences></wow-my-account-shopper-preferences>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.deliveryaddresses', {
        url: '/deliveryaddresses',
        views: {
            'center-panel@shop': {
                template: '<div class="myaccount"><wow-my-account-delivery-addresses></wow-my-account-delivery-addresses></div>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.changepassword', {
        url: '/password',
        views: {
            'center-panel@shop': {
                template: '<wow-change-password></wow-change-password>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.woolworthsrewards', {
        url: '/woolworthsrewards',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-everyday-rewards></wow-my-account-everyday-rewards>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.trackmyorder', {
        url: '/trackmyorder',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-track-my-order></wow-my-account-track-my-order>'
            },
            'left-panel@shop': {
                template: '<wow-my-account-nav-links></wow-my-account-nav-links>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.trackmyorder.orderId', {
        url: '/:orderId'
    })

    // My Account- Account details
    .state('shop.myaccount.details', {
        url: '/details',
        views: {
            'center-panel@shop': {
                template: '<div class="myaccount"><wow-my-account-details></wow-my-account-details></div>'
            }
        },
        data: {
            authenticate: true
        }
    })

    // My Account - Delivery Savers
    .state('shop.myaccount.deliverysavers', {
        url: '/deliverypasses',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-delivery-savers></wow-my-account-delivery-savers>'
            }
        },
        data: {
            authenticate: true
        }
    })

    // My Account - My invoices lists
    .state('shop.myaccount.myinvoices', {
        url: '/myinvoices?{pageNumber:int}&{searchInvoice}&{startDate}&{endDate}',
        views: {
            'center-panel@shop': {
                template: '<wow-my-invoices></wow-my-invoices>'
            }
        },
        data: {
            authenticate: true
        }
    });
};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, $q, loginService, authMethod, loginAuthMessage) {
    $q.when($state.transition).then(function (targetState) {
        if (authMethod !== 'Shopper' && authMethod !== 'Impersonate') {
            loginService.promptForLogin(loginAuthMessage, targetState);
        }
    });
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.guestList', {
        url: '/suggestedlists?{pageNumber:int}&{sortBy}',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('lists');
            }]
        },
        onEnter: ['$state', 'ShopperService', function ($state, shopperService) {
            if (!shopperService.IsGuest) {
                $state.go('shop.list');
            }
        }],
        views: {
            'left-panel@shop': {
                controller: ['$scope', 'SuggestedListService', 'ListProductService', 'BreakpointsService', '$state', function ($scope, suggestedListService, listProductService, breakpointsService, $state) {

                    suggestedListService.listSuggestedLists().then(function () {
                        $scope.suggestedLists = suggestedListService.suggestedlists;

                        if (!$state.params.Id) {
                            // Navigate to first suggested list by default
                            var firstSuggestedList = $scope.suggestedLists[0];
                            var listId = firstSuggestedList.ID;
                            var listName = firstSuggestedList.Name;
                            suggestedListService.selectList(listProductService, listName, listId);

                            $state.go('shop.guestList.suggestedlists', { Id: listId, name: undefined, cardId: undefined, productId: undefined, recipeId: undefined });
                        }
                    });
                }],
                template: __webpack_require__(623).trim()
            }
        },
        data: {
            pageMetadata: {
                title: 'Lists - Woolworths Online',
                metaDescription: 'Lists - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.guestList.suggestedlists', {
        url: '/suggestedlists/{Id:int}',
        reloadOnSearch: false,
        resolve: {
            init: ['$stateParams', 'SuggestedListService', function ($stateParams, suggestedListService) {
                suggestedListService.listId = $stateParams.Id;
            }]
        },
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-suggested-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-suggested-list-tile-list>\n                    '
            }
        }
    }).state('shop.list', {
        url: '/mylists?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('lists');
            }]
        },
        onEnter: ['SavedListsService', function (savedListsService) {
            if (savedListsService.savedLists && savedListsService.savedLists.length > 0) {
                savedListsService.listId = savedListsService.savedLists[0].ListId;
            }
        }],
        views: {
            'center-panel@shop': {
                controller: ['$state', 'SavedListsService', function ($state, savedListsService) {
                    this.$state = $state;
                    this.listid = savedListsService.listId;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-saved-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            list-id="$ctrl.listid">\n                        </wow-saved-list-tile-list>\n                    '
            },
            'left-panel@shop': {
                template: __webpack_require__(624).trim()
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-wishlist-instrumentation></wow-rr-wishlist-instrumentation>'
            }
        },
        data: {
            authenticate: true,
            pageMetadata: {
                title: 'Lists - Woolworths Online',
                metaDescription: 'Lists - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.list.pastshops', {
        url: '/pastshops/{orderId}',
        reloadOnSearch: false,
        params: {
            totalRecordCount: null
        },
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-past-shop-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            total-record-count="$ctrl.$state.params.totalRecordCount">\n                        </wow-past-shop-tile-list>\n                    '
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>'
            }
        }
    }).state('shop.list.pastordershops', {
        url: '/pastordershops/{orderId}',
        reloadOnSearch: false,
        resolve: {
            init: ['$stateParams', 'PastShopService', 'ListProductService', function ($stateParams, pastShopService, listProductService) {
                pastShopService.selectOrder(listProductService, $stateParams.orderId);
            }]
        },
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.list.pastordershops': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-past-shop-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-past-shop-tile-list>\n                    '
            }
        }
    }).state('shop.list.suggestedlists', {
        url: '/suggestedlists/{Id}',
        reloadOnSearch: false,
        resolve: {
            init: ['$stateParams', 'SuggestedListService', function ($stateParams, suggestedListService) {
                suggestedListService.listId = $stateParams.Id;
            }]
        },
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-suggested-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-suggested-list-tile-list>\n                    '
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-generic-instrumentation></wow-rr-generic-instrumentation>'
            }
        }
    }).state('shop.list.edit', {
        url: '/{listId}',
        reloadOnSearch: false,
        params: {
            totalRecordCount: null
        },
        resolve: {
            init: ['$stateParams', 'SavedListsService', function ($stateParams, savedListService) {
                savedListService.listId = $stateParams.listId;
                savedListService.isListEmpty = false;
                savedListService.freeTextProducts = false;
                return savedListService.listSavedLists();
            }]
        },
        views: {
            'left-panel@shop': {
                controller: ['$stateParams', function ($stateParams) {
                    this.listId = $stateParams.listId;
                }],
                controllerAs: 'editListController',
                template: '<div class="my-lists-container navigation"><wow-saved-lists-edit list-id="editListController.listId"></wow-saved-lists-edit></div>'
            },
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-saved-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            list-id="$ctrl.$state.params.listId"\n                            total-record-count="$ctrl.$state.params.totalRecordCount">\n                        </wow-saved-list-tile-list>\n                    '
            }
        },
        data: {
            isListEditMode: false
        }
    }).state('shop.list.edit.freetext', {
        url: '/products?searchTerm',
        reloadOnSearch: false,
        resolve: {
            init: ['SavedListsService', function (savedListService) {
                savedListService.freeTextProducts = true;
            }]
        },
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-product-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            is-special="false"\n                            is-list="true"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-search-product-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<div class=\"my-lists-container navigation\">\r\n    <a ui-sref=\"shop.list\">\r\n        <h2 class=\" navigation-header\">\r\n            My <span class=\"sr-only\">saved</span> Lists\r\n        </h2>\r\n    </a>\r\n    <wow-suggested-list></wow-suggested-list>\r\n</div>"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "<nav role=\"navigation\" class=\"my-lists-container navigation\">\r\n    <wow-saved-lists></wow-saved-lists>\r\n    <wow-past-shop-list></wow-past-shop-list>\r\n    <wow-suggested-list></wow-suggested-list>\r\n</nav>"

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.authentication', {
        abstract: true,
        onExit: ['LoginService', function (loginService) {
            // If the state was navigated to as a result of a prompt for login,
            // we need to reject the promise for the prompt when we exit the login panel.
            // If the login is successful, the promise should already have been resolved and
            // this will do nothing.
            loginService.rejectPromptForLogin();
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            }
        },
        data: {
            onAuthReturnToState: 'root'
        }
    }).state('shop.authentication.login', {
        url: '/securelogin',
        params: {
            toState: null,
            toStateParams: null,
            toStateOptions: { reload: false }
        },
        onEnter: ['$rootScope', '$state', '$stateParams', function ($rootScope, $state, $stateParams) {
            // When toState is not specified in the stateParams use
            // previous state, if available, for redirection.
            if (!$stateParams.toState && $rootScope.onAuthRedirectedState) {
                $stateParams.toState = $rootScope.onAuthRedirectedState.name;
                $stateParams.toStateParams = $rootScope.onAuthRedirectedStateParams;
            }
        }],
        resolve: {
            authenticationMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod().then(function (result) {
                    return result.AuthenticationMethod;
                });
            }]
        },
        views: {
            'center-panel': {
                controller: ['$scope', '$state', '$stateParams', '$timeout', 'authenticationMethod', function ($scope, $state, $stateParams, $timeout, authenticationMethod) {
                    this.authenticationMethod = authenticationMethod;

                    $scope.$on('login:success', function () {
                        // Redirect with a page load in a timeout to make sure other 'login:success'
                        // handlers also get to run
                        $timeout(function () {
                            window.location.href = $stateParams.toState ? $state.href($stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/' : '/';
                        }, 0, false);
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-login-page authentication-method="$ctrl.authenticationMethod"></wow-login-page>'
            }
        }
    }).state('shop.authentication.signup', {
        url: '/signup?id&token',
        views: {
            'center-panel': {
                controller: ['$scope', '$timeout', function ($scope, $timeout) {
                    $scope.$on('signup:success', function () {
                        // Redirect with a page load in a timeout to make sure other 'login:success'
                        // handlers also get to run
                        $timeout(function () {
                            window.location.href = '/';
                        }, 0, false);
                    });
                }],
                template: '<wow-signup-page></wow-signup-page>'
            }
        }
    })
    // Reset password
    .state('shop.authentication.resetpassword', {
        url: '/resetpassword?passwordResetToken',
        views: {
            'center-panel': {
                controller: ['$stateParams', function ($stateParams) {
                    this.passwordResetToken = $stateParams.passwordResetToken;
                }],
                controllerAs: '$ctrl',
                template: '<wow-reset-password password-reset-token="{{::$ctrl.passwordResetToken}}"></wow-reset-password>'
            }
        }
    })
    // Forgot password
    .state('shop.authentication.forgotpassword', {
        url: '/forgotpassword',
        views: {
            'center-panel': {
                template: '<wow-login-forgot-password></wow-login-forgot-password>'
            }
        }
    });
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var embeddedBasePageTemplate = __webpack_require__(627).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('embedded', {
        abstract: true,
        url: '/embedded',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('embedded');
            }]
        },
        views: {
            '@': {
                template: embeddedBasePageTemplate
            }
        }
    })
    // login via agent
    .state('embedded.loginviaagent', {
        url: '/loginviaagent?linktoken&uid',
        views: {
            'embedded-base-content@embedded': {
                template: '<wow-embedded-login-form></wow-embedded-login-form>'
            }
        }
    })
    // signup via agent
    .state('embedded.registerviaagent', {
        url: '/registerviaagent?linktoken&uid',
        views: {
            'embedded-base-content@embedded': {
                template: '<wow-embedded-signup-form></wow-embedded-signup-form>'
            }
        }
    })
    // signup via agent confirmation
    .state('embedded.registerviaagent.confirmation', {
        url: '/confirmation?name&email&mobile&birth&work&abn&company&address&shopperid&redirectToAgentUrl',
        views: {
            'embedded-base-content@embedded': {
                template: '<wow-embedded-signup-confirmation></wow-embedded-signup-confirmation>'
            }
        }
    });
};

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "<div class=\"embeddedPage\">\r\n    <div class=\"embeddedPage-content\" ui-view=\"embedded-base-content\"></div>\r\n</div>"

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var checkoutTemplate = __webpack_require__(629).trim(),
    centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('checkoutroot', {
        abstract: true,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('checkout');
            }]
        },
        views: {
            '@': {
                template: checkoutTemplate
            }
        },
        data: {
            authenticate: true
        }
    })
    // Have you forgotten
    .state('hyf', {
        url: '^/shop/checkout',
        parent: 'checkoutroot',
        onEnter: ['CheckoutStepService', function (checkoutStepService) {
            checkoutStepService.currentStep = 'hyf';
        }],
        views: {
            'checkout-content@checkoutroot': {
                controller: ['$state', 'HaveYouForgottenService', 'FeatureService', function ($state, haveYouForgottenService, featureService) {
                    if (featureService.isEnabled(featureService.features.rrShowPlacementsInHyfPages)) {
                        this.products = {};
                    } else {
                        haveYouForgottenService.getProducts().then(function (response) {
                            if (!response.length) {
                                $state.go('checkout', null, { location: 'replace' });
                            }
                        });
                    }
                }],
                template: '<wow-have-you-forgotten></wow-have-you-forgotten>',
                resolve: {
                    skipHaveYouForgottenSettings: ['$state', 'SettingsByBreakpointService', function ($state, settingsByBreakpointService) {
                        var shouldSkipHaveYouForgotten = settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
                            largeFormat: 'SkipHaveYouForgottenLargeFormatEnabled',
                            mediumFormat: 'SkipHaveYouForgottenMediumFormatEnabled',
                            smallFormat: 'SkipHaveYouForgottenSmallFormatEnabled'
                        });

                        if (shouldSkipHaveYouForgotten) {
                            $state.go('checkout', null, { location: 'replace' });
                        }
                    }]
                }
            },
            'rr-instrumentation-panel@checkoutroot': {
                template: '<wow-rr-generic-instrumentation page-group="Hyf" placement-ids="generic_page.have_you_forgotten"></wow-rr-generic-instrumentation>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Have You Forgotten',
                metaDescription: 'Have You Forgotten'
            }
        }
    })
    // Conversational Checkout Wizard routes
    .state('checkout', {
        url: '/checkout',
        parent: 'checkoutroot',
        views: {
            'checkout-content@checkoutroot': {
                template: '<wow-checkout-wizard></wow-checkout-wizard>'
            }
        },
        onEnter: ['CheckoutStepService', 'FeatureService', function (checkoutStepService, featureService) {
            if (featureService.isEnabled(featureService.features.checkoutPerformanceEnhancements)) {
                checkoutStepService.setCurrentStep('delivery');
            }
        }],
        data: {
            pageMetadata: {
                title: 'Checkout - Woolworths Online',
                metaDescription: 'Checkout - Woolworths Online'
            }
        }
    }).state('shop.confirmation', {
        url: '/confirmation?orderId&saveCard',
        resolve: {
            orderConfirmation: ['$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                return $ocLazyLoad.load('checkout').then(function () {
                    var checkoutService = $injector.get('CheckoutService');
                    return checkoutService.getOrderConfirmation($stateParams.orderId);
                });
            }]
        },
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'rr-instrumentation-panel@root': {
                controller: ['$scope', 'orderConfirmation', function ($scope, orderConfirmation) {
                    $scope.order = orderConfirmation.Order;
                }],
                template: '<wow-rr-purchased-instrumentation order="order"></wow-rr-purchased-instrumentation>'
            },
            'center-panel@shop.confirmation': {
                controller: ['$scope', '$stateParams', 'orderConfirmation', function ($scope, $stateParams, orderConfirmation) {
                    $scope.orderConfirmation = orderConfirmation;
                    $scope.saveCard = Boolean($stateParams.saveCard);
                }],
                template: '<wow-order-confirmation-panel order="orderConfirmation" save-card="saveCard"></wow-order-confirmation-panel>'
            }
        },
        data: {
            authenticate: true
        }
    });
};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-base\">\r\n    <h1 class=\"sr-only\">Checkout</h1>\r\n\r\n    <div ui-view=\"rr-instrumentation-panel\"></div>\r\n    <wow-checkout-header></wow-checkout-header>\r\n\r\n    <div ui-view=\"checkout-content\">\r\n    </div>\r\n</div>"

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.productgroup', {
        url: '/productgroup/{Id}?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        data: {
            pageMetadata: {
                title: 'Shop Product Group',
                metaDescription: 'Shop Product Group',
                metaRobot: 'noindex'
            }
        },
        views: {
            'left-panel@shop': {
                template: '<wow-product-group></wow-product-group>',
                controller: ['$state', '$stateParams', 'ProductGroupService', 'FeatureService', function ($state, $stateParams, productGroupService) {
                    return productGroupService.selectProductGroup($stateParams.Id).then(function (group) {
                        if (!group) {
                            $state.go('error.404', null, { location: 'replace' });
                        }
                        if (!isNaN($stateParams.Id)) {
                            $state.transitionTo('shop.productgroup', {
                                Id: group.Url,
                                id: $stateParams.id,
                                name: $stateParams.name
                            }, { location: 'replace' });
                        }
                        return group;
                    });
                }]
            },
            'center-panel@shop': {
                controller: ['$state', 'ProductGroupService', function ($state, productGroupService) {
                    this.$state = $state;
                    this.productGroupService = productGroupService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-product-group-tile-list\n                            ng-if="::$ctrl.productGroupService.selectedGroup"\n                            product-group-id="$ctrl.$state.params.Id"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-product-group-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.partner', {
        url: '/partner/:id',
        views: {
            'left-panel@shop': {
                controller: ['BreakpointsService', '$scope', function (breakpointsService, $scope) {
                    $scope.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                template: '<wow-partner-small-format ng-if="showLeftPanel()"><wow-partner></wow-partner></wow-partner-small-format>'
            },
            'center-panel@shop': {
                template: '<wow-partner></wow-partner>'
            }
        },
        onEnter: function onEnter() {
            $('.center-content').css('position', 'relative');
        },
        onExit: function onExit() {
            $('.center-content').css('position', '');
        },

        data: {
            pageMetadata: ['$state', 'PartnerService', function ($state, partnerService) {
                return partnerService.getPartner($state.params.id).then(function (response) {
                    return {
                        title: response.PartnerDto.Name,
                        metaDescription: response.PartnerDto.Name
                    };
                });
            }]
        }
    }).state('shop.partnerbranch', {
        url: '/partnerbranch/:id',
        views: {
            'left-panel@shop': {
                controller: ['BreakpointsService', '$scope', function (breakpointsService, $scope) {
                    $scope.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                template: '<wow-partner-small-format ng-if="showLeftPanel()"></wow-partner-small-format>'
            }
        },
        data: {
            pageMetadata: ['$state', 'PartnerService', function ($state, partnerService) {
                return partnerService.getBranch($state.params.id).then(function (response) {
                    return {
                        title: response.PartnerBranchName,
                        metaDescription: response.PartnerBranchName
                    };
                });
            }]
        }
    }).state('shop.conveniencepack', {
        url: '/conveniencepack/:packId?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', 'ProductGroupService', function ($state, productGroupService) {
                    this.$state = $state;

                    productGroupService.selectProductGroup($state.params.packId);
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-convenience-pack-tile-list\n                            pack-id="$ctrl.$state.params.packId"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-convenience-pack-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.support', {
        url: '/support',
        views: {
            'left-panel@shop': {
                template: '<wow-accessibility-nav-links></wow-accessibility-nav-links>'
            }
        },
        data: {
            authenticate: false
        }
    }).state('shop.support.accessibility', {
        url: '/accessibility',
        views: {
            'center-panel@shop': {
                template: '<wow-shopper-accessibility></wow-shopper-accessibility>'
            }
        },
        data: {
            authenticate: false
        }
    });
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.page', {
        url: '/page/:scheduleKey'
    }).state('shop.embedded', {
        // this state is used for dynamic content pages which are embedded as iframes
        // in woolworths mobile applications
        url: '/embedded/:scheduleKey',
        views: {
            '@': {
                template: '<div style="height: 100%;" wow-hide-scroll wow-scrollbar><oly-dynamic-content oly-dc-url-schedule></oly-dynamic-content></div>'
            }
        }
    });
};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('print', {
        abstract: true,
        url: '/print',
        parent: 'root',
        views: {
            '@': {
                template: ''
            }
        }
    }).state('print.recipe', {
        url: '^/shop/printrecipe/{recipeId}',
        data: {
            pageMetadata: {
                title: 'Shop Print Recipe - Woolworths Online',
                metaDescription: 'Shop Print Recipe',
                metaRobot: 'noindex'
            }
        },
        resolve: {
            recipe: ['RecipeService', '$stateParams', function (recipeService, $stateParams) {
                return recipeService.getRecipe($stateParams.recipeId).then(function (recipe) {
                    return recipe;
                });
            }]
        },
        views: {
            '@': {
                controller: ['recipe', function (recipe) {
                    this.recipe = recipe;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-print recipe="$ctrl.recipe"></wow-recipe-print>'
            }
        }
    }).state('print.orderconfirmation', {
        url: '^/checkout/printconfirmation?{OrderID}',
        data: {
            pageMetadata: {
                title: 'Print Order Confirmation - Woolworths Online',
                metaDescription: 'Print Order Confirmation',
                metaRobot: 'noindex'
            }
        },
        resolve: {
            orderConfirmation: ['$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                return $ocLazyLoad.load('checkout').then(function () {
                    var checkoutService = $injector.get('CheckoutService');
                    return checkoutService.getOrderConfirmation($stateParams.OrderID);
                });
            }]
        },
        views: {
            '@': {
                controller: ['$scope', 'orderConfirmation', function ($scope, orderConfirmation) {
                    $scope.order = orderConfirmation.Order;
                }],
                template: '<wow-order-confirmation-print order="order"></wow-order-confirmation-print>'
            }
        }
    });
};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.productdetails', {
        // temporary for old product description popup
        url: '/productdetails/:productId/:productName',
        params: {
            product: null
        },
        data: {
            pageMetadata: ['DetailProductService', 'PageMetadataService', '$stateParams', function (detailProductService, pageMetadataService, $stateParams) {
                return detailProductService.getProductDetail($stateParams.productId).then(function (details) {
                    return pageMetadataService.getMetadata({
                        name: (details.Product.Name + ' ' + details.Product.PackageSize).trim()
                    }, null, null, 'Product');
                });
            }]
        },
        onEnter: ['RichRelevanceService', '$stateParams', function (richRelevanceService, $stateParams) {
            if ($stateParams.product) {
                richRelevanceService.rrItemDetailsPageRequest($stateParams.product.Stockcode, $stateParams.product.Source);
            }
        }],
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('productdetail');
            }]
        },
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.productdetails': {
                controller: ['DetailProductService', '$stateParams', function (detailProductService, $stateParams) {
                    var _this = this;

                    if ($stateParams.product) {
                        this.detail = { Product: $stateParams.product };
                    }
                    detailProductService.getProductDetail($stateParams.productId).then(function (detail) {
                        _this.detail = detail;
                        _this.isLoaded = true;
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-product-detail ng-if="$ctrl.detail" detail="$ctrl.detail" is-loaded="$ctrl.isLoaded"></wow-product-detail>'
            },
            'rr-instrumentation-panel@root': {
                controller: ['$stateParams', 'Settings', 'RichRelevanceService', function ($stateParams, settings, richRelevanceService) {
                    this.removeDuplicatedProducts = settings.richRelevance.removeDuplicatedProducts;
                    this.productId = $stateParams.productId;
                    this.productName = $stateParams.productName;
                    this.placementIds = richRelevanceService.itemPageRankOne + ', ' + richRelevanceService.itemPageRankTwo;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-item-instrumentation ng-if="!$ctrl.removeDuplicatedProducts" page-group="Category" item-id="$ctrl.productId" item-name="$ctrl.productName" placement-ids="$ctrl.placementIds"></wow-rr-item-instrumentation>'
            }
        }
    });
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.cart', {
        url: '/cart',
        views: {
            'content@root': {
                template: '' + centerPanel
            },
            'center-panel@shop.cart': {
                template: '<wow-cart></wow-cart>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Shopping Cart - Woolworths Online',
                metaDescription: 'Shopping Cart - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    });
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var leftPanel = __webpack_require__(638).trim(),
    centerPanel = __webpack_require__(8).trim(),
    rightPanel = __webpack_require__(10).trim();

module.exports = function ($stateProvider) {
    var rootScopeListener = void 0;

    $stateProvider.state('shop.stores', {
        resolve: {
            google: ['SettingsService', 'GoogleMapsApi', function (settingsService, googleMapsApi) {
                return settingsService.getSettingValue('StoreLocator', 'StoreLocatorGoogleMapApiURL').then(googleMapsApi).then(function (googleApi) {
                    window.google = googleApi;
                });
            }],
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('stores');
            }]
        },
        views: {
            'content@root': {
                template: leftPanel + ' ' + centerPanel + ' ' + rightPanel
            }
        }
    }).state('shop.locator', {
        parent: 'shop.stores',
        url: '/storelocator',
        onEnter: ['$rootScope', '$state', 'StoreService', function ($rootScope, $state, storeService) {
            // this is a hack becaues onEnter doesn't fire if you move from
            // a child state to a parent state. Therefore we need to listen for all state changes
            // and unselect a store if we are arriving in this state.
            rootScopeListener = $rootScope.$on('$stateChangeSuccess', function () {
                if ($state.is('shop.locator')) {
                    storeService.setSelectedStore(undefined);
                }
            });
        }],
        onExit: [function () {
            rootScopeListener();
        }],
        views: {
            'left-panel': {
                controller: ['BreakpointsService', 'StoreFilterService', function (breakpointsService, storeFilterService) {
                    this.storeFilterService = storeFilterService;

                    this.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                controllerAs: 'storeLocatorLeftCtrl',
                template: '\n                        <wow-store-locator-search\n                            divisions="storeLocatorLeftCtrl.storeFilterService.divisions"\n                            facilities="storeLocatorLeftCtrl.storeFilterService.facilities">\n                        </wow-store-locator-search>\n                    '
            },
            'center-panel': {
                template: '<wow-store-locator-map></wow-store-locator-map>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({ name: 'Stores' });
            }]
        }
    }).state('shop.locator.store', {
        url: '/:store',
        params: {
            storeDetails: null
        },
        onEnter: ['StoreService', '$state', '$stateParams', function (storeService, $state, $stateParams) {
            var storeInfo = storeService.getStoreInfoFromUrlParams($stateParams.store);

            if ($stateParams.storeDetails && storeService.urlParametersValid($stateParams.storeDetails, storeInfo)) {
                storeService.setSelectedStore($stateParams.storeDetails);
            } else if (storeInfo && storeInfo.storeNo) {
                storeService.getStore(storeInfo.storeNo, storeInfo.division).then(function (store) {
                    if (storeService.urlParametersValid(store, storeInfo)) {
                        storeService.setSelectedStore(store);
                    } else {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                });
            } else {
                $state.go('error.404', null, { location: 'replace' });
            }
        }]
    }).state('shop.tripplanner', {
        parent: 'shop.stores',
        url: '/tripplanner?{destination}',
        views: {
            'left-panel': {
                controller: ['StoreFilterService', 'TripPlannerService', '$stateParams', function (storeFilterService, tripPlannerService, $stateParams) {
                    this.storeFilterService = storeFilterService;
                    this.tripPlannerService = tripPlannerService;
                    this.$stateParams = $stateParams;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-trip-planner-search\n                            directions="$ctrl.tripPlannerService.directions"\n                            route-index="$ctrl.tripPlannerService.routeIndex"\n                            waypoint-stores="$ctrl.tripPlannerService.waypointStores"\n                            stores="$ctrl.tripPlannerService.stores"\n                            selected-store="$ctrl.tripPlannerService.selectedStore"\n                            divisions="$ctrl.storeFilterService.divisions"\n                            facilities="$ctrl.storeFilterService.facilities"\n                            destination="$ctrl.$stateParams.destination">\n                        </wow-trip-planner-search>\n                    '
            },
            'center-panel': {
                controller: ['TripPlannerService', function (tripPlannerService) {
                    this.tripPlannerService = tripPlannerService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-trip-planner-map\n                            directions="$ctrl.tripPlannerService.directions"\n                            route-index="$ctrl.tripPlannerService.routeIndex"\n                            waypoint-stores="$ctrl.tripPlannerService.waypointStores"\n                            stores="$ctrl.tripPlannerService.stores"\n                            selected-store="$ctrl.tripPlannerService.selectedStore">\n                        </wow-trip-planner-map>\n                    '
            }
        }
    });
};

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "<div id=\"left-panel\" class=\"stores-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.new', {
        url: '/new?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        views: {
            'left-panel@shop': {
                template: '<wow-new-products-nav></wow-new-products-nav>'
            },
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-new-products-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-new-products-tile-list>\n                    '
            }
        },
        data: {
            pageMetadata: {
                title: 'Shop New Products',
                metaDescription: 'Shop New Products'
            }
        }
    });
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(8).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('error', {
        parent: 'root',
        abstract: true,
        views: {
            'content@root': {
                template: '' + centerPanel
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-error-instrumentation></wow-rr-error-instrumentation>'
            }
        }
    }).state('error.404', {
        url: '/resourcenotfound',
        views: {
            'center-panel': {
                template: '<wow-error-page error-page=\'404\'></wow-error-page>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                var currentMetaData = pageMetadataService.getCurrentMetadata();
                currentMetaData.meta404 = {
                    name: 'prerender-status-code',
                    content: '404'
                };
                return currentMetaData;
            }]
        }
    }).state('error.500', {
        url: '/error',
        views: {
            'center-panel@error': {
                template: '<wow-error-page error-page=\'500\'></wow-error-page>'
            }
        }
    }).state('error.403', {
        url: '/unauthorisederror',
        views: {
            'center-panel@error': {
                template: '<wow-error-page error-page="403"></wow-error-page>'
            }
        }
    });
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.addtotrolley', {
        url: '/addtotrolley?{stockcode}&{quantity:int}&{source}',
        onEnter: ['ShelfProductService', '$stateParams', '$state', function (shelfProductService, $stateParams, $state) {
            if ($stateParams.stockcode && $stateParams.quantity) {
                shelfProductService.addItemToTrolley($stateParams.stockcode, $stateParams.quantity, $stateParams.source).then(function () {
                    return $state.go('root');
                });
            } else {
                $state.go('root');
            }
        }]
    });
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.offergroup', {
        url: '/offergroup/{Id}?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        data: {
            pageMetadata: {
                title: 'Shop Offer Group',
                metaDescription: 'Shop Offer Group',
                metaRobot: 'noindex'
            }
        },
        views: {
            'left-panel@shop': {
                template: '<wow-product-group group-type="\'OfferGroup\'"></wow-product-group>',
                controller: ['$state', '$stateParams', 'OfferGroupService', function ($state, $stateParams, offerGroupService) {
                    return offerGroupService.selectOfferGroup($stateParams.Id).then(function (group) {
                        if (!group) {
                            $state.go('error.404', null, { location: 'replace' });
                        }
                        if (!isNaN($stateParams.Id)) {
                            $state.go('shop.offergroup', {
                                Id: group.Url,
                                name: $stateParams.name
                            }, { location: 'replace' });
                        }
                        return group;
                    });
                }]
            },
            'center-panel@shop': {
                controller: ['$state', 'OfferGroupService', function ($state, offerGroupService) {
                    this.$state = $state;
                    this.offerGroupService = offerGroupService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-offer-group-tile-list\n                            ng-if="::$ctrl.offerGroupService.selectedGroup"\n                            offer-group-id="$ctrl.$state.params.Id"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-offer-group-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('diagnostics', {
        abstract: true,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('diagnostics');
            }]
        }
    }).state('diagnostics.styleguide', {
        url: '/styleguide',
        views: {
            '@': {
                template: '<wow-styleguide></<wow-styleguide>'
            }
        }
    }).state('diagnostics.settings', {
        url: '/settingsdiagnostics',
        views: {
            '@': {
                template: '<wow-missing-settings></wow-missing-settings>'
            }
        }
    });
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($httpProvider, $provide) {
    $provide.factory('http401Interceptor', ['$q', '$injector', '$window', 'LoadingIndicatorService', function ($q, $injector, $window, loadingIndicator) {
        return {
            responseError: function responseError(rejection) {
                if (rejection.status === 401) {
                    var loginService = $injector.get('LoginService');
                    loadingIndicator.finishLoading();

                    loginService.promptForLogin(loginService.LoginToContinueMessage);
                }
                var $state = $injector.get('$state');
                if (rejection.status === 404) {
                    $state.go('error.404', null, { location: 'replace' });
                }
                if (rejection.status === 500) {
                    $state.go('error.500');
                }
                if (rejection.status === 403) {
                    $state.go('error.403');
                }

                return $q.reject(rejection);
            }
        };
    }]);

    $provide.factory('http200Interceptor', ['$rootScope', function ($rootScope) {
        return {
            response: function response(_response) {
                if (_response.status === 200) {
                    // Reset the reservation timer
                    $rootScope.$broadcast('http:success');
                }

                return _response;
            }
        };
    }]);

    $httpProvider.interceptors.push('http401Interceptor');
    $httpProvider.interceptors.push('http200Interceptor');
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

module.exports = function ($provide) {
    $provide.decorator('$state', ['$delegate', '$stateParams', '$injector', function ($state, $stateParams, $injector) {
        $state.shouldGetMetaData = function () {
            var toState = $state.current;
            return !toState.data || toState.data && toState.data.shouldGetMetadata !== false;
        };

        $state.getMetadata = function () {
            var toState = $state.current;
            if (toState.data && toState.data.pageMetadata) {
                return angular.isArray(toState.data.pageMetadata) ? $injector.invoke(toState.data.pageMetadata) : toState.data.pageMetadata;
            }

            return {
                title: '',
                metaDescription: ''
            };
        };

        $state.shouldAuthenticate = function (toState, toParams) {
            return $injector.invoke(toState.data.authenticate, undefined, { toParams: toParams });
        };
        return $state;
    }]);
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($provide) {
    $provide.decorator('$location', ['$delegate', function ($location) {
        $location.pathAndSearch = function () {
            var url = $location.url();
            if (url) {
                return url.split('#')[0];
            }

            return url;
        };

        return $location;
    }]);
};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($compileProvider) {
    $compileProvider.debugInfoEnabled('wowIsDebuggingEnabled' in window ? !!window.wowIsDebuggingEnabled : true);
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
        modules: 'wowModules' in window ? window.wowModules : []
    });
};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(0);

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then(function (requiresLogin) {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', function () {
        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(function () {
            return $('#center-panel h1').filter(':first');
        }, false);
    });

    $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
        memoScroll.rememberScrollPosition(oldUrl);
    });

    $rootScope.$on('$locationChangeSuccess', function (event, newUrl) {
        if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore)) {
            memoScroll.restoreScrollPosition(newUrl);
        }
    });
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dtmPageInfoDataMapper = __webpack_require__(651);

var getSystemEnvironment = function getSystemEnvironment(breakpointsService) {
    if (breakpointsService.isLargeFormat()) {
        return 'Desktop';
    } else if (breakpointsService.isMediumFormat()) {
        return 'Tablet';
    }

    return 'Mobile';
};

var PageAnalytics = function () {
    function PageAnalytics(analytics, $rootScope, $location, $window, $document, breakpointsService, shopperService, shopperAnalytics) {
        _classCallCheck(this, PageAnalytics);

        this.analytics = analytics;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$window = $window;
        this.$document = $document;
        this.breakpointsService = breakpointsService;
        this.shopperService = shopperService;
        this.shopperAnalytics = shopperAnalytics;
    }

    _createClass(PageAnalytics, [{
        key: 'setupPageChangeWatchers',
        value: function setupPageChangeWatchers() {
            var _this = this;

            /**
             * Location Change Success event is fired once on actual page reload.
             */
            this.$rootScope.$on('$locationChangeSuccess', function (e, toUrl, fromUrl) {
                // Update Page Analytics.
                _this.push(toUrl, fromUrl);
            });
        }
    }, {
        key: 'push',
        value: function push(toUrl, fromUrl) {
            var analyticsPageInfoData = {
                sysEnv: getSystemEnvironment(this.breakpointsService),
                variant: this.$window.navigator.userAgent,
                language: this.$window.navigator.language,
                toUrl: toUrl,
                fromUrl: toUrl === fromUrl ? this.$document[0].referrer : fromUrl
            };

            this.analytics.push({ data: analyticsPageInfoData, dtmMapperFn: dtmPageInfoDataMapper });
        }
    }]);

    return PageAnalytics;
}();

module.exports = PageAnalytics;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data) {
    var mappedData = {
        page: {
            pageInfo: {
                sysEnv: data.sysEnv,
                variant: data.variant,
                language: data.language
            }
        }
    };

    if (data.toUrl) {
        mappedData.page.pageInfo.destinationUrl = data.toUrl;
    }
    if (data.fromUrl) {
        mappedData.page.pageInfo.referringUrl = data.fromUrl;
    }

    return mappedData;
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pageAnalytics, settings) {
    if (!settings.analytics || !settings.analytics.enableAdobeAnalytics) return;
    pageAnalytics.setupPageChangeWatchers();
    pageAnalytics.push();
};

/***/ })
],[311]);


// WEBPACK FOOTER //
// wowapp.2a6c853f77ff534f75ba.bundle.js